(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._unmatchedHeader_qcj19_1{opacity:.55}._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as JF, getPartnerDevApiHeaders as XF, WidgetContextProvider as ZF, makeExecuteQuery as eI, makeUseLazyQuery as nI, makeUseQuery as tI, makeUseMutation as rI, validateApiHostName as cy, useTracking as Cn, useWidgetContext as yn, hasDownstreamApiForbiddenError as kl, hasDownstreamApiAuthorizationError as bl, DisplayErrors as In, useCopyWithDelay as Gt, defaultDateFormat as St, displayAttributeValue as Oi, useWidgetSettingsMutations as Xr, useWidgetSettingsQuery as Zr, useRenderConditions as ei, PartnerSettingsWrapper as ni, handleWidgetSubmit as ti, MisconfigurationBanner as ri, OAuthSettings as ga, WidgetSettingsFormFooter as ii, useData as uy, PartnerHookFormSecretText as Ro, isDownstreamApiNotFoundError as iI, isDownstreamApiAuthorizationError as fw, KlaviyoSubscribeSetting as aI, isDownstreamApiPermissionError as oI, capitalizeFirstCharacter as hw, humanizeKey as sI, hasDownstreamApiTooManyRequestsError as lI, hasDownstreamApiPermissionError as yw, PartnerHookFormBasicAuth as cI, hasDownstreamApiNotFoundError as va, getCountryNameFromCountryCode as uI, parseBoolean as dI, parseString as mI, IntegrationModal as gw, useInboundOAuthContext as pI, getWidgetConfigurationByIdQuery as fI, createWidgetConfigurationMutation as hI, updateWidgetConfigurationMutation as yI, trackRenderConditionsSaved as gI, deleteWidgetConfigurationMutation as vI } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import Ie, { useMemo as Kn, useState as le, useEffect as Ye, useRef as Ii, useCallback as lt, useReducer as kI, useLayoutEffect as bI, useContext as dy, isValidElement as vw, createContext as kw, createElement as _I, Fragment as xI } from "react";
import { Text as A, FlexBox as b, Spinner as fn, Icon as pe, Tooltip as Ge, List as We, Badge as Vn, Button as Yn, IconButton as ir, Switch as Qs, FieldLabel as bw, FieldWrapper as en, InputText as fr, InputSelectionList as ui, FormGrid as at, FormField as me, Tag as qn, NavigationButton as Rt, Select as Fr, CollapseCard as hr, Box as tt, Modal as jt, ModalHead as wt, ModalBody as Ct, ModalFoot as Pt, Textarea as bh, TagsInput as _l, Image as ka, Banner as xl, Divider as my, SelectionList as mt, FieldText as tr, FieldTextarea as SI, CopyToClipboardButton as NI, getSelectionListContext as jI, Avatar as py, Timestamp as wI, Attachment as CI, FieldSwitch as fy, EmptyState as Js, Table as et, Checkbox as Gg, TextWithHighlight as FI, ErrorBoundaryContext as _w } from "@dixa/lib-shared-habla";
import it from "classnames";
import { ApolloLink as hy, Observable as xw, ApolloClient as II, InMemoryCache as $I, createHttpLink as EI, ApolloProvider as TI, useApolloClient as DI, ApolloConsumer as OI, NetworkStatus as rr, isApolloError as Sw, ApolloError as Nw, gql as Sl, useQuery as RI, useMutation as Yg } from "@apollo/client";
import PI from "cross-fetch";
import { config as Eo } from "lib-shared-backend-config";
import Hn from "moment";
import "moment-timezone";
import { __rest as AI, __assign as Jl } from "tslib";
import { useLocation as LI } from "react-router-dom";
function yy(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Jo = { exports: {} }, $a = {};
var Qg;
function VI() {
  if (Qg) return $a;
  Qg = 1;
  var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return $a.Fragment = r, $a.jsx = s, $a.jsxs = s, $a;
}
var Ea = {};
var Jg;
function zI() {
  return Jg || (Jg = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[N];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        z("error", t, m);
      }
    }
    function z(t, c, m) {
      {
        var y = C.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var P = m.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var T = !1, I = !1, D = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || U || t === v || T || I || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function q(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return q(c) + ".Consumer";
          case s:
            var m = t;
            return q(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return R(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, be, fe, de, ge, K, xe, $e;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          be = console.log, fe = console.info, de = console.warn, ge = console.error, K = console.group, xe = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: be
            }),
            info: B({}, t, {
              value: fe
            }),
            warn: B({}, t, {
              value: de
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: K
            }),
            groupCollapsed: B({}, t, {
              value: xe
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = C.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var ze = !1, Re;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new on();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var m = Re.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      ze = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Le.current, Le.current = null, qe();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var S = te.stack.split(`
`), ne = y.stack.split(`
`), H = S.length - 1, x = ne.length - 1; H >= 1 && x >= 0 && S[H] !== ne[x]; )
            x--;
          for (; H >= 1 && x >= 0; H--, x--)
            if (S[H] !== ne[x]) {
              if (H !== 1 || x !== 1)
                do
                  if (H--, x--, x < 0 || S[H] !== ne[x]) {
                    var Z = `
` + S[H].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (H >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Le.current = P, Me(), Error.prepareStackTrace = $;
      }
      var ue = t ? t.displayName || t.name : "", _e = ue ? De(ue) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Qe(t, c, m) {
      return Ee(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Xe(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case d:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Qe(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return se(P($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, je = {}, Ve = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function dn(t, c, m, y, $) {
      {
        var P = Function.call.bind(ye);
        for (var w in t)
          if (P(t, w)) {
            var S = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + m + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[w](c, w, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              S = H;
            }
            S && !(S instanceof Error) && (Oe($), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, w, typeof S), Oe(null)), S instanceof Error && !(S.message in je) && (je[S.message] = !0, Oe($), g("Failed %s type: %s", m, S.message), Oe(null));
          }
      }
    }
    var E = Array.isArray;
    function _(t) {
      return E(t);
    }
    function O(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function W(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function L(t) {
      if (W(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", O(t)), J(t);
    }
    var M = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Ze(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function sn(t, c) {
      {
        var m = function() {
          he || (he = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function hn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, m, y, $, P, w) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function _n(t, c, m, y, $) {
      {
        var P, w = {}, S = null, ne = null;
        m !== void 0 && (L(m), S = "" + m), mn(c) && (L(c.key), S = "" + c.key), nn(c) && (ne = c.ref, Ze(c, $));
        for (P in c)
          ye.call(c, P) && !ie.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var H = t.defaultProps;
          for (P in H)
            w[P] === void 0 && (w[P] = H[P]);
        }
        if (S || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && sn(w, x), ne && hn(w, x);
        }
        return pn(t, S, ne, $, y, M.current, w);
      }
    }
    var Je = C.ReactCurrentOwner, Nn = C.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(m);
      } else
        Nn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (Je.current) {
          var t = R(Je.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Mn(t) {
      return "";
    }
    var jn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = kn(c);
        if (jn[m])
          return;
        jn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Je.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ae(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ae(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            cn(y) && gn(y, c);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              cn(w.value) && gn(w.value, c);
        }
      }
    }
    function zn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = R(c);
          dn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var $ = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function An(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ae(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var xn = {};
    function Sn(t, c, m, y, $, P) {
      {
        var w = re(t);
        if (!w) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = Mn();
          ne ? S += ne : S += vn();
          var H;
          t === null ? H = "null" : _(t) ? H = "array" : t !== void 0 && t.$$typeof === n ? (H = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : H = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, S);
        }
        var x = _n(t, c, m, $, P);
        if (x == null)
          return x;
        if (w) {
          var Z = c.children;
          if (Z !== void 0)
            if (y)
              if (_(Z)) {
                for (var ue = 0; ue < Z.length; ue++)
                  wn(Z[ue], t);
                Object.freeze && Object.freeze(Z);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = R(t), te = Object.keys(c).filter(function($n) {
            return $n !== "key";
          }), Ke = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? An(x) : zn(x), x;
      }
    }
    function Bn(t, c, m) {
      return Sn(t, c, m, !0);
    }
    function On(t, c, m) {
      return Sn(t, c, m, !1);
    }
    var Rn = On, Un = Bn;
    Ea.Fragment = i, Ea.jsx = Rn, Ea.jsxs = Un;
  })()), Ea;
}
var Xg;
function UI() {
  return Xg || (Xg = 1, process.env.NODE_ENV === "production" ? Jo.exports = VI() : Jo.exports = zI()), Jo.exports;
}
var Be = UI();
function jw(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: MI } = Object.prototype, { getPrototypeOf: Nl } = Object, { iterator: jl, toStringTag: ww } = Symbol, wl = /* @__PURE__ */ ((e) => (n) => {
  const r = MI.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Ir = (e) => (e = e.toLowerCase(), (n) => wl(n) === e), Cl = (e) => (n) => typeof n === e, { isArray: ba } = Array, ma = Cl("undefined");
function Po(e) {
  return e !== null && !ma(e) && e.constructor !== null && !ma(e.constructor) && Zt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Cw = Ir("ArrayBuffer");
function BI(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && Cw(e.buffer), n;
}
const qI = Cl("string"), Zt = Cl("function"), Fw = Cl("number"), Ao = (e) => e !== null && typeof e == "object", HI = (e) => e === !0 || e === !1, Ds = (e) => {
  if (wl(e) !== "object")
    return !1;
  const n = Nl(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(ww in e) && !(jl in e);
}, WI = (e) => {
  if (!Ao(e) || Po(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, KI = Ir("Date"), GI = Ir("File"), YI = (e) => !!(e && typeof e.uri < "u"), QI = (e) => e && typeof e.getParts < "u", JI = Ir("Blob"), XI = Ir("FileList"), ZI = (e) => Ao(e) && Zt(e.pipe);
function e$() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const Zg = e$(), ev = typeof Zg.FormData < "u" ? Zg.FormData : void 0, n$ = (e) => {
  if (!e) return !1;
  if (ev && e instanceof ev) return !0;
  const n = Nl(e);
  if (!n || n === Object.prototype || !Zt(e.append)) return !1;
  const r = wl(e);
  return r === "formdata" || // detect form-data instance
  r === "object" && Zt(e.toString) && e.toString() === "[object FormData]";
}, t$ = Ir("URLSearchParams"), [r$, i$, a$, o$] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Ir), s$ = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Lo(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), ba(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (Po(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function Iw(e, n) {
  if (Po(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const ji = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, $w = (e) => !ma(e) && e !== ji;
function _h() {
  const { caseless: e, skipUndefined: n } = $w(this) && this || {}, r = {}, i = (a, o) => {
    if (o === "__proto__" || o === "constructor" || o === "prototype")
      return;
    const s = e && Iw(r, o) || o;
    Ds(r[s]) && Ds(a) ? r[s] = _h(r[s], a) : Ds(a) ? r[s] = _h({}, a) : ba(a) ? r[s] = a.slice() : (!n || !ma(a)) && (r[s] = a);
  };
  for (let a = 0, o = arguments.length; a < o; a++)
    arguments[a] && Lo(arguments[a], i);
  return r;
}
const l$ = (e, n, r, { allOwnKeys: i } = {}) => (Lo(
  n,
  (a, o) => {
    r && Zt(a) ? Object.defineProperty(e, o, {
      value: jw(a, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      value: a,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: i }
), e), c$ = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), u$ = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), Object.defineProperty(e.prototype, "constructor", {
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, d$ = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && Nl(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, m$ = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, p$ = (e) => {
  if (!e) return null;
  if (ba(e)) return e;
  let n = e.length;
  if (!Fw(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, f$ = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && Nl(Uint8Array)), h$ = (e, n) => {
  const i = (e && e[jl]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, y$ = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, g$ = Ir("HTMLFormElement"), v$ = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, i, a) {
  return i.toUpperCase() + a;
}), nv = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), k$ = Ir("RegExp"), Ew = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  Lo(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, b$ = (e) => {
  Ew(e, (n, r) => {
    if (Zt(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const i = e[r];
    if (Zt(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, _$ = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return ba(e) ? i(e) : i(String(e).split(n)), r;
}, x$ = () => {
}, S$ = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function N$(e) {
  return !!(e && Zt(e.append) && e[ww] === "FormData" && e[jl]);
}
const j$ = (e) => {
  const n = new Array(10), r = (i, a) => {
    if (Ao(i)) {
      if (n.indexOf(i) >= 0)
        return;
      if (Po(i))
        return i;
      if (!("toJSON" in i)) {
        n[a] = i;
        const o = ba(i) ? [] : {};
        return Lo(i, (s, l) => {
          const u = r(s, a + 1);
          !ma(u) && (o[l] = u);
        }), n[a] = void 0, o;
      }
    }
    return i;
  };
  return r(e, 0);
}, w$ = Ir("AsyncFunction"), C$ = (e) => e && (Ao(e) || Zt(e)) && Zt(e.then) && Zt(e.catch), Tw = ((e, n) => e ? setImmediate : n ? ((r, i) => (ji.addEventListener(
  "message",
  ({ source: a, data: o }) => {
    a === ji && o === r && i.length && i.shift()();
  },
  !1
), (a) => {
  i.push(a), ji.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", Zt(ji.postMessage)), F$ = typeof queueMicrotask < "u" ? queueMicrotask.bind(ji) : typeof process < "u" && process.nextTick || Tw, I$ = (e) => e != null && Zt(e[jl]), Se = {
  isArray: ba,
  isArrayBuffer: Cw,
  isBuffer: Po,
  isFormData: n$,
  isArrayBufferView: BI,
  isString: qI,
  isNumber: Fw,
  isBoolean: HI,
  isObject: Ao,
  isPlainObject: Ds,
  isEmptyObject: WI,
  isReadableStream: r$,
  isRequest: i$,
  isResponse: a$,
  isHeaders: o$,
  isUndefined: ma,
  isDate: KI,
  isFile: GI,
  isReactNativeBlob: YI,
  isReactNative: QI,
  isBlob: JI,
  isRegExp: k$,
  isFunction: Zt,
  isStream: ZI,
  isURLSearchParams: t$,
  isTypedArray: f$,
  isFileList: XI,
  forEach: Lo,
  merge: _h,
  extend: l$,
  trim: s$,
  stripBOM: c$,
  inherits: u$,
  toFlatObject: d$,
  kindOf: wl,
  kindOfTest: Ir,
  endsWith: m$,
  toArray: p$,
  forEachEntry: h$,
  matchAll: y$,
  isHTMLForm: g$,
  hasOwnProperty: nv,
  hasOwnProp: nv,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Ew,
  freezeMethods: b$,
  toObjectSet: _$,
  toCamelCase: v$,
  noop: x$,
  toFiniteNumber: S$,
  findKey: Iw,
  global: ji,
  isContextDefined: $w,
  isSpecCompliantForm: N$,
  toJSONObject: j$,
  isAsyncFn: w$,
  isThenable: C$,
  setImmediate: Tw,
  asap: F$,
  isIterable: I$
};
let bn = class Dw extends Error {
  static from(n, r, i, a, o, s) {
    const l = new Dw(n.message, r || n.code, i, a, o);
    return l.cause = n, l.name = n.name, n.status != null && l.status == null && (l.status = n.status), s && Object.assign(l, s), l;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, r, i, a, o) {
    super(n), Object.defineProperty(this, "message", {
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), i && (this.config = i), a && (this.request = a), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: Se.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
};
bn.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
bn.ERR_BAD_OPTION = "ERR_BAD_OPTION";
bn.ECONNABORTED = "ECONNABORTED";
bn.ETIMEDOUT = "ETIMEDOUT";
bn.ERR_NETWORK = "ERR_NETWORK";
bn.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
bn.ERR_DEPRECATED = "ERR_DEPRECATED";
bn.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
bn.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
bn.ERR_CANCELED = "ERR_CANCELED";
bn.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
bn.ERR_INVALID_URL = "ERR_INVALID_URL";
bn.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const $$ = null;
function xh(e) {
  return Se.isPlainObject(e) || Se.isArray(e);
}
function Ow(e) {
  return Se.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Xl(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = Ow(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function E$(e) {
  return Se.isArray(e) && !e.some(xh);
}
const T$ = Se.toFlatObject(Se, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Fl(e, n, r) {
  if (!Se.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = Se.toFlatObject(
    r,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(j, C) {
      return !Se.isUndefined(C[j]);
    }
  );
  const i = r.metaTokens, a = r.visitor || f, o = r.dots, s = r.indexes, l = r.Blob || typeof Blob < "u" && Blob, u = r.maxDepth === void 0 ? 100 : r.maxDepth, p = l && Se.isSpecCompliantForm(n);
  if (!Se.isFunction(a))
    throw new TypeError("visitor must be a function");
  function d(N) {
    if (N === null) return "";
    if (Se.isDate(N))
      return N.toISOString();
    if (Se.isBoolean(N))
      return N.toString();
    if (!p && Se.isBlob(N))
      throw new bn("Blob is not supported. Use a Buffer instead.");
    return Se.isArrayBuffer(N) || Se.isTypedArray(N) ? p && typeof Blob == "function" ? new Blob([N]) : Buffer.from(N) : N;
  }
  function f(N, j, C) {
    let g = N;
    if (Se.isReactNative(n) && Se.isReactNativeBlob(N))
      return n.append(Xl(C, j, o), d(N)), !1;
    if (N && !C && typeof N == "object") {
      if (Se.endsWith(j, "{}"))
        j = i ? j : j.slice(0, -2), N = JSON.stringify(N);
      else if (Se.isArray(N) && E$(N) || (Se.isFileList(N) || Se.endsWith(j, "[]")) && (g = Se.toArray(N)))
        return j = Ow(j), g.forEach(function(T, I) {
          !(Se.isUndefined(T) || T === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Xl([j], I, o) : s === null ? j : j + "[]",
            d(T)
          );
        }), !1;
    }
    return xh(N) ? !0 : (n.append(Xl(C, j, o), d(N)), !1);
  }
  const h = [], v = Object.assign(T$, {
    defaultVisitor: f,
    convertValue: d,
    isVisitable: xh
  });
  function F(N, j, C = 0) {
    if (!Se.isUndefined(N)) {
      if (C > u)
        throw new bn(
          "Object is too deeply nested (" + C + " levels). Max depth: " + u,
          bn.ERR_FORM_DATA_DEPTH_EXCEEDED
        );
      if (h.indexOf(N) !== -1)
        throw Error("Circular reference detected in " + j.join("."));
      h.push(N), Se.forEach(N, function(z, T) {
        (!(Se.isUndefined(z) || z === null) && a.call(n, z, Se.isString(T) ? T.trim() : T, j, v)) === !0 && F(z, j ? j.concat(T) : [T], C + 1);
      }), h.pop();
    }
  }
  if (!Se.isObject(e))
    throw new TypeError("data must be an object");
  return F(e), n;
}
function tv(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(i) {
    return n[i];
  });
}
function gy(e, n) {
  this._pairs = [], e && Fl(e, this, n);
}
const Rw = gy.prototype;
Rw.append = function(n, r) {
  this._pairs.push([n, r]);
};
Rw.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, tv);
  } : tv;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function D$(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Pw(e, n, r) {
  if (!n)
    return e;
  const i = r && r.encode || D$, a = Se.isFunction(r) ? {
    serialize: r
  } : r, o = a && a.serialize;
  let s;
  if (o ? s = o(n, a) : s = Se.isURLSearchParams(n) ? n.toString() : new gy(n, a).toString(i), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class rv {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    Se.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const vy = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, O$ = typeof URLSearchParams < "u" ? URLSearchParams : gy, R$ = typeof FormData < "u" ? FormData : null, P$ = typeof Blob < "u" ? Blob : null, A$ = {
  isBrowser: !0,
  classes: {
    URLSearchParams: O$,
    FormData: R$,
    Blob: P$
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, ky = typeof window < "u" && typeof document < "u", Sh = typeof navigator == "object" && navigator || void 0, L$ = ky && (!Sh || ["ReactNative", "NativeScript", "NS"].indexOf(Sh.product) < 0), V$ = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", z$ = ky && window.location.href || "http://localhost", U$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: ky,
  hasStandardBrowserEnv: L$,
  hasStandardBrowserWebWorkerEnv: V$,
  navigator: Sh,
  origin: z$
}, Symbol.toStringTag, { value: "Module" })), At = {
  ...U$,
  ...A$
};
function M$(e, n) {
  return Fl(e, new At.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return At.isNode && Se.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
function B$(e) {
  return Se.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function q$(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function Aw(e) {
  function n(r, i, a, o) {
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), u = o >= r.length;
    return s = !s && Se.isArray(a) ? a.length : s, u ? (Se.hasOwnProp(a, s) ? a[s] = Se.isArray(a[s]) ? a[s].concat(i) : [a[s], i] : a[s] = i, !l) : ((!a[s] || !Se.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && Se.isArray(a[s]) && (a[s] = q$(a[s])), !l);
  }
  if (Se.isFormData(e) && Se.isFunction(e.entries)) {
    const r = {};
    return Se.forEachEntry(e, (i, a) => {
      n(B$(i), a, r, 0);
    }), r;
  }
  return null;
}
const Bi = (e, n) => e != null && Se.hasOwnProp(e, n) ? e[n] : void 0;
function H$(e, n, r) {
  if (Se.isString(e))
    try {
      return (n || JSON.parse)(e), Se.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const Vo = {
  transitional: vy,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, r) {
      const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = Se.isObject(n);
      if (o && Se.isHTMLForm(n) && (n = new FormData(n)), Se.isFormData(n))
        return a ? JSON.stringify(Aw(n)) : n;
      if (Se.isArrayBuffer(n) || Se.isBuffer(n) || Se.isStream(n) || Se.isFile(n) || Se.isBlob(n) || Se.isReadableStream(n))
        return n;
      if (Se.isArrayBufferView(n))
        return n.buffer;
      if (Se.isURLSearchParams(n))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let l;
      if (o) {
        const u = Bi(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return M$(n, u).toString();
        if ((l = Se.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
          const p = Bi(this, "env"), d = p && p.FormData;
          return Fl(
            l ? { "files[]": n } : n,
            d && new d(),
            u
          );
        }
      }
      return o || a ? (r.setContentType("application/json", !1), H$(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const r = Bi(this, "transitional") || Vo.transitional, i = r && r.forcedJSONParsing, a = Bi(this, "responseType"), o = a === "json";
      if (Se.isResponse(n) || Se.isReadableStream(n))
        return n;
      if (n && Se.isString(n) && (i && !a || o)) {
        const l = !(r && r.silentJSONParsing) && o;
        try {
          return JSON.parse(n, Bi(this, "parseReviver"));
        } catch (u) {
          if (l)
            throw u.name === "SyntaxError" ? bn.from(u, bn.ERR_BAD_RESPONSE, this, null, Bi(this, "response")) : u;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: At.classes.FormData,
    Blob: At.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
Se.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Vo.headers[e] = {};
});
const W$ = Se.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), K$ = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && W$[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
}, iv = Symbol("internals"), G$ = /[^\x09\x20-\x7E\x80-\xFF]/g;
function Y$(e) {
  let n = 0, r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; r > n; ) {
    const i = e.charCodeAt(r - 1);
    if (i !== 9 && i !== 32)
      break;
    r -= 1;
  }
  return n === 0 && r === e.length ? e : e.slice(n, r);
}
function Ta(e) {
  return e && String(e).trim().toLowerCase();
}
function Q$(e) {
  return Y$(e.replace(G$, ""));
}
function Os(e) {
  return e === !1 || e == null ? e : Se.isArray(e) ? e.map(Os) : Q$(String(e));
}
function J$(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const X$ = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Zl(e, n, r, i, a) {
  if (Se.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!Se.isString(n)) {
    if (Se.isString(i))
      return n.indexOf(i) !== -1;
    if (Se.isRegExp(i))
      return i.test(n);
  }
}
function Z$(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function eE(e, n) {
  const r = Se.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let er = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, u, p) {
      const d = Ta(u);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const f = Se.findKey(a, d);
      (!f || a[f] === void 0 || p === !0 || p === void 0 && a[f] !== !1) && (a[f || u] = Os(l));
    }
    const s = (l, u) => Se.forEach(l, (p, d) => o(p, d, u));
    if (Se.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (Se.isString(n) && (n = n.trim()) && !X$(n))
      s(K$(n), r);
    else if (Se.isObject(n) && Se.isIterable(n)) {
      let l = {}, u, p;
      for (const d of n) {
        if (!Se.isArray(d))
          throw TypeError("Object iterator must return a key-value pair");
        l[p = d[0]] = (u = l[p]) ? Se.isArray(u) ? [...u, d[1]] : [u, d[1]] : d[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = Ta(n), n) {
      const i = Se.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return J$(a);
        if (Se.isFunction(r))
          return r.call(this, a, i);
        if (Se.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = Ta(n), n) {
      const i = Se.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || Zl(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = Ta(s), s) {
        const l = Se.findKey(i, s);
        l && (!r || Zl(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return Se.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || Zl(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return Se.forEach(this, (a, o) => {
      const s = Se.findKey(i, o);
      if (s) {
        r[s] = Os(a), delete r[o];
        return;
      }
      const l = n ? Z$(o) : String(o).trim();
      l !== o && delete r[o], r[l] = Os(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return Se.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && Se.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[iv] = this[iv] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = Ta(s);
      i[l] || (eE(a, s), i[l] = !0);
    }
    return Se.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
er.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
Se.reduceDescriptors(er.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
Se.freezeMethods(er);
function ec(e, n) {
  const r = this || Vo, i = n || r, a = er.from(i.headers);
  let o = i.data;
  return Se.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function Lw(e) {
  return !!(e && e.__CANCEL__);
}
let zo = class extends bn {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, r, i) {
    super(n ?? "canceled", bn.ERR_CANCELED, r, i), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function Vw(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(
    new bn(
      "Request failed with status code " + r.status,
      [bn.ERR_BAD_REQUEST, bn.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
      r.config,
      r.request,
      r
    )
  );
}
function nE(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function tE(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(u) {
    const p = Date.now(), d = i[o];
    s || (s = p), r[a] = u, i[a] = p;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), p - s < n)
      return;
    const v = d && p - d;
    return v ? Math.round(h * 1e3 / v) : void 0;
  };
}
function rE(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (p, d = Date.now()) => {
    r = d, a = null, o && (clearTimeout(o), o = null), e(...p);
  };
  return [(...p) => {
    const d = Date.now(), f = d - r;
    f >= i ? s(p, d) : (a = p, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const Xs = (e, n, r = 3) => {
  let i = 0;
  const a = tE(50, 250);
  return rE((o) => {
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, u = l != null ? Math.min(s, l) : s, p = Math.max(0, u - i), d = a(p);
    i = Math.max(i, u);
    const f = {
      loaded: u,
      total: l,
      progress: l ? u / l : void 0,
      bytes: p,
      rate: d || void 0,
      estimated: d && l ? (l - u) / d : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, av = (e, n) => {
  const r = e != null;
  return [
    (i) => n[0]({
      lengthComputable: r,
      total: e,
      loaded: i
    }),
    n[1]
  ];
}, ov = (e) => (...n) => Se.asap(() => e(...n)), iE = At.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, At.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(At.origin),
  At.navigator && /(msie|trident)/i.test(At.navigator.userAgent)
) : () => !0, aE = At.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o, s) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(n)}`];
      Se.isNumber(r) && l.push(`expires=${new Date(r).toUTCString()}`), Se.isString(i) && l.push(`path=${i}`), Se.isString(a) && l.push(`domain=${a}`), o === !0 && l.push("secure"), Se.isString(s) && l.push(`SameSite=${s}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return n ? decodeURIComponent(n[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function oE(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function sE(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function zw(e, n, r) {
  let i = !oE(n);
  return e && (i || r === !1) ? sE(e, n) : n;
}
const sv = (e) => e instanceof er ? { ...e } : e;
function Ri(e, n) {
  n = n || {};
  const r = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(r, "hasOwnProperty", {
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function i(p, d, f, h) {
    return Se.isPlainObject(p) && Se.isPlainObject(d) ? Se.merge.call({ caseless: h }, p, d) : Se.isPlainObject(d) ? Se.merge({}, d) : Se.isArray(d) ? d.slice() : d;
  }
  function a(p, d, f, h) {
    if (Se.isUndefined(d)) {
      if (!Se.isUndefined(p))
        return i(void 0, p, f, h);
    } else return i(p, d, f, h);
  }
  function o(p, d) {
    if (!Se.isUndefined(d))
      return i(void 0, d);
  }
  function s(p, d) {
    if (Se.isUndefined(d)) {
      if (!Se.isUndefined(p))
        return i(void 0, p);
    } else return i(void 0, d);
  }
  function l(p, d, f) {
    if (Se.hasOwnProp(n, f))
      return i(p, d);
    if (Se.hasOwnProp(e, f))
      return i(void 0, p);
  }
  const u = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    allowedSocketPaths: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (p, d, f) => a(sv(p), sv(d), f, !0)
  };
  return Se.forEach(Object.keys({ ...e, ...n }), function(d) {
    if (d === "__proto__" || d === "constructor" || d === "prototype") return;
    const f = Se.hasOwnProp(u, d) ? u[d] : a, h = Se.hasOwnProp(e, d) ? e[d] : void 0, v = Se.hasOwnProp(n, d) ? n[d] : void 0, F = f(h, v, d);
    Se.isUndefined(F) && f !== l || (r[d] = F);
  }), r;
}
const Uw = (e) => {
  const n = Ri({}, e), r = (h) => Se.hasOwnProp(n, h) ? n[h] : void 0, i = r("data");
  let a = r("withXSRFToken");
  const o = r("xsrfHeaderName"), s = r("xsrfCookieName");
  let l = r("headers");
  const u = r("auth"), p = r("baseURL"), d = r("allowAbsoluteUrls"), f = r("url");
  if (n.headers = l = er.from(l), n.url = Pw(
    zw(p, f, d),
    e.params,
    e.paramsSerializer
  ), u && l.set(
    "Authorization",
    "Basic " + btoa(
      (u.username || "") + ":" + (u.password ? unescape(encodeURIComponent(u.password)) : "")
    )
  ), Se.isFormData(i)) {
    if (At.hasStandardBrowserEnv || At.hasStandardBrowserWebWorkerEnv)
      l.setContentType(void 0);
    else if (Se.isFunction(i.getHeaders)) {
      const h = i.getHeaders(), v = ["content-type", "content-length"];
      Object.entries(h).forEach(([F, N]) => {
        v.includes(F.toLowerCase()) && l.set(F, N);
      });
    }
  }
  if (At.hasStandardBrowserEnv && (Se.isFunction(a) && (a = a(n)), a === !0 || a == null && iE(n.url))) {
    const v = o && s && aE.read(s);
    v && l.set(o, v);
  }
  return n;
}, lE = typeof XMLHttpRequest < "u", cE = lE && function(e) {
  return new Promise(function(r, i) {
    const a = Uw(e);
    let o = a.data;
    const s = er.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: u, onDownloadProgress: p } = a, d, f, h, v, F;
    function N() {
      v && v(), F && F(), a.cancelToken && a.cancelToken.unsubscribe(d), a.signal && a.signal.removeEventListener("abort", d);
    }
    let j = new XMLHttpRequest();
    j.open(a.method.toUpperCase(), a.url, !0), j.timeout = a.timeout;
    function C() {
      if (!j)
        return;
      const z = er.from(
        "getAllResponseHeaders" in j && j.getAllResponseHeaders()
      ), I = {
        data: !l || l === "text" || l === "json" ? j.responseText : j.response,
        status: j.status,
        statusText: j.statusText,
        headers: z,
        config: e,
        request: j
      };
      Vw(
        function(U) {
          r(U), N();
        },
        function(U) {
          i(U), N();
        },
        I
      ), j = null;
    }
    "onloadend" in j ? j.onloadend = C : j.onreadystatechange = function() {
      !j || j.readyState !== 4 || j.status === 0 && !(j.responseURL && j.responseURL.indexOf("file:") === 0) || setTimeout(C);
    }, j.onabort = function() {
      j && (i(new bn("Request aborted", bn.ECONNABORTED, e, j)), j = null);
    }, j.onerror = function(T) {
      const I = T && T.message ? T.message : "Network Error", D = new bn(I, bn.ERR_NETWORK, e, j);
      D.event = T || null, i(D), j = null;
    }, j.ontimeout = function() {
      let T = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const I = a.transitional || vy;
      a.timeoutErrorMessage && (T = a.timeoutErrorMessage), i(
        new bn(
          T,
          I.clarifyTimeoutError ? bn.ETIMEDOUT : bn.ECONNABORTED,
          e,
          j
        )
      ), j = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in j && Se.forEach(s.toJSON(), function(T, I) {
      j.setRequestHeader(I, T);
    }), Se.isUndefined(a.withCredentials) || (j.withCredentials = !!a.withCredentials), l && l !== "json" && (j.responseType = a.responseType), p && ([h, F] = Xs(p, !0), j.addEventListener("progress", h)), u && j.upload && ([f, v] = Xs(u), j.upload.addEventListener("progress", f), j.upload.addEventListener("loadend", v)), (a.cancelToken || a.signal) && (d = (z) => {
      j && (i(!z || z.type ? new zo(null, e, j) : z), j.abort(), j = null);
    }, a.cancelToken && a.cancelToken.subscribe(d), a.signal && (a.signal.aborted ? d() : a.signal.addEventListener("abort", d)));
    const g = nE(a.url);
    if (g && At.protocols.indexOf(g) === -1) {
      i(
        new bn(
          "Unsupported protocol " + g + ":",
          bn.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    j.send(o || null);
  });
}, uE = (e, n) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (n || r) {
    let i = new AbortController(), a;
    const o = function(p) {
      if (!a) {
        a = !0, l();
        const d = p instanceof Error ? p : this.reason;
        i.abort(
          d instanceof bn ? d : new zo(d instanceof Error ? d.message : d)
        );
      }
    };
    let s = n && setTimeout(() => {
      s = null, o(new bn(`timeout of ${n}ms exceeded`, bn.ETIMEDOUT));
    }, n);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((p) => {
        p.unsubscribe ? p.unsubscribe(o) : p.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((p) => p.addEventListener("abort", o));
    const { signal: u } = i;
    return u.unsubscribe = () => Se.asap(l), u;
  }
}, dE = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, mE = async function* (e, n) {
  for await (const r of pE(e))
    yield* dE(r, n);
}, pE = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, lv = (e, n, r, i) => {
  const a = mE(e, n);
  let o = 0, s, l = (u) => {
    s || (s = !0, i && i(u));
  };
  return new ReadableStream(
    {
      async pull(u) {
        try {
          const { done: p, value: d } = await a.next();
          if (p) {
            l(), u.close();
            return;
          }
          let f = d.byteLength;
          if (r) {
            let h = o += f;
            r(h);
          }
          u.enqueue(new Uint8Array(d));
        } catch (p) {
          throw l(p), p;
        }
      },
      cancel(u) {
        return l(u), a.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, cv = 64 * 1024, { isFunction: Xo } = Se, fE = (({ Request: e, Response: n }) => ({
  Request: e,
  Response: n
}))(Se.global), { ReadableStream: uv, TextEncoder: dv } = Se.global, mv = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, hE = (e) => {
  e = Se.merge.call(
    {
      skipUndefined: !0
    },
    fE,
    e
  );
  const { fetch: n, Request: r, Response: i } = e, a = n ? Xo(n) : typeof fetch == "function", o = Xo(r), s = Xo(i);
  if (!a)
    return !1;
  const l = a && Xo(uv), u = a && (typeof dv == "function" ? /* @__PURE__ */ ((F) => (N) => F.encode(N))(new dv()) : async (F) => new Uint8Array(await new r(F).arrayBuffer())), p = o && l && mv(() => {
    let F = !1;
    const N = new r(At.origin, {
      body: new uv(),
      method: "POST",
      get duplex() {
        return F = !0, "half";
      }
    }), j = N.headers.has("Content-Type");
    return N.body != null && N.body.cancel(), F && !j;
  }), d = s && l && mv(() => Se.isReadableStream(new i("").body)), f = {
    stream: d && ((F) => F.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((F) => {
    !f[F] && (f[F] = (N, j) => {
      let C = N && N[F];
      if (C)
        return C.call(N);
      throw new bn(
        `Response type '${F}' is not supported`,
        bn.ERR_NOT_SUPPORT,
        j
      );
    });
  });
  const h = async (F) => {
    if (F == null)
      return 0;
    if (Se.isBlob(F))
      return F.size;
    if (Se.isSpecCompliantForm(F))
      return (await new r(At.origin, {
        method: "POST",
        body: F
      }).arrayBuffer()).byteLength;
    if (Se.isArrayBufferView(F) || Se.isArrayBuffer(F))
      return F.byteLength;
    if (Se.isURLSearchParams(F) && (F = F + ""), Se.isString(F))
      return (await u(F)).byteLength;
  }, v = async (F, N) => {
    const j = Se.toFiniteNumber(F.getContentLength());
    return j ?? h(N);
  };
  return async (F) => {
    let {
      url: N,
      method: j,
      data: C,
      signal: g,
      cancelToken: z,
      timeout: T,
      onDownloadProgress: I,
      onUploadProgress: D,
      responseType: U,
      headers: Q,
      withCredentials: X = "same-origin",
      fetchOptions: re
    } = Uw(F), G = n || fetch;
    U = U ? (U + "").toLowerCase() : "text";
    let q = uE(
      [g, z && z.toAbortSignal()],
      T
    ), R = null;
    const B = q && q.unsubscribe && (() => {
      q.unsubscribe();
    });
    let ee;
    try {
      if (D && p && j !== "get" && j !== "head" && (ee = await v(Q, C)) !== 0) {
        let xe = new r(N, {
          method: "POST",
          body: C,
          duplex: "half"
        }), $e;
        if (Se.isFormData(C) && ($e = xe.headers.get("content-type")) && Q.setContentType($e), xe.body) {
          const [Y, qe] = av(
            ee,
            Xs(ov(D))
          );
          C = lv(xe.body, cv, Y, qe);
        }
      }
      Se.isString(X) || (X = X ? "include" : "omit");
      const be = o && "credentials" in r.prototype;
      if (Se.isFormData(C)) {
        const xe = Q.getContentType();
        xe && /^multipart\/form-data/i.test(xe) && !/boundary=/i.test(xe) && Q.delete("content-type");
      }
      const fe = {
        ...re,
        signal: q,
        method: j.toUpperCase(),
        headers: Q.normalize().toJSON(),
        body: C,
        duplex: "half",
        credentials: be ? X : void 0
      };
      R = o && new r(N, fe);
      let de = await (o ? G(R, re) : G(N, fe));
      const ge = d && (U === "stream" || U === "response");
      if (d && (I || ge && B)) {
        const xe = {};
        ["status", "statusText", "headers"].forEach((Me) => {
          xe[Me] = de[Me];
        });
        const $e = Se.toFiniteNumber(de.headers.get("content-length")), [Y, qe] = I && av(
          $e,
          Xs(ov(I), !0)
        ) || [];
        de = new i(
          lv(de.body, cv, Y, () => {
            qe && qe(), B && B();
          }),
          xe
        );
      }
      U = U || "text";
      let K = await f[Se.findKey(f, U) || "text"](
        de,
        F
      );
      return !ge && B && B(), await new Promise((xe, $e) => {
        Vw(xe, $e, {
          data: K,
          headers: er.from(de.headers),
          status: de.status,
          statusText: de.statusText,
          config: F,
          request: R
        });
      });
    } catch (be) {
      throw B && B(), be && be.name === "TypeError" && /Load failed|fetch/i.test(be.message) ? Object.assign(
        new bn(
          "Network Error",
          bn.ERR_NETWORK,
          F,
          R,
          be && be.response
        ),
        {
          cause: be.cause || be
        }
      ) : bn.from(be, be && be.code, F, R, be && be.response);
    }
  };
}, yE = /* @__PURE__ */ new Map(), Mw = (e) => {
  let n = e && e.env || {};
  const { fetch: r, Request: i, Response: a } = n, o = [i, a, r];
  let s = o.length, l = s, u, p, d = yE;
  for (; l--; )
    u = o[l], p = d.get(u), p === void 0 && d.set(u, p = l ? /* @__PURE__ */ new Map() : hE(n)), d = p;
  return p;
};
Mw();
const by = {
  http: $$,
  xhr: cE,
  fetch: {
    get: Mw
  }
};
Se.forEach(by, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const pv = (e) => `- ${e}`, gE = (e) => Se.isFunction(e) || e === null || e === !1;
function vE(e, n) {
  e = Se.isArray(e) ? e : [e];
  const { length: r } = e;
  let i, a;
  const o = {};
  for (let s = 0; s < r; s++) {
    i = e[s];
    let l;
    if (a = i, !gE(i) && (a = by[(l = String(i)).toLowerCase()], a === void 0))
      throw new bn(`Unknown adapter '${l}'`);
    if (a && (Se.isFunction(a) || (a = a.get(n))))
      break;
    o[l || "#" + s] = a;
  }
  if (!a) {
    const s = Object.entries(o).map(
      ([u, p]) => `adapter ${u} ` + (p === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = r ? s.length > 1 ? `since :
` + s.map(pv).join(`
`) : " " + pv(s[0]) : "as no adapter specified";
    throw new bn(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const Bw = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: vE,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: by
};
function nc(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new zo(null, e);
}
function fv(e) {
  return nc(e), e.headers = er.from(e.headers), e.data = ec.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Bw.getAdapter(e.adapter || Vo.adapter, e)(e).then(
    function(i) {
      return nc(e), i.data = ec.call(e, e.transformResponse, i), i.headers = er.from(i.headers), i;
    },
    function(i) {
      return Lw(i) || (nc(e), i && i.response && (i.response.data = ec.call(
        e,
        e.transformResponse,
        i.response
      ), i.response.headers = er.from(i.response.headers))), Promise.reject(i);
    }
  );
}
const qw = "1.15.2", Il = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  Il[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const hv = {};
Il.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + qw + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new bn(
        a(s, " has been removed" + (r ? " in " + r : "")),
        bn.ERR_DEPRECATED
      );
    return r && !hv[s] && (hv[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
Il.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function kE(e, n, r) {
  if (typeof e != "object")
    throw new bn("options must be an object", bn.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : void 0;
    if (s) {
      const l = e[o], u = l === void 0 || s(l, o, e);
      if (u !== !0)
        throw new bn(
          "option " + o + " must be " + u,
          bn.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new bn("Unknown option " + o, bn.ERR_BAD_OPTION);
  }
}
const Rs = {
  assertOptions: kE,
  validators: Il
}, ur = Rs.validators;
let $i = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new rv(),
      response: new rv()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = (() => {
          if (!a.stack)
            return "";
          const s = a.stack.indexOf(`
`);
          return s === -1 ? "" : a.stack.slice(s + 1);
        })();
        try {
          if (!i.stack)
            i.stack = o;
          else if (o) {
            const s = o.indexOf(`
`), l = s === -1 ? -1 : o.indexOf(`
`, s + 1), u = l === -1 ? "" : o.slice(l + 1);
            String(i.stack).endsWith(u) || (i.stack += `
` + o);
          }
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = Ri(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && Rs.assertOptions(
      i,
      {
        silentJSONParsing: ur.transitional(ur.boolean),
        forcedJSONParsing: ur.transitional(ur.boolean),
        clarifyTimeoutError: ur.transitional(ur.boolean),
        legacyInterceptorReqResOrdering: ur.transitional(ur.boolean)
      },
      !1
    ), a != null && (Se.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : Rs.assertOptions(
      a,
      {
        encode: ur.function,
        serialize: ur.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Rs.assertOptions(
      r,
      {
        baseUrl: ur.spelling("baseURL"),
        withXsrfToken: ur.spelling("withXSRFToken")
      },
      !0
    ), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && Se.merge(o.common, o[r.method]);
    o && Se.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (F) => {
      delete o[F];
    }), r.headers = er.concat(s, o);
    const l = [];
    let u = !0;
    this.interceptors.request.forEach(function(N) {
      if (typeof N.runWhen == "function" && N.runWhen(r) === !1)
        return;
      u = u && N.synchronous;
      const j = r.transitional || vy;
      j && j.legacyInterceptorReqResOrdering ? l.unshift(N.fulfilled, N.rejected) : l.push(N.fulfilled, N.rejected);
    });
    const p = [];
    this.interceptors.response.forEach(function(N) {
      p.push(N.fulfilled, N.rejected);
    });
    let d, f = 0, h;
    if (!u) {
      const F = [fv.bind(this), void 0];
      for (F.unshift(...l), F.push(...p), h = F.length, d = Promise.resolve(r); f < h; )
        d = d.then(F[f++], F[f++]);
      return d;
    }
    h = l.length;
    let v = r;
    for (; f < h; ) {
      const F = l[f++], N = l[f++];
      try {
        v = F(v);
      } catch (j) {
        N.call(this, j);
        break;
      }
    }
    try {
      d = fv.call(this, v);
    } catch (F) {
      return Promise.reject(F);
    }
    for (f = 0, h = p.length; f < h; )
      d = d.then(p[f++], p[f++]);
    return d;
  }
  getUri(n) {
    n = Ri(this.defaults, n);
    const r = zw(n.baseURL, n.url, n.allowAbsoluteUrls);
    return Pw(r, n.params, n.paramsSerializer);
  }
};
Se.forEach(["delete", "get", "head", "options"], function(n) {
  $i.prototype[n] = function(r, i) {
    return this.request(
      Ri(i || {}, {
        method: n,
        url: r,
        data: (i || {}).data
      })
    );
  };
});
Se.forEach(["post", "put", "patch"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(
        Ri(l || {}, {
          method: n,
          headers: i ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: s
        })
      );
    };
  }
  $i.prototype[n] = r(), $i.prototype[n + "Form"] = r(!0);
});
let bE = class Hw {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new zo(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new Hw(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function _E(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function xE(e) {
  return Se.isObject(e) && e.isAxiosError === !0;
}
const Nh = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(Nh).forEach(([e, n]) => {
  Nh[n] = e;
});
function Ww(e) {
  const n = new $i(e), r = jw($i.prototype.request, n);
  return Se.extend(r, $i.prototype, n, { allOwnKeys: !0 }), Se.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return Ww(Ri(e, a));
  }, r;
}
const yt = Ww(Vo);
yt.Axios = $i;
yt.CanceledError = zo;
yt.CancelToken = bE;
yt.isCancel = Lw;
yt.VERSION = qw;
yt.toFormData = Fl;
yt.AxiosError = bn;
yt.Cancel = yt.CanceledError;
yt.all = function(n) {
  return Promise.all(n);
};
yt.spread = _E;
yt.isAxiosError = xE;
yt.mergeConfig = Ri;
yt.AxiosHeaders = er;
yt.formToJSON = (e) => Aw(Se.isHTMLForm(e) ? new FormData(e) : e);
yt.getAdapter = Bw.getAdapter;
yt.HttpStatusCode = Nh;
yt.default = yt;
const {
  Axios: m8,
  AxiosError: p8,
  CanceledError: f8,
  isCancel: h8,
  CancelToken: y8,
  VERSION: g8,
  all: v8,
  Cancel: k8,
  isAxiosError: SE,
  spread: b8,
  toFormData: _8,
  AxiosHeaders: x8,
  HttpStatusCode: S8,
  formToJSON: N8,
  getAdapter: j8,
  mergeConfig: w8
} = yt;
class NE {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const yv = new NE();
function jE(e, n) {
  return gv(e), gv(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function gv(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const wE = Object.prototype.toString;
function CE(e, n) {
  return wE.call(e) === `[object ${n}]`;
}
function FE(e) {
  return CE(e, "Object");
}
function IE(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const vo = "8.36.0", Jr = globalThis;
function _y(e, n, r) {
  const i = r || Jr, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[vo] = a[vo] || {};
  return o[e] || (o[e] = n());
}
const Kw = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, $E = "Sentry Logger ", vv = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], kv = {};
function Gw(e) {
  if (!("console" in Jr))
    return e();
  const n = Jr.console, r = {}, i = Object.keys(kv);
  i.forEach((a) => {
    const o = kv[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function EE() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return Kw ? vv.forEach((r) => {
    n[r] = (...i) => {
      e && Gw(() => {
        Jr.console[r](`${$E}[${r}]:`, ...i);
      });
    };
  }) : vv.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const Ps = _y("logger", EE);
function TE(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    Kw && Ps.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const Yw = 1e3;
function xy() {
  return Date.now() / Yw;
}
function DE() {
  const { performance: e } = Jr;
  if (!e || !e.now)
    return xy;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / Yw;
}
const OE = DE();
(() => {
  const { performance: e } = Jr;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, u = typeof s == "number" ? Math.abs(s + r - i) : n, p = u < n;
  return o || p ? a <= u ? e.timeOrigin : s : i;
})();
function oa() {
  const e = Jr, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function bv() {
  return {
    traceId: oa(),
    spanId: oa().substring(16)
  };
}
function Sy() {
  return Ny(Jr), Jr;
}
function Ny(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || vo, n[vo] = n[vo] || {};
}
function RE(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || OE(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : oa()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const jh = "_sentrySpan";
function _v(e, n) {
  n ? TE(e, jh, n) : delete e[jh];
}
function xv(e) {
  return e[jh];
}
const PE = 100;
class jy {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = bv();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new jy();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, _v(n, xv(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && RE(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof pa ? [r.getScopeData(), r.getRequestSession()] : FE(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: u, level: p, fingerprint: d = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...u }, l && Object.keys(l).length && (this._user = l), p && (this._level = p), d.length && (this._fingerprint = d), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, _v(this, void 0), this._attachments = [], this._propagationContext = bv(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : PE;
    if (i <= 0)
      return this;
    const a = {
      timestamp: xy(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: xv(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : oa();
    if (!this._client)
      return Ps.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : oa();
    if (!this._client)
      return Ps.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : oa();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (Ps.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const pa = jy;
function AE() {
  return _y("defaultCurrentScope", () => new pa());
}
function LE() {
  return _y("defaultIsolationScope", () => new pa());
}
class VE {
  constructor(n, r) {
    let i;
    n ? i = n : i = new pa();
    let a;
    r ? a = r : a = new pa(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return IE(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function fa() {
  const e = Sy(), n = Ny(e);
  return n.stack = n.stack || new VE(AE(), LE());
}
function zE(e) {
  return fa().withScope(e);
}
function UE(e, n) {
  const r = fa();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function Sv(e) {
  return fa().withScope(() => e(fa().getIsolationScope()));
}
function ME() {
  return {
    withIsolationScope: Sv,
    withScope: zE,
    withSetScope: UE,
    withSetIsolationScope: (e, n) => Sv(n),
    getCurrentScope: () => fa().getScope(),
    getIsolationScope: () => fa().getIsolationScope()
  };
}
function Qw(e) {
  const n = Ny(e);
  return n.acs ? n.acs : ME();
}
function wy() {
  const e = Sy();
  return Qw(e).getCurrentScope();
}
function Jw() {
  const e = Sy();
  return Qw(e).getIsolationScope();
}
function BE() {
  return wy().getClient();
}
function qE(e) {
  if (e)
    return HE(e) ? { captureContext: e } : KE(e) ? {
      captureContext: e
    } : e;
}
function HE(e) {
  return e instanceof pa || typeof e == "function";
}
const WE = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function KE(e) {
  return Object.keys(e).some((n) => WE.includes(n));
}
function Nv(e, n) {
  return wy().captureException(e, qE(n));
}
function GE(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return wy().captureMessage(e, r, i);
}
function YE(e, n) {
  Jw().setContext(e, n);
}
const QE = 100;
function xi(e, n) {
  const r = BE(), i = Jw();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = QE } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: xy(), ...e }, u = a ? Gw(() => a(l, n)) : l;
  u !== null && (r.emit && r.emit("beforeAddBreadcrumb", u, n), i.addBreadcrumb(u, o));
}
var To;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(To || (To = {}));
function sa(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const JE = Eo.backendDomain ? {
  "backend-domain": Eo.backendDomain
} : void 0;
function As() {
  const e = new URLSearchParams({
    noToken: "true",
    ...JE
  }).toString();
  document.location.href = `${Eo.url.logIn}?${e}`;
}
const tc = "authData", rc = 30, XE = 600, ic = 5;
class ZE {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= ic || this.clientServerTimeDiff <= -ic ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + XE, a = sa(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > ic) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(tc, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(tc), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(tc);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - rc;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = sa(n), i = r.exp - rc;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - rc - this.estimatedServerTime()) * 1e3;
  }
}
const Ft = new ZE();
async function eT(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? sa(o).exp : "None", l = await $l.getAuthData({ localStorageOnly: !0 }), u = Math.floor(Date.now() / 1e3), p = l?.access_token, d = l?.refresh_token, f = p ? sa(p).exp : "None", h = d ? sa(d).exp : "None", v = typeof s == "number" ? u - s : "Unknown", F = typeof f == "number" ? u - f : "Unknown", N = typeof h == "number" ? u - h : "Unknown", j = e.response.headers["x-dixa-rid"];
      YE("Expires", {
        currentTimestamp: u,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: v,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: F,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: N,
        xDixaRid: j,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    GE("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: To.Platform,
        domain: n
      }
    });
  }
}
const ac = /* @__PURE__ */ new Map(), nT = 3;
function tT(e) {
  e.interceptors.response.use((n) => (ac.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case wh.Unauthorized:
          if (!$l.isRefreshTokenExpired() && n.config) {
            xi({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = ac.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= nT)
              return ac.set(n.config.url, i + 1), e(n.config);
          }
          eT(n), console.error("401 unauthorized interceptor"), As();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const Xw = yt.create();
tT(Xw);
const Br = console.log;
async function jv(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class rT extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function iT(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const aT = 5;
class oT {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      Ft.setAuthData(r);
    else {
      const i = Ft.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new rT("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = Ft.getAccessToken();
    if (!n)
      return {};
    const r = sa(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return Ft.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = Ft.getAuthData();
    return r ? Ft.isAccessTokenExpired() ? (xi({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && Ft.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return Ft.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return Ft.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return Ft.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = Ft.getAuthData();
    return n ? Ft.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!yv.isElectron())
      return !0;
    const n = await yv.getVersion();
    return jE(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = aT) {
    try {
      return await Xw.post(`${Eo.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Br("AUTH", "Network connection offline - waiting..."), xi({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await jv(5);
    n && (Br("AUTH", "Network connection restored"), xi({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = iT(this.retryCount);
    return Br("AUTH", `Retrying in ${i} seconds`), await jv(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if (Ft.isRefreshTokenExpired(r))
      return Br("AUTH", "Refresh token expired"), xi({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), Ft.removeAuthData(), As(), null;
    if (SE(n)) {
      if (n.message === "timeout exceeded")
        return Br("AUTH", "Timeout exceeded"), xi({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Br("AUTH", "Network error"), xi({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Br("AUTH", "Refresh token invalid (401)"), Ft.removeAuthData(), As(), null;
      Nv(n, {
        level: "error",
        tags: {
          team: To.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Br("AUTH", "Retries exhausted, logging out"), Nv(n, {
      level: "error",
      tags: {
        team: To.Platform,
        errorSource: "authManager.refresh"
      }
    }), Ft.removeAuthData(), As(), null) : (Br("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return Ft.accessTokenExpiresInMs();
  }
}
const $l = new oT();
var wh;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(wh || (wh = {}));
const sT = new hy((e, n) => new xw((r) => {
  $l.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), lT = new hy(
  (e, n) => new xw((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    $l.getAuthData().then((u) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...JF(Eo.url.partnerIntegrations) && u?.access_token && XF(u.access_token)
      }
    }), n(e).subscribe(r))).catch((u) => r.error(u));
  })
), cT = new AbortController(), Zw = (e) => new II({
  queryDeduplication: !1,
  cache: new $I(),
  link: hy.from([
    sT,
    lT,
    EI({
      uri: `${e}/graphql`,
      fetch: PI,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: cT.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), uT = ({
  configuration: e,
  children: n
}) => {
  const r = Kn(
    () => Zw(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ Be.jsx(TI, { client: r, children: n });
};
function dT() {
  try {
    return DI(), !0;
  } catch {
    return !1;
  }
}
const mT = ({
  configuration: e,
  children: n
}) => dT() ? n : /* @__PURE__ */ Be.jsx(uT, { configuration: e, children: n }), pT = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ Be.jsx(OI, { children: (o) => /* @__PURE__ */ Be.jsx(
  ZF,
  {
    value: {
      useMutation: rI(e, n),
      useQuery: tI(e, n),
      useLazyQuery: nI(e, n),
      executeQuery: eI(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), e1 = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ Be.jsx(mT, { configuration: r, children: s ? /* @__PURE__ */ Be.jsx(
    pT,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, fT = "_unmatchedHeader_qcj19_1", hT = {
  unmatchedHeader: fT
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_1wjfs_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1wjfs_53{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1wjfs_63{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1wjfs_63:last-child:not(:only-child){border-bottom:none}._collapsible_1wjfs_72{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_1wjfs_72:hover,._collapsibleIsOpen_1wjfs_80{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_1wjfs_83{cursor:pointer}._collapsibleIconTrue_1wjfs_86{color:var(--dixa-color-green-500)}._collapsibleIconFalse_1wjfs_89{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var oc = { exports: {} }, Da = {}, wv;
function yT() {
  if (wv) return Da;
  wv = 1;
  var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Da.Fragment = r, Da.jsx = s, Da.jsxs = s, Da;
}
var Zo = {}, Cv;
function gT() {
  return Cv || (Cv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[N];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        z("error", t, m);
      }
    }
    function z(t, c, m) {
      {
        var y = C.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var P = m.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var T = !1, I = !1, D = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || U || t === v || T || I || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function q(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return q(c) + ".Consumer";
          case s:
            var m = t;
            return q(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return R(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, be, fe, de, ge, K, xe, $e;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          be = console.log, fe = console.info, de = console.warn, ge = console.error, K = console.group, xe = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: be
            }),
            info: B({}, t, {
              value: fe
            }),
            warn: B({}, t, {
              value: de
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: K
            }),
            groupCollapsed: B({}, t, {
              value: xe
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = C.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var ze = !1, Re;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new on();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var m = Re.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      ze = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Le.current, Le.current = null, qe();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var S = te.stack.split(`
`), ne = y.stack.split(`
`), H = S.length - 1, x = ne.length - 1; H >= 1 && x >= 0 && S[H] !== ne[x]; )
            x--;
          for (; H >= 1 && x >= 0; H--, x--)
            if (S[H] !== ne[x]) {
              if (H !== 1 || x !== 1)
                do
                  if (H--, x--, x < 0 || S[H] !== ne[x]) {
                    var Z = `
` + S[H].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (H >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Le.current = P, Me(), Error.prepareStackTrace = $;
      }
      var ue = t ? t.displayName || t.name : "", _e = ue ? De(ue) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Qe(t, c, m) {
      return Ee(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Xe(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case d:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Qe(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return se(P($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, je = {}, Ve = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function dn(t, c, m, y, $) {
      {
        var P = Function.call.bind(ye);
        for (var w in t)
          if (P(t, w)) {
            var S = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + m + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[w](c, w, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              S = H;
            }
            S && !(S instanceof Error) && (Oe($), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, w, typeof S), Oe(null)), S instanceof Error && !(S.message in je) && (je[S.message] = !0, Oe($), g("Failed %s type: %s", m, S.message), Oe(null));
          }
      }
    }
    var E = Array.isArray;
    function _(t) {
      return E(t);
    }
    function O(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function W(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function L(t) {
      if (W(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", O(t)), J(t);
    }
    var M = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Ze(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function sn(t, c) {
      {
        var m = function() {
          he || (he = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function hn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, m, y, $, P, w) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function _n(t, c, m, y, $) {
      {
        var P, w = {}, S = null, ne = null;
        m !== void 0 && (L(m), S = "" + m), mn(c) && (L(c.key), S = "" + c.key), nn(c) && (ne = c.ref, Ze(c));
        for (P in c)
          ye.call(c, P) && !ie.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var H = t.defaultProps;
          for (P in H)
            w[P] === void 0 && (w[P] = H[P]);
        }
        if (S || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && sn(w, x), ne && hn(w, x);
        }
        return pn(t, S, ne, $, y, M.current, w);
      }
    }
    var Je = C.ReactCurrentOwner, Nn = C.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(m);
      } else
        Nn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (Je.current) {
          var t = R(Je.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Mn(t) {
      return "";
    }
    var jn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = kn(c);
        if (jn[m])
          return;
        jn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Je.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ae(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ae(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            cn(y) && gn(y, c);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              cn(w.value) && gn(w.value, c);
        }
      }
    }
    function zn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = R(c);
          dn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var $ = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function An(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ae(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var xn = {};
    function Sn(t, c, m, y, $, P) {
      {
        var w = re(t);
        if (!w) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = Mn();
          ne ? S += ne : S += vn();
          var H;
          t === null ? H = "null" : _(t) ? H = "array" : t !== void 0 && t.$$typeof === n ? (H = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : H = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, S);
        }
        var x = _n(t, c, m, $, P);
        if (x == null)
          return x;
        if (w) {
          var Z = c.children;
          if (Z !== void 0)
            if (y)
              if (_(Z)) {
                for (var ue = 0; ue < Z.length; ue++)
                  wn(Z[ue], t);
                Object.freeze && Object.freeze(Z);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = R(t), te = Object.keys(c).filter(function($n) {
            return $n !== "key";
          }), Ke = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? An(x) : zn(x), x;
      }
    }
    function Bn(t, c, m) {
      return Sn(t, c, m, !0);
    }
    function On(t, c, m) {
      return Sn(t, c, m, !1);
    }
    var Rn = On, Un = Bn;
    Zo.Fragment = i, Zo.jsx = Rn, Zo.jsxs = Un;
  })()), Zo;
}
var Fv;
function vT() {
  return Fv || (Fv = 1, process.env.NODE_ENV === "production" ? oc.exports = yT() : oc.exports = gT()), oc.exports;
}
var oe = vT();
const kT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, bT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, _T = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": kT,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": bT
};
function n1(e) {
  return _T[e] ?? {};
}
const xT = n1(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), ST = n1(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), NT = "_copyIcon_1wjfs_48", jT = "_list_1wjfs_53", wT = "_listItem_1wjfs_63", CT = "_collapsible_1wjfs_72", FT = "_collapsibleIsOpen_1wjfs_80", IT = "_collapsibleHeader_1wjfs_83", $T = "_collapsibleIconTrue_1wjfs_86", ET = "_collapsibleIconFalse_1wjfs_89", Ln = {
  copyIcon: NT,
  list: jT,
  listItem: wT,
  collapsible: CT,
  collapsibleIsOpen: FT,
  collapsibleHeader: IT,
  collapsibleIconTrue: $T,
  collapsibleIconFalse: ET
}, TT = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = le(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: u,
    last_used: p
  } = e;
  return /* @__PURE__ */ oe.jsxs(
    b,
    {
      className: it(Ln.collapsible, {
        [Ln.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ oe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ln.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ oe.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ oe.jsxs(We, { className: Ln.list, children: [
          /* @__PURE__ */ oe.jsx(We.Text, { variant: "dense", className: Ln.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ oe.jsx(We.Text, { variant: "dense", className: Ln.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ oe.jsx(We.Text, { variant: "dense", className: Ln.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ oe.jsx(We.Text, { variant: "dense", className: Ln.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Hn(u).format(St) })
          ] }) }),
          /* @__PURE__ */ oe.jsx(We.Text, { variant: "dense", className: Ln.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Hn(p).format(St) })
          ] }) })
        ] })
      ]
    }
  );
}, DT = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ oe.jsx(Vn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ oe.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ oe.jsx(TT, { app: r, openByDefault: i === 0 }, i))
  ] });
}, OT = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ oe.jsx(oe.Fragment, { children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ oe.jsx(We, { className: Ln.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ oe.jsx(
      We.Text,
      {
        variant: "dense",
        className: Ln.listItem,
        children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: i }),
          Oi(a)
        ] })
      },
      o
    )) })
  ] }) });
}, RT = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ oe.jsx(oe.Fragment, { children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ oe.jsx(We, { className: Ln.list, children: r.map((a, o) => /* @__PURE__ */ oe.jsx(
      We.Text,
      {
        variant: "dense",
        className: Ln.listItem,
        children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ oe.jsx(
            Ge,
            {
              content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ oe.jsx(b, { children: `First ${Hn(a?.first).format(
                  St
                )}` }),
                /* @__PURE__ */ oe.jsx(b, { children: `Last ${Hn(a?.last).format(
                  St
                )}` })
              ] }),
              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, Zs = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const u = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${u}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${u}.` : `Opted in: The user has explicitly confirmed they want to receive ${u}.`;
  };
  return /* @__PURE__ */ oe.jsx(Ge, { content: n ? null : l(), children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(pe, { size: 14, name: o(), color: s() }) }) });
}, PT = "_wrapper_1xucg_1", AT = "_externalLink_1xucg_7", sc = {
  wrapper: PT,
  externalLink: AT
}, LT = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Gt(), { isCopied: i, copy: a } = Gt(), { isCopied: o, copy: s } = Gt(), { isCopied: l, copy: u } = Gt(), { isCopied: p, copy: d } = Gt();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: v,
    last_name: F,
    home_city: N,
    country: j,
    email: C,
    phone: g,
    dob: z,
    created_at: T,
    email_subscribe: I,
    push_subscribe: D
  } = e, U = 14, Q = `${v || ""} ${F || ""}`.trim() || "A customer has no name", X = `${N ? `${N} /` : ""} ${j || ""}`.trim(), re = z ? Hn(z).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ oe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ oe.jsxs(b, { className: sc.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: sc.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-2", children: Q }),
          re && /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    T && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: Hn(T).format(St) })
    ] }),
    X && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "map-pin" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: X })
      ] }),
      /* @__PURE__ */ oe.jsx(Ge, { content: "Copy location", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        pe,
        {
          size: U,
          name: o ? "done" : "copy",
          onClick: () => s(X),
          className: Ln.copyIcon
        }
      ) }) })
    ] }),
    C && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "mail" }),
        /* @__PURE__ */ oe.jsx("span", { className: sc.externalLink, children: C })
      ] }),
      /* @__PURE__ */ oe.jsx(Ge, { content: "Copy email", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        pe,
        {
          size: U,
          name: n ? "done" : "copy",
          onClick: () => r(C),
          className: Ln.copyIcon
        }
      ) }) })
    ] }),
    g && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "phone" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: g })
      ] }),
      /* @__PURE__ */ oe.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        pe,
        {
          size: U,
          name: i ? "done" : "copy",
          onClick: () => a(g),
          className: Ln.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "user" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ oe.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ oe.jsx(Ge, { content: "Copy Braze ID", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        pe,
        {
          size: U,
          name: l ? "done" : "copy",
          onClick: () => u(h),
          className: Ln.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "tag" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ oe.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ oe.jsx(Ge, { content: "Copy External ID", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        pe,
        {
          size: U,
          name: p ? "done" : "copy",
          onClick: () => d(f),
          className: Ln.copyIcon
        }
      ) }) })
    ] }),
    I && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "sync" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ oe.jsx(Zs, { state: I })
    ] }),
    D && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "bell" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ oe.jsx(Zs, { isPush: !0, state: D })
    ] })
  ] }) });
}, VT = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = le(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: u,
    idfa: p,
    idfv: d,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ oe.jsxs(
    b,
    {
      className: it(Ln.collapsible, {
        [Ln.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ oe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ln.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ oe.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ oe.jsxs(We, { className: Ln.list, children: [
          /* @__PURE__ */ oe.jsx(We.Text, { variant: "dense", className: Ln.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ oe.jsx(We.Text, { variant: "dense", className: Ln.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ oe.jsx(We.Text, { variant: "dense", className: Ln.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ oe.jsx(
              pe,
              {
                size: a,
                className: it({
                  [Ln.collapsibleIconTrue]: u,
                  [Ln.collapsibleIconFalse]: !u
                }),
                name: u ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ge, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ oe.jsx(We.Text, { variant: "dense", className: Ln.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: d })
              ]
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(Ge, { content: "For iOS", children: /* @__PURE__ */ oe.jsx(We.Text, { variant: "dense", className: Ln.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: p })
              ]
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(We.Text, { variant: "dense", className: Ln.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ oe.jsx(We.Text, { variant: "dense", className: Ln.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, zT = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ oe.jsx(Vn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ oe.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ oe.jsx(VT, { device: r, openByDefault: i === 0 }, i))
  ] });
}, Oa = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, es = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = Cn(), { useMutation: a } = yn(), [o, s] = le(!1), [l] = a(
    ST,
    {
      onCompleted: (p) => {
        p?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), u = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: Oa[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ oe.jsx(Ge, { content: Oa[n].tooltipContent, children: /* @__PURE__ */ oe.jsx(
    Yn,
    {
      variant: "secondary",
      color: Oa[n].color,
      isLoading: o,
      onClick: () => u(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ oe.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(
          Zs,
          {
            noTooltip: !0,
            state: Oa[n].parameter
          }
        ),
        Oa[n].label
      ] })
    }
  ) });
}, UT = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ oe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ oe.jsx(We, { className: Ln.list, children: /* @__PURE__ */ oe.jsx(We.Text, { variant: "dense", className: Ln.listItem, children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: 14, name: "sync" }),
        /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ oe.jsx(Zs, { state: a })
    ] }) }) }),
    /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
        /* @__PURE__ */ oe.jsx(
          es,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ oe.jsx(
          es,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ oe.jsx(
        es,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ oe.jsx(
        es,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, MT = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ oe.jsx(oe.Fragment, { children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ oe.jsx(We, { className: Ln.list, children: r.map((a, o) => /* @__PURE__ */ oe.jsx(
      We.Text,
      {
        variant: "dense",
        className: Ln.listItem,
        children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ oe.jsx(
            Ge,
            {
              content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ oe.jsx(b, { children: `First ${Hn(a?.first).format(
                  St
                )}` }),
                /* @__PURE__ */ oe.jsx(b, { children: `Last ${Hn(a?.last).format(
                  St
                )}` })
              ] }),
              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, BT = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = Cn(), { useMutation: i } = yn(), [a, o] = le(), [s, l] = le(!1), [u, p] = le(!1), d = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, v = n.updateEmailSubscriptionState ?? !1, F = n.displayCustomAttributes ?? !1, N = n.displayCustomEvents ?? !1, j = n.displayPuchases ?? !1, C = n.displayDevices ?? !1, g = n.displayApps ?? !1, z = !h && !v && !F && !N && !j, [T, { error: I }] = i(
    xT,
    {
      onError: () => {
      },
      onCompleted: (U) => {
        const Q = U?.Braze?.exportUserDetails?.users?.[0];
        Q ? (o(Q), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), D = async () => {
    d || f ? await T({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...d ? { email_address: d } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (Ye(() => {
    async function U() {
      p(!0), await D();
    }
    U().finally(() => p(!1));
  }, [d, f]), I) {
    const U = I.graphQLErrors;
    return kl({ errors: U }) ? /* @__PURE__ */ oe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : bl({ errors: U }) ? /* @__PURE__ */ oe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ oe.jsx(In, { error: I });
  }
  return u ? /* @__PURE__ */ oe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ oe.jsx(fn, {}) }) : z ? /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ oe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ oe.jsx(LT, { customerDetails: a }),
        v && !!a && /* @__PURE__ */ oe.jsx(
          UT,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await D()
          }
        ),
        F && !!a && /* @__PURE__ */ oe.jsx(OT, { customerDetails: a }),
        N && !!a && /* @__PURE__ */ oe.jsx(RT, { customerDetails: a }),
        j && !!a && /* @__PURE__ */ oe.jsx(MT, { customerDetails: a }),
        C && !!a && /* @__PURE__ */ oe.jsx(zT, { devices: a?.devices }),
        g && !!a && /* @__PURE__ */ oe.jsx(DT, { apps: a?.apps })
      ]
    }
  );
}, qT = [
  {
    key: "apiHostName",
    label: "API endpoint",
    placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => cy(e)
  },
  {
    key: "brazeApiKey",
    label: "API key",
    placeholder: "Insert your API key",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayPuchases",
    label: "Display a list of purchases",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  }
];
function HT() {
  var e = Ii(!1), n = lt(function() {
    return e.current;
  }, []);
  return Ye(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var WT = function(e) {
  e === void 0 && (e = {});
  var n = le(e), r = n[0], i = n[1], a = lt(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, KT = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, Iv = function(e) {
  return kI(KT, e);
}, lc, $v;
function GT() {
  return $v || ($v = 1, lc = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), lc;
}
var cc, Ev;
function YT() {
  if (Ev) return cc;
  Ev = 1;
  var e = GT(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, u, p, d, f, h, v = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      p = e(), d = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(N) {
        if (N.stopPropagation(), s.format)
          if (N.preventDefault(), typeof N.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var j = n[s.format] || n.default;
            window.clipboardData.setData(j, o);
          } else
            N.clipboardData.clearData(), N.clipboardData.setData(s.format, o);
        s.onCopy && (N.preventDefault(), s.onCopy(N.clipboardData));
      }), document.body.appendChild(h), d.selectNodeContents(h), f.addRange(d);
      var F = document.execCommand("copy");
      if (!F)
        throw new Error("copy command was unsuccessful");
      v = !0;
    } catch (N) {
      l && console.error("unable to copy using execCommand: ", N), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), v = !0;
      } catch (j) {
        l && console.error("unable to copy using clipboardData: ", j), l && console.error("falling back to prompt"), u = i("message" in s ? s.message : r), window.prompt(u, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(d) : f.removeAllRanges()), h && document.body.removeChild(h), p();
    }
    return v;
  }
  return cc = a, cc;
}
var QT = YT();
const JT = /* @__PURE__ */ yy(QT);
var t1 = function() {
  var e = HT(), n = WT({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = lt(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var u = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(u), i({
            value: o,
            error: u,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var u = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(u), i({
            value: o,
            error: u,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = JT(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (p) {
        i({
          value: l,
          error: p,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function XT(e, n) {
  n === void 0 && (n = 0);
  var r = Ii(!1), i = Ii(), a = Ii(e), o = lt(function() {
    return r.current;
  }, []), s = lt(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = lt(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return Ye(function() {
    a.current = e;
  }, [e]), Ye(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function Pi(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = XT(e, n), a = i[0], o = i[1], s = i[2];
  return Ye(s, r), [a, o];
}
var ZT = function(e) {
  Ye(e, []);
}, eD = function(e, n) {
  var r = Ii(function() {
  });
  Ye(function() {
    r.current = e;
  }), Ye(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, nD = function(e) {
  e === void 0 && (e = {});
  var n = le(e), r = n[0], i = n[1], a = Kn(function() {
    return {
      set: function(s, l) {
        i(function(u) {
          var p;
          return Jl(Jl({}, u), (p = {}, p[s] = l, p));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var u = l, p = s;
          u[p];
          var d = AI(u, [typeof p == "symbol" ? p : p + ""]);
          return d;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = Jl({ get: lt(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, tD = function(e) {
  var n = Ii(e);
  n.current = e, ZT(function() {
    return function() {
      return n.current();
    };
  });
}, Uo = (e) => e.type === "checkbox", wi = (e) => e instanceof Date, Ht = (e) => e == null;
const r1 = (e) => typeof e == "object";
var pt = (e) => !Ht(e) && !Array.isArray(e) && r1(e) && !wi(e), i1 = (e) => pt(e) && e.target ? Uo(e.target) ? e.target.checked : e.target.value : e, rD = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, a1 = (e, n) => e.has(rD(n)), iD = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return pt(n) && n.hasOwnProperty("isPrototypeOf");
}, Cy = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Et(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Cy && (e instanceof Blob || i)) && (r || pt(e)))
    if (n = r ? [] : {}, !r && !iD(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Et(e[a]));
  else
    return e;
  return n;
}
var El = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ct = (e) => e === void 0, tn = (e, n, r) => {
  if (!n || !pt(e))
    return r;
  const i = El(n.split(/[,[\].]+?/)).reduce((a, o) => Ht(a) ? a : a[o], e);
  return ct(i) || i === e ? ct(e[n]) ? r : e[n] : i;
}, or = (e) => typeof e == "boolean", Fy = (e) => /^\w*$/.test(e), o1 = (e) => El(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Jn = (e, n, r) => {
  let i = -1;
  const a = Fy(n) ? [n] : o1(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let u = r;
    if (i !== s) {
      const p = e[l];
      u = pt(p) || Array.isArray(p) ? p : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = u, e = e[l];
  }
};
const el = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, br = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, qr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, s1 = Ie.createContext(null), zr = () => Ie.useContext(s1), Iy = (e) => {
  const { children: n, ...r } = e;
  return Ie.createElement(s1.Provider, { value: r }, n);
};
var l1 = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== br.all && (n._proxyFormState[s] = !i || br.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function aD(e) {
  const n = zr(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Ie.useState(r._formState), u = Ie.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), p = Ie.useRef(a);
  return p.current = a, Ie.useEffect(() => r._subscribe({
    name: p.current,
    formState: u.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...r._formState,
        ...d
      });
    }
  }), [r, i, o]), Ie.useEffect(() => {
    u.current.isValid && r._setValid(!0);
  }, [r]), Ie.useMemo(() => l1(s, r, u.current, !1), [s, r]);
}
var Rr = (e) => typeof e == "string", c1 = (e, n, r, i, a) => Rr(e) ? (i && n.watch.add(e), tn(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), tn(r, o))) : (i && (n.watchAll = !0), r);
function ko(e) {
  const n = zr(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Ie.useRef(i), u = Ie.useRef(a);
  l.current = i, Ie.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && d(c1(l.current, r._names, f.values || r._formValues, !1, u.current))
  }), [r, o, s]);
  const [p, d] = Ie.useState(r._getWatch(i, a));
  return Ie.useEffect(() => r._removeUnmounted()), p;
}
function $y(e) {
  const n = zr(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = a1(a._names.array, r), l = ko({
    control: a,
    name: r,
    defaultValue: tn(a._formValues, r, tn(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), u = aD({
    control: a,
    name: r,
    exact: !0
  }), p = Ie.useRef(e), d = Ie.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...or(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Ie.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!tn(u.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!tn(u.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!tn(u.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!tn(u.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => tn(u.errors, r)
    }
  }), [u, r]), h = Ie.useCallback((j) => d.current.onChange({
    target: {
      value: i1(j),
      name: r
    },
    type: el.CHANGE
  }), [r]), v = Ie.useCallback(() => d.current.onBlur({
    target: {
      value: tn(a._formValues, r),
      name: r
    },
    type: el.BLUR
  }), [r, a._formValues]), F = Ie.useCallback((j) => {
    const C = tn(a._fields, r);
    C && j && (C._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (g) => j.setCustomValidity(g),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), N = Ie.useMemo(() => ({
    name: r,
    value: l,
    ...or(i) || u.disabled ? { disabled: u.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: F
  }), [r, i, u.disabled, h, v, F, l]);
  return Ie.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...p.current.rules,
      ...or(p.current.disabled) ? { disabled: p.current.disabled } : {}
    });
    const C = (g, z) => {
      const T = tn(a._fields, g);
      T && T._f && (T._f.mount = z);
    };
    if (C(r, !0), j) {
      const g = Et(tn(a._options.defaultValues, r));
      Jn(a._defaultValues, r, g), ct(tn(a._formValues, r)) && Jn(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : C(r, !1);
    };
  }, [r, a, s, o]), Ie.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Ie.useMemo(() => ({
    field: N,
    formState: u,
    fieldState: f
  }), [N, u, f]);
}
const Ot = (e) => e.render($y(e));
var oD = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, bo = (e) => Array.isArray(e) ? e : [e], Tv = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Ch = (e) => Ht(e) || !r1(e);
function di(e, n) {
  if (Ch(e) || Ch(n))
    return e === n;
  if (wi(e) && wi(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (wi(o) && wi(s) || pt(o) && pt(s) || Array.isArray(o) && Array.isArray(s) ? !di(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Mt = (e) => pt(e) && !Object.keys(e).length, Ey = (e) => e.type === "file", _r = (e) => typeof e == "function", nl = (e) => {
  if (!Cy)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, u1 = (e) => e.type === "select-multiple", Ty = (e) => e.type === "radio", sD = (e) => Ty(e) || Uo(e), uc = (e) => nl(e) && e.isConnected;
function lD(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = ct(e) ? i++ : e[n[i++]];
  return e;
}
function cD(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ct(e[n]))
      return !1;
  return !0;
}
function bt(e, n) {
  const r = Array.isArray(n) ? n : Fy(n) ? [n] : o1(n), i = r.length === 1 ? e : lD(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (pt(i) && Mt(i) || Array.isArray(i) && cD(i)) && bt(e, r.slice(0, -1)), e;
}
var d1 = (e) => {
  for (const n in e)
    if (_r(e[n]))
      return !0;
  return !1;
};
function tl(e, n = {}) {
  const r = Array.isArray(e);
  if (pt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || pt(e[i]) && !d1(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, tl(e[i], n[i])) : Ht(e[i]) || (n[i] = !0);
  return n;
}
function m1(e, n, r) {
  const i = Array.isArray(e);
  if (pt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || pt(e[a]) && !d1(e[a]) ? ct(n) || Ch(r[a]) ? r[a] = Array.isArray(e[a]) ? tl(e[a], []) : { ...tl(e[a]) } : m1(e[a], Ht(n) ? {} : n[a], r[a]) : r[a] = !di(e[a], n[a]);
  return r;
}
var Ra = (e, n) => m1(e, n, tl(n));
const Dv = {
  value: !1,
  isValid: !1
}, Ov = { value: !0, isValid: !0 };
var p1 = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ct(e[0].attributes.value) ? ct(e[0].value) || e[0].value === "" ? Ov : { value: e[0].value, isValid: !0 } : Ov
    ) : Dv;
  }
  return Dv;
}, f1 = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => ct(e) ? e : n ? e === "" ? NaN : e && +e : r && Rr(e) ? new Date(e) : i ? i(e) : e;
const Rv = {
  isValid: !1,
  value: null
};
var h1 = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Rv) : Rv;
function Pv(e) {
  const n = e.ref;
  return Ey(n) ? n.files : Ty(n) ? h1(e.refs).value : u1(n) ? [...n.selectedOptions].map(({ value: r }) => r) : Uo(n) ? p1(e.refs).value : f1(ct(n.value) ? e.ref.value : n.value, e);
}
var uD = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = tn(n, o);
    s && Jn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, rl = (e) => e instanceof RegExp, Pa = (e) => ct(e) ? e : rl(e) ? e.source : pt(e) ? rl(e.value) ? e.value.source : e.value : e, Av = (e) => ({
  isOnSubmit: !e || e === br.onSubmit,
  isOnBlur: e === br.onBlur,
  isOnChange: e === br.onChange,
  isOnAll: e === br.all,
  isOnTouch: e === br.onTouched
});
const Lv = "AsyncFunction";
var dD = (e) => !!e && !!e.validate && !!(_r(e.validate) && e.validate.constructor.name === Lv || pt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Lv)), mD = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Vv = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const _o = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = tn(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (_o(l, n))
          break;
      } else if (pt(l) && _o(l, n))
        break;
    }
  }
};
function zv(e, n, r) {
  const i = tn(e, r);
  if (i || Fy(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = tn(n, o), l = tn(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var pD = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Mt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || br.all));
}, fD = (e, n, r) => !e || !n || e === n || bo(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), hD = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, yD = (e, n) => !El(tn(e, n)).length && bt(e, n), gD = (e, n, r) => {
  const i = bo(tn(e, r));
  return Jn(i, "root", n[r]), Jn(e, r, i), e;
}, Ls = (e) => Rr(e);
function Uv(e, n, r = "validate") {
  if (Ls(e) || Array.isArray(e) && e.every(Ls) || or(e) && !e)
    return {
      type: r,
      message: Ls(e) ? e : "",
      ref: n
    };
}
var qi = (e) => pt(e) && !rl(e) ? e : {
  value: e,
  message: ""
}, Mv = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: u, maxLength: p, minLength: d, min: f, max: h, pattern: v, validate: F, name: N, valueAsNumber: j, mount: C } = e._f, g = tn(r, N);
  if (!C || n.has(N))
    return {};
  const z = l ? l[0] : s, T = (q) => {
    a && z.reportValidity && (z.setCustomValidity(or(q) ? "" : q || ""), z.reportValidity());
  }, I = {}, D = Ty(s), U = Uo(s), Q = D || U, X = (j || Ey(s)) && ct(s.value) && ct(g) || nl(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, re = oD.bind(null, N, i, I), G = (q, R, B, ee = qr.maxLength, be = qr.minLength) => {
    const fe = q ? R : B;
    I[N] = {
      type: q ? ee : be,
      message: fe,
      ref: s,
      ...re(q ? ee : be, fe)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : u && (!Q && (X || Ht(g)) || or(g) && !g || U && !p1(l).isValid || D && !h1(l).isValid)) {
    const { value: q, message: R } = Ls(u) ? { value: !!u, message: u } : qi(u);
    if (q && (I[N] = {
      type: qr.required,
      message: R,
      ref: z,
      ...re(qr.required, R)
    }, !i))
      return T(R), I;
  }
  if (!X && (!Ht(f) || !Ht(h))) {
    let q, R;
    const B = qi(h), ee = qi(f);
    if (!Ht(g) && !isNaN(g)) {
      const be = s.valueAsNumber || g && +g;
      Ht(B.value) || (q = be > B.value), Ht(ee.value) || (R = be < ee.value);
    } else {
      const be = s.valueAsDate || new Date(g), fe = (K) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + K), de = s.type == "time", ge = s.type == "week";
      Rr(B.value) && g && (q = de ? fe(g) > fe(B.value) : ge ? g > B.value : be > new Date(B.value)), Rr(ee.value) && g && (R = de ? fe(g) < fe(ee.value) : ge ? g < ee.value : be < new Date(ee.value));
    }
    if ((q || R) && (G(!!q, B.message, ee.message, qr.max, qr.min), !i))
      return T(I[N].message), I;
  }
  if ((p || d) && !X && (Rr(g) || o && Array.isArray(g))) {
    const q = qi(p), R = qi(d), B = !Ht(q.value) && g.length > +q.value, ee = !Ht(R.value) && g.length < +R.value;
    if ((B || ee) && (G(B, q.message, R.message), !i))
      return T(I[N].message), I;
  }
  if (v && !X && Rr(g)) {
    const { value: q, message: R } = qi(v);
    if (rl(q) && !g.match(q) && (I[N] = {
      type: qr.pattern,
      message: R,
      ref: s,
      ...re(qr.pattern, R)
    }, !i))
      return T(R), I;
  }
  if (F) {
    if (_r(F)) {
      const q = await F(g, r), R = Uv(q, z);
      if (R && (I[N] = {
        ...R,
        ...re(qr.validate, R.message)
      }, !i))
        return T(R.message), I;
    } else if (pt(F)) {
      let q = {};
      for (const R in F) {
        if (!Mt(q) && !i)
          break;
        const B = Uv(await F[R](g, r), z, R);
        B && (q = {
          ...B,
          ...re(R, B.message)
        }, T(B.message), i && (I[N] = q));
      }
      if (!Mt(q) && (I[N] = {
        ref: z,
        ...q
      }, !i))
        return I;
    }
  }
  return T(!0), I;
};
const vD = {
  mode: br.onSubmit,
  reValidateMode: br.onChange,
  shouldFocusError: !0
};
function kD(e = {}) {
  let n = {
    ...vD,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: _r(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = pt(n.defaultValues) || pt(n.values) ? Et(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Et(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, p = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...d
  };
  const h = {
    array: Tv(),
    state: Tv()
  }, v = Av(n.mode), F = Av(n.reValidateMode), N = n.criteriaMode === br.all, j = (_) => (O) => {
    clearTimeout(p), p = setTimeout(_, O);
  }, C = async (_) => {
    if (!n.disabled && (d.isValid || f.isValid || _)) {
      const O = n.resolver ? Mt((await X()).errors) : await G(i, !0);
      O !== r.isValid && h.state.next({
        isValid: O
      });
    }
  }, g = (_, O) => {
    !n.disabled && (d.isValidating || d.validatingFields || f.isValidating || f.validatingFields) && ((_ || Array.from(l.mount)).forEach((W) => {
      W && (O ? Jn(r.validatingFields, W, O) : bt(r.validatingFields, W));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Mt(r.validatingFields)
    }));
  }, z = (_, O = [], W, J, L = !0, M = !0) => {
    if (J && W && !n.disabled) {
      if (s.action = !0, M && Array.isArray(tn(i, _))) {
        const ie = W(tn(i, _), J.argA, J.argB);
        L && Jn(i, _, ie);
      }
      if (M && Array.isArray(tn(r.errors, _))) {
        const ie = W(tn(r.errors, _), J.argA, J.argB);
        L && Jn(r.errors, _, ie), yD(r.errors, _);
      }
      if ((d.touchedFields || f.touchedFields) && M && Array.isArray(tn(r.touchedFields, _))) {
        const ie = W(tn(r.touchedFields, _), J.argA, J.argB);
        L && Jn(r.touchedFields, _, ie);
      }
      (d.dirtyFields || f.dirtyFields) && (r.dirtyFields = Ra(a, o)), h.state.next({
        name: _,
        isDirty: R(_, O),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Jn(o, _, O);
  }, T = (_, O) => {
    Jn(r.errors, _, O), h.state.next({
      errors: r.errors
    });
  }, I = (_) => {
    r.errors = _, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (_, O, W, J) => {
    const L = tn(i, _);
    if (L) {
      const M = tn(o, _, ct(W) ? tn(a, _) : W);
      ct(M) || J && J.defaultChecked || O ? Jn(o, _, O ? M : Pv(L._f)) : be(_, M), s.mount && C();
    }
  }, U = (_, O, W, J, L) => {
    let M = !1, ie = !1;
    const he = {
      name: _
    };
    if (!n.disabled) {
      if (!W || J) {
        (d.isDirty || f.isDirty) && (ie = r.isDirty, r.isDirty = he.isDirty = R(), M = ie !== he.isDirty);
        const Ne = di(tn(a, _), O);
        ie = !!tn(r.dirtyFields, _), Ne ? bt(r.dirtyFields, _) : Jn(r.dirtyFields, _, !0), he.dirtyFields = r.dirtyFields, M = M || (d.dirtyFields || f.dirtyFields) && ie !== !Ne;
      }
      if (W) {
        const Ne = tn(r.touchedFields, _);
        Ne || (Jn(r.touchedFields, _, W), he.touchedFields = r.touchedFields, M = M || (d.touchedFields || f.touchedFields) && Ne !== W);
      }
      M && L && h.state.next(he);
    }
    return M ? he : {};
  }, Q = (_, O, W, J) => {
    const L = tn(r.errors, _), M = (d.isValid || f.isValid) && or(O) && r.isValid !== O;
    if (n.delayError && W ? (u = j(() => T(_, W)), u(n.delayError)) : (clearTimeout(p), u = null, W ? Jn(r.errors, _, W) : bt(r.errors, _)), (W ? !di(L, W) : L) || !Mt(J) || M) {
      const ie = {
        ...J,
        ...M && or(O) ? { isValid: O } : {},
        errors: r.errors,
        name: _
      };
      r = {
        ...r,
        ...ie
      }, h.state.next(ie);
    }
  }, X = async (_) => {
    g(_, !0);
    const O = await n.resolver(o, n.context, uD(_ || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(_), O;
  }, re = async (_) => {
    const { errors: O } = await X(_);
    if (_)
      for (const W of _) {
        const J = tn(O, W);
        J ? Jn(r.errors, W, J) : bt(r.errors, W);
      }
    else
      r.errors = O;
    return O;
  }, G = async (_, O, W = {
    valid: !0
  }) => {
    for (const J in _) {
      const L = _[J];
      if (L) {
        const { _f: M, ...ie } = L;
        if (M) {
          const he = l.array.has(M.name), Ne = L._f && dD(L._f);
          Ne && d.validatingFields && g([J], !0);
          const nn = await Mv(L, l.disabled, o, N, n.shouldUseNativeValidation && !O, he);
          if (Ne && d.validatingFields && g([J]), nn[M.name] && (W.valid = !1, O))
            break;
          !O && (tn(nn, M.name) ? he ? gD(r.errors, nn, M.name) : Jn(r.errors, M.name, nn[M.name]) : bt(r.errors, M.name));
        }
        !Mt(ie) && await G(ie, O, W);
      }
    }
    return W.valid;
  }, q = () => {
    for (const _ of l.unMount) {
      const O = tn(i, _);
      O && (O._f.refs ? O._f.refs.every((W) => !uc(W)) : !uc(O._f.ref)) && ze(_);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (_, O) => !n.disabled && (_ && O && Jn(o, _, O), !di($e(), a)), B = (_, O, W) => c1(_, l, {
    ...s.mount ? o : ct(O) ? a : Rr(_) ? { [_]: O } : O
  }, W, O), ee = (_) => El(tn(s.mount ? o : a, _, n.shouldUnregister ? tn(a, _, []) : [])), be = (_, O, W = {}) => {
    const J = tn(i, _);
    let L = O;
    if (J) {
      const M = J._f;
      M && (!M.disabled && Jn(o, _, f1(O, M)), L = nl(M.ref) && Ht(O) ? "" : O, u1(M.ref) ? [...M.ref.options].forEach((ie) => ie.selected = L.includes(ie.value)) : M.refs ? Uo(M.ref) ? M.refs.length > 1 ? M.refs.forEach((ie) => (!ie.defaultChecked || !ie.disabled) && (ie.checked = Array.isArray(L) ? !!L.find((he) => he === ie.value) : L === ie.value)) : M.refs[0] && (M.refs[0].checked = !!L) : M.refs.forEach((ie) => ie.checked = ie.value === L) : Ey(M.ref) ? M.ref.value = "" : (M.ref.value = L, M.ref.type || h.state.next({
        name: _,
        values: Et(o)
      })));
    }
    (W.shouldDirty || W.shouldTouch) && U(_, L, W.shouldTouch, W.shouldDirty, !0), W.shouldValidate && xe(_);
  }, fe = (_, O, W) => {
    for (const J in O) {
      const L = O[J], M = `${_}.${J}`, ie = tn(i, M);
      (l.array.has(_) || pt(L) || ie && !ie._f) && !wi(L) ? fe(M, L, W) : be(M, L, W);
    }
  }, de = (_, O, W = {}) => {
    const J = tn(i, _), L = l.array.has(_), M = Et(O);
    Jn(o, _, M), L ? (h.array.next({
      name: _,
      values: Et(o)
    }), (d.isDirty || d.dirtyFields || f.isDirty || f.dirtyFields) && W.shouldDirty && h.state.next({
      name: _,
      dirtyFields: Ra(a, o),
      isDirty: R(_, M)
    })) : J && !J._f && !Ht(M) ? fe(_, M, W) : be(_, M, W), Vv(_, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? _ : void 0,
      values: Et(o)
    });
  }, ge = async (_) => {
    s.mount = !0;
    const O = _.target;
    let W = O.name, J = !0;
    const L = tn(i, W), M = (ie) => {
      J = Number.isNaN(ie) || wi(ie) && isNaN(ie.getTime()) || di(ie, tn(o, W, ie));
    };
    if (L) {
      let ie, he;
      const Ne = O.type ? Pv(L._f) : i1(_), nn = _.type === el.BLUR || _.type === el.FOCUS_OUT, mn = !mD(L._f) && !n.resolver && !tn(r.errors, W) && !L._f.deps || hD(nn, tn(r.touchedFields, W), r.isSubmitted, F, v), Ze = Vv(W, l, nn);
      Jn(o, W, Ne), nn ? (L._f.onBlur && L._f.onBlur(_), u && u(0)) : L._f.onChange && L._f.onChange(_);
      const sn = U(W, Ne, nn), hn = !Mt(sn) || Ze;
      if (!nn && h.state.next({
        name: W,
        type: _.type,
        values: Et(o)
      }), mn)
        return (d.isValid || f.isValid) && (n.mode === "onBlur" ? nn && C() : nn || C()), hn && h.state.next({ name: W, ...Ze ? {} : sn });
      if (!nn && Ze && h.state.next({ ...r }), n.resolver) {
        const { errors: pn } = await X([W]);
        if (M(Ne), J) {
          const _n = zv(r.errors, i, W), Je = zv(pn, i, _n.name || W);
          ie = Je.error, W = Je.name, he = Mt(pn);
        }
      } else
        g([W], !0), ie = (await Mv(L, l.disabled, o, N, n.shouldUseNativeValidation))[W], g([W]), M(Ne), J && (ie ? he = !1 : (d.isValid || f.isValid) && (he = await G(i, !0)));
      J && (L._f.deps && xe(L._f.deps), Q(W, he, ie, sn));
    }
  }, K = (_, O) => {
    if (tn(r.errors, O) && _.focus)
      return _.focus(), 1;
  }, xe = async (_, O = {}) => {
    let W, J;
    const L = bo(_);
    if (n.resolver) {
      const M = await re(ct(_) ? _ : L);
      W = Mt(M), J = _ ? !L.some((ie) => tn(M, ie)) : W;
    } else _ ? (J = (await Promise.all(L.map(async (M) => {
      const ie = tn(i, M);
      return await G(ie && ie._f ? { [M]: ie } : ie);
    }))).every(Boolean), !(!J && !r.isValid) && C()) : J = W = await G(i);
    return h.state.next({
      ...!Rr(_) || (d.isValid || f.isValid) && W !== r.isValid ? {} : { name: _ },
      ...n.resolver || !_ ? { isValid: W } : {},
      errors: r.errors
    }), O.shouldFocus && !J && _o(i, K, _ ? L : l.mount), J;
  }, $e = (_) => {
    const O = {
      ...s.mount ? o : a
    };
    return ct(_) ? O : Rr(_) ? tn(O, _) : _.map((W) => tn(O, W));
  }, Y = (_, O) => ({
    invalid: !!tn((O || r).errors, _),
    isDirty: !!tn((O || r).dirtyFields, _),
    error: tn((O || r).errors, _),
    isValidating: !!tn(r.validatingFields, _),
    isTouched: !!tn((O || r).touchedFields, _)
  }), qe = (_) => {
    _ && bo(_).forEach((O) => bt(r.errors, O)), h.state.next({
      errors: _ ? r.errors : {}
    });
  }, Me = (_, O, W) => {
    const J = (tn(i, _, { _f: {} })._f || {}).ref, L = tn(r.errors, _) || {}, { ref: M, message: ie, type: he, ...Ne } = L;
    Jn(r.errors, _, {
      ...Ne,
      ...O,
      ref: J
    }), h.state.next({
      name: _,
      errors: r.errors,
      isValid: !1
    }), W && W.shouldFocus && J && J.focus && J.focus();
  }, Le = (_, O) => _r(_) ? h.state.subscribe({
    next: (W) => _(B(void 0, O), W)
  }) : B(_, O, !0), Ue = (_) => h.state.subscribe({
    next: (O) => {
      fD(_.name, O.name, _.exact) && pD(O, _.formState || d, Oe, _.reRenderRoot) && _.callback({
        values: { ...o },
        ...r,
        ...O
      });
    }
  }).unsubscribe, De = (_) => (s.mount = !0, f = {
    ...f,
    ..._.formState
  }, Ue({
    ..._,
    formState: f
  })), ze = (_, O = {}) => {
    for (const W of _ ? bo(_) : l.mount)
      l.mount.delete(W), l.array.delete(W), O.keepValue || (bt(i, W), bt(o, W)), !O.keepError && bt(r.errors, W), !O.keepDirty && bt(r.dirtyFields, W), !O.keepTouched && bt(r.touchedFields, W), !O.keepIsValidating && bt(r.validatingFields, W), !n.shouldUnregister && !O.keepDefaultValue && bt(a, W);
    h.state.next({
      values: Et(o)
    }), h.state.next({
      ...r,
      ...O.keepDirty ? { isDirty: R() } : {}
    }), !O.keepIsValid && C();
  }, Re = ({ disabled: _, name: O }) => {
    (or(_) && s.mount || _ || l.disabled.has(O)) && (_ ? l.disabled.add(O) : l.disabled.delete(O));
  }, on = (_, O = {}) => {
    let W = tn(i, _);
    const J = or(O.disabled) || or(n.disabled);
    return Jn(i, _, {
      ...W || {},
      _f: {
        ...W && W._f ? W._f : { ref: { name: _ } },
        name: _,
        mount: !0,
        ...O
      }
    }), l.mount.add(_), W ? Re({
      disabled: or(O.disabled) ? O.disabled : n.disabled,
      name: _
    }) : D(_, !0, O.value), {
      ...J ? { disabled: O.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!O.required,
        min: Pa(O.min),
        max: Pa(O.max),
        minLength: Pa(O.minLength),
        maxLength: Pa(O.maxLength),
        pattern: Pa(O.pattern)
      } : {},
      name: _,
      onChange: ge,
      onBlur: ge,
      ref: (L) => {
        if (L) {
          on(_, O), W = tn(i, _);
          const M = ct(L.value) && L.querySelectorAll && L.querySelectorAll("input,select,textarea")[0] || L, ie = sD(M), he = W._f.refs || [];
          if (ie ? he.find((Ne) => Ne === M) : M === W._f.ref)
            return;
          Jn(i, _, {
            _f: {
              ...W._f,
              ...ie ? {
                refs: [
                  ...he.filter(uc),
                  M,
                  ...Array.isArray(tn(a, _)) ? [{}] : []
                ],
                ref: { type: M.type, name: _ }
              } : { ref: M }
            }
          }), D(_, !1, void 0, M);
        } else
          W = tn(i, _, {}), W._f && (W._f.mount = !1), (n.shouldUnregister || O.shouldUnregister) && !(a1(l.array, _) && s.action) && l.unMount.add(_);
      }
    };
  }, Ee = () => n.shouldFocusError && _o(i, K, l.mount), Qe = (_) => {
    or(_) && (h.state.next({ disabled: _ }), _o(i, (O, W) => {
      const J = tn(i, W);
      J && (O.disabled = J._f.disabled || _, Array.isArray(J._f.refs) && J._f.refs.forEach((L) => {
        L.disabled = J._f.disabled || _;
      }));
    }, 0, !1));
  }, Xe = (_, O) => async (W) => {
    let J;
    W && (W.preventDefault && W.preventDefault(), W.persist && W.persist());
    let L = Et(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: M, values: ie } = await X();
      r.errors = M, L = ie;
    } else
      await G(i);
    if (l.disabled.size)
      for (const M of l.disabled)
        Jn(L, M, void 0);
    if (bt(r.errors, "root"), Mt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await _(L, W);
      } catch (M) {
        J = M;
      }
    } else
      O && await O({ ...r.errors }, W), Ee(), setTimeout(Ee);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Mt(r.errors) && !J,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), J)
      throw J;
  }, se = (_, O = {}) => {
    tn(i, _) && (ct(O.defaultValue) ? de(_, Et(tn(a, _))) : (de(_, O.defaultValue), Jn(a, _, Et(O.defaultValue))), O.keepTouched || bt(r.touchedFields, _), O.keepDirty || (bt(r.dirtyFields, _), r.isDirty = O.defaultValue ? R(_, Et(tn(a, _))) : R()), O.keepError || (bt(r.errors, _), d.isValid && C()), h.state.next({ ...r }));
  }, ye = (_, O = {}) => {
    const W = _ ? Et(_) : a, J = Et(W), L = Mt(_), M = L ? a : J;
    if (O.keepDefaultValues || (a = W), !O.keepValues) {
      if (O.keepDirtyValues) {
        const ie = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Ra(a, o))
        ]);
        for (const he of Array.from(ie))
          tn(r.dirtyFields, he) ? Jn(M, he, tn(o, he)) : de(he, tn(M, he));
      } else {
        if (Cy && ct(_))
          for (const ie of l.mount) {
            const he = tn(i, ie);
            if (he && he._f) {
              const Ne = Array.isArray(he._f.refs) ? he._f.refs[0] : he._f.ref;
              if (nl(Ne)) {
                const nn = Ne.closest("form");
                if (nn) {
                  nn.reset();
                  break;
                }
              }
            }
          }
        for (const ie of l.mount)
          de(ie, tn(M, ie));
      }
      o = Et(M), h.array.next({
        values: { ...M }
      }), h.state.next({
        values: { ...M }
      });
    }
    l = {
      mount: O.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!O.keepIsValid || !!O.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: O.keepSubmitCount ? r.submitCount : 0,
      isDirty: L ? !1 : O.keepDirty ? r.isDirty : !!(O.keepDefaultValues && !di(_, a)),
      isSubmitted: O.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: L ? {} : O.keepDirtyValues ? O.keepDefaultValues && o ? Ra(a, o) : r.dirtyFields : O.keepDefaultValues && _ ? Ra(a, _) : O.keepDirty ? r.dirtyFields : {},
      touchedFields: O.keepTouched ? r.touchedFields : {},
      errors: O.keepErrors ? r.errors : {},
      isSubmitSuccessful: O.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, je = (_, O) => ye(_r(_) ? _(o) : _, O), Ve = (_, O = {}) => {
    const W = tn(i, _), J = W && W._f;
    if (J) {
      const L = J.refs ? J.refs[0] : J.ref;
      L.focus && (L.focus(), O.shouldSelect && _r(L.select) && L.select());
    }
  }, Oe = (_) => {
    r = {
      ...r,
      ..._
    };
  }, E = {
    control: {
      register: on,
      unregister: ze,
      getFieldState: Y,
      handleSubmit: Xe,
      setError: Me,
      _subscribe: Ue,
      _runSchema: X,
      _getWatch: B,
      _getDirty: R,
      _setValid: C,
      _setFieldArray: z,
      _setDisabledField: Re,
      _setErrors: I,
      _getFieldArray: ee,
      _reset: ye,
      _resetDefaultValues: () => _r(n.defaultValues) && n.defaultValues().then((_) => {
        je(_, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: q,
      _disableForm: Qe,
      _subjects: h,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(_) {
        s = _;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(_) {
        l = _;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(_) {
        n = {
          ...n,
          ..._
        };
      }
    },
    subscribe: De,
    trigger: xe,
    register: on,
    handleSubmit: Xe,
    watch: Le,
    setValue: de,
    getValues: $e,
    reset: je,
    resetField: se,
    clearErrors: qe,
    unregister: ze,
    setError: Me,
    setFocus: Ve,
    getFieldState: Y
  };
  return {
    ...E,
    formControl: E
  };
}
function gt(e = {}) {
  const n = Ie.useRef(void 0), r = Ie.useRef(void 0), [i, a] = Ie.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: _r(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: _r(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : kD(e),
    formState: i
  }, e.formControl && e.defaultValues && !_r(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Ie.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Ie.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Ie.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Ie.useEffect(() => {
    e.values && !di(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Ie.useEffect(() => {
    e.errors && !Mt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Ie.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Ie.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = l1(i, o), n.current;
}
var ns = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function y1(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var dc = { exports: {} }, Aa = {}, Bv;
function bD() {
  if (Bv) return Aa;
  Bv = 1;
  var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Aa.Fragment = r, Aa.jsx = s, Aa.jsxs = s, Aa;
}
var ts = {}, qv;
function _D() {
  return qv || (qv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[N];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        z("error", t, m);
      }
    }
    function z(t, c, m) {
      {
        var y = C.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var P = m.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var T = !1, I = !1, D = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || U || t === v || T || I || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function q(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return q(c) + ".Consumer";
          case s:
            var m = t;
            return q(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return R(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, be, fe, de, ge, K, xe, $e;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          be = console.log, fe = console.info, de = console.warn, ge = console.error, K = console.group, xe = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: be
            }),
            info: B({}, t, {
              value: fe
            }),
            warn: B({}, t, {
              value: de
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: K
            }),
            groupCollapsed: B({}, t, {
              value: xe
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = C.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var ze = !1, Re;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new on();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var m = Re.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      ze = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Le.current, Le.current = null, qe();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var S = te.stack.split(`
`), ne = y.stack.split(`
`), H = S.length - 1, x = ne.length - 1; H >= 1 && x >= 0 && S[H] !== ne[x]; )
            x--;
          for (; H >= 1 && x >= 0; H--, x--)
            if (S[H] !== ne[x]) {
              if (H !== 1 || x !== 1)
                do
                  if (H--, x--, x < 0 || S[H] !== ne[x]) {
                    var Z = `
` + S[H].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (H >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Le.current = P, Me(), Error.prepareStackTrace = $;
      }
      var ue = t ? t.displayName || t.name : "", _e = ue ? De(ue) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Qe(t, c, m) {
      return Ee(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Xe(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case d:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Qe(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return se(P($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, je = {}, Ve = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function dn(t, c, m, y, $) {
      {
        var P = Function.call.bind(ye);
        for (var w in t)
          if (P(t, w)) {
            var S = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + m + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[w](c, w, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              S = H;
            }
            S && !(S instanceof Error) && (Oe($), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, w, typeof S), Oe(null)), S instanceof Error && !(S.message in je) && (je[S.message] = !0, Oe($), g("Failed %s type: %s", m, S.message), Oe(null));
          }
      }
    }
    var E = Array.isArray;
    function _(t) {
      return E(t);
    }
    function O(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function W(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function L(t) {
      if (W(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", O(t)), J(t);
    }
    var M = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Ze(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function sn(t, c) {
      {
        var m = function() {
          he || (he = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function hn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, m, y, $, P, w) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function _n(t, c, m, y, $) {
      {
        var P, w = {}, S = null, ne = null;
        m !== void 0 && (L(m), S = "" + m), mn(c) && (L(c.key), S = "" + c.key), nn(c) && (ne = c.ref, Ze(c));
        for (P in c)
          ye.call(c, P) && !ie.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var H = t.defaultProps;
          for (P in H)
            w[P] === void 0 && (w[P] = H[P]);
        }
        if (S || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && sn(w, x), ne && hn(w, x);
        }
        return pn(t, S, ne, $, y, M.current, w);
      }
    }
    var Je = C.ReactCurrentOwner, Nn = C.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(m);
      } else
        Nn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (Je.current) {
          var t = R(Je.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Mn(t) {
      return "";
    }
    var jn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = kn(c);
        if (jn[m])
          return;
        jn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Je.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ae(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ae(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            cn(y) && gn(y, c);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              cn(w.value) && gn(w.value, c);
        }
      }
    }
    function zn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = R(c);
          dn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var $ = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function An(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ae(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var xn = {};
    function Sn(t, c, m, y, $, P) {
      {
        var w = re(t);
        if (!w) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = Mn();
          ne ? S += ne : S += vn();
          var H;
          t === null ? H = "null" : _(t) ? H = "array" : t !== void 0 && t.$$typeof === n ? (H = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : H = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, S);
        }
        var x = _n(t, c, m, $, P);
        if (x == null)
          return x;
        if (w) {
          var Z = c.children;
          if (Z !== void 0)
            if (y)
              if (_(Z)) {
                for (var ue = 0; ue < Z.length; ue++)
                  wn(Z[ue], t);
                Object.freeze && Object.freeze(Z);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = R(t), te = Object.keys(c).filter(function($n) {
            return $n !== "key";
          }), Ke = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? An(x) : zn(x), x;
      }
    }
    function Bn(t, c, m) {
      return Sn(t, c, m, !0);
    }
    function On(t, c, m) {
      return Sn(t, c, m, !1);
    }
    var Rn = On, Un = Bn;
    ts.Fragment = i, ts.jsx = Rn, ts.jsxs = Un;
  })()), ts;
}
var Hv;
function xD() {
  return Hv || (Hv = 1, process.env.NODE_ENV === "production" ? dc.exports = bD() : dc.exports = _D()), dc.exports;
}
var Ei = xD();
function SD(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var mc, Wv;
function fi() {
  if (Wv) return mc;
  Wv = 1;
  var e = Array.isArray;
  return mc = e, mc;
}
var pc, Kv;
function g1() {
  if (Kv) return pc;
  Kv = 1;
  var e = typeof ns == "object" && ns && ns.Object === Object && ns;
  return pc = e, pc;
}
var fc, Gv;
function Ur() {
  if (Gv) return fc;
  Gv = 1;
  var e = g1(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return fc = r, fc;
}
var hc, Yv;
function Mo() {
  if (Yv) return hc;
  Yv = 1;
  var e = Ur(), n = e.Symbol;
  return hc = n, hc;
}
var yc, Qv;
function ND() {
  if (Qv) return yc;
  Qv = 1;
  var e = Mo(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), u = s[a];
    try {
      s[a] = void 0;
      var p = !0;
    } catch {
    }
    var d = i.call(s);
    return p && (l ? s[a] = u : delete s[a]), d;
  }
  return yc = o, yc;
}
var gc, Jv;
function jD() {
  if (Jv) return gc;
  Jv = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return gc = r, gc;
}
var vc, Xv;
function _a() {
  if (Xv) return vc;
  Xv = 1;
  var e = Mo(), n = ND(), r = jD(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return vc = s, vc;
}
var kc, Zv;
function Ai() {
  if (Zv) return kc;
  Zv = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return kc = e, kc;
}
var bc, ek;
function Dy() {
  if (ek) return bc;
  ek = 1;
  var e = _a(), n = Ai(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return bc = i, bc;
}
var _c, nk;
function wD() {
  if (nk) return _c;
  nk = 1;
  var e = fi(), n = Dy(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return _c = a, _c;
}
var xc, tk;
function xa() {
  if (tk) return xc;
  tk = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return xc = e, xc;
}
var Sc, rk;
function v1() {
  if (rk) return Sc;
  rk = 1;
  var e = _a(), n = xa(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var u = e(l);
    return u == i || u == a || u == r || u == o;
  }
  return Sc = s, Sc;
}
var Nc, ik;
function CD() {
  if (ik) return Nc;
  ik = 1;
  var e = Ur(), n = e["__core-js_shared__"];
  return Nc = n, Nc;
}
var jc, ak;
function FD() {
  if (ak) return jc;
  ak = 1;
  var e = CD(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return jc = r, jc;
}
var wc, ok;
function k1() {
  if (ok) return wc;
  ok = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return wc = r, wc;
}
var Cc, sk;
function ID() {
  if (sk) return Cc;
  sk = 1;
  var e = v1(), n = FD(), r = xa(), i = k1(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, u = s.toString, p = l.hasOwnProperty, d = RegExp(
    "^" + u.call(p).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var v = e(h) ? d : o;
    return v.test(i(h));
  }
  return Cc = f, Cc;
}
var Fc, lk;
function $D() {
  if (lk) return Fc;
  lk = 1;
  function e(n, r) {
    return n?.[r];
  }
  return Fc = e, Fc;
}
var Ic, ck;
function Li() {
  if (ck) return Ic;
  ck = 1;
  var e = ID(), n = $D();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Ic = r, Ic;
}
var $c, uk;
function Tl() {
  if (uk) return $c;
  uk = 1;
  var e = Li(), n = e(Object, "create");
  return $c = n, $c;
}
var Ec, dk;
function ED() {
  if (dk) return Ec;
  dk = 1;
  var e = Tl();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Ec = n, Ec;
}
var Tc, mk;
function TD() {
  if (mk) return Tc;
  mk = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return Tc = e, Tc;
}
var Dc, pk;
function DD() {
  if (pk) return Dc;
  pk = 1;
  var e = Tl(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Dc = a, Dc;
}
var Oc, fk;
function OD() {
  if (fk) return Oc;
  fk = 1;
  var e = Tl(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Oc = i, Oc;
}
var Rc, hk;
function RD() {
  if (hk) return Rc;
  hk = 1;
  var e = Tl(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return Rc = r, Rc;
}
var Pc, yk;
function PD() {
  if (yk) return Pc;
  yk = 1;
  var e = ED(), n = TD(), r = DD(), i = OD(), a = RD();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Pc = o, Pc;
}
var Ac, gk;
function AD() {
  if (gk) return Ac;
  gk = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Ac = e, Ac;
}
var Lc, vk;
function b1() {
  if (vk) return Lc;
  vk = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return Lc = e, Lc;
}
var Vc, kk;
function Dl() {
  if (kk) return Vc;
  kk = 1;
  var e = b1();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return Vc = n, Vc;
}
var zc, bk;
function LD() {
  if (bk) return zc;
  bk = 1;
  var e = Dl(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return zc = i, zc;
}
var Uc, _k;
function VD() {
  if (_k) return Uc;
  _k = 1;
  var e = Dl();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return Uc = n, Uc;
}
var Mc, xk;
function zD() {
  if (xk) return Mc;
  xk = 1;
  var e = Dl();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return Mc = n, Mc;
}
var Bc, Sk;
function UD() {
  if (Sk) return Bc;
  Sk = 1;
  var e = Dl();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return Bc = n, Bc;
}
var qc, Nk;
function Ol() {
  if (Nk) return qc;
  Nk = 1;
  var e = AD(), n = LD(), r = VD(), i = zD(), a = UD();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, qc = o, qc;
}
var Hc, jk;
function Oy() {
  if (jk) return Hc;
  jk = 1;
  var e = Li(), n = Ur(), r = e(n, "Map");
  return Hc = r, Hc;
}
var Wc, wk;
function MD() {
  if (wk) return Wc;
  wk = 1;
  var e = PD(), n = Ol(), r = Oy();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return Wc = i, Wc;
}
var Kc, Ck;
function BD() {
  if (Ck) return Kc;
  Ck = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return Kc = e, Kc;
}
var Gc, Fk;
function Rl() {
  if (Fk) return Gc;
  Fk = 1;
  var e = BD();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return Gc = n, Gc;
}
var Yc, Ik;
function qD() {
  if (Ik) return Yc;
  Ik = 1;
  var e = Rl();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return Yc = n, Yc;
}
var Qc, $k;
function HD() {
  if ($k) return Qc;
  $k = 1;
  var e = Rl();
  function n(r) {
    return e(this, r).get(r);
  }
  return Qc = n, Qc;
}
var Jc, Ek;
function WD() {
  if (Ek) return Jc;
  Ek = 1;
  var e = Rl();
  function n(r) {
    return e(this, r).has(r);
  }
  return Jc = n, Jc;
}
var Xc, Tk;
function KD() {
  if (Tk) return Xc;
  Tk = 1;
  var e = Rl();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return Xc = n, Xc;
}
var Zc, Dk;
function _1() {
  if (Dk) return Zc;
  Dk = 1;
  var e = MD(), n = qD(), r = HD(), i = WD(), a = KD();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Zc = o, Zc;
}
var eu, Ok;
function GD() {
  if (Ok) return eu;
  Ok = 1;
  var e = _1(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], u = o.cache;
      if (u.has(l))
        return u.get(l);
      var p = i.apply(this, s);
      return o.cache = u.set(l, p) || u, p;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, eu = r, eu;
}
var nu, Rk;
function YD() {
  if (Rk) return nu;
  Rk = 1;
  var e = GD(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return nu = r, nu;
}
var tu, Pk;
function QD() {
  if (Pk) return tu;
  Pk = 1;
  var e = YD(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, u, p) {
      o.push(u ? p.replace(r, "$1") : l || s);
    }), o;
  });
  return tu = i, tu;
}
var ru, Ak;
function x1() {
  if (Ak) return ru;
  Ak = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return ru = e, ru;
}
var iu, Lk;
function JD() {
  if (Lk) return iu;
  Lk = 1;
  var e = Mo(), n = x1(), r = fi(), i = Dy(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var u = l + "";
    return u == "0" && 1 / l == -1 / 0 ? "-0" : u;
  }
  return iu = s, iu;
}
var au, Vk;
function XD() {
  if (Vk) return au;
  Vk = 1;
  var e = JD();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return au = n, au;
}
var ou, zk;
function Sa() {
  if (zk) return ou;
  zk = 1;
  var e = fi(), n = wD(), r = QD(), i = XD();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return ou = a, ou;
}
var su, Uk;
function Pl() {
  if (Uk) return su;
  Uk = 1;
  var e = Dy();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return su = n, su;
}
var lu, Mk;
function S1() {
  if (Mk) return lu;
  Mk = 1;
  var e = Sa(), n = Pl();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return lu = r, lu;
}
var cu, Bk;
function N1() {
  if (Bk) return cu;
  Bk = 1;
  var e = Li(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return cu = n, cu;
}
var uu, qk;
function j1() {
  if (qk) return uu;
  qk = 1;
  var e = N1();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return uu = n, uu;
}
var du, Hk;
function Ry() {
  if (Hk) return du;
  Hk = 1;
  var e = j1(), n = b1(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var u = o[s];
    (!(i.call(o, s) && n(u, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return du = a, du;
}
var mu, Wk;
function Py() {
  if (Wk) return mu;
  Wk = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return mu = r, mu;
}
var pu, Kk;
function ZD() {
  if (Kk) return pu;
  Kk = 1;
  var e = Ry(), n = Sa(), r = Py(), i = xa(), a = Pl();
  function o(s, l, u, p) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var d = -1, f = l.length, h = f - 1, v = s; v != null && ++d < f; ) {
      var F = a(l[d]), N = u;
      if (F === "__proto__" || F === "constructor" || F === "prototype")
        return s;
      if (d != h) {
        var j = v[F];
        N = p ? p(j, F, v) : void 0, N === void 0 && (N = i(j) ? j : r(l[d + 1]) ? [] : {});
      }
      e(v, F, N), v = v[F];
    }
    return s;
  }
  return pu = o, pu;
}
var fu, Gk;
function eO() {
  if (Gk) return fu;
  Gk = 1;
  var e = S1(), n = ZD(), r = Sa();
  function i(a, o, s) {
    for (var l = -1, u = o.length, p = {}; ++l < u; ) {
      var d = o[l], f = e(a, d);
      s(f, d) && n(p, r(d, a), f);
    }
    return p;
  }
  return fu = i, fu;
}
var hu, Yk;
function nO() {
  if (Yk) return hu;
  Yk = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return hu = e, hu;
}
var yu, Qk;
function tO() {
  if (Qk) return yu;
  Qk = 1;
  var e = _a(), n = Ai(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return yu = i, yu;
}
var gu, Jk;
function Ay() {
  if (Jk) return gu;
  Jk = 1;
  var e = tO(), n = Ai(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return gu = o, gu;
}
var vu, Xk;
function Ly() {
  if (Xk) return vu;
  Xk = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return vu = n, vu;
}
var ku, Zk;
function rO() {
  if (Zk) return ku;
  Zk = 1;
  var e = Sa(), n = Ay(), r = fi(), i = Py(), a = Ly(), o = Pl();
  function s(l, u, p) {
    u = e(u, l);
    for (var d = -1, f = u.length, h = !1; ++d < f; ) {
      var v = o(u[d]);
      if (!(h = l != null && p(l, v)))
        break;
      l = l[v];
    }
    return h || ++d != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (r(l) || n(l)));
  }
  return ku = s, ku;
}
var bu, eb;
function iO() {
  if (eb) return bu;
  eb = 1;
  var e = nO(), n = rO();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return bu = r, bu;
}
var _u, nb;
function aO() {
  if (nb) return _u;
  nb = 1;
  var e = eO(), n = iO();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return _u = r, _u;
}
var xu, tb;
function Vy() {
  if (tb) return xu;
  tb = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return xu = e, xu;
}
var Su, rb;
function oO() {
  if (rb) return Su;
  rb = 1;
  var e = Mo(), n = Ay(), r = fi(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return Su = a, Su;
}
var Nu, ib;
function sO() {
  if (ib) return Nu;
  ib = 1;
  var e = Vy(), n = oO();
  function r(i, a, o, s, l) {
    var u = -1, p = i.length;
    for (o || (o = n), l || (l = []); ++u < p; ) {
      var d = i[u];
      a > 0 && o(d) ? a > 1 ? r(d, a - 1, o, s, l) : e(l, d) : s || (l[l.length] = d);
    }
    return l;
  }
  return Nu = r, Nu;
}
var ju, ab;
function lO() {
  if (ab) return ju;
  ab = 1;
  var e = sO();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return ju = n, ju;
}
var wu, ob;
function cO() {
  if (ob) return wu;
  ob = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return wu = e, wu;
}
var Cu, sb;
function uO() {
  if (sb) return Cu;
  sb = 1;
  var e = cO(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, u = n(s.length - a, 0), p = Array(u); ++l < u; )
        p[l] = s[a + l];
      l = -1;
      for (var d = Array(a + 1); ++l < a; )
        d[l] = s[l];
      return d[a] = o(p), e(i, this, d);
    };
  }
  return Cu = r, Cu;
}
var Fu, lb;
function dO() {
  if (lb) return Fu;
  lb = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Fu = e, Fu;
}
var Iu, cb;
function w1() {
  if (cb) return Iu;
  cb = 1;
  function e(n) {
    return n;
  }
  return Iu = e, Iu;
}
var $u, ub;
function mO() {
  if (ub) return $u;
  ub = 1;
  var e = dO(), n = N1(), r = w1(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return $u = i, $u;
}
var Eu, db;
function pO() {
  if (db) return Eu;
  db = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), u = n - (l - s);
      if (s = l, u > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Eu = i, Eu;
}
var Tu, mb;
function fO() {
  if (mb) return Tu;
  mb = 1;
  var e = mO(), n = pO(), r = n(e);
  return Tu = r, Tu;
}
var Du, pb;
function C1() {
  if (pb) return Du;
  pb = 1;
  var e = lO(), n = uO(), r = fO();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Du = i, Du;
}
var Ou, fb;
function hO() {
  if (fb) return Ou;
  fb = 1;
  var e = aO(), n = C1(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Ou = r, Ou;
}
var yO = hO();
const F1 = /* @__PURE__ */ y1(yO), gO = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function I1(e) {
  const n = F1(e, gO);
  return {
    controller: $y(n),
    controllerProps: n
  };
}
const vO = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function $1(e) {
  const { controller: n, controllerProps: r } = I1(e), i = {
    ...F1(e, vO),
    required: SD(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var Ru, hb;
function kO() {
  if (hb) return Ru;
  hb = 1;
  var e = Ol();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return Ru = n, Ru;
}
var Pu, yb;
function bO() {
  if (yb) return Pu;
  yb = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return Pu = e, Pu;
}
var Au, gb;
function _O() {
  if (gb) return Au;
  gb = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return Au = e, Au;
}
var Lu, vb;
function xO() {
  if (vb) return Lu;
  vb = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return Lu = e, Lu;
}
var Vu, kb;
function SO() {
  if (kb) return Vu;
  kb = 1;
  var e = Ol(), n = Oy(), r = _1(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var u = l.__data__;
      if (!n || u.length < i - 1)
        return u.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(u);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return Vu = a, Vu;
}
var zu, bb;
function NO() {
  if (bb) return zu;
  bb = 1;
  var e = Ol(), n = kO(), r = bO(), i = _O(), a = xO(), o = SO();
  function s(l) {
    var u = this.__data__ = new e(l);
    this.size = u.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, zu = s, zu;
}
var Uu, _b;
function jO() {
  if (_b) return Uu;
  _b = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return Uu = e, Uu;
}
var Mu, xb;
function Bo() {
  if (xb) return Mu;
  xb = 1;
  var e = Ry(), n = j1();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var u = -1, p = a.length; ++u < p; ) {
      var d = a[u], f = s ? s(o[d], i[d], d, o, i) : void 0;
      f === void 0 && (f = i[d]), l ? n(o, d, f) : e(o, d, f);
    }
    return o;
  }
  return Mu = r, Mu;
}
var Bu, Sb;
function wO() {
  if (Sb) return Bu;
  Sb = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return Bu = e, Bu;
}
var Vs = { exports: {} }, qu, Nb;
function CO() {
  if (Nb) return qu;
  Nb = 1;
  function e() {
    return !1;
  }
  return qu = e, qu;
}
Vs.exports;
var jb;
function E1() {
  return jb || (jb = 1, (function(e, n) {
    var r = Ur(), i = CO(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, u = l ? l.isBuffer : void 0, p = u || i;
    e.exports = p;
  })(Vs, Vs.exports)), Vs.exports;
}
var Hu, wb;
function FO() {
  if (wb) return Hu;
  wb = 1;
  var e = _a(), n = Ly(), r = Ai(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", u = "[object Function]", p = "[object Map]", d = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", F = "[object String]", N = "[object WeakMap]", j = "[object ArrayBuffer]", C = "[object DataView]", g = "[object Float32Array]", z = "[object Float64Array]", T = "[object Int8Array]", I = "[object Int16Array]", D = "[object Int32Array]", U = "[object Uint8Array]", Q = "[object Uint8ClampedArray]", X = "[object Uint16Array]", re = "[object Uint32Array]", G = {};
  G[g] = G[z] = G[T] = G[I] = G[D] = G[U] = G[Q] = G[X] = G[re] = !0, G[i] = G[a] = G[j] = G[o] = G[C] = G[s] = G[l] = G[u] = G[p] = G[d] = G[f] = G[h] = G[v] = G[F] = G[N] = !1;
  function q(R) {
    return r(R) && n(R.length) && !!G[e(R)];
  }
  return Hu = q, Hu;
}
var Wu, Cb;
function zy() {
  if (Cb) return Wu;
  Cb = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return Wu = e, Wu;
}
var zs = { exports: {} };
zs.exports;
var Fb;
function Uy() {
  return Fb || (Fb = 1, (function(e, n) {
    var r = g1(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var u = a && a.require && a.require("util").types;
        return u || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(zs, zs.exports)), zs.exports;
}
var Ku, Ib;
function IO() {
  if (Ib) return Ku;
  Ib = 1;
  var e = FO(), n = zy(), r = Uy(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return Ku = a, Ku;
}
var Gu, $b;
function T1() {
  if ($b) return Gu;
  $b = 1;
  var e = wO(), n = Ay(), r = fi(), i = E1(), a = Py(), o = IO(), s = Object.prototype, l = s.hasOwnProperty;
  function u(p, d) {
    var f = r(p), h = !f && n(p), v = !f && !h && i(p), F = !f && !h && !v && o(p), N = f || h || v || F, j = N ? e(p.length, String) : [], C = j.length;
    for (var g in p)
      (d || l.call(p, g)) && !(N && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      F && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, C))) && j.push(g);
    return j;
  }
  return Gu = u, Gu;
}
var Yu, Eb;
function My() {
  if (Eb) return Yu;
  Eb = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return Yu = n, Yu;
}
var Qu, Tb;
function D1() {
  if (Tb) return Qu;
  Tb = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return Qu = e, Qu;
}
var Ju, Db;
function $O() {
  if (Db) return Ju;
  Db = 1;
  var e = D1(), n = e(Object.keys, Object);
  return Ju = n, Ju;
}
var Xu, Ob;
function EO() {
  if (Ob) return Xu;
  Ob = 1;
  var e = My(), n = $O(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return Xu = a, Xu;
}
var Zu, Rb;
function O1() {
  if (Rb) return Zu;
  Rb = 1;
  var e = v1(), n = Ly();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return Zu = r, Zu;
}
var ed, Pb;
function By() {
  if (Pb) return ed;
  Pb = 1;
  var e = T1(), n = EO(), r = O1();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return ed = i, ed;
}
var nd, Ab;
function TO() {
  if (Ab) return nd;
  Ab = 1;
  var e = Bo(), n = By();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return nd = r, nd;
}
var td, Lb;
function DO() {
  if (Lb) return td;
  Lb = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return td = e, td;
}
var rd, Vb;
function OO() {
  if (Vb) return rd;
  Vb = 1;
  var e = xa(), n = My(), r = DO(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), u = [];
    for (var p in s)
      p == "constructor" && (l || !a.call(s, p)) || u.push(p);
    return u;
  }
  return rd = o, rd;
}
var id, zb;
function qy() {
  if (zb) return id;
  zb = 1;
  var e = T1(), n = OO(), r = O1();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return id = i, id;
}
var ad, Ub;
function RO() {
  if (Ub) return ad;
  Ub = 1;
  var e = Bo(), n = qy();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return ad = r, ad;
}
var Us = { exports: {} };
Us.exports;
var Mb;
function PO() {
  return Mb || (Mb = 1, (function(e, n) {
    var r = Ur(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function u(p, d) {
      if (d)
        return p.slice();
      var f = p.length, h = l ? l(f) : new p.constructor(f);
      return p.copy(h), h;
    }
    e.exports = u;
  })(Us, Us.exports)), Us.exports;
}
var od, Bb;
function AO() {
  if (Bb) return od;
  Bb = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return od = e, od;
}
var sd, qb;
function LO() {
  if (qb) return sd;
  qb = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return sd = e, sd;
}
var ld, Hb;
function R1() {
  if (Hb) return ld;
  Hb = 1;
  function e() {
    return [];
  }
  return ld = e, ld;
}
var cd, Wb;
function Hy() {
  if (Wb) return cd;
  Wb = 1;
  var e = LO(), n = R1(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return cd = o, cd;
}
var ud, Kb;
function VO() {
  if (Kb) return ud;
  Kb = 1;
  var e = Bo(), n = Hy();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return ud = r, ud;
}
var dd, Gb;
function Wy() {
  if (Gb) return dd;
  Gb = 1;
  var e = D1(), n = e(Object.getPrototypeOf, Object);
  return dd = n, dd;
}
var md, Yb;
function P1() {
  if (Yb) return md;
  Yb = 1;
  var e = Vy(), n = Wy(), r = Hy(), i = R1(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return md = o, md;
}
var pd, Qb;
function zO() {
  if (Qb) return pd;
  Qb = 1;
  var e = Bo(), n = P1();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return pd = r, pd;
}
var fd, Jb;
function A1() {
  if (Jb) return fd;
  Jb = 1;
  var e = Vy(), n = fi();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return fd = r, fd;
}
var hd, Xb;
function UO() {
  if (Xb) return hd;
  Xb = 1;
  var e = A1(), n = Hy(), r = By();
  function i(a) {
    return e(a, r, n);
  }
  return hd = i, hd;
}
var yd, Zb;
function L1() {
  if (Zb) return yd;
  Zb = 1;
  var e = A1(), n = P1(), r = qy();
  function i(a) {
    return e(a, r, n);
  }
  return yd = i, yd;
}
var gd, e_;
function MO() {
  if (e_) return gd;
  e_ = 1;
  var e = Li(), n = Ur(), r = e(n, "DataView");
  return gd = r, gd;
}
var vd, n_;
function BO() {
  if (n_) return vd;
  n_ = 1;
  var e = Li(), n = Ur(), r = e(n, "Promise");
  return vd = r, vd;
}
var kd, t_;
function qO() {
  if (t_) return kd;
  t_ = 1;
  var e = Li(), n = Ur(), r = e(n, "Set");
  return kd = r, kd;
}
var bd, r_;
function HO() {
  if (r_) return bd;
  r_ = 1;
  var e = Li(), n = Ur(), r = e(n, "WeakMap");
  return bd = r, bd;
}
var _d, i_;
function Ky() {
  if (i_) return _d;
  i_ = 1;
  var e = MO(), n = Oy(), r = BO(), i = qO(), a = HO(), o = _a(), s = k1(), l = "[object Map]", u = "[object Object]", p = "[object Promise]", d = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), F = s(n), N = s(r), j = s(i), C = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != p || i && g(new i()) != d || a && g(new a()) != f) && (g = function(z) {
    var T = o(z), I = T == u ? z.constructor : void 0, D = I ? s(I) : "";
    if (D)
      switch (D) {
        case v:
          return h;
        case F:
          return l;
        case N:
          return p;
        case j:
          return d;
        case C:
          return f;
      }
    return T;
  }), _d = g, _d;
}
var xd, a_;
function WO() {
  if (a_) return xd;
  a_ = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return xd = r, xd;
}
var Sd, o_;
function KO() {
  if (o_) return Sd;
  o_ = 1;
  var e = Ur(), n = e.Uint8Array;
  return Sd = n, Sd;
}
var Nd, s_;
function Gy() {
  if (s_) return Nd;
  s_ = 1;
  var e = KO();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return Nd = n, Nd;
}
var jd, l_;
function GO() {
  if (l_) return jd;
  l_ = 1;
  var e = Gy();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return jd = n, jd;
}
var wd, c_;
function YO() {
  if (c_) return wd;
  c_ = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return wd = n, wd;
}
var Cd, u_;
function QO() {
  if (u_) return Cd;
  u_ = 1;
  var e = Mo(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return Cd = i, Cd;
}
var Fd, d_;
function JO() {
  if (d_) return Fd;
  d_ = 1;
  var e = Gy();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Fd = n, Fd;
}
var Id, m_;
function XO() {
  if (m_) return Id;
  m_ = 1;
  var e = Gy(), n = GO(), r = YO(), i = QO(), a = JO(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", u = "[object Number]", p = "[object RegExp]", d = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", F = "[object DataView]", N = "[object Float32Array]", j = "[object Float64Array]", C = "[object Int8Array]", g = "[object Int16Array]", z = "[object Int32Array]", T = "[object Uint8Array]", I = "[object Uint8ClampedArray]", D = "[object Uint16Array]", U = "[object Uint32Array]";
  function Q(X, re, G) {
    var q = X.constructor;
    switch (re) {
      case v:
        return e(X);
      case o:
      case s:
        return new q(+X);
      case F:
        return n(X, G);
      case N:
      case j:
      case C:
      case g:
      case z:
      case T:
      case I:
      case D:
      case U:
        return a(X, G);
      case l:
        return new q();
      case u:
      case f:
        return new q(X);
      case p:
        return r(X);
      case d:
        return new q();
      case h:
        return i(X);
    }
  }
  return Id = Q, Id;
}
var $d, p_;
function ZO() {
  if (p_) return $d;
  p_ = 1;
  var e = xa(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return $d = r, $d;
}
var Ed, f_;
function eR() {
  if (f_) return Ed;
  f_ = 1;
  var e = ZO(), n = Wy(), r = My();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Ed = i, Ed;
}
var Td, h_;
function nR() {
  if (h_) return Td;
  h_ = 1;
  var e = Ky(), n = Ai(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Td = i, Td;
}
var Dd, y_;
function tR() {
  if (y_) return Dd;
  y_ = 1;
  var e = nR(), n = zy(), r = Uy(), i = r && r.isMap, a = i ? n(i) : e;
  return Dd = a, Dd;
}
var Od, g_;
function rR() {
  if (g_) return Od;
  g_ = 1;
  var e = Ky(), n = Ai(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Od = i, Od;
}
var Rd, v_;
function iR() {
  if (v_) return Rd;
  v_ = 1;
  var e = rR(), n = zy(), r = Uy(), i = r && r.isSet, a = i ? n(i) : e;
  return Rd = a, Rd;
}
var Pd, k_;
function aR() {
  if (k_) return Pd;
  k_ = 1;
  var e = NO(), n = jO(), r = Ry(), i = TO(), a = RO(), o = PO(), s = AO(), l = VO(), u = zO(), p = UO(), d = L1(), f = Ky(), h = WO(), v = XO(), F = eR(), N = fi(), j = E1(), C = tR(), g = xa(), z = iR(), T = By(), I = qy(), D = 1, U = 2, Q = 4, X = "[object Arguments]", re = "[object Array]", G = "[object Boolean]", q = "[object Date]", R = "[object Error]", B = "[object Function]", ee = "[object GeneratorFunction]", be = "[object Map]", fe = "[object Number]", de = "[object Object]", ge = "[object RegExp]", K = "[object Set]", xe = "[object String]", $e = "[object Symbol]", Y = "[object WeakMap]", qe = "[object ArrayBuffer]", Me = "[object DataView]", Le = "[object Float32Array]", Ue = "[object Float64Array]", De = "[object Int8Array]", ze = "[object Int16Array]", Re = "[object Int32Array]", on = "[object Uint8Array]", Ee = "[object Uint8ClampedArray]", Qe = "[object Uint16Array]", Xe = "[object Uint32Array]", se = {};
  se[X] = se[re] = se[qe] = se[Me] = se[G] = se[q] = se[Le] = se[Ue] = se[De] = se[ze] = se[Re] = se[be] = se[fe] = se[de] = se[ge] = se[K] = se[xe] = se[$e] = se[on] = se[Ee] = se[Qe] = se[Xe] = !0, se[R] = se[B] = se[Y] = !1;
  function ye(je, Ve, Oe, dn, E, _) {
    var O, W = Ve & D, J = Ve & U, L = Ve & Q;
    if (Oe && (O = E ? Oe(je, dn, E, _) : Oe(je)), O !== void 0)
      return O;
    if (!g(je))
      return je;
    var M = N(je);
    if (M) {
      if (O = h(je), !W)
        return s(je, O);
    } else {
      var ie = f(je), he = ie == B || ie == ee;
      if (j(je))
        return o(je, W);
      if (ie == de || ie == X || he && !E) {
        if (O = J || he ? {} : F(je), !W)
          return J ? u(je, a(O, je)) : l(je, i(O, je));
      } else {
        if (!se[ie])
          return E ? je : {};
        O = v(je, ie, W);
      }
    }
    _ || (_ = new e());
    var Ne = _.get(je);
    if (Ne)
      return Ne;
    _.set(je, O), z(je) ? je.forEach(function(Ze) {
      O.add(ye(Ze, Ve, Oe, Ze, je, _));
    }) : C(je) && je.forEach(function(Ze, sn) {
      O.set(sn, ye(Ze, Ve, Oe, sn, je, _));
    });
    var nn = L ? J ? d : p : J ? I : T, mn = M ? void 0 : nn(je);
    return n(mn || je, function(Ze, sn) {
      mn && (sn = Ze, Ze = je[sn]), r(O, sn, ye(Ze, Ve, Oe, sn, je, _));
    }), O;
  }
  return Pd = ye, Pd;
}
var Ad, b_;
function oR() {
  if (b_) return Ad;
  b_ = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return Ad = e, Ad;
}
var Ld, __;
function sR() {
  if (__) return Ld;
  __ = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return Ld = e, Ld;
}
var Vd, x_;
function lR() {
  if (x_) return Vd;
  x_ = 1;
  var e = S1(), n = sR();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return Vd = r, Vd;
}
var zd, S_;
function cR() {
  if (S_) return zd;
  S_ = 1;
  var e = Sa(), n = oR(), r = lR(), i = Pl(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, u) {
    u = e(u, l);
    var p = -1, d = u.length;
    if (!d)
      return !0;
    for (; ++p < d; ) {
      var f = i(u[p]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && p < d - 1)
        return !1;
    }
    var h = r(l, u);
    return h == null || delete h[i(n(u))];
  }
  return zd = s, zd;
}
var Ud, N_;
function uR() {
  if (N_) return Ud;
  N_ = 1;
  var e = _a(), n = Wy(), r = Ai(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, u = s.call(Object);
  function p(d) {
    if (!r(d) || e(d) != i)
      return !1;
    var f = n(d);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == u;
  }
  return Ud = p, Ud;
}
var Md, j_;
function dR() {
  if (j_) return Md;
  j_ = 1;
  var e = uR();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return Md = n, Md;
}
var Bd, w_;
function mR() {
  if (w_) return Bd;
  w_ = 1;
  var e = x1(), n = aR(), r = cR(), i = Sa(), a = Bo(), o = dR(), s = C1(), l = L1(), u = 1, p = 2, d = 4, f = s(function(h, v) {
    var F = {};
    if (h == null)
      return F;
    var N = !1;
    v = e(v, function(C) {
      return C = i(C, h), N || (N = C.length > 1), C;
    }), a(h, l(h), F), N && (F = n(F, u | p | d, o));
    for (var j = v.length; j--; )
      r(F, v[j]);
    return F;
  });
  return Bd = f, Bd;
}
mR();
const Cr = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = $1(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...u
  } = r.field;
  return /* @__PURE__ */ Ei.jsx(en, { ...a, children: /* @__PURE__ */ Ei.jsx(
    ui,
    {
      ...n.componentProps,
      ...u,
      multiple: !1,
      value: u.value ? [u.value] : [],
      onBlur: (p) => {
        n.componentProps?.onBlur?.(p), s();
      },
      onChange: (p) => {
        n.componentProps?.onChange?.(p), l(p.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: en.getStatus(a.meta),
      children: e
    }
  ) });
};
var pR = w1();
const fR = /* @__PURE__ */ y1(pR), Pn = ({
  transformValue: e = fR,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = I1(a);
  return /* @__PURE__ */ Ei.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ Ei.jsx(
      Qs,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ Ei.jsx(bw, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, Qn = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = $1(e);
  return /* @__PURE__ */ Ei.jsx(en, { ...i, children: /* @__PURE__ */ Ei.jsx(
    fr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: en.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var qd = { exports: {} }, La = {}, C_;
function hR() {
  if (C_) return La;
  C_ = 1;
  var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return La.Fragment = r, La.jsx = s, La.jsxs = s, La;
}
var rs = {}, F_;
function yR() {
  return F_ || (F_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[N];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        z("error", t, m);
      }
    }
    function z(t, c, m) {
      {
        var y = C.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var P = m.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var T = !1, I = !1, D = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || U || t === v || T || I || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function q(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return q(c) + ".Consumer";
          case s:
            var m = t;
            return q(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return R(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, be, fe, de, ge, K, xe, $e;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          be = console.log, fe = console.info, de = console.warn, ge = console.error, K = console.group, xe = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: be
            }),
            info: B({}, t, {
              value: fe
            }),
            warn: B({}, t, {
              value: de
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: K
            }),
            groupCollapsed: B({}, t, {
              value: xe
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = C.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var ze = !1, Re;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new on();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var m = Re.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      ze = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Le.current, Le.current = null, qe();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var S = te.stack.split(`
`), ne = y.stack.split(`
`), H = S.length - 1, x = ne.length - 1; H >= 1 && x >= 0 && S[H] !== ne[x]; )
            x--;
          for (; H >= 1 && x >= 0; H--, x--)
            if (S[H] !== ne[x]) {
              if (H !== 1 || x !== 1)
                do
                  if (H--, x--, x < 0 || S[H] !== ne[x]) {
                    var Z = `
` + S[H].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (H >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Le.current = P, Me(), Error.prepareStackTrace = $;
      }
      var ue = t ? t.displayName || t.name : "", _e = ue ? De(ue) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Qe(t, c, m) {
      return Ee(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Xe(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case d:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Qe(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return se(P($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, je = {}, Ve = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function dn(t, c, m, y, $) {
      {
        var P = Function.call.bind(ye);
        for (var w in t)
          if (P(t, w)) {
            var S = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + m + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[w](c, w, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              S = H;
            }
            S && !(S instanceof Error) && (Oe($), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, w, typeof S), Oe(null)), S instanceof Error && !(S.message in je) && (je[S.message] = !0, Oe($), g("Failed %s type: %s", m, S.message), Oe(null));
          }
      }
    }
    var E = Array.isArray;
    function _(t) {
      return E(t);
    }
    function O(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function W(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function L(t) {
      if (W(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", O(t)), J(t);
    }
    var M = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Ze(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function sn(t, c) {
      {
        var m = function() {
          he || (he = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function hn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, m, y, $, P, w) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function _n(t, c, m, y, $) {
      {
        var P, w = {}, S = null, ne = null;
        m !== void 0 && (L(m), S = "" + m), mn(c) && (L(c.key), S = "" + c.key), nn(c) && (ne = c.ref, Ze(c));
        for (P in c)
          ye.call(c, P) && !ie.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var H = t.defaultProps;
          for (P in H)
            w[P] === void 0 && (w[P] = H[P]);
        }
        if (S || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && sn(w, x), ne && hn(w, x);
        }
        return pn(t, S, ne, $, y, M.current, w);
      }
    }
    var Je = C.ReactCurrentOwner, Nn = C.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(m);
      } else
        Nn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (Je.current) {
          var t = R(Je.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Mn(t) {
      return "";
    }
    var jn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = kn(c);
        if (jn[m])
          return;
        jn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Je.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ae(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ae(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            cn(y) && gn(y, c);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              cn(w.value) && gn(w.value, c);
        }
      }
    }
    function zn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = R(c);
          dn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var $ = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function An(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ae(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var xn = {};
    function Sn(t, c, m, y, $, P) {
      {
        var w = re(t);
        if (!w) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = Mn();
          ne ? S += ne : S += vn();
          var H;
          t === null ? H = "null" : _(t) ? H = "array" : t !== void 0 && t.$$typeof === n ? (H = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : H = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, S);
        }
        var x = _n(t, c, m, $, P);
        if (x == null)
          return x;
        if (w) {
          var Z = c.children;
          if (Z !== void 0)
            if (y)
              if (_(Z)) {
                for (var ue = 0; ue < Z.length; ue++)
                  wn(Z[ue], t);
                Object.freeze && Object.freeze(Z);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = R(t), te = Object.keys(c).filter(function($n) {
            return $n !== "key";
          }), Ke = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? An(x) : zn(x), x;
      }
    }
    function Bn(t, c, m) {
      return Sn(t, c, m, !0);
    }
    function On(t, c, m) {
      return Sn(t, c, m, !1);
    }
    var Rn = On, Un = Bn;
    rs.Fragment = i, rs.jsx = Rn, rs.jsxs = Un;
  })()), rs;
}
var I_;
function gR() {
  return I_ || (I_ = 1, process.env.NODE_ENV === "production" ? qd.exports = hR() : qd.exports = yR()), qd.exports;
}
var ke = gR();
const vR = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, kR = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, bR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, _R = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, xR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, SR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, NR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, jR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, wR = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": bR,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": _R,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": xR,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": vR,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": kR,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": SR,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": NR,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": jR
};
function Na(e) {
  return wR[e] ?? {};
}
const CR = Na(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), FR = Na(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), IR = Na(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), $_ = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, mr = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, $R = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), E_ = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, Fh = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ ke.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ ke.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ ke.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ ke.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ ke.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ ke.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ ke.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ ke.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ ke.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ ke.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ ke.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ ke.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function ER({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = le(
    []
  ), [o, s] = le([]), [l, u] = le([]), [p, d] = le([]), [f, h] = le(), { showNotification: v, showModal: F, executeQuery: N } = yn(), { track: j } = Cn(), {
    loading: C,
    data: g,
    error: z,
    store: T
  } = uy(e ?? null), I = g?.github?.issues || [], D = g?.github?.pullRequests || [], [U, Q] = le(!1), [X, re] = le();
  Ye(
    () => h(z || X || void 0),
    [z, X]
  ), Ye(
    () => {
      !C && (I?.length || D?.length) ? (a(I), s(D), q(I, D)) : (a([]), s([]), u([]), d([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  );
  const G = async (ge, K) => {
    await T(ge).then(() => {
      v({
        icon: "check-circle-filled",
        severity: "success",
        title: K.success.title,
        text: K.success.text
      });
    }).catch((xe) => {
      v({
        title: K.error.title,
        text: `${K.error.text} ${xe.message && " (" + xe.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, q = (ge, K) => {
    if (!ge?.length && !K?.length) {
      u([]), d([]);
      return;
    }
    const xe = (ge || []).map(
      (qe) => N(FR, {
        owner: qe.owner,
        repositoryName: qe.repository,
        issueNumber: qe.number
      })
    ), $e = (K || []).map(
      (qe) => N(IR, {
        owner: qe.owner,
        repositoryName: qe.repository,
        prNumber: qe.number
      })
    ), Y = [...xe, ...$e];
    Q(!0), Promise.all(Y).then((qe) => {
      const Me = [], Le = [];
      qe.forEach((Ue) => {
        const De = Ue?.data?.GitHub;
        if (!De) {
          u([]), d([]);
          return;
        }
        Object.keys(De).forEach((ze) => {
          if (ze.startsWith("repository")) {
            const Re = De[ze];
            Object.keys(Re).forEach((on) => {
              const Ee = Re[on], Qe = {
                number: Ee?.number,
                owner: Ee?.repository?.owner?.login,
                repository: Ee?.repository?.name
              };
              on.startsWith("issue") && Me.push({
                ...Ee,
                type: "ISSUE",
                key: Qe
              }), on.startsWith("pullRequest") && Le.push({
                ...Ee,
                type: "PR",
                key: Qe
              });
            });
          }
        });
      }), u(Me), d(Le);
    }).catch(re).finally(() => {
      Q(!1);
    });
  }, R = ({ key: ge, type: K }) => {
    j("github:link:issue:clicked", {
      githubOrganization: n
    });
    const xe = g && (I.length || D.length) ? g : r, $e = K === "ISSUE" ? "issues" : "pullRequests";
    xe.github[$e] = Array.from(
      new Set(xe.github[$e]).add(ge)
    ), G(xe, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${mr(
          ge
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${mr(ge)} failed. Please try again.`
      }
    });
  }, B = async ({ key: ge, type: K }) => {
    j("github:link:issue:clicked", {
      githubOrganization: n
    });
    const xe = g && (I.length || D.length) ? g : r, $e = K === "ISSUE" ? "issues" : "pullRequests";
    xe.github[$e] = Array.from(
      new Set(xe.github[$e]).add(ge)
    ), await T(xe).catch((Y) => {
      v({
        title: "Linking failed",
        text: `Linking ${ge} failed. Please try again. ${Y.message && " (" + Y.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ee = ({ key: ge, type: K }) => {
    j("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const xe = K === "ISSUE" ? "issue" : "pull request";
    F({
      headline: `Unlink ${xe} ${mr(ge)}?`,
      text: `You are about to unlink the ${xe} ${mr(
        ge
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${xe}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const $e = K === "ISSUE" ? "issues" : "pullRequests";
        if (!g)
          return;
        const Y = {
          ...g,
          github: {
            ...g?.github,
            [$e]: g?.github?.[$e].filter(
              (qe) => qe.number !== ge.number || qe.owner !== ge.owner || qe.repository !== ge.repository
            )
          }
        };
        j("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), G(Y, {
          success: {
            title: `GitHub ${xe} unlinked`,
            text: `You unlinked the GitHub ${xe} ${mr(
              ge
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${mr(ge)} failed.`
          }
        });
      },
      onCancel: () => {
        j("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, be = () => {
    j("github:unlink:all:clicked", {
      githubOrganization: n
    }), F({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        j("github:unlink:all:confirmed", {
          githubOrganization: n
        }), G(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        j("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, fe = I.filter(
    (ge) => !i?.includes(ge)
  ) || [], de = D.filter(
    (ge) => !o?.includes(ge)
  ) || [];
  return {
    linkGithubItem: R,
    linkGithubItemQuietly: B,
    unlinkGithubItem: ee,
    loadGithubItems: q,
    removeDanglingGithubItemLinks: () => {
      const ge = {
        ...g,
        github: {
          ...g?.github,
          issues: I.filter(
            (K) => !fe.includes(K)
          ) || [],
          pullRequests: D.filter(
            (K) => !de.includes(K)
          ) || []
        }
      };
      T(ge);
    },
    unlinkAllGithubItems: be,
    isLoadingGithubItemLinks: C,
    danglingIssueLinks: fe,
    danglingPullRequestLinks: de,
    isLoadingGithubItems: U,
    issues: l,
    pullRequests: p,
    error: f
  };
}
const TR = "_contentWrapper_1vx3c_1", DR = "_contentWrapperHeadline_1vx3c_4", OR = "_contentWrapperBody_1vx3c_11", RR = "_contentWrapperAssigneeIcon_1vx3c_15", PR = "_contentWrapperStatusTag_1vx3c_20", Hr = {
  contentWrapper: TR,
  contentWrapperHeadline: DR,
  contentWrapperBody: OR,
  contentWrapperAssigneeIcon: RR,
  contentWrapperStatusTag: PR
}, V1 = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
  e && /* @__PURE__ */ ke.jsxs(tt, { className: Hr.contentWrapper, children: [
    /* @__PURE__ */ ke.jsx(tt, { className: Hr.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ ke.jsx(tt, { className: Hr.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ ke.jsxs(tt, { className: Hr.contentWrapper, children: [
    /* @__PURE__ */ ke.jsx(tt, { className: Hr.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ ke.jsx(tt, { className: Hr.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ ke.jsxs(tt, { margin: "100 0", children: [
        /* @__PURE__ */ ke.jsx(
          "img",
          {
            className: Hr.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ ke.jsx(tt, { className: Hr.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ ke.jsx(
      qn,
      {
        className: Hr.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), AR = "_collapse_1bdjy_1", LR = "_collapseHeader_1bdjy_10", VR = "_collapseHeaderKey_1bdjy_31", zR = "_collapseHeaderKeyIcon_1bdjy_36", UR = "_collapseHeaderKeyLink_1bdjy_41", MR = "_collapseHeaderIcon_1bdjy_44", BR = "_collapseHeaderTitle_1bdjy_49", qR = "_collapseContent_1bdjy_57", HR = "_collapseContentButtonSpacer_1bdjy_60", WR = "_collapseContentButtonLink_1bdjy_63", $r = {
  collapse: AR,
  collapseHeader: LR,
  collapseHeaderKey: VR,
  collapseHeaderKeyIcon: zR,
  collapseHeaderKeyLink: UR,
  collapseHeaderIcon: MR,
  collapseHeaderTitle: BR,
  collapseContent: qR,
  collapseContentButtonSpacer: HR,
  collapseContentButtonLink: WR
}, KR = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (u, p) => ({ ...u, [p.id]: !1 }),
    {}
  ), [a, o] = le(i), { track: s } = Cn(), l = (u, p) => {
    o({ ...a, [u]: p });
  };
  return /* @__PURE__ */ ke.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((u) => {
    const {
      id: p,
      number: d,
      key: f,
      title: h,
      bodyText: v,
      repository: F,
      type: N,
      state: j,
      assignees: C,
      labels: g
    } = u, z = a[p];
    return /* @__PURE__ */ ke.jsxs(
      hr,
      {
        onToggle: () => l(p, !a[p]),
        isOpen: z,
        className: $r.collapse,
        children: [
          /* @__PURE__ */ ke.jsx(hr.Header, { className: $r.collapseHeader, children: /* @__PURE__ */ ke.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ ke.jsx(tt, { children: /* @__PURE__ */ ke.jsxs(tt, { as: "span", className: $r.collapseHeaderKey, children: [
                  Fh(
                    N,
                    j,
                    $r.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ ke.jsxs(
                    "a",
                    {
                      href: $_(f),
                      className: $r.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (T) => {
                        T.stopPropagation();
                      },
                      children: [
                        mr(f),
                        /* @__PURE__ */ ke.jsx(
                          pe,
                          {
                            className: $r.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ ke.jsx(tt, { className: $r.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ ke.jsx(hr.Content, { className: $r.collapseContent, children: /* @__PURE__ */ ke.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ ke.jsx(
              V1,
              {
                description: v,
                assignees: C,
                labels: g
              }
            ),
            /* @__PURE__ */ ke.jsxs(
              Yn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: $r.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: d,
                    owner: F?.owner.login,
                    repository: u.repository.name
                  },
                  type: N
                }),
                children: [
                  "Unlink ",
                  E_(N)
                ]
              }
            ),
            /* @__PURE__ */ ke.jsxs(
              Rt,
              {
                slotEnd: /* @__PURE__ */ ke.jsx(pe, { name: "external-link" }),
                variant: "tertiary",
                className: $r.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open($_(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  E_(N),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      p
    );
  }) : /* @__PURE__ */ ke.jsx(ke.Fragment, {}) });
}, GR = "_result_1uaom_1", YR = "_resultName_1uaom_21", QR = "_resultItemIcon_1uaom_29", JR = "_resultDescription_1uaom_34", XR = "_resultLinkIcon_1uaom_46", ZR = "_tooltip_1uaom_55", eP = "_tooltipName_1uaom_61", nP = "_tooltipTag_1uaom_71", Wr = {
  result: GR,
  resultName: YR,
  resultItemIcon: QR,
  resultDescription: JR,
  resultLinkIcon: XR,
  tooltip: ZR,
  tooltipName: eP,
  tooltipTag: nP
}, tP = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: u } = e, [p, d] = le(!1);
  return /* @__PURE__ */ ke.jsx(
    Ge,
    {
      className: Wr.tooltip,
      content: /* @__PURE__ */ ke.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ ke.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ ke.jsxs(tt, { as: "span", className: Wr.tooltipName, children: [
                Fh(a, o, Wr.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ ke.jsx(qn, { className: Wr.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ ke.jsx(
          V1,
          {
            description: l,
            assignees: u,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ ke.jsxs(
        "button",
        {
          className: Wr.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => d(!0),
          onMouseLeave: () => d(!1),
          children: [
            /* @__PURE__ */ ke.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: p ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ ke.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ ke.jsxs(tt, { as: "span", className: Wr.resultName, children: [
                    Fh(a, o, Wr.resultItemIcon),
                    mr(r)
                  ] }) }),
                  /* @__PURE__ */ ke.jsx(tt, { className: Wr.resultDescription, children: i })
                ]
              }
            ),
            p && /* @__PURE__ */ ke.jsx(
              pe,
              {
                className: Wr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, rP = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ ke.jsx(
  Rt,
  {
    slotEnd: /* @__PURE__ */ ke.jsx(pe, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), il = "[a-zA-z0-9_.-]+", z1 = "[0-9]+", iP = new RegExp(
  `(${il})/(${il})/(?:issues|pull)/(${z1})`,
  "i"
), T_ = new RegExp(`^${iP.source}$`), D_ = new RegExp(
  `https://github.com/(${il})/(${il})/(?:issues|pull)/(${z1})`,
  "i"
), aP = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = Kn(() => r?.map((D) => D.id) || [], [r]), o = Kn(() => i?.map((D) => D.id) || [], [i]), [s, l] = le([]), { useLazyQuery: u } = yn(), [p, d] = le(), [f, { loading: h, error: v, data: F, networkStatus: N }] = u(CR, {
    notifyOnNetworkStatusChange: !0
  });
  Pi(
    () => {
      !h && p && N === rr.ready ? f({
        variables: {
          issueQuery: `${p} type:issue`,
          prQuery: `${p} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [p]
  ), Ye(() => {
    let D = F?.GitHub?.issues?.nodes || [], U = F?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (D = D.filter((Q) => !a.includes(Q.id))), o.length > 0 && (U = U.filter(
      (Q) => !o.includes(Q.id)
    )), l([
      ...D.map((Q) => ({
        ...Q,
        type: "ISSUE",
        key: {
          number: Q.number,
          owner: Q.repository.owner.login,
          repository: Q.repository.name
        }
      })),
      ...U.map((Q) => ({
        ...Q,
        type: "PR",
        key: {
          number: Q.number,
          owner: Q.repository.owner.login,
          repository: Q.repository.name
        }
      }))
    ]);
  }, [F, a, o]);
  function j(D) {
    const U = D?.trim();
    if (T_.test(U)) {
      const [Q, X, re, G] = U.match(T_) || [];
      return X !== n ? void 0 : {
        owner: n,
        repository: re,
        number: parseInt(G)
      };
    }
    if (D_.test(U)) {
      const [Q, X, re, G] = U.match(D_) || [];
      return X !== n ? void 0 : {
        owner: n,
        repository: re,
        number: parseInt(G)
      };
    }
  }
  const C = (D) => {
    e({
      key: $R(D),
      type: D.type
    }), d(void 0);
  }, g = (D) => {
    const U = j(D);
    d(
      U ? `org:${U.owner} repo:${U.repository} ${U.number}` : `org:${n} ${D}`
    );
  }, z = () => {
    d(void 0);
  }, T = ({ className: D, searched: U }) => /* @__PURE__ */ ke.jsx(
    rP,
    {
      className: D,
      searched: U,
      githubOrganization: n
    }
  ), I = ({ item: D, onSelect: U }) => /* @__PURE__ */ ke.jsx(tP, { item: D, onSelect: U });
  return !h && v ? /* @__PURE__ */ ke.jsx(In, { error: v }) : /* @__PURE__ */ ke.jsx(
    Fr,
    {
      items: s?.map((D) => ({ name: D.title, ...D })),
      loading: h,
      onSearch: g,
      onSelect: C,
      onClear: z,
      emptyMessage: p ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: T,
      itemComponent: I,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, oP = "_itemButton_3sxfy_1", sP = "_result_3sxfy_6", lP = "_resultName_3sxfy_30", cP = "_resultCheckIcon_3sxfy_38", uP = "_resultAssigneeIcon_3sxfy_41", Va = {
  itemButton: oP,
  result: sP,
  resultName: lP,
  resultCheckIcon: cP,
  resultAssigneeIcon: uP
}, U1 = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ ke.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ ke.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: Va.itemButton,
        children: /* @__PURE__ */ ke.jsxs(b, { className: Va.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ ke.jsx(tt, { margin: "100 0", children: /* @__PURE__ */ ke.jsx(
            "img",
            {
              className: Va.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ ke.jsx(tt, { className: Va.resultName, children: e.name }),
          n && /* @__PURE__ */ ke.jsx(tt, { className: Va.resultCheckIcon, children: /* @__PURE__ */ ke.jsx(pe, { name: "done" }) })
        ] })
      }
    )
  }
), dP = Na(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), mP = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = yn(), [o, s] = le([]), [l, u] = le(""), p = 2, [d, { loading: f, error: h, data: v, networkStatus: F }] = a(
    dP,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return Pi(
    () => {
      !f && l && l.length >= p && F === rr.ready ? d({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Ye(() => {
    const N = v?.GitHub?.organization?.teams || { edges: [] }, j = [];
    N?.edges?.forEach((C) => {
      const g = C?.node?.members?.edges;
      (g?.length || 0) > 0 && g?.forEach((z) => {
        const T = z?.node;
        T && (T?.id && j.find((I) => I.id === T.id) || j.push(T));
      });
    }), s(
      j.sort((C, g) => {
        const z = C.name?.toLowerCase() || C.login?.toLowerCase(), T = g.name?.toLowerCase() || g.login?.toLowerCase();
        return z.localeCompare(T, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [v]), !f && h ? /* @__PURE__ */ ke.jsx(In, { error: h }) : /* @__PURE__ */ ke.jsx(
    Fr,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: N, name: j, login: C, avatarUrl: g }) => ({
        id: N,
        name: j || C,
        iconUrl: g
      })) || [],
      loading: f,
      onSearch: (N) => u(N),
      onChange: (N, j) => {
        const C = N.id;
        i ? (j && !n.find(
          (g) => g.id === C
        ) && n.push(N), j || (n = n.filter(
          (g) => g.id !== C
        ))) : n = j ? [N] : [], r(n);
      },
      onClear: () => u(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: N, onSelect: j, checked: C }) => /* @__PURE__ */ ke.jsx(
        U1,
        {
          item: N,
          checked: C,
          onSelectItem: j
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, pP = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ ke.jsx(fr, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ ke.jsx(
        Fr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: u }) => ({
            id: s,
            name: l || u
          }))
        }
      ) : /* @__PURE__ */ ke.jsx(
        _l,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ ke.jsx(fr, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ ke.jsx(
        Fr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: u }) => ({
              id: s,
              name: l || u
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ ke.jsx(fr, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ ke.jsx(bh, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ ke.jsx(
        mP,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ ke.jsx(ke.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, fP = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ ke.jsx(ke.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ ke.jsx(
  Ot,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ ke.jsx(
      en,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: pP({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), hP = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ ke.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ ke.jsxs(A.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ ke.jsxs(A.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ ke.jsx(pe, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ ke.jsx(en, { label: "GitHub issue link", children: /* @__PURE__ */ ke.jsx(
          fr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, yP = "_modalBody_1hk1o_1", gP = "_modalBodyFormFields_1hk1o_4", Hd = {
  modalBody: yP,
  modalBodyFormFields: gP
}, vP = Na(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), kP = Na(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), bP = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], _P = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = yn(), { track: u } = Cn(), {
    control: p,
    handleSubmit: d,
    formState: { errors: f },
    reset: h,
    getValues: v
  } = gt(), [F, N] = le(""), [j, C] = le([]), [g, z] = le(), [T, I] = le(!1), [D, U] = le(!1), [Q, X] = t1(), [
    re,
    {
      loading: G,
      error: q,
      networkStatus: R
    }
  ] = s(vP, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: ($e) => {
      C(
        $e.GitHub.search?.edges?.map((Y) => Y?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), C([]);
    }
  });
  Pi(
    () => {
      !G && F && R === rr.ready ? re({
        variables: {
          query: F,
          maxResults: 10
        }
      }) : C([]);
    },
    500,
    [F]
  );
  const [B, { error: ee }] = l(
    kP,
    {
      onError: ($e) => {
        I(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", $e);
      },
      onCompleted: ($e) => {
        I(!1);
        const Y = $e.GitHub.createIssue?.issue;
        z(Y), o({
          title: "Success",
          text: `GitHub issue '${Y.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: Y.repository.name,
          number: Y.number
        });
      }
    }
  ), be = ($e) => {
    N(`org:${a} ${$e}`);
  }, fe = ($e, Y) => {
    Y($e), N("");
  }, de = () => {
    N("");
  }, ge = ($e) => {
    u("github:create:issue:confirmed", {
      githubOrganization: a
    }), I(!0), B({
      variables: {
        input: {
          repositoryId: $e.repository.id,
          title: $e.title,
          body: $e.body,
          assigneeIds: $e.assignees?.length > 0 ? $e.assignees.map((Y) => Y.id) : void 0
        }
      }
    });
  };
  Ye(() => {
    const $e = D ? window.setTimeout(() => U(!1), 2e3) : void 0;
    return () => window.clearTimeout($e);
  }, [D]);
  const K = () => {
    N(""), C([]), z(void 0), I(!1), U(!1);
  }, xe = () => {
    u("github:create:issue:canceled", {
      githubOrganization: a
    }), K(), h(), n();
  };
  return /* @__PURE__ */ ke.jsxs(
    jt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: xe,
      children: [
        /* @__PURE__ */ ke.jsx(
          wt,
          {
            title: g ? "Issue creation successful" : "Create new GitHub issue",
            onClose: xe
          }
        ),
        /* @__PURE__ */ ke.jsxs(Ct, { className: Hd.modalBody, children: [
          !G && q && /* @__PURE__ */ ke.jsx(In, { error: q }),
          !T && ee && /* @__PURE__ */ ke.jsx(In, { error: ee }),
          g ? /* @__PURE__ */ ke.jsx(
            hP,
            {
              createdIssue: g,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: D,
              setIssueLinkCopied: U,
              copyToClipboard: X
            }
          ) : /* @__PURE__ */ ke.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: d(ge),
              children: /* @__PURE__ */ ke.jsxs(at, { children: [
                /* @__PURE__ */ ke.jsx(me, { children: /* @__PURE__ */ ke.jsx(en, { label: "Repository", required: !0, children: /* @__PURE__ */ ke.jsx(
                  Ot,
                  {
                    control: p,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: $e, value: Y } }) => /* @__PURE__ */ ke.jsx(
                      Fr,
                      {
                        className: Hd.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: G,
                        onSearch: be,
                        onSelect: (qe) => fe(qe, $e),
                        onClear: de,
                        selectedItems: [Y],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: q ? "No repositories found" : "No repositories available",
                        items: j || [],
                        itemComponent: ({ item: qe, onSelect: Me, checked: Le }) => /* @__PURE__ */ ke.jsx(
                          U1,
                          {
                            item: qe,
                            checked: Le,
                            onSelectItem: Me
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ ke.jsx(me, { className: Hd.modalBodyFormFields, children: /* @__PURE__ */ ke.jsx(
                  fP,
                  {
                    control: p,
                    errors: f,
                    getValues: v,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: bP
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ ke.jsx(
          Pt,
          {
            confirmOnClick: g ? xe : d(ge),
            confirmProps: {
              isLoading: T,
              loadingIndicator: /* @__PURE__ */ ke.jsx(fn, { size: 16 })
            },
            confirmName: g ? "Close" : "Save",
            cancelOnClick: g ? void 0 : xe
          }
        )
      ]
    }
  );
}, xP = "_wrapper_19v8w_1", SP = "_inputWrapper_19v8w_6", NP = "_buttonLink_19v8w_19", jP = "_noItemsFound_19v8w_23", wP = "_createIssueButton_19v8w_28", Hi = {
  wrapper: xP,
  inputWrapper: SP,
  buttonLink: NP,
  noItemsFound: jP,
  createIssueButton: wP
}, CP = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = le(!1), { track: a } = Cn(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: u,
    unlinkGithubItem: p,
    loadGithubItems: d,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: v,
    danglingIssueLinks: F,
    danglingPullRequestLinks: N,
    isLoadingGithubItems: j,
    issues: C,
    pullRequests: g,
    error: z
  } = ER({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), T = (X) => u({ key: X, type: "ISSUE" }), I = !(!!C?.length).valueOf() && !(!!g?.length).valueOf() && !(!!F?.length).valueOf() && !(!!N?.length).valueOf(), D = !v && !j && !!F?.length && !!N?.length && !!n?.showDanglingLinks, U = n?.enableCreateIssue, Q = !!C?.length || !!g?.length;
  return !j && z ? /* @__PURE__ */ ke.jsx(In, { error: z, retry: () => d() }) : /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
    /* @__PURE__ */ ke.jsxs(b, { className: Hi.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ ke.jsxs(b, { className: Hi.inputWrapper, flexDirection: "column", children: [
        U && /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
          /* @__PURE__ */ ke.jsx(
            Yn,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: Hi.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ ke.jsx("div", { className: Hi.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ ke.jsx(
          aP,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: C,
            linkedPullRequests: g
          }
        )
      ] }),
      j ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ke.jsx(fn, { "data-testid": "github-widget-item-spinner" }) }) : Q ? /* @__PURE__ */ ke.jsx(
        KR,
        {
          items: [...C, ...g],
          unlinkGithubItem: p,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ ke.jsx(A.Paragraph, { align: "center", className: Hi.noItemsFound, children: "No linked items found." }),
      D && /* @__PURE__ */ ke.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ ke.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ ke.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              F.map((X) => /* @__PURE__ */ ke.jsx(
                qn,
                {
                  onDelete: () => p({
                    key: X,
                    type: "ISSUE"
                  }),
                  children: mr(X)
                },
                mr(X)
              )),
              N.map((X) => /* @__PURE__ */ ke.jsx(
                qn,
                {
                  onDelete: () => p({ key: X, type: "PR" }),
                  children: mr(X)
                },
                mr(X)
              ))
            ] }),
            /* @__PURE__ */ ke.jsx(
              Yn,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && Q && /* @__PURE__ */ ke.jsx(
        Yn,
        {
          variant: "secondary",
          disabled: I,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ ke.jsx(
        Rt,
        {
          slotEnd: /* @__PURE__ */ ke.jsx(pe, { name: "external-link" }),
          variant: "tertiary",
          className: Hi.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ ke.jsx(
      _P,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: T,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, Ih = [
  {
    key: "githubOrganization",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], gi = "GITHUB", FP = {
  enabled: !1,
  name: "",
  githubOrganization: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0
}, IP = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = gt({
    mode: "onChange",
    defaultValues: FP
  }), {
    create: u,
    update: p,
    remove: d,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: F
  } = Xr({
    integrationId: e,
    integrationType: gi,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: C,
    refetch: g,
    widgetConfiguration: z
  } = Zr({
    integrationId: e,
    fieldDefinitions: Ih,
    form: l,
    onMisconfigured: F
  }), { renderConditions: T, setRenderConditions: I, renderConditionsForSubmit: D } = ei({
    integrationId: e,
    widgetConfiguration: z,
    renderConditionsEditor: o
  }), U = (X) => ti(X, {
    fieldDefinitions: Ih,
    isCreationMode: s,
    create: u,
    update: p,
    renderConditions: D
  }), Q = l.watch("name");
  return /* @__PURE__ */ ke.jsxs(
    ni,
    {
      form: l,
      integrationId: e,
      onValidSubmit: U,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: C,
      children: [
        v && /* @__PURE__ */ ke.jsx(ri, { cause: v }),
        /* @__PURE__ */ ke.jsxs(at, { children: [
          /* @__PURE__ */ ke.jsx(me, { children: /* @__PURE__ */ ke.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ke.jsx(
            Pn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(me, { span: 3, children: /* @__PURE__ */ ke.jsx(
            Qn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ke.jsx(me, { span: 3 }),
          /* @__PURE__ */ ke.jsx(me, { span: 3, children: /* @__PURE__ */ ke.jsx(
            Qn,
            {
              name: "githubOrganization",
              label: "GitHub organization or user",
              control: l.control,
              rules: { required: "GitHub organization or user is required" },
              componentProps: {
                placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ke.jsx(me, { span: 3 }),
          /* @__PURE__ */ ke.jsx(me, { span: 3, children: /* @__PURE__ */ ke.jsx(en, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ ke.jsx(
            Pn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(me, { span: 3 }),
          /* @__PURE__ */ ke.jsx(me, { span: 3, children: /* @__PURE__ */ ke.jsx(en, { label: "Show unresolved links to GitHub items", children: /* @__PURE__ */ ke.jsx(
            Pn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(me, { span: 3 }),
          /* @__PURE__ */ ke.jsx(me, { span: 3, children: /* @__PURE__ */ ke.jsx(en, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ ke.jsx(
            Pn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(me, { span: 3 }),
          !s && e && /* @__PURE__ */ ke.jsx(
            ga,
            {
              configuration: n,
              integrationId: e,
              integrationType: gi,
              label: "Authorize with OAuth"
            }
          ),
          o && T !== null && /* @__PURE__ */ ke.jsx(me, { children: o({
            value: T,
            onChange: I,
            configurationKey: z?.id
          }) })
        ] }),
        /* @__PURE__ */ ke.jsx(
          ii,
          {
            integrationType: gi,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => d(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ ke.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ ke.jsx(
                pe,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ ke.jsxs(A.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  gi,
                  " integration, all links between Dixa and ",
                  gi,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ ke.jsxs(A.Paragraph, { children: [
                  "All data in ",
                  gi,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ ke.jsxs(A.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  gi,
                  " ",
                  'integration "',
                  Q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Wd = { exports: {} }, za = {}, O_;
function $P() {
  if (O_) return za;
  O_ = 1;
  var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return za.Fragment = r, za.jsx = s, za.jsxs = s, za;
}
var is = {}, R_;
function EP() {
  return R_ || (R_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[N];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        z("error", t, m);
      }
    }
    function z(t, c, m) {
      {
        var y = C.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var P = m.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var T = !1, I = !1, D = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || U || t === v || T || I || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function q(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return q(c) + ".Consumer";
          case s:
            var m = t;
            return q(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return R(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, be, fe, de, ge, K, xe, $e;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          be = console.log, fe = console.info, de = console.warn, ge = console.error, K = console.group, xe = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: be
            }),
            info: B({}, t, {
              value: fe
            }),
            warn: B({}, t, {
              value: de
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: K
            }),
            groupCollapsed: B({}, t, {
              value: xe
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = C.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var ze = !1, Re;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new on();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var m = Re.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      ze = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Le.current, Le.current = null, qe();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var S = te.stack.split(`
`), ne = y.stack.split(`
`), H = S.length - 1, x = ne.length - 1; H >= 1 && x >= 0 && S[H] !== ne[x]; )
            x--;
          for (; H >= 1 && x >= 0; H--, x--)
            if (S[H] !== ne[x]) {
              if (H !== 1 || x !== 1)
                do
                  if (H--, x--, x < 0 || S[H] !== ne[x]) {
                    var Z = `
` + S[H].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (H >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Le.current = P, Me(), Error.prepareStackTrace = $;
      }
      var ue = t ? t.displayName || t.name : "", _e = ue ? De(ue) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Qe(t, c, m) {
      return Ee(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Xe(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case d:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Qe(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return se(P($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, je = {}, Ve = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function dn(t, c, m, y, $) {
      {
        var P = Function.call.bind(ye);
        for (var w in t)
          if (P(t, w)) {
            var S = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + m + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[w](c, w, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              S = H;
            }
            S && !(S instanceof Error) && (Oe($), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, w, typeof S), Oe(null)), S instanceof Error && !(S.message in je) && (je[S.message] = !0, Oe($), g("Failed %s type: %s", m, S.message), Oe(null));
          }
      }
    }
    var E = Array.isArray;
    function _(t) {
      return E(t);
    }
    function O(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function W(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function L(t) {
      if (W(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", O(t)), J(t);
    }
    var M = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Ze(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function sn(t, c) {
      {
        var m = function() {
          he || (he = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function hn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, m, y, $, P, w) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function _n(t, c, m, y, $) {
      {
        var P, w = {}, S = null, ne = null;
        m !== void 0 && (L(m), S = "" + m), mn(c) && (L(c.key), S = "" + c.key), nn(c) && (ne = c.ref, Ze(c));
        for (P in c)
          ye.call(c, P) && !ie.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var H = t.defaultProps;
          for (P in H)
            w[P] === void 0 && (w[P] = H[P]);
        }
        if (S || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && sn(w, x), ne && hn(w, x);
        }
        return pn(t, S, ne, $, y, M.current, w);
      }
    }
    var Je = C.ReactCurrentOwner, Nn = C.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(m);
      } else
        Nn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (Je.current) {
          var t = R(Je.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Mn(t) {
      return "";
    }
    var jn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = kn(c);
        if (jn[m])
          return;
        jn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Je.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ae(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ae(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            cn(y) && gn(y, c);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              cn(w.value) && gn(w.value, c);
        }
      }
    }
    function zn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = R(c);
          dn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var $ = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function An(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ae(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var xn = {};
    function Sn(t, c, m, y, $, P) {
      {
        var w = re(t);
        if (!w) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = Mn();
          ne ? S += ne : S += vn();
          var H;
          t === null ? H = "null" : _(t) ? H = "array" : t !== void 0 && t.$$typeof === n ? (H = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : H = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, S);
        }
        var x = _n(t, c, m, $, P);
        if (x == null)
          return x;
        if (w) {
          var Z = c.children;
          if (Z !== void 0)
            if (y)
              if (_(Z)) {
                for (var ue = 0; ue < Z.length; ue++)
                  wn(Z[ue], t);
                Object.freeze && Object.freeze(Z);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = R(t), te = Object.keys(c).filter(function($n) {
            return $n !== "key";
          }), Ke = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? An(x) : zn(x), x;
      }
    }
    function Bn(t, c, m) {
      return Sn(t, c, m, !0);
    }
    function On(t, c, m) {
      return Sn(t, c, m, !1);
    }
    var Rn = On, Un = Bn;
    is.Fragment = i, is.jsx = Rn, is.jsxs = Un;
  })()), is;
}
var P_;
function TP() {
  return P_ || (P_ = 1, process.env.NODE_ENV === "production" ? Wd.exports = $P() : Wd.exports = EP()), Wd.exports;
}
var we = TP(), yo = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(yo || {}), Si = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(Si || {}), Qt = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(Qt || {});
const DP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, OP = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": DP
};
function RP(e) {
  return OP[e] ?? {};
}
const PP = RP(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), A_ = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, M1 = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, AP = "_listItem_16pij_4", LP = "_clickableIcon_16pij_15", Do = {
  listItem: AP,
  clickableIcon: LP
}, B1 = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = le(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ we.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ we.jsx(pe, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ we.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ we.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: Do.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ we.jsx(
              pe,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ we.jsx(We, { children: e.map((l, u) => {
      if (!l) return null;
      const { name: p, quantity: d, price: f, image: h, sku: v } = l, F = l.currency ?? r;
      return /* @__PURE__ */ we.jsx(
        We.Item,
        {
          contentLeft: /* @__PURE__ */ we.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ we.jsx(A.Paragraph, { children: d }),
            /* @__PURE__ */ we.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ we.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", children: p }),
            f != null && /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: M1(f / 100, F) })
          ] }),
          contentRight: h && /* @__PURE__ */ we.jsx(ka, { src: h, alt: p ?? "Product image" }),
          className: Do.listItem
        },
        `item-${u}-${v}`
      );
    }) })
  ] }) });
}, VP = "_boxWrapper_89s7l_1", zP = "_trackButton_89s7l_10", L_ = {
  boxWrapper: VP,
  trackButton: zP
}, UP = {
  [Qt.StepUnknown]: "Unknown",
  [Qt.StepConfirmedByMerchant]: "Confirmed by merchant",
  [Qt.StepPreparedByMerchant]: "Prepared by merchant",
  [Qt.StepSubmittedToCarrier]: "Submitted to carrier",
  [Qt.StepLinehaulToCarrier]: "Linehaul to carrier",
  [Qt.StepOnRoute]: "On route",
  [Qt.StepDeliveredToPickupPoint]: "At pickup point",
  [Qt.StepDeliveredToConsumer]: "Delivered to customer",
  [Qt.StepDeliveredToMerchant]: "Returned to merchant",
  [Qt.StepReturnRequested]: "Return requested",
  [Qt.StepSentBack]: "Sent back",
  [Qt.StepTerminated]: "Terminated",
  [Qt.StepAwaitingSupplier]: "Awaiting supplier"
}, MP = {
  [Si.Delivery]: "Home delivery",
  [Si.Pickup]: "Pickup point",
  [Si.Instore]: "In-store pickup",
  [Si.Mailbox]: "Mailbox",
  [Si.Inwarehouse]: "Warehouse",
  [Si.Unknown]: "Unknown"
}, BP = {
  [yo.Outbound]: "From merchant to customer",
  [yo.Return]: "Return from customer to merchant",
  [yo.Unspecified]: "Unspecified",
  [yo.UnknownDirectionType]: "Unknown"
}, qP = (e) => e ? UP[e] ?? e : "", HP = (e) => e ? MP[e] ?? e : "", WP = (e) => e ? BP[e] ?? e : "", KP = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, GP = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = Gt();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: u,
    display_carrier_name: p,
    delivery_type: d,
    direction_type: f,
    estimated_delivery_time: h
  } = e, v = p || l || i, F = a?.filter((T) => T?.time !== ""), N = qP(F?.[0]?.step), j = HP(d), C = WP(f), g = KP(e.location?.address), z = 14;
  return /* @__PURE__ */ we.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: L_.boxWrapper,
      children: [
        /* @__PURE__ */ we.jsx(A.Heading, { variant: "heading-4", children: v }),
        /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ we.jsx(
              pe,
              {
                size: z,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ we.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ we.jsx(Ge, { content: "Copy tracking ID", children: /* @__PURE__ */ we.jsx(
            pe,
            {
              size: z,
              name: n ? "done" : "copy",
              className: Do.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        N && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(pe, { size: z, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", color: "secondary", children: N })
          ] })
        ] }),
        C && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(pe, { size: z, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", color: "secondary", children: C })
          ] })
        ] }),
        h && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(pe, { size: z, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ we.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
              A_(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", color: "secondary", children: A_(h.end) })
          ] })
        ] }),
        d && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(pe, { size: z, name: "info", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", color: "secondary", children: j })
          ] })
        ] }),
        g && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(pe, { size: z, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", color: "secondary", children: g })
          ] })
        ] }),
        /* @__PURE__ */ we.jsx(B1, { title: "Parcel items", items: s }),
        u && /* @__PURE__ */ we.jsxs(
          Rt,
          {
            variant: "secondary",
            className: L_.trackButton,
            navigate: () => window.open(u, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ we.jsx(pe, { name: "external-link" }),
            children: [
              "Track on ",
              v ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, YP = "_order_135ze_1", QP = "_orderIsOpen_135ze_9", JP = "_orderHeader_135ze_12", Kd = {
  order: YP,
  orderIsOpen: QP,
  orderHeader: JP
}, V_ = "No order number found", XP = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = le(n), { isCopied: a, copy: o } = Gt(), { isCopied: s, copy: l } = Gt();
  if (!e)
    return null;
  const { cart: u, parcels: p, sender_name: d, tos_id: f } = e, h = e.external_id?.trim(), v = u?.currency || "", F = u?.prices?.total?.price ?? 0, N = M1(F / 100, v), j = 14, C = d && d.trim() !== "" ? d : "unknown sender";
  return /* @__PURE__ */ we.jsxs(
    b,
    {
      className: it(Kd.order, {
        [Kd.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ we.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Kd.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ we.jsxs(A.Paragraph, { variant: "4", children: [
                  "From ",
                  C
                ] }),
                h ? /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "3", children: /* @__PURE__ */ we.jsxs("span", { children: [
                  "#",
                  h
                ] }) }) : /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: V_ })
              ] }),
              /* @__PURE__ */ we.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ we.jsx(pe, { size: j, name: "tag", color: "blue.900" }),
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "3", children: "Order number" }),
                /* @__PURE__ */ we.jsx(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: h ? /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", color: "secondary", children: h }) : /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: V_ }) })
              ] })
            ] }),
            h && /* @__PURE__ */ we.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ we.jsx(Ge, { content: "Copy order number", children: /* @__PURE__ */ we.jsx(
              pe,
              {
                size: j,
                name: s ? "done" : "copy",
                className: Do.clickableIcon,
                onClick: () => l(h)
              }
            ) }) })
          ] }),
          /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ we.jsx(
                pe,
                {
                  size: j,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !f && /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  f && /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", color: "secondary", children: f })
                ] })
              ] })
            ] }),
            f && /* @__PURE__ */ we.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ we.jsx(Ge, { content: "Copy tracking ID", children: /* @__PURE__ */ we.jsx(
              pe,
              {
                size: j,
                name: a ? "done" : "copy",
                className: Do.clickableIcon,
                onClick: () => o(f)
              }
            ) }) })
          ] }),
          d && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ we.jsx(pe, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", children: d })
            ] })
          ] }),
          /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ we.jsx(pe, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", children: N })
            ] })
          ] }),
          /* @__PURE__ */ we.jsx(
            B1,
            {
              openByDefault: !0,
              title: "Order items",
              items: u?.items?.map((g) => g),
              currency: u?.currency
            }
          ),
          p && /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ we.jsx(A.Heading, { variant: "heading-4", children: "Parcels" }),
              p.length > 0 && /* @__PURE__ */ we.jsx(Vn, { variant: "success", size: "small", children: p.length })
            ] }),
            p.length === 0 && /* @__PURE__ */ we.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            p.map((g, z) => /* @__PURE__ */ we.jsx(
              GP,
              {
                parcel: g
              },
              `parcel-${z}-${g?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, ZP = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, z_ = (e) => {
  let n = 1 / 0;
  for (const r of e?.parcels ?? [])
    for (const i of r?.progress ?? []) {
      if (!i?.time)
        continue;
      const a = new Date(i.time).getTime();
      !Number.isNaN(a) && a < n && (n = a);
    }
  return n === 1 / 0 ? -1 / 0 : n;
}, eA = (e) => [...e].sort(
  (n, r) => z_(r) - z_(n)
), nA = ({
  customerEmail: e
}) => {
  const { useQuery: n } = yn(), [r, i] = le([]), a = !e, { data: o, loading: s, error: l } = n(PP, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), u = !s && r.length > 0, p = l ? iI({
    error: l.graphQLErrors?.[0]
  }) : !1, d = l ? fw({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return Ye(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(
      eA(
        ZP(f.orders)
      )
    );
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ we.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ we.jsx(fn, {}) }) : p || !u && !l ? /* @__PURE__ */ we.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : d ? /* @__PURE__ */ we.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ we.jsx(In, { error: l }) : /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ we.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ we.jsx(Vn, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ we.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ we.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ we.jsx(
      XP,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, tA = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ we.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ we.jsx(nA, { customerEmail: n })
    }
  );
}, $h = [
  {
    key: "ingridUseStagingEnvironment",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "ingridApiToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], rA = {
  enabled: !1,
  name: "",
  ingridSiteId: "",
  ingridApiToken: "",
  ingridUseStagingEnvironment: !1
}, iA = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = gt({
    mode: "onChange",
    defaultValues: rA
  }), {
    create: l,
    update: u,
    remove: p,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = Xr({
    integrationId: e,
    integrationType: "INGRID",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: N,
    isWidgetUnknown: j,
    refetch: C,
    widgetConfiguration: g
  } = Zr({
    integrationId: e,
    fieldDefinitions: $h,
    form: s,
    onMisconfigured: v
  }), { renderConditions: z, setRenderConditions: T, renderConditionsForSubmit: I } = ei({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), D = (Q) => ti(Q, {
    fieldDefinitions: $h,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: I
  }), U = s.watch("name");
  return /* @__PURE__ */ we.jsxs(
    ni,
    {
      form: s,
      integrationId: e,
      onValidSubmit: D,
      error: N ?? f,
      onRetry: N ? C : void 0,
      isLoading: d || F,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ we.jsx(ri, { cause: h }),
        /* @__PURE__ */ we.jsxs(at, { children: [
          /* @__PURE__ */ we.jsx(me, { children: /* @__PURE__ */ we.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ we.jsx(
            Pn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(me, { span: 3, children: /* @__PURE__ */ we.jsx(
            Qn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ we.jsx(me, { span: 3 }),
          /* @__PURE__ */ we.jsx(me, { span: 3, children: /* @__PURE__ */ we.jsx(en, { label: "Use Ingrid staging environment", children: /* @__PURE__ */ we.jsx(
            Pn,
            {
              name: "ingridUseStagingEnvironment",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(me, { span: 3 }),
          /* @__PURE__ */ we.jsx(me, { span: 3, children: /* @__PURE__ */ we.jsx(
            Qn,
            {
              name: "ingridSiteId",
              label: "Site ID",
              control: s.control,
              rules: { required: "Site ID is required" },
              componentProps: {
                placeholder: "Site ID from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ we.jsx(me, { span: 3 }),
          /* @__PURE__ */ we.jsx(me, { span: 3, children: /* @__PURE__ */ we.jsx(
            Ro,
            {
              name: "ingridApiToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "API token from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ we.jsx(me, { span: 3 }),
          a && z !== null && /* @__PURE__ */ we.jsx(me, { children: a({
            value: z,
            onChange: T,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ we.jsx(
          ii,
          {
            integrationType: "INGRID",
            integrationId: e,
            widgetName: U,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_axxxc_48{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_axxxc_48:hover,._result_axxxc_48:focus{background-color:var(--dixa-color-neutral-100)}._resultName_axxxc_68{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_axxxc_76{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_axxxc_81{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_axxxc_93{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_axxxc_102{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_axxxc_108{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_axxxc_115{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_axxxc_120{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_axxxc_125{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_axxxc_133{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_axxxc_137{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Gd = { exports: {} }, Ua = {}, U_;
function aA() {
  if (U_) return Ua;
  U_ = 1;
  var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ua.Fragment = r, Ua.jsx = s, Ua.jsxs = s, Ua;
}
var as = {}, M_;
function oA() {
  return M_ || (M_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[N];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        z("error", t, m);
      }
    }
    function z(t, c, m) {
      {
        var y = C.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var P = m.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var T = !1, I = !1, D = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || U || t === v || T || I || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function q(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return q(c) + ".Consumer";
          case s:
            var m = t;
            return q(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return R(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, be, fe, de, ge, K, xe, $e;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          be = console.log, fe = console.info, de = console.warn, ge = console.error, K = console.group, xe = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: be
            }),
            info: B({}, t, {
              value: fe
            }),
            warn: B({}, t, {
              value: de
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: K
            }),
            groupCollapsed: B({}, t, {
              value: xe
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = C.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var ze = !1, Re;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new on();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var m = Re.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      ze = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Le.current, Le.current = null, qe();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var S = te.stack.split(`
`), ne = y.stack.split(`
`), H = S.length - 1, x = ne.length - 1; H >= 1 && x >= 0 && S[H] !== ne[x]; )
            x--;
          for (; H >= 1 && x >= 0; H--, x--)
            if (S[H] !== ne[x]) {
              if (H !== 1 || x !== 1)
                do
                  if (H--, x--, x < 0 || S[H] !== ne[x]) {
                    var Z = `
` + S[H].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (H >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Le.current = P, Me(), Error.prepareStackTrace = $;
      }
      var ue = t ? t.displayName || t.name : "", _e = ue ? De(ue) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Qe(t, c, m) {
      return Ee(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Xe(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case d:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Qe(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return se(P($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, je = {}, Ve = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function dn(t, c, m, y, $) {
      {
        var P = Function.call.bind(ye);
        for (var w in t)
          if (P(t, w)) {
            var S = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + m + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[w](c, w, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              S = H;
            }
            S && !(S instanceof Error) && (Oe($), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, w, typeof S), Oe(null)), S instanceof Error && !(S.message in je) && (je[S.message] = !0, Oe($), g("Failed %s type: %s", m, S.message), Oe(null));
          }
      }
    }
    var E = Array.isArray;
    function _(t) {
      return E(t);
    }
    function O(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function W(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function L(t) {
      if (W(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", O(t)), J(t);
    }
    var M = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Ze(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function sn(t, c) {
      {
        var m = function() {
          he || (he = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function hn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, m, y, $, P, w) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function _n(t, c, m, y, $) {
      {
        var P, w = {}, S = null, ne = null;
        m !== void 0 && (L(m), S = "" + m), mn(c) && (L(c.key), S = "" + c.key), nn(c) && (ne = c.ref, Ze(c));
        for (P in c)
          ye.call(c, P) && !ie.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var H = t.defaultProps;
          for (P in H)
            w[P] === void 0 && (w[P] = H[P]);
        }
        if (S || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && sn(w, x), ne && hn(w, x);
        }
        return pn(t, S, ne, $, y, M.current, w);
      }
    }
    var Je = C.ReactCurrentOwner, Nn = C.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(m);
      } else
        Nn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (Je.current) {
          var t = R(Je.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Mn(t) {
      return "";
    }
    var jn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = kn(c);
        if (jn[m])
          return;
        jn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Je.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ae(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ae(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            cn(y) && gn(y, c);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              cn(w.value) && gn(w.value, c);
        }
      }
    }
    function zn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = R(c);
          dn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var $ = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function An(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ae(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var xn = {};
    function Sn(t, c, m, y, $, P) {
      {
        var w = re(t);
        if (!w) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = Mn();
          ne ? S += ne : S += vn();
          var H;
          t === null ? H = "null" : _(t) ? H = "array" : t !== void 0 && t.$$typeof === n ? (H = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : H = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, S);
        }
        var x = _n(t, c, m, $, P);
        if (x == null)
          return x;
        if (w) {
          var Z = c.children;
          if (Z !== void 0)
            if (y)
              if (_(Z)) {
                for (var ue = 0; ue < Z.length; ue++)
                  wn(Z[ue], t);
                Object.freeze && Object.freeze(Z);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = R(t), te = Object.keys(c).filter(function($n) {
            return $n !== "key";
          }), Ke = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? An(x) : zn(x), x;
      }
    }
    function Bn(t, c, m) {
      return Sn(t, c, m, !0);
    }
    function On(t, c, m) {
      return Sn(t, c, m, !1);
    }
    var Rn = On, Un = Bn;
    as.Fragment = i, as.jsx = Rn, as.jsxs = Un;
  })()), as;
}
var B_;
function sA() {
  return B_ || (B_ = 1, process.env.NODE_ENV === "production" ? Gd.exports = aA() : Gd.exports = oA()), Gd.exports;
}
var ce = sA();
const Yy = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => Yy(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, lA = "_jiraCode_h30p6_1", cA = "_jiraCodeInline_h30p6_8", Yd = {
  jiraCode: lA,
  jiraCodeInline: cA
}, q1 = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ ce.jsx(ce.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ ce.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ ce.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ ce.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ ce.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ ce.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ ce.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ ce.jsx("pre", { children: /* @__PURE__ */ ce.jsx("code", { className: Yd.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ ce.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ ce.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ ce.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ ce.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ ce.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ ce.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ ce.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ ce.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ ce.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ ce.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ ce.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ ce.jsx("code", { className: it(Yd.jiraCode, Yd.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, al = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = le(!1);
  return !e || i ? /* @__PURE__ */ ce.jsx(pe, { size: r, name: "question", className: n }) : /* @__PURE__ */ ce.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, uA = "_collapse_m2gjh_1", dA = "_collapseHeader_m2gjh_10", mA = "_collapseHeaderLink_m2gjh_31", pA = "_collapseHeaderStatus_m2gjh_40", fA = "_collapseHeaderTitle_m2gjh_51", hA = "_collapseContent_m2gjh_59", yA = "_collapseContentHeadline_m2gjh_62", gA = "_collapseContentButtonSpacer_m2gjh_68", vA = "_collapseContentButtonLink_m2gjh_71", kA = "_collapseContentStatusTag_m2gjh_74", bA = "_collapseContentDescription_m2gjh_77", kr = {
  collapse: uA,
  collapseHeader: dA,
  collapseHeaderLink: mA,
  collapseHeaderStatus: pA,
  collapseHeaderTitle: fA,
  collapseContent: hA,
  collapseContentHeadline: yA,
  collapseContentButtonSpacer: gA,
  collapseContentButtonLink: vA,
  collapseContentStatusTag: kA,
  collapseContentDescription: bA
}, H1 = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, _A = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (u, p) => p?.id ? { ...u, [p.id]: !1 } : u,
    {}
  ), [a, o] = le(i), { track: s } = Cn(), l = (u, p) => {
    o({ ...a, [u]: p });
  };
  return /* @__PURE__ */ ce.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((u) => {
    const { summary: p, description: d, status: f, issuetype: h } = u?.fields || {}, v = H1({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), F = !!(u?.id && a[u.id]);
    return /* @__PURE__ */ ce.jsxs(
      hr,
      {
        onToggle: () => u?.id && l(u.id, !a[u.id]),
        isOpen: F,
        className: kr.collapse,
        children: [
          /* @__PURE__ */ ce.jsx(hr.Header, { className: kr.collapseHeader, children: /* @__PURE__ */ ce.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ ce.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ ce.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ ce.jsx(al, { width: 16, iconUrl: v }),
                    /* @__PURE__ */ ce.jsx(
                      "a",
                      {
                        className: kr.collapseHeaderLink,
                        href: `${n}/browse/${u?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (N) => {
                          N.stopPropagation(), u?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: u.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ ce.jsxs(b, { alignItems: "center", gap: "200", children: [
                          u?.key,
                          /* @__PURE__ */ ce.jsx(pe, { name: "external-link", size: 16 })
                        ] })
                      },
                      u?.key
                    )
                  ] }),
                  /* @__PURE__ */ ce.jsx("span", { className: kr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ ce.jsx(qn, { className: kr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ ce.jsx("div", { className: kr.collapseHeaderTitle, children: p })
              ]
            }
          ) }),
          /* @__PURE__ */ ce.jsx(hr.Content, { className: kr.collapseContent, children: /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ ce.jsx("div", { className: kr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ ce.jsx(tt, { className: kr.collapseContentDescription, children: d ? Yy(d, q1) : "" }),
            /* @__PURE__ */ ce.jsx(
              Yn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: kr.collapseContentButtonSpacer,
                onClick: () => u?.key && r(u.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ ce.jsx(
              Rt,
              {
                slotEnd: /* @__PURE__ */ ce.jsx(pe, { name: "external-link" }),
                variant: "tertiary",
                className: kr.collapseContentButtonLink,
                navigate: () => {
                  u?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: u.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${u.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      u?.id
    );
  }) : /* @__PURE__ */ ce.jsx(ce.Fragment, {}) });
}, xA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, SA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, NA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, jA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, wA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, CA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, FA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, IA = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': xA,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": SA,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": NA,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": jA,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': wA,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': CA,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": FA
};
function Vi(e) {
  return IA[e] ?? {};
}
const W1 = Vi(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), $A = Vi(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), EA = Vi(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), TA = Vi(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), DA = Vi(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), OA = Vi(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), RA = Vi(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), Qy = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), PA = new RegExp(`^${Qy.source}$`), AA = new RegExp(`/${Qy.source}$`), q_ = new RegExp(
  `.+?[&?]selectedIssue=(${Qy.source})[&?]?.*`
);
function K1(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = le([]), [o, s] = le([]), [l, u] = le(), { track: p } = Cn(), { showNotification: d, showModal: f, useLazyQuery: h, useMutation: v } = yn(), {
    loading: F,
    data: N,
    error: j,
    store: C
  } = uy(e ?? null), [
    g,
    { loading: z, error: T, data: I }
  ] = h(W1, {
    notifyOnNetworkStatusChange: !0
  });
  Ye(() => {
    const de = I?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    de?.length && (s(de), a(de.map((ge) => ge?.key).filter(Boolean)));
  }, [I]), Ye(
    () => u(j || T || void 0),
    [j, T]
  ), Ye(
    () => {
      F || q();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [N?.jira?.issues, F]
  );
  const D = async (de, ge) => {
    await C(de).then(() => {
      d({
        icon: "check-circle-filled",
        severity: "success",
        title: ge.success.title,
        text: ge.success.text
      });
    }).catch((K) => {
      d({
        title: ge.error.title,
        text: `${ge.error.text} ${K.message && " (" + K.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [U] = v($A, {
    onError: (de) => {
      d({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${de.message && " (" + de.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), Q = (de, ge) => {
    const K = window.location.href, xe = ge ? K.replace(
      e?.toString() ?? "",
      ge?.toString()
    ) : K, $e = ge ? `# ${ge}` : `# ${e}`;
    U({
      variables: {
        issueKey: de,
        title: $e,
        url: xe,
        globalId: `system=${xe}`
      }
    });
  }, [X] = v(EA, {
    onError: (de) => {
      d({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${de.message && " (" + de.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), re = (de) => {
    const ge = window.location.href;
    X({
      variables: {
        issueKey: de,
        globalId: `system=${ge}`
      }
    });
  }, G = (de) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: de
  }), q = () => {
    N && N.jira?.issues?.length > 0 ? g({
      variables: {
        jql: `key in (${N?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, R = async (de, ge) => {
    p("jira:issue:link:clicked", G(de));
    const K = N?.jira?.issues ? N : r;
    K.jira.issues = Array.from(
      new Set(K.jira.issues).add(de)
    ), await C(K, ge?.toString()).then(() => Q(de, ge)).catch((xe) => {
      d({
        title: "Linking failed",
        text: `Linking ${de} failed. Please try again. ${xe.message && " (" + xe.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, B = (de) => {
    p("jira:issue:link:clicked", G(de));
    const ge = N?.jira?.issues ? N : r;
    ge.jira.issues = Array.from(
      new Set(ge.jira.issues).add(de)
    ), D(ge, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${de} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${de} failed. Please try again.`
      }
    }).then(() => Q(de));
  }, ee = (de) => {
    p("jira:issue:unlink:clicked", G(de)), f({
      headline: `Unlink issue ${de}?`,
      text: `You are about to unlink the issue ${de}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        p("jira:issue:unlink:confirmed", G(de));
        const ge = {
          ...N,
          jira: {
            ...N?.jira,
            issues: N?.jira?.issues.filter((K) => K !== de) || []
          }
        };
        D(ge, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${de}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${de} failed.`
          }
        }).then(() => re(de));
      },
      onCancel: () => p("jira:issue:unlink:cancelled", G(de))
    });
  }, be = () => {
    p("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        p("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((de) => de?.key && re(de.key)), D(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => p("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, fe = N?.jira?.issues?.filter(
    (de) => !i?.includes(de)
  ) || [];
  return {
    linkIssue: B,
    linkIssueQuietly: R,
    unlinkIssue: ee,
    loadIssues: q,
    removeDanglingIssueLinks: () => {
      p("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const de = {
        ...N,
        jira: {
          ...N?.jira,
          issues: N?.jira?.issues.filter(
            (ge) => !fe.includes(ge)
          ) || []
        }
      };
      C(de);
    },
    unlinkAllIssues: be,
    maybeExtractIssueKey: (de) => {
      const ge = de.replace(/\s/g, "");
      if (PA.test(ge))
        return ge;
      if (q_.test(de))
        return de.match(q_)?.[1];
      if (de.startsWith(n) && AA.test(de))
        return de.substring(de.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: F,
    danglingIssueLinks: fe,
    isLoadingIssues: z,
    issues: o,
    error: l
  };
}
function LA(e = !1, n) {
  const [r, i] = le(e);
  return Ye(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const VA = "_result_axxxc_48", zA = "_resultName_axxxc_68", UA = "_resultNameIcon_axxxc_76", MA = "_resultDescription_axxxc_81", BA = "_resultLinkIcon_axxxc_93", qA = "_tooltip_axxxc_102", HA = "_tooltipContent_axxxc_108", WA = "_tooltipName_axxxc_115", KA = "_tooltipNameIcon_axxxc_120", GA = "_tooltipDescription_axxxc_125", YA = "_tooltipSummary_axxxc_133", QA = "_tooltipTag_axxxc_137", dr = {
  result: VA,
  resultName: zA,
  resultNameIcon: UA,
  resultDescription: MA,
  resultLinkIcon: BA,
  tooltip: qA,
  tooltipContent: HA,
  tooltipName: WA,
  tooltipNameIcon: KA,
  tooltipDescription: GA,
  tooltipSummary: YA,
  tooltipTag: QA
}, JA = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: u, description: p } = e, [d, f] = le(!1), h = H1({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ ce.jsx(
    Ge,
    {
      disabled: i,
      className: dr.tooltip,
      content: /* @__PURE__ */ ce.jsxs("div", { className: dr.tooltipContent, children: [
        /* @__PURE__ */ ce.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ ce.jsxs("span", { className: dr.tooltipName, children: [
                /* @__PURE__ */ ce.jsx(
                  al,
                  {
                    width: 16,
                    iconUrl: h,
                    className: dr.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ ce.jsx(qn, { className: dr.tooltipTag, children: l.name })
            ]
          }
        ),
        p && /* @__PURE__ */ ce.jsx("div", { className: dr.tooltipSummary, children: p }),
        u && /* @__PURE__ */ ce.jsx("div", { className: dr.tooltipDescription, children: u })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ ce.jsxs(
        "button",
        {
          ...a,
          className: dr.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ ce.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: d ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ ce.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ ce.jsxs("span", { className: dr.resultName, children: [
                    /* @__PURE__ */ ce.jsx(
                      al,
                      {
                        width: 16,
                        iconUrl: h,
                        className: dr.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  p && /* @__PURE__ */ ce.jsx("div", { className: dr.resultDescription, children: p })
                ]
              }
            ),
            d && /* @__PURE__ */ ce.jsx(
              pe,
              {
                className: dr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, XA = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ ce.jsx(
  Rt,
  {
    slotEnd: /* @__PURE__ */ ce.jsx(pe, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), ZA = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = yn(), [o, s] = le([]), [l, u] = le(""), [p, { loading: d, error: f, data: h, networkStatus: v }] = a(W1, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: F } = K1(null, n);
  Pi(
    () => {
      !d && l && v === rr.ready ? p({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), Ye(() => {
    const T = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      T.map((I) => ({
        id: I?.key ?? "",
        name: I?.key ?? "",
        description: I?.fields.summary,
        status: I?.fields.status,
        issuetype: I?.fields.issuetype,
        text: I?.fields.description ? Yy(I?.fields.description, q1) : /* @__PURE__ */ ce.jsx(ce.Fragment, {})
      }))
    );
  }, [h]);
  const N = (T) => {
    e(T.id), u("");
  }, j = (T) => {
    const I = T.trim(), D = F(I);
    if (D) {
      const U = D.replaceAll("[-_|]", "\\\\$0");
      u(`key = '${U}'`);
    } else I !== "" && u(
      `text ~ '${I}'${r ? " and project = " + r : ""}`
    );
  }, C = () => {
    u("");
  }, g = (T) => /* @__PURE__ */ ce.jsx(XA, { ...T, jiraInstanceUrl: n }), z = (T) => /* @__PURE__ */ ce.jsx(
    JA,
    {
      ...T,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !d && f ? /* @__PURE__ */ ce.jsx(In, { error: f }) : /* @__PURE__ */ ce.jsx(
    Fr,
    {
      items: o,
      loading: d,
      onSearch: j,
      onSelect: N,
      onClear: C,
      emptyMessage: l ? d ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: g,
      itemComponent: z,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, eL = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = le(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: u }) => u !== s.id)
    );
  };
  return Ye(() => {
    r(i);
  }, [i]), /* @__PURE__ */ ce.jsx(
    Fr,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: u }) => ({
          id: s,
          name: l || u
        })
      )
    }
  );
}, nL = "_itemButton_1hl53_1", tL = "_result_1hl53_6", rL = "_resultIcon_1hl53_26", iL = "_resultName_1hl53_30", aL = "_resultCheckIcon_1hl53_38", Ma = {
  itemButton: nL,
  result: tL,
  resultIcon: rL,
  resultName: iL,
  resultCheckIcon: aL
}, Eh = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ ce.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ ce.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: Ma.itemButton,
          children: /* @__PURE__ */ ce.jsxs(b, { className: Ma.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ ce.jsx(
              al,
              {
                width: 36,
                iconUrl: o || "",
                className: Ma.resultIcon
              }
            ),
            /* @__PURE__ */ ce.jsx(tt, { className: Ma.resultName, children: e.name }),
            n && /* @__PURE__ */ ce.jsx(tt, { className: Ma.resultCheckIcon, children: /* @__PURE__ */ ce.jsx(pe, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, oL = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = yn(), [o, s] = le([]), [l, u] = le(), p = 2, [d, { loading: f, error: h, data: v, networkStatus: F }] = a(RA, {
    notifyOnNetworkStatusChange: !0
  });
  return Pi(
    () => {
      !f && l && l.length >= p && F === rr.ready ? d({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Ye(() => {
    n && d({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((N) => {
      if (N?.data?.Jira.findUsers?.length === 1) {
        const j = N?.data?.Jira?.findUsers[0];
        r(j.accountId), s([
          {
            id: j.accountId,
            name: j.displayName
          }
        ]);
      }
    });
  }, []), Ye(() => {
    const N = v?.Jira?.findUsers || [];
    s(
      N.filter(({ active: j }) => j).map(({ accountId: j, displayName: C, avatarUrls: g, active: z }) => ({
        id: j,
        name: C,
        avatarUrls: g,
        active: z
      }))
    );
  }, [v]), !f && h ? /* @__PURE__ */ ce.jsx(In, { error: h }) : /* @__PURE__ */ ce.jsx(
    Fr,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (N) => u(N),
      onSelect: r,
      onClear: () => u(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: N, onSelect: j, checked: C }) => /* @__PURE__ */ ce.jsx(
        Eh,
        {
          item: N,
          checked: C,
          onSelectItem: j,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, H_ = ({
  field: e
}) => {
  const [n, r] = le(!1), [i, a] = t1();
  return Ye(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ ce.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ ce.jsx(b, { children: /* @__PURE__ */ ce.jsx(pe, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ ce.jsx(A.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ ce.jsx(Ge, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ ce.jsx(
      ir,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, sL = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ ce.jsx(H_, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ ce.jsx(fr, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ ce.jsx(bh, { onChange: n, value: r }) : /* @__PURE__ */ ce.jsx(fr, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ ce.jsx(bh, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ ce.jsx(fr, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ ce.jsx(
        oL,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ ce.jsx(
        Fr,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: u, value: p }) => ({
              id: l,
              name: u || p
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ ce.jsx(eL, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ ce.jsx(H_, { field: e });
  }
}, lL = ["description", "reporter", "summary"], cL = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ ce.jsx(ce.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || lL.includes(o)
).map((o) => /* @__PURE__ */ ce.jsx(
  Ot,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ ce.jsx(
      en,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: sL({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), uL = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ ce.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ ce.jsxs(A.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ ce.jsxs(
          A.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ ce.jsx(pe, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ ce.jsx(en, { label: "Jira issue link", children: /* @__PURE__ */ ce.jsx(
        fr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), dL = "_modalBody_1hk1o_1", mL = "_modalBodyFormFields_1hk1o_4", W_ = {
  modalBody: dL,
  modalBodyFormFields: mL
}, pL = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), fL = (e) => e?.custom?.split(":")?.[1] || null, hL = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, yL = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = hL(a, n), l = fL(s) ?? a;
        return r.includes(l) ? i[a] = pL(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, gL = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, u] = le([]), [p, d] = le(), [f, h] = le(0), [v, F] = le([]), [N, j] = le([]), [C, g] = le(!1), [z, T] = le(!1), [I, D] = le({}), { track: U } = Cn(), { isCopied: Q, copyToClipboard: X } = LA(), re = Kn(() => i?.conversationId, [e]), { useMutation: G, useLazyQuery: q, showNotification: R } = yn(), {
    control: B,
    handleSubmit: ee,
    formState: { errors: be },
    reset: fe,
    setValue: de,
    getValues: ge
  } = gt({
    defaultValues: s
  }), K = N.length > 0, xe = `${a}/browse`, $e = Object.keys(I).length > 0, [Y, { loading: qe, error: Me }] = q(TA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (ye) => {
      u(ye.Jira.getAllProjects);
    },
    onError: (ye) => {
      R({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", ye), u([]);
    }
  }), [
    Le,
    { loading: Ue, error: De }
  ] = q(DA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (ye) => {
      h(0);
      const je = ye?.Jira?.getCreateIssueMeta?.projects[0];
      if (je) {
        const Ve = je?.issuetypes.filter(
          ({ subtask: Oe }) => !Oe
        );
        F(Ve || []), de(
          "issuetype",
          Ve.length > 0 ? Ve[0] : void 0
        );
      } else
        R({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), F([]), j([]);
    },
    onError: (ye) => {
      R({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", ye), F([]), j([]), h(0);
    }
  }), [ze, { error: Re }] = G(
    OA,
    {
      onError: () => {
        g(!1), R({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), U("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (ye) => {
        if (g(!1), ye?.Jira && "key" in ye.Jira.createIssue)
          d(ye?.Jira?.createIssue), R({
            title: "Success",
            text: `Jira issue '${ye.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), U("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: ye.Jira.createIssue.key
          }), re && r(
            ye.Jira.createIssue.key,
            re
          );
        else if ("errorMessages" in ye.Jira.createIssue || "errors" in ye.Jira.createIssue) {
          const je = ye?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", je), R({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), on = (ye) => {
    g(!0), D({}), ze({
      variables: {
        input: yL(ye, N)
      }
    });
  };
  Ye(() => {
    if (e)
      try {
        Y();
      } catch (ye) {
        console.warn("Error when fetching initial projects", ye);
      }
  }, [e]), Ye(() => {
    const ye = z ? window.setTimeout(() => T(!1), 2e3) : void 0;
    return () => window.clearTimeout(ye);
  }, [z]), Ye(() => {
    if (v?.length > 0) {
      de("issuetype", v[f]);
      const ye = v[f]?.fields?.additionalProperties;
      if (ye?.length > 0) {
        const je = ye.map(
          ({ value: E }) => E
        ), Ve = (o ? je.sort(({ name: E }, { name: _ }) => E.localeCompare(_)) : je).sort(
          ({ required: E }, { required: _ }) => Number(_) - Number(E)
        ), { project: Oe, issuetype: dn } = ge();
        fe({ project: Oe, issuetype: dn }), j(Ve);
      }
    } else
      j([]), de("issuetype", void 0);
  }, [v, de, f]), Ye(() => {
    if (Re && Sw(Re)) {
      if (Re?.graphQLErrors?.length > 0) {
        const { graphQLErrors: ye } = Re, je = ye[0].extensions?.integration?.responseBody;
        try {
          const Ve = JSON.parse(je);
          if (Ve?.errors) {
            const Oe = Object.keys(Ve.errors).reduce(
              (dn, E) => ({
                ...dn,
                [E]: {
                  type: "required",
                  message: Ve.errors[E],
                  ref: {
                    name: E
                  }
                }
              }),
              {}
            );
            D(Oe);
          }
        } catch {
        }
      }
    } else
      D({});
  }, [Re]);
  const Ee = () => {
    u([]), j([]), F([]), d(void 0), h(0), g(!1), D({});
  }, Qe = () => {
    Ee(), fe(s), n();
  }, Xe = (ye) => {
    ye && Le({
      variables: {
        projectKey: ye
      }
    });
  }, se = (ye) => {
    const je = v.map((Ve) => Ve.id).indexOf(ye);
    h(je ?? 0);
  };
  return /* @__PURE__ */ ce.jsxs(
    jt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: Qe,
      children: [
        /* @__PURE__ */ ce.jsx(
          wt,
          {
            title: p ? "Issue creation successful" : "Create new Jira issue",
            onClose: Qe
          }
        ),
        /* @__PURE__ */ ce.jsxs(Ct, { className: W_.modalBody, children: [
          !qe && Me && /* @__PURE__ */ ce.jsx(In, { error: Me, retry: Y }),
          !Ue && De && /* @__PURE__ */ ce.jsx(
            In,
            {
              error: De,
              retry: Le
            }
          ),
          !C && $e && /* @__PURE__ */ ce.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ce.jsx(
            xl,
            {
              variant: "warning",
              description: /* @__PURE__ */ ce.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ ce.jsx(
                      Yn,
                      {
                        icon: Q ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => X(JSON.stringify(N, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          p ? /* @__PURE__ */ ce.jsx(
            uL,
            {
              createdIssue: p,
              issueBaseLink: xe,
              issueLinkCopied: z,
              setIssueLinkCopied: T,
              copyToClipboard: X
            }
          ) : /* @__PURE__ */ ce.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: ee(on),
              children: /* @__PURE__ */ ce.jsxs(at, { children: [
                /* @__PURE__ */ ce.jsx(me, { span: 3, children: /* @__PURE__ */ ce.jsx(en, { label: "Project", required: !0, children: /* @__PURE__ */ ce.jsx(
                  Ot,
                  {
                    control: B,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: ye, value: je } }) => /* @__PURE__ */ ce.jsx(
                      Fr,
                      {
                        searchable: !0,
                        loading: qe,
                        onSelect: (Ve) => {
                          Xe(Ve.key), ye(Ve);
                        },
                        selectedItems: [je],
                        placeholder: "Select Jira project",
                        emptyMessage: Me ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Ve, onSelect: Oe, checked: dn }) => /* @__PURE__ */ ce.jsx(
                          Eh,
                          {
                            item: Ve,
                            checked: dn,
                            onSelectItem: Oe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ ce.jsx(me, { span: 3, children: /* @__PURE__ */ ce.jsx(en, { label: "Issue type", required: !0, children: /* @__PURE__ */ ce.jsx(
                  Ot,
                  {
                    control: B,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: ye, value: je } }) => /* @__PURE__ */ ce.jsx(
                      Fr,
                      {
                        disabled: v.length === 0,
                        loading: Ue,
                        onSelect: (Ve) => {
                          se(Ve.id), ye(Ve);
                        },
                        selectedItems: [je],
                        placeholder: v.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: De ? "No issues found" : "No issues available",
                        items: v,
                        itemComponent: ({ item: Ve, onSelect: Oe, checked: dn }) => /* @__PURE__ */ ce.jsx(
                          Eh,
                          {
                            item: Ve,
                            checked: dn,
                            onSelectItem: Oe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                K && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ ce.jsx(me, { className: W_.modalBodyFormFields, children: /* @__PURE__ */ ce.jsx(
                  cL,
                  {
                    control: B,
                    errors: { ...be, ...I },
                    getValues: ge,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: N
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ ce.jsx(
          Pt,
          {
            confirmOnClick: p ? Qe : ee(on),
            confirmProps: {
              disabled: !K,
              isLoading: C,
              loadingIndicator: /* @__PURE__ */ ce.jsx(fn, { size: 16 })
            },
            confirmName: p ? "Close" : "Save",
            cancelOnClick: p ? void 0 : Qe
          }
        )
      ]
    }
  );
}, vL = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, kL = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, bL = "_wrapper_1bylq_1", _L = "_inputWrapper_1bylq_6", xL = "_inputSeparator_1bylq_18", SL = "_buttonLink_1bylq_23", NL = "_noIssuesFound_1bylq_27", Ba = {
  wrapper: bL,
  inputWrapper: _L,
  inputSeparator: xL,
  buttonLink: SL,
  noIssuesFound: NL
}, jL = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = Cn(), i = vL(n?.jiraSiteUrl), [a, o] = le(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: u,
    unlinkIssue: p,
    unlinkAllIssues: d,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: v,
    isLoadingIssueLinks: F,
    isLoadingIssues: N,
    issues: j,
    error: C
  } = K1(
    s ? e.conversationId : null,
    i
  ), g = !!n?.enableCreateIssue, z = !!n?.enableSortIssueTypeByLabel, T = !!(j?.length || v?.length), I = !!n?.enableRemoveAllLinks && T, D = !F && !N && v?.length > 0 && !!n?.showDanglingLinks;
  return !N && C ? /* @__PURE__ */ ce.jsx(In, { error: C, retry: () => f() }) : /* @__PURE__ */ ce.jsxs(ce.Fragment, { children: [
    /* @__PURE__ */ ce.jsxs(b, { className: Ba.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ ce.jsxs(b, { className: Ba.inputWrapper, flexDirection: "column", children: [
        g && /* @__PURE__ */ ce.jsxs(ce.Fragment, { children: [
          /* @__PURE__ */ ce.jsx(
            Yn,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ ce.jsx("div", { className: Ba.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ ce.jsx(
          ZA,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      N ? /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ce.jsx(fn, { "data-testid": "jira-widget-issue-spinner" }) }) : j?.length ? /* @__PURE__ */ ce.jsx(
        _A,
        {
          issues: j,
          jiraInstanceUrl: i,
          unlinkIssue: p
        }
      ) : /* @__PURE__ */ ce.jsx(A.Paragraph, { align: "center", className: Ba.noIssuesFound, children: "No linked issues found" }),
      I && j?.length > 0 && /* @__PURE__ */ ce.jsx(
        Yn,
        {
          variant: "secondary",
          disabled: !j?.length && !v?.length,
          onClick: d,
          children: "Unlink all issues"
        }
      ),
      D && /* @__PURE__ */ ce.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ ce.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: v.map((U) => /* @__PURE__ */ ce.jsx(qn, { onDelete: () => p(U), children: U }, U)) }),
            /* @__PURE__ */ ce.jsx(
              Yn,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ ce.jsx(
        Rt,
        {
          slotEnd: /* @__PURE__ */ ce.jsx(pe, { name: "external-link" }),
          variant: "tertiary",
          className: Ba.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ ce.jsx(
      gL,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: u,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: z
      }
    )
  ] });
}, Th = [
  {
    key: "jiraSiteUrl",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  }
], wL = (e) => {
  const n = kL(e);
  return typeof n == "string" ? n : !0;
}, vi = "JIRA", CL = {
  enabled: !1,
  name: "",
  jiraSiteUrl: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0,
  enableSortIssueTypeByLabel: !1
}, FL = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = gt({
    mode: "onChange",
    defaultValues: CL
  }), {
    create: u,
    update: p,
    remove: d,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: F
  } = Xr({
    integrationId: e,
    integrationType: vi,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: C,
    refetch: g,
    widgetConfiguration: z
  } = Zr({
    integrationId: e,
    fieldDefinitions: Th,
    form: l,
    onMisconfigured: F
  }), { renderConditions: T, setRenderConditions: I, renderConditionsForSubmit: D } = ei({
    integrationId: e,
    widgetConfiguration: z,
    renderConditionsEditor: o
  }), U = (X) => ti(X, {
    fieldDefinitions: Th,
    isCreationMode: s,
    create: u,
    update: p,
    renderConditions: D
  }), Q = l.watch("name");
  return /* @__PURE__ */ ce.jsxs(
    ni,
    {
      form: l,
      integrationId: e,
      onValidSubmit: U,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: C,
      children: [
        v && /* @__PURE__ */ ce.jsx(ri, { cause: v }),
        /* @__PURE__ */ ce.jsxs(at, { children: [
          /* @__PURE__ */ ce.jsx(me, { children: /* @__PURE__ */ ce.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ce.jsx(
            Pn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ce.jsx(me, { span: 3, children: /* @__PURE__ */ ce.jsx(
            Qn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ce.jsx(me, { span: 3 }),
          /* @__PURE__ */ ce.jsx(me, { span: 3, children: /* @__PURE__ */ ce.jsx(
            Qn,
            {
              name: "jiraSiteUrl",
              label: "Jira site URL",
              control: l.control,
              rules: {
                validate: (X) => wL(X)
              },
              componentProps: {
                placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ce.jsx(me, { span: 3 }),
          /* @__PURE__ */ ce.jsx(me, { span: 3, children: /* @__PURE__ */ ce.jsx(en, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ ce.jsx(
            Pn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ce.jsx(me, { span: 3 }),
          /* @__PURE__ */ ce.jsx(me, { span: 3, children: /* @__PURE__ */ ce.jsx(en, { label: "Show unresolved links to Jira issues", children: /* @__PURE__ */ ce.jsx(
            Pn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ce.jsx(me, { span: 3 }),
          /* @__PURE__ */ ce.jsx(me, { span: 3, children: /* @__PURE__ */ ce.jsx(en, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ ce.jsx(
            Pn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ce.jsx(me, { span: 3 }),
          /* @__PURE__ */ ce.jsx(me, { span: 3, children: /* @__PURE__ */ ce.jsx(en, { label: "Enable to sort the issue types by label", children: /* @__PURE__ */ ce.jsx(
            Pn,
            {
              name: "enableSortIssueTypeByLabel",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ce.jsx(me, { span: 3 }),
          !s && e && /* @__PURE__ */ ce.jsx(
            ga,
            {
              configuration: n,
              integrationId: e,
              integrationType: vi,
              label: "Authorize with OAuth"
            }
          ),
          o && T !== null && /* @__PURE__ */ ce.jsx(me, { children: o({
            value: T,
            onChange: I,
            configurationKey: z?.id
          }) })
        ] }),
        /* @__PURE__ */ ce.jsx(
          ii,
          {
            integrationType: vi,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => d(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ ce.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ ce.jsx(
                pe,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ ce.jsxs(A.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  vi,
                  " integration, all links between Dixa and ",
                  vi,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ ce.jsxs(A.Paragraph, { children: [
                  "All data in ",
                  vi,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ ce.jsxs(A.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  vi,
                  " ",
                  'integration "',
                  Q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_1vrar_48{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_1vrar_48:hover,._messageIsOpen_1vrar_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_1vrar_59{cursor:pointer}._messageUnattended_1vrar_62{text-decoration:line-through}._messageLabel_1vrar_65{color:var(--dixa-typography-color-secondary)}._messageText_1vrar_68{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_1vrar_68::-webkit-scrollbar{width:7px;height:7px}._messageText_1vrar_68::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_1vrar_68::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Qd = { exports: {} }, qa = {}, K_;
function IL() {
  if (K_) return qa;
  K_ = 1;
  var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return qa.Fragment = r, qa.jsx = s, qa.jsxs = s, qa;
}
var os = {}, G_;
function $L() {
  return G_ || (G_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[N];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        z("error", t, m);
      }
    }
    function z(t, c, m) {
      {
        var y = C.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var P = m.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var T = !1, I = !1, D = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || U || t === v || T || I || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function q(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return q(c) + ".Consumer";
          case s:
            var m = t;
            return q(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return R(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, be, fe, de, ge, K, xe, $e;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          be = console.log, fe = console.info, de = console.warn, ge = console.error, K = console.group, xe = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: be
            }),
            info: B({}, t, {
              value: fe
            }),
            warn: B({}, t, {
              value: de
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: K
            }),
            groupCollapsed: B({}, t, {
              value: xe
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = C.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var ze = !1, Re;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new on();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var m = Re.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      ze = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Le.current, Le.current = null, qe();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var S = te.stack.split(`
`), ne = y.stack.split(`
`), H = S.length - 1, x = ne.length - 1; H >= 1 && x >= 0 && S[H] !== ne[x]; )
            x--;
          for (; H >= 1 && x >= 0; H--, x--)
            if (S[H] !== ne[x]) {
              if (H !== 1 || x !== 1)
                do
                  if (H--, x--, x < 0 || S[H] !== ne[x]) {
                    var Z = `
` + S[H].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (H >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Le.current = P, Me(), Error.prepareStackTrace = $;
      }
      var ue = t ? t.displayName || t.name : "", _e = ue ? De(ue) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Qe(t, c, m) {
      return Ee(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Xe(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case d:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Qe(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return se(P($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, je = {}, Ve = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function dn(t, c, m, y, $) {
      {
        var P = Function.call.bind(ye);
        for (var w in t)
          if (P(t, w)) {
            var S = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + m + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[w](c, w, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              S = H;
            }
            S && !(S instanceof Error) && (Oe($), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, w, typeof S), Oe(null)), S instanceof Error && !(S.message in je) && (je[S.message] = !0, Oe($), g("Failed %s type: %s", m, S.message), Oe(null));
          }
      }
    }
    var E = Array.isArray;
    function _(t) {
      return E(t);
    }
    function O(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function W(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function L(t) {
      if (W(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", O(t)), J(t);
    }
    var M = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Ze(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function sn(t, c) {
      {
        var m = function() {
          he || (he = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function hn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, m, y, $, P, w) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function _n(t, c, m, y, $) {
      {
        var P, w = {}, S = null, ne = null;
        m !== void 0 && (L(m), S = "" + m), mn(c) && (L(c.key), S = "" + c.key), nn(c) && (ne = c.ref, Ze(c));
        for (P in c)
          ye.call(c, P) && !ie.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var H = t.defaultProps;
          for (P in H)
            w[P] === void 0 && (w[P] = H[P]);
        }
        if (S || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && sn(w, x), ne && hn(w, x);
        }
        return pn(t, S, ne, $, y, M.current, w);
      }
    }
    var Je = C.ReactCurrentOwner, Nn = C.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(m);
      } else
        Nn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (Je.current) {
          var t = R(Je.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Mn(t) {
      return "";
    }
    var jn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = kn(c);
        if (jn[m])
          return;
        jn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Je.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ae(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ae(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            cn(y) && gn(y, c);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              cn(w.value) && gn(w.value, c);
        }
      }
    }
    function zn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = R(c);
          dn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var $ = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function An(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ae(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var xn = {};
    function Sn(t, c, m, y, $, P) {
      {
        var w = re(t);
        if (!w) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = Mn();
          ne ? S += ne : S += vn();
          var H;
          t === null ? H = "null" : _(t) ? H = "array" : t !== void 0 && t.$$typeof === n ? (H = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : H = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, S);
        }
        var x = _n(t, c, m, $, P);
        if (x == null)
          return x;
        if (w) {
          var Z = c.children;
          if (Z !== void 0)
            if (y)
              if (_(Z)) {
                for (var ue = 0; ue < Z.length; ue++)
                  wn(Z[ue], t);
                Object.freeze && Object.freeze(Z);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = R(t), te = Object.keys(c).filter(function($n) {
            return $n !== "key";
          }), Ke = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? An(x) : zn(x), x;
      }
    }
    function Bn(t, c, m) {
      return Sn(t, c, m, !0);
    }
    function On(t, c, m) {
      return Sn(t, c, m, !1);
    }
    var Rn = On, Un = Bn;
    os.Fragment = i, os.jsx = Rn, os.jsxs = Un;
  })()), os;
}
var Y_;
function EL() {
  return Y_ || (Y_ = 1, process.env.NODE_ENV === "production" ? Qd.exports = IL() : Qd.exports = $L()), Qd.exports;
}
var Te = EL();
function TL({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = yn(), [a, o] = le([]), [s] = i(e, n), [l, u] = le(
    []
  );
  return Ye(() => () => {
    l.forEach((p) => window.clearTimeout(p));
  }, []), [async (p) => {
    const d = [];
    for (const [f, h] of p.entries()) {
      f !== 0 && await new Promise((F) => {
        const N = setTimeout(F, r);
        u([...l, N]);
      });
      const v = await s({
        variables: h
      });
      d.push(v);
    }
    o(d);
  }, a];
}
var G1 = /* @__PURE__ */ ((e) => (e.List = "list", e))(G1 || {}), Dh = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))(Dh || {}), Oh = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(Oh || {}), Rh = /* @__PURE__ */ ((e) => (e.Unsubscribed = "UNSUBSCRIBED", e))(Rh || {});
const DL = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, OL = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, RL = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, PL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, AL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, LL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, VL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "definition" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_FlowEmail" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, zL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, UL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, ML = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "properties" }, { kind: "EnumValue", value: "predictive_analytics" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "predictive_analytics" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "predictive_analytics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "average_order_value" } }, { kind: "Field", name: { kind: "Name", value: "churn_probability" } }, { kind: "Field", name: { kind: "Name", value: "predicted_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_clv" } }, { kind: "Field", name: { kind: "Name", value: "total_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "predicted_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "average_days_between_orders" } }, { kind: "Field", name: { kind: "Name", value: "expected_date_of_next_order" } }, { kind: "Field", name: { kind: "Name", value: "ranked_channel_affinity" } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, BL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, qL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_segments_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, HL = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": DL,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": OL,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": PL,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": AL,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": RL,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": LL,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": VL,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": zL,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": UL,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": ML,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": BL,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": qL
};
function ai(e) {
  return HL[e] ?? {};
}
const WL = ai(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), KL = ai(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {
          data {
            id
            type
            attributes {
              definition {
                ... on Klaviyo_FlowEmail {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), GL = ai(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), YL = ai(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), QL = ai(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          properties
          predictive_analytics
        ]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          predictive_analytics
        ]
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
              properties
              predictive_analytics {
                average_order_value
                churn_probability
                predicted_clv
                historic_clv
                total_clv
                historic_number_of_orders
                predicted_number_of_orders
                average_days_between_orders
                expected_date_of_next_order
                ranked_channel_affinity
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), JL = ai(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_lists_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), XL = ai(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_segments_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), ZL = ai(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      bulk_subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), e2 = ai(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      bulk_unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function Ph(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function Q_(e) {
  return Ph(e) && e?.attributes?.event_properties?.$message;
}
function n2(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function J_(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function t2(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollectionCompoundDocument" && e.Klaviyo.get_metrics.data || [];
}
function r2(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function i2(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function a2(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function o2(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function s2(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function X_(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function l2(e) {
  return e?.attributes?.definition?.__typename === "Klaviyo_FlowEmail" && e.attributes.definition.preview_text || void 0;
}
function c2(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const u2 = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function d2(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function m2(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function p2({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = yn(), { track: a } = Cn(), [o, s] = le(null), [l, u] = le(
    null
  ), [p, d] = le(null), [f, h] = le(null), [v, F] = le(
    null
  ), [N, j] = le([]), {
    data: C,
    error: g,
    loading: z,
    networkStatus: T
  } = i(GL, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    I,
    {
      data: D,
      error: U,
      loading: Q,
      networkStatus: X
    }
  ] = r(WL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Ye(() => {
    if (C && !z && T === rr.ready) {
      const re = t2(C);
      s(
        re.find((G) => G?.attributes?.name === "Received Email")?.id || null
      ), u(
        re.find((G) => G?.attributes?.name === "Opened Email")?.id || null
      ), d(
        re.find((G) => G?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        re.find((G) => G?.attributes?.name === "Bounced Email")?.id || null
      ), F(
        re.find((G) => G?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), u(null), d(null), h(null), F(null);
  }, [C]), Ye(() => {
    o && l && p && f && v && !Q && X === rr.ready ? I({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${p}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${v}")`,
        pageSize: n
      }
    }) : j([]);
  }, [
    o,
    l,
    p,
    f,
    v
  ]), Ye(() => {
    if (!Q && D) {
      const re = r2(D), G = a2(
        D
      ).map(
        (fe) => fe?.attributes?.event_properties.$message
      ), q = o2(
        D
      ).map(
        (fe) => fe?.attributes?.event_properties.$message
      );
      re.forEach((fe) => {
        const de = fe.attributes?.event_properties.$message;
        fe.opened = G.includes(de), fe.clicked = q.includes(de);
      });
      const R = i2(D), B = s2(D), ee = [
        ...re,
        ...B,
        ...R
      ].sort((fe, de) => {
        const ge = J_(fe), K = J_(de);
        return ge == null && K == null ? 0 : ge == null ? 1 : K == null ? -1 : K - ge;
      }).slice(0, n);
      j(ee);
      const be = ee.map((fe) => fe.id);
      a("klaviyo:messages:received", {
        emailsReceived: re.filter(
          (fe) => be.includes(fe.id)
        ).length,
        emailsBounced: B.filter(
          (fe) => be.includes(fe.id)
        ).length,
        smsReceived: R.filter(
          (fe) => be.includes(fe.id)
        ).length,
        total: be.length
      });
    } else
      j([]);
  }, [Q, D]), Kn(
    () => ({
      receivedMessages: N,
      isLoading: z || Q,
      error: g || U
    }),
    [
      N,
      z,
      Q,
      g,
      U
    ]
  );
}
function f2({ profileId: e }) {
  const { useQuery: n } = yn(), [r, i] = le(), [a, o] = le(), {
    data: s,
    error: l,
    loading: u,
    refetch: p
  } = n(QL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  Ye(() => {
    l && o(l);
  }, [l]), Ye(() => {
    !u && s && i(s.Klaviyo.get_profile);
  }, [u, s]);
  const d = async () => {
    const f = await p();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Kn(
    () => ({
      profile: r,
      refetchProfile: d,
      isLoading: u,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, u, a]
  );
}
function h2({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = Cn(), { useLazyQuery: i } = yn(), [a, o] = le(), [s, l] = le(), [
    u,
    { data: p, error: d, loading: f }
  ] = i(YL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Ye(() => {
    if (!f && p) {
      const v = p.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && p.Klaviyo.profileByEmail || void 0, F = p.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && p.Klaviyo.profileByPhoneNumber || void 0;
      h(v, F);
    }
  }, [f, p]);
  const h = (v, F) => {
    const N = v?.data?.length === 1 && v.data[0]?.id || void 0, j = F?.data?.length === 1 && F.data[0]?.id || void 0, C = N || j, g = !N || !j || N === j;
    if (C && g) {
      o(N || j), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), g || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${N}) and phone number ${n} (profile ID ${j}).`
      )
    );
  };
  return Kn(
    () => ({
      profileId: a,
      getProfileId: u,
      isLoading: f,
      error: d || s
    }),
    [a, u, f, d, s]
  );
}
const Z_ = 800, y2 = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, g2 = 3, v2 = 1.5, k2 = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = g2,
  useDelayRange: a = !1
}) => {
  const o = (U) => Math.floor(Math.random() * (U.max - U.min) + U.min), [s, l] = le(0), [u, p] = le(n || Z_), [d, f] = le(r || y2), [h, v] = le(!1), [F, N] = le(!1), j = a || !!r, C = j ? o(d) : n || Z_, [g, z] = le(C);
  eD(
    async () => {
      const U = s + 1, Q = v2 ** U;
      l(U), z(
        (j ? o(d) : u) * Q
      ), await e().then(() => {
        N(!0), D();
      });
    },
    h ? g : null
  ), tD(() => D());
  const T = lt(() => {
    l(0), z(C);
  }, [C]), I = lt(
    (U = {}) => {
      const { delay: Q, delayRange: X } = U;
      N(!1), T(), X && (f(X), z(o(X))), Q && (p(Q), z(Q)), v(!0);
    },
    [T]
  ), D = lt(() => {
    v(!1), T();
  }, [T]);
  return Ye(() => {
    s >= i && D();
  }, [s, i, D]), Kn(
    () => ({ isRunning: h, isSuccessful: F, start: I, stop: D }),
    [h, F, I, D]
  );
}, b2 = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, _2 = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function x2({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = yn(), [i, a] = le(), [o, s] = le(), {
    data: l,
    error: u,
    loading: p,
    refetch: d,
    networkStatus: f
  } = r(
    n === "lists" ? JL : XL,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: v,
    stop: F
  } = k2({
    query: d,
    useDelayRange: !0
  }), N = p || h;
  return Ye(() => {
    if (u)
      if (lI({
        errors: u.graphQLErrors
      })) {
        if (!h) {
          const j = b2(u);
          v({
            ...j && {
              delayRange: _2(j)
            }
          });
        }
      } else
        s(u);
  }, [u]), Ye(() => {
    if (!p && l?.Klaviyo) {
      let j = {}, C = {};
      n === "lists" && (j = l?.Klaviyo?.get_lists_for_profile), n === "segments" && (C = l?.Klaviyo?.get_segments_for_profile), (j?.data || C?.data) && (F(), a(
        (n === "lists" ? j?.data : C?.data)?.map((g) => ({
          ...g,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [p, l]), Kn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: v,
      isLoading: N,
      error: o,
      networkStatus: f
    }),
    [i, N, o, f, v]
  );
}
const S2 = "_notificationText_1polx_1", Jy = {
  notificationText: S2
}, Al = ({ error: e }) => {
  const { track: n } = Cn();
  let r = e;
  if (Sw(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && fw({ error: i[0] }), o = i.length === 1 && oI({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ Te.jsx(In, { error: e });
  }
  return /* @__PURE__ */ Te.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ Te.jsx(
    We.Item,
    {
      contentLeft: /* @__PURE__ */ Te.jsx(pe, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, N2 = "_message_1vrar_48", j2 = "_messageIsOpen_1vrar_56", w2 = "_messageHeader_1vrar_59", C2 = "_messageLabel_1vrar_65", F2 = "_messageText_1vrar_68", la = {
  message: N2,
  messageIsOpen: j2,
  messageHeader: w2,
  messageLabel: C2,
  messageText: F2
}, I2 = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && l2(e.flowMessage);
  return /* @__PURE__ */ Te.jsxs(Te.Fragment, { children: [
    /* @__PURE__ */ Te.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", className: la.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ Te.jsx(A.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ Te.jsx(fn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ Te.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ Te.jsx(b, { children: /* @__PURE__ */ Te.jsx(
            A.Paragraph,
            {
              variant: "4",
              className: la.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", className: la.messageText, children: i })
        ]
      }
    )
  ] });
}, $2 = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ Te.jsx(Te.Fragment, { children: /* @__PURE__ */ Te.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ Te.jsx(b, { children: /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ Te.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, E2 = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = le(r), { attributes: o, eventType: s } = e, l = o?.datetime, u = o?.timestamp, p = "DD MMM YYYY @ HH:mm", d = Kn(
    () => () => l ? Hn(l).format(p) : u ? Hn.unix(u).format(p) : null,
    [u, l]
  )(), f = s === "EMAIL", h = s === "SMS", v = f && e.opened, F = f && e.clicked, N = f && o?.event_properties.Subject, j = h && o?.event_properties["Message Name"], C = f ? "mail" : "sms";
  return /* @__PURE__ */ Te.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: it(la.message, {
        [la.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ Te.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: la.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Te.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ Te.jsx(pe, { size: 16, name: C }),
                  " ",
                  u2(s),
                  d && /* @__PURE__ */ Te.jsx(Vn, { size: "small", variant: "info", children: d })
                ] }),
                N && N,
                j && j
              ] }),
              /* @__PURE__ */ Te.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ Te.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ Te.jsx(my, {}),
          n2(e) && /* @__PURE__ */ Te.jsx(b, { children: /* @__PURE__ */ Te.jsx(Vn, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ Te.jsxs(Te.Fragment, { children: [
            /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ Te.jsx(qn, { children: /* @__PURE__ */ Te.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Te.jsx(
                  pe,
                  {
                    size: 16,
                    color: v ? "green.400" : "red.400",
                    name: v ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ Te.jsx(qn, { children: /* @__PURE__ */ Te.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Te.jsx(
                  pe,
                  {
                    size: 16,
                    color: F ? "green.400" : "red.400",
                    name: F ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ Te.jsx(I2, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ Te.jsx($2, { event: e })
        ] })
      ]
    }
  );
}, T2 = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, D2 = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = le(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = p2({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, u] = TL({
    query: KL,
    options: T2,
    delayMs: 1e3
  }), [p, d] = le([]);
  Ye(() => {
    if (a.length > 0) {
      d(a);
      const h = a.filter((v) => Ph(v)).map((v) => Q_(v));
      h.length > 0 && (i(!0), l(
        h.map((v) => ({
          messageId: v
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), Ye(() => {
    u.length > 0 && d(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && Ph(h) && !h.flowMessage) {
          const v = Q_(h), F = u.find((j) => (j.data && X_(j.data))?.id === v), N = F?.data && X_(F.data);
          if (N)
            return {
              ...c2(h),
              flowMessage: N
            };
        }
        return h;
      })
    );
  }, [u]);
  const f = [];
  return s && f.push(s), u.length > 0 && f.push(
    ...u.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ Te.jsx(Te.Fragment, { children: f.map((h, v) => h.graphQLErrors ? /* @__PURE__ */ Te.jsx(
    In,
    {
      error: h
    },
    `lastMessagesError${v}`
  ) : /* @__PURE__ */ Te.jsx(
    Al,
    {
      error: h
    },
    `lastMessagesError${v}`
  )) }) : /* @__PURE__ */ Te.jsxs(Te.Fragment, { children: [
    /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Te.jsx(fn, {}) }) : /* @__PURE__ */ Te.jsx(Te.Fragment, { children: p?.length > 0 ? /* @__PURE__ */ Te.jsx(b, { gap: "200", flexDirection: "column", children: p.map((h, v) => /* @__PURE__ */ Te.jsx(
      E2,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: v === 0
      },
      h.id
    )) }) : /* @__PURE__ */ Te.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: Jy.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, O2 = "_list_ld0hf_1", R2 = "_listItem_ld0hf_4", Qr = {
  list: O2,
  listItem: R2
}, P2 = ({
  profile: e
}) => {
  const n = e?.data?.attributes?.properties, r = Object.entries(
    n ?? {}
  ).filter(([a, o]) => a !== "__typename" && o != null), i = r.length > 0;
  return /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Custom properties" }),
    !i && /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom properties available" }),
    i && /* @__PURE__ */ Te.jsx(We, { className: Qr.list, children: r.map(([a, o]) => typeof o == "boolean" || typeof o == "string" || typeof o == "number" || Array.isArray(o) && o.every((s) => typeof s == "string") ? /* @__PURE__ */ Te.jsx(We.Text, { variant: "dense", className: Qr.listItem, children: /* @__PURE__ */ Te.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "200",
        children: [
          /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: sI(a) }),
          /* @__PURE__ */ Te.jsx(
            b,
            {
              style: { flex: 1, minWidth: 0 },
              justifyContent: "flex-end",
              children: Oi(o)
            }
          )
        ]
      }
    ) }, a) : null) })
  ] });
}, ex = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = le(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: u
  } = x2({ profileId: e, query: n });
  Ye(() => {
    l === 4 && i(!0);
  }, [l]);
  const p = () => {
    a || u();
  }, d = a || [];
  return o ? /* @__PURE__ */ Te.jsx(Al, { error: o }) : s ? /* @__PURE__ */ Te.jsx(We.Text, { variant: "dense", className: Qr.listItem, children: /* @__PURE__ */ Te.jsx(fn, { size: 14 }) }, "loading") : d.length > 0 ? /* @__PURE__ */ Te.jsx(Te.Fragment, { children: d.map(
    ({ attributes: f, type: h }, v) => /* @__PURE__ */ Te.jsx(We.Text, { variant: "dense", className: Qr.listItem, children: /* @__PURE__ */ Te.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ Te.jsx(qn, { children: hw(h) })
    ] }) }, v)
  ) }) : r && !a ? /* @__PURE__ */ Te.jsx(We.Text, { variant: "dense", className: Qr.listItem, children: /* @__PURE__ */ Te.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ Te.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Te.jsx(pe, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ Te.jsxs(A.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ Te.jsx(Ge, { content: "Refresh lists and segments", children: /* @__PURE__ */ Te.jsx(Yn, { icon: "sync", variant: "secondary", onClick: () => p(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ Te.jsx(We.Text, { variant: "dense", className: Qr.listItem, children: /* @__PURE__ */ Te.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ Te.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, A2 = 0.7, L2 = 0.3, V2 = (e) => e >= A2 ? { variant: "error", label: "High risk" } : e >= L2 ? { variant: "warning", label: "Medium risk" } : { variant: "success", label: "Low risk" }, z2 = (e) => /* @__PURE__ */ Te.jsx(A.Paragraph, { as: "span", variant: "4", children: e.toFixed(2) }), U2 = (e) => {
  const n = V2(e);
  return /* @__PURE__ */ Te.jsxs(b, { alignItems: "center", gap: "100", children: [
    /* @__PURE__ */ Te.jsx(Vn, { size: "small", variant: n.variant, children: n.label }),
    /* @__PURE__ */ Te.jsx(A.Paragraph, { as: "span", variant: "4", children: `${(e * 100).toFixed(1)}%` })
  ] });
}, M2 = (e) => {
  const n = e?.data?.attributes?.predictive_analytics ?? null;
  if (!n)
    return [];
  const r = [
    ["Average order value", n.average_order_value],
    ["Historic lifetime value", n.historic_clv],
    ["Predicted lifetime value", n.predicted_clv],
    ["Total lifetime value", n.total_clv]
  ], i = [
    ["Historic orders", n.historic_number_of_orders],
    ["Predicted orders", n.predicted_number_of_orders],
    [
      "Average days between orders",
      n.average_days_between_orders
    ],
    ["Expected next order", n.expected_date_of_next_order]
  ], a = n.churn_probability, o = n.ranked_channel_affinity?.filter(Boolean) ?? null;
  return [
    ...r.flatMap(
      ([s, l]) => l ? [{ label: s, content: z2(l) }] : []
    ),
    ...i.flatMap(
      ([s, l]) => l ? [{ label: s, content: Oi(l) }] : []
    ),
    ...a ? [
      {
        label: "Churn probability",
        content: U2(a)
      }
    ] : [],
    ...o?.length ? [
      {
        label: "Channel affinity",
        content: Oi(o)
      }
    ] : []
  ];
}, B2 = ({
  profile: e
}) => {
  const n = M2(e);
  return /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Predictive analytics" }),
    n.length === 0 && /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No predictive analytics available" }),
    n.length > 0 && /* @__PURE__ */ Te.jsx(We, { className: Qr.list, children: n.map(({ label: r, content: i }) => /* @__PURE__ */ Te.jsx(We.Text, { variant: "dense", className: Qr.listItem, children: /* @__PURE__ */ Te.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "200",
        children: [
          /* @__PURE__ */ Te.jsx(A.Paragraph, { as: "span", variant: "4", children: r }),
          i
        ]
      }
    ) }, r)) })
  ] });
}, q2 = "_tagHover_kzbzk_1", H2 = "_channelUnsubscribed_kzbzk_6", nx = {
  tagHover: q2,
  channelUnsubscribed: H2
}, tx = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ Te.jsx(
    Ge,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ Te.jsx(
        qn,
        {
          className: nx.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ Te.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: it({
                [nx.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ Te.jsx(fn, { size: 16 }) : /* @__PURE__ */ Te.jsx(pe, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, W2 = "_subscriptionError_1qhhx_1", K2 = {
  subscriptionError: W2
}, G2 = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = le(!1), [u, p] = le(!1), [d, f] = le(), { track: h } = Cn(), [v, F] = nD({
    channel: null,
    request: null
  }), N = d2(n), j = m2(n), C = !!e, { useMutation: g } = yn(), [z] = g(
    ZL
  ), [T] = g(
    e2
  ), I = (Q) => {
    h("klaviyo:profile:subscribe:clicked", { channel: Q }), F.setAll({
      channel: Q,
      request: "subscribed"
    }), ((X) => z({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: Dh.Profile,
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...X === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: Oh.Subscribed
                        }
                      }
                    },
                    ...X === "SMS" && {
                      sms: {
                        marketing: {
                          consent: Oh.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: G1.List,
              id: e
            }
          }
        }
      }
    }))(Q).then(
      (X) => U({
        channel: Q,
        mutationResponse: X,
        isSubscriptionRequest: !0
      })
    ).catch(
      (X) => U({
        channel: Q,
        mutationErrorResponse: X,
        isSubscriptionRequest: !0
      })
    );
  }, D = (Q) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: Q }), F.setAll({
      channel: Q,
      request: "unsubscribed"
    }), T({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: Dh.Profile,
                attributes: {
                  ...Q === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...Q === "SMS" ? { phone_number: i } : {},
                  subscriptions: {
                    ...Q === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: Rh.Unsubscribed
                        }
                      }
                    },
                    ...Q === "SMS" && {
                      sms: {
                        marketing: {
                          consent: Rh.Unsubscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }).then(
      (X) => U({
        channel: Q,
        mutationResponse: X,
        isSubscriptionRequest: !1
      })
    ).catch(
      (X) => U({
        channel: Q,
        mutationErrorResponse: X,
        isSubscriptionRequest: !1
      })
    );
  }, U = async ({
    channel: Q,
    mutationResponse: X,
    mutationErrorResponse: re,
    isSubscriptionRequest: G
  }) => {
    const q = re?.networkError, R = q ? q?.statusCode : NaN, B = X?.errors, ee = !!B && yw({
      errors: B
    });
    R === 202 ? (h(
      G ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: Q }
    ), await o()) : ee ? (h(
      G ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Q,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${G ? "opt-in" : "opt-out"}.`
    )) : (h(
      G ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Q,
        reason: q?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${G ? "opt-in" : "opt-out"}.`
    )), p(!1), l(!1);
  };
  return Ye(() => {
    if (v.request === "subscribed") {
      const Q = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${v.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      v.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(Q), F.reset()), v.channel === "SMS" && !u && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(Q), F.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    u
  ]), /* @__PURE__ */ Te.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ Te.jsx(
            tx,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: N,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: C,
              handleAction: () => {
                l(!0), f(void 0), N ? D("EMAIL") : I("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ Te.jsx(
            tx,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: u,
              isSubscribed: j,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: C,
              handleAction: () => {
                p(!0), f(void 0), j ? D("SMS") : I("SMS");
              }
            }
          )
        ] }),
        d && /* @__PURE__ */ Te.jsx(b, { className: K2.subscriptionError, children: d })
      ] })
    }
  );
}, Y2 = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  showCustomProperties: s,
  showPredictiveAnalytics: l,
  noOfMessagesToShow: u,
  subscriptionListId: p
}) => {
  const {
    profile: d,
    error: f,
    isLoading: h,
    refetchProfile: v
  } = f2({ profileId: e });
  return f ? /* @__PURE__ */ Te.jsx(Al, { error: f }) : h ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Te.jsx(fn, {}) }) : !d && !h ? /* @__PURE__ */ Te.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: Jy.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ Te.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ Te.jsxs(We, { className: Qr.list, children: [
        i && /* @__PURE__ */ Te.jsx(ex, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ Te.jsx(
          ex,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    d && e && o && /* @__PURE__ */ Te.jsx(
      G2,
      {
        profile: d,
        profileId: e,
        subscriptionListId: p,
        refetchProfile: v,
        email: n,
        phoneNumber: r
      }
    ),
    d && l && /* @__PURE__ */ Te.jsx(B2, { profile: d }),
    d && s && /* @__PURE__ */ Te.jsx(P2, { profile: d }),
    /* @__PURE__ */ Te.jsx(
      D2,
      {
        profileId: e,
        noOfMessagesToShow: u
      }
    )
  ] });
}, Q2 = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = n?.showCustomProperties, u = n?.showPredictiveAnalytics, p = Number(n?.noOfMessagesToShow), d = n?.subscriptionListId, {
    profileId: f,
    getProfileId: h,
    isLoading: v,
    error: F
  } = h2({ email: r, phoneNumber: i });
  return bI(() => {
    (r || i) && h({
      variables: {
        emailFilter: r ? `equals(email,"${r}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!r,
        hasPhoneNumber: !!i
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : v ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Te.jsx(fn, {}) }) : F ? /* @__PURE__ */ Te.jsx(Al, { error: F }) : f ? /* @__PURE__ */ Te.jsx(
    Y2,
    {
      profileId: f,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      showCustomProperties: l,
      showPredictiveAnalytics: u,
      noOfMessagesToShow: p,
      subscriptionListId: d
    }
  ) : /* @__PURE__ */ Te.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: Jy.notificationText,
      children: "No profile ID found"
    }
  );
}, J2 = [
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showCustomProperties",
    label: "Show custom properties for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPredictiveAnalytics",
    label: "Show predictive analytics for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: aI
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
], X2 = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: ga
  }
], Z2 = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  }
];
function eV(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const nV = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, tV = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, rV = {};
function rx(e, n) {
  return (rV.jsx ? tV : nV).test(e);
}
const iV = /[ \t\n\f\r]/g;
function aV(e) {
  return typeof e == "object" ? e.type === "text" ? ix(e.value) : !1 : ix(e);
}
function ix(e) {
  return e.replace(iV, "") === "";
}
class qo {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
qo.prototype.property = {};
qo.prototype.normal = {};
qo.prototype.space = null;
function Y1(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new qo(r, i, n);
}
function Ah(e) {
  return e.toLowerCase();
}
class gr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
gr.prototype.space = null;
gr.prototype.boolean = !1;
gr.prototype.booleanish = !1;
gr.prototype.overloadedBoolean = !1;
gr.prototype.number = !1;
gr.prototype.commaSeparated = !1;
gr.prototype.spaceSeparated = !1;
gr.prototype.commaOrSpaceSeparated = !1;
gr.prototype.mustUseProperty = !1;
gr.prototype.defined = !1;
let oV = 0;
const En = zi(), vt = zi(), Q1 = zi(), He = zi(), nt = zi(), ca = zi(), ar = zi();
function zi() {
  return 2 ** ++oV;
}
const Lh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: En,
  booleanish: vt,
  commaOrSpaceSeparated: ar,
  commaSeparated: ca,
  number: He,
  overloadedBoolean: Q1,
  spaceSeparated: nt
}, Symbol.toStringTag, { value: "Module" })), Jd = Object.keys(Lh);
class Xy extends gr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), ax(this, "space", a), typeof i == "number")
      for (; ++o < Jd.length; ) {
        const s = Jd[o];
        ax(this, Jd[o], (i & Lh[s]) === Lh[s]);
      }
  }
}
Xy.prototype.defined = !0;
function ax(e, n, r) {
  r && (e[n] = r);
}
const sV = {}.hasOwnProperty;
function ja(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (sV.call(e.properties, i)) {
      const a = e.properties[i], o = new Xy(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[Ah(i)] = i, r[Ah(o.attribute)] = i;
    }
  return new qo(n, r, e.space);
}
const J1 = ja({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), X1 = ja({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function Z1(e, n) {
  return n in e ? e[n] : n;
}
function eC(e, n) {
  return Z1(e, n.toLowerCase());
}
const nC = ja({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: eC,
  properties: { xmlns: null, xmlnsXLink: null }
}), tC = ja({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: vt,
    ariaAutoComplete: null,
    ariaBusy: vt,
    ariaChecked: vt,
    ariaColCount: He,
    ariaColIndex: He,
    ariaColSpan: He,
    ariaControls: nt,
    ariaCurrent: null,
    ariaDescribedBy: nt,
    ariaDetails: null,
    ariaDisabled: vt,
    ariaDropEffect: nt,
    ariaErrorMessage: null,
    ariaExpanded: vt,
    ariaFlowTo: nt,
    ariaGrabbed: vt,
    ariaHasPopup: null,
    ariaHidden: vt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: nt,
    ariaLevel: He,
    ariaLive: null,
    ariaModal: vt,
    ariaMultiLine: vt,
    ariaMultiSelectable: vt,
    ariaOrientation: null,
    ariaOwns: nt,
    ariaPlaceholder: null,
    ariaPosInSet: He,
    ariaPressed: vt,
    ariaReadOnly: vt,
    ariaRelevant: null,
    ariaRequired: vt,
    ariaRoleDescription: nt,
    ariaRowCount: He,
    ariaRowIndex: He,
    ariaRowSpan: He,
    ariaSelected: vt,
    ariaSetSize: He,
    ariaSort: null,
    ariaValueMax: He,
    ariaValueMin: He,
    ariaValueNow: He,
    ariaValueText: null,
    role: null
  }
}), lV = ja({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: eC,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: ca,
    acceptCharset: nt,
    accessKey: nt,
    action: null,
    allow: null,
    allowFullScreen: En,
    allowPaymentRequest: En,
    allowUserMedia: En,
    alt: null,
    as: null,
    async: En,
    autoCapitalize: null,
    autoComplete: nt,
    autoFocus: En,
    autoPlay: En,
    blocking: nt,
    capture: null,
    charSet: null,
    checked: En,
    cite: null,
    className: nt,
    cols: He,
    colSpan: null,
    content: null,
    contentEditable: vt,
    controls: En,
    controlsList: nt,
    coords: He | ca,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: En,
    defer: En,
    dir: null,
    dirName: null,
    disabled: En,
    download: Q1,
    draggable: vt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: En,
    formTarget: null,
    headers: nt,
    height: He,
    hidden: En,
    high: He,
    href: null,
    hrefLang: null,
    htmlFor: nt,
    httpEquiv: nt,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: En,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: En,
    itemId: null,
    itemProp: nt,
    itemRef: nt,
    itemScope: En,
    itemType: nt,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: En,
    low: He,
    manifest: null,
    max: null,
    maxLength: He,
    media: null,
    method: null,
    min: null,
    minLength: He,
    multiple: En,
    muted: En,
    name: null,
    nonce: null,
    noModule: En,
    noValidate: En,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: En,
    optimum: He,
    pattern: null,
    ping: nt,
    placeholder: null,
    playsInline: En,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: En,
    referrerPolicy: null,
    rel: nt,
    required: En,
    reversed: En,
    rows: He,
    rowSpan: He,
    sandbox: nt,
    scope: null,
    scoped: En,
    seamless: En,
    selected: En,
    shadowRootClonable: En,
    shadowRootDelegatesFocus: En,
    shadowRootMode: null,
    shape: null,
    size: He,
    sizes: null,
    slot: null,
    span: He,
    spellCheck: vt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: He,
    step: null,
    style: null,
    tabIndex: He,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: En,
    useMap: null,
    value: vt,
    width: He,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: nt,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: He,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: He,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: En,
    // Lists. Use CSS to reduce space between items instead
    declare: En,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: He,
    // `<img>` and `<object>`
    leftMargin: He,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: He,
    // `<body>`
    marginWidth: He,
    // `<body>`
    noResize: En,
    // `<frame>`
    noHref: En,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: En,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: En,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: He,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: vt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: He,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: He,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: En,
    disableRemotePlayback: En,
    prefix: null,
    property: null,
    results: He,
    security: null,
    unselectable: null
  }
}), cV = ja({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: Z1,
  properties: {
    about: ar,
    accentHeight: He,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: He,
    amplitude: He,
    arabicForm: null,
    ascent: He,
    attributeName: null,
    attributeType: null,
    azimuth: He,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: He,
    by: null,
    calcMode: null,
    capHeight: He,
    className: nt,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: He,
    diffuseConstant: He,
    direction: null,
    display: null,
    dur: null,
    divisor: He,
    dominantBaseline: null,
    download: En,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: He,
    enableBackground: null,
    end: null,
    event: null,
    exponent: He,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: He,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: ca,
    g2: ca,
    glyphName: ca,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: He,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: He,
    horizOriginX: He,
    horizOriginY: He,
    id: null,
    ideographic: He,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: He,
    k: He,
    k1: He,
    k2: He,
    k3: He,
    k4: He,
    kernelMatrix: ar,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: He,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: He,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: He,
    overlineThickness: He,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: He,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: nt,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: He,
    pointsAtY: He,
    pointsAtZ: He,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: ar,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: ar,
    rev: ar,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: ar,
    requiredFeatures: ar,
    requiredFonts: ar,
    requiredFormats: ar,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: He,
    specularExponent: He,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: He,
    strikethroughThickness: He,
    string: null,
    stroke: null,
    strokeDashArray: ar,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: He,
    strokeOpacity: He,
    strokeWidth: null,
    style: null,
    surfaceScale: He,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: ar,
    tabIndex: He,
    tableValues: null,
    target: null,
    targetX: He,
    targetY: He,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: ar,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: He,
    underlineThickness: He,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: He,
    values: null,
    vAlphabetic: He,
    vMathematical: He,
    vectorEffect: null,
    vHanging: He,
    vIdeographic: He,
    version: null,
    vertAdvY: He,
    vertOriginX: He,
    vertOriginY: He,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: He,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), uV = /^data[-\w.:]+$/i, ox = /-[a-z]/g, dV = /[A-Z]/g;
function mV(e, n) {
  const r = Ah(n);
  let i = n, a = gr;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && uV.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(ox, fV);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!ox.test(o)) {
        let s = o.replace(dV, pV);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = Xy;
  }
  return new a(i, n);
}
function pV(e) {
  return "-" + e.toLowerCase();
}
function fV(e) {
  return e.charAt(1).toUpperCase();
}
const hV = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, yV = Y1([X1, J1, nC, tC, lV], "html"), Zy = Y1([X1, J1, nC, tC, cV], "svg");
function gV(e) {
  return e.join(" ").trim();
}
var Wi = {}, Xd, sx;
function vV() {
  if (sx) return Xd;
  sx = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, u = `
`, p = "/", d = "*", f = "", h = "comment", v = "declaration";
  Xd = function(N, j) {
    if (typeof N != "string")
      throw new TypeError("First argument must be a string");
    if (!N) return [];
    j = j || {};
    var C = 1, g = 1;
    function z(R) {
      var B = R.match(n);
      B && (C += B.length);
      var ee = R.lastIndexOf(u);
      g = ~ee ? R.length - ee : g + R.length;
    }
    function T() {
      var R = { line: C, column: g };
      return function(B) {
        return B.position = new I(R), Q(), B;
      };
    }
    function I(R) {
      this.start = R, this.end = { line: C, column: g }, this.source = j.source;
    }
    I.prototype.content = N;
    function D(R) {
      var B = new Error(
        j.source + ":" + C + ":" + g + ": " + R
      );
      if (B.reason = R, B.filename = j.source, B.line = C, B.column = g, B.source = N, !j.silent) throw B;
    }
    function U(R) {
      var B = R.exec(N);
      if (B) {
        var ee = B[0];
        return z(ee), N = N.slice(ee.length), B;
      }
    }
    function Q() {
      U(r);
    }
    function X(R) {
      var B;
      for (R = R || []; B = re(); )
        B !== !1 && R.push(B);
      return R;
    }
    function re() {
      var R = T();
      if (!(p != N.charAt(0) || d != N.charAt(1))) {
        for (var B = 2; f != N.charAt(B) && (d != N.charAt(B) || p != N.charAt(B + 1)); )
          ++B;
        if (B += 2, f === N.charAt(B - 1))
          return D("End of comment missing");
        var ee = N.slice(2, B - 2);
        return g += 2, z(ee), N = N.slice(B), g += 2, R({
          type: h,
          comment: ee
        });
      }
    }
    function G() {
      var R = T(), B = U(i);
      if (B) {
        if (re(), !U(a)) return D("property missing ':'");
        var ee = U(o), be = R({
          type: v,
          property: F(B[0].replace(e, f)),
          value: ee ? F(ee[0].replace(e, f)) : f
        });
        return U(s), be;
      }
    }
    function q() {
      var R = [];
      X(R);
      for (var B; B = G(); )
        B !== !1 && (R.push(B), X(R));
      return R;
    }
    return Q(), q();
  };
  function F(N) {
    return N ? N.replace(l, f) : f;
  }
  return Xd;
}
var lx;
function kV() {
  if (lx) return Wi;
  lx = 1;
  var e = Wi && Wi.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Wi, "__esModule", { value: !0 }), Wi.default = r;
  var n = e(vV());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(u) {
      if (u.type === "declaration") {
        var p = u.property, d = u.value;
        l ? a(p, d, u) : d && (o = o || {}, o[p] = d);
      }
    }), o;
  }
  return Wi;
}
var bV = kV();
const cx = /* @__PURE__ */ yy(bV), _V = cx.default || cx, rC = iC("end"), eg = iC("start");
function iC(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function xV(e) {
  const n = eg(e), r = rC(e);
  if (n && r)
    return { start: n, end: r };
}
function xo(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? ux(e.position) : "start" in e || "end" in e ? ux(e) : "line" in e || "column" in e ? Vh(e) : "";
}
function Vh(e) {
  return dx(e && e.line) + ":" + dx(e && e.column);
}
function ux(e) {
  return Vh(e && e.start) + "-" + Vh(e && e.end);
}
function dx(e) {
  return e && typeof e == "number" ? e : 1;
}
class Vt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const u = i.indexOf(":");
      u === -1 ? o.ruleId = i : (o.source = i.slice(0, u), o.ruleId = i.slice(u + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const u = o.ancestors[o.ancestors.length - 1];
      u && (o.place = u.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = xo(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Vt.prototype.file = "";
Vt.prototype.name = "";
Vt.prototype.reason = "";
Vt.prototype.message = "";
Vt.prototype.stack = "";
Vt.prototype.column = void 0;
Vt.prototype.line = void 0;
Vt.prototype.ancestors = void 0;
Vt.prototype.cause = void 0;
Vt.prototype.fatal = void 0;
Vt.prototype.place = void 0;
Vt.prototype.ruleId = void 0;
Vt.prototype.source = void 0;
const ng = {}.hasOwnProperty, SV = /* @__PURE__ */ new Map(), NV = /[A-Z]/g, jV = /-([a-z])/g, wV = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), CV = /* @__PURE__ */ new Set(["td", "th"]), aC = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function FV(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = PV(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = RV(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? Zy : yV,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = oC(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function oC(e, n, r) {
  if (n.type === "element")
    return IV(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return $V(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return TV(e, n, r);
  if (n.type === "mdxjsEsm")
    return EV(e, n);
  if (n.type === "root")
    return DV(e, n, r);
  if (n.type === "text")
    return OV(e, n);
}
function IV(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = Zy, e.schema = a), e.ancestors.push(n);
  const o = lC(e, n.tagName, !1), s = AV(e, n);
  let l = rg(e, n);
  return wV.has(n.tagName) && (l = l.filter(function(u) {
    return typeof u == "string" ? !aV(u) : !0;
  })), sC(e, s, o, n), tg(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function $V(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Oo(e, n.position);
}
function EV(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Oo(e, n.position);
}
function TV(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = Zy, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : lC(e, n.name, !0), s = LV(e, n), l = rg(e, n);
  return sC(e, s, o, n), tg(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function DV(e, n, r) {
  const i = {};
  return tg(i, rg(e, n)), e.create(n, e.Fragment, i, r);
}
function OV(e, n) {
  return n.value;
}
function sC(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function tg(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function RV(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const p = Array.isArray(s.children) ? r : n;
    return l ? p(o, s, l) : p(o, s);
  }
}
function PV(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), u = eg(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: u ? u.column - 1 : void 0,
        fileName: e,
        lineNumber: u ? u.line : void 0
      },
      void 0
    );
  }
}
function AV(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && ng.call(n.properties, a)) {
      const o = VV(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && CV.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function LV(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        Oo(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          Oo(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function rg(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : SV;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const u = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (u) {
        const p = a.get(u) || 0;
        s = u + "-" + p, a.set(u, p + 1);
      }
    }
    const l = oC(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function VV(e, n, r) {
  const i = mV(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? eV(r) : gV(r)), i.property === "style") {
      let a = typeof r == "object" ? r : zV(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = UV(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? hV[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function zV(e, n) {
  const r = {};
  try {
    _V(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Vt("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = aC + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(jV, BV)), r[s] = o;
  }
}
function lC(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = rx(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = rx(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return ng.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Oo(e);
}
function Oo(e, n) {
  const r = new Vt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = aC + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function UV(e) {
  const n = {};
  let r;
  for (r in e)
    ng.call(e, r) && (n[MV(r)] = e[r]);
  return n;
}
function MV(e) {
  let n = e.replace(NV, qV);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function BV(e, n) {
  return n.toUpperCase();
}
function qV(e) {
  return "-" + e.toLowerCase();
}
const Zd = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, HV = {};
function WV(e, n) {
  const r = HV, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return cC(e, i, a);
}
function cC(e, n, r) {
  if (KV(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return mx(e.children, n, r);
  }
  return Array.isArray(e) ? mx(e, n, r) : "";
}
function mx(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = cC(e[a], n, r);
  return i.join("");
}
function KV(e) {
  return !!(e && typeof e == "object");
}
const px = document.createElement("i");
function ig(e) {
  const n = "&" + e + ";";
  px.innerHTML = n;
  const r = px.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Vr(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function pr(e, n) {
  return e.length > 0 ? (Vr(e, e.length, 0, n), e) : n;
}
const fx = {}.hasOwnProperty;
function GV(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    YV(n, e[r]);
  return n;
}
function YV(e, n) {
  let r;
  for (r in n) {
    const a = (fx.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        fx.call(a, s) || (a[s] = []);
        const l = o[s];
        QV(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function QV(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Vr(e, 0, 0, i);
}
function uC(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function ua(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Dr = hi(/[A-Za-z]/), cr = hi(/[\dA-Za-z]/), JV = hi(/[#-'*+\--9=?A-Z^-~]/);
function zh(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Uh = hi(/\d/), XV = hi(/[\dA-Fa-f]/), ZV = hi(/[!-/:-@[-`{-~]/);
function Fn(e) {
  return e !== null && e < -2;
}
function nr(e) {
  return e !== null && (e < 0 || e === 32);
}
function Wn(e) {
  return e === -2 || e === -1 || e === 32;
}
const e3 = hi(new RegExp("\\p{P}|\\p{S}", "u")), n3 = hi(/\s/);
function hi(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function wa(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && cr(e.charCodeAt(r + 1)) && cr(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function rt(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(u) {
    return Wn(u) ? (e.enter(r), l(u)) : n(u);
  }
  function l(u) {
    return Wn(u) && o++ < a ? (e.consume(u), l) : (e.exit(r), n(u));
  }
}
const t3 = {
  tokenize: r3
};
function r3(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), rt(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const u = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = u), r = u, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return Fn(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const i3 = {
  tokenize: a3
}, hx = {
  tokenize: o3
};
function a3(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(z) {
    if (i < r.length) {
      const T = r[i];
      return n.containerState = T[1], e.attempt(T[0].continuation, u, p)(z);
    }
    return p(z);
  }
  function u(z) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && g();
      const T = n.events.length;
      let I = T, D;
      for (; I--; )
        if (n.events[I][0] === "exit" && n.events[I][1].type === "chunkFlow") {
          D = n.events[I][1].end;
          break;
        }
      C(i);
      let U = T;
      for (; U < n.events.length; )
        n.events[U][1].end = {
          ...D
        }, U++;
      return Vr(n.events, I + 1, 0, n.events.slice(T)), n.events.length = U, p(z);
    }
    return l(z);
  }
  function p(z) {
    if (i === r.length) {
      if (!a)
        return h(z);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return F(z);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(hx, d, f)(z);
  }
  function d(z) {
    return a && g(), C(i), h(z);
  }
  function f(z) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, F(z);
  }
  function h(z) {
    return n.containerState = {}, e.attempt(hx, v, F)(z);
  }
  function v(z) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(z);
  }
  function F(z) {
    if (z === null) {
      a && g(), C(0), e.consume(z);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), N(z);
  }
  function N(z) {
    if (z === null) {
      j(e.exit("chunkFlow"), !0), C(0), e.consume(z);
      return;
    }
    return Fn(z) ? (e.consume(z), j(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(z), N);
  }
  function j(z, T) {
    const I = n.sliceStream(z);
    if (T && I.push(null), z.previous = o, o && (o.next = z), o = z, a.defineSkip(z.start), a.write(I), n.parser.lazy[z.start.line]) {
      let D = a.events.length;
      for (; D--; )
        if (
          // The token starts before the line ending…
          a.events[D][1].start.offset < s && // …and either is not ended yet…
          (!a.events[D][1].end || // …or ends after it.
          a.events[D][1].end.offset > s)
        )
          return;
      const U = n.events.length;
      let Q = U, X, re;
      for (; Q--; )
        if (n.events[Q][0] === "exit" && n.events[Q][1].type === "chunkFlow") {
          if (X) {
            re = n.events[Q][1].end;
            break;
          }
          X = !0;
        }
      for (C(i), D = U; D < n.events.length; )
        n.events[D][1].end = {
          ...re
        }, D++;
      Vr(n.events, Q + 1, 0, n.events.slice(U)), n.events.length = D;
    }
  }
  function C(z) {
    let T = r.length;
    for (; T-- > z; ) {
      const I = r[T];
      n.containerState = I[1], I[0].exit.call(n, e);
    }
    r.length = z;
  }
  function g() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function o3(e, n, r) {
  return rt(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function yx(e) {
  if (e === null || nr(e) || n3(e))
    return 1;
  if (e3(e))
    return 2;
}
function ag(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const Mh = {
  name: "attention",
  resolveAll: s3,
  tokenize: l3
};
function s3(e, n) {
  let r = -1, i, a, o, s, l, u, p, d;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          u = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          gx(f, -u), gx(h, u), s = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: u > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: u > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, p = [], e[i][1].end.offset - e[i][1].start.offset && (p = pr(p, [["enter", e[i][1], n], ["exit", e[i][1], n]])), p = pr(p, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), p = pr(p, ag(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), p = pr(p, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (d = 2, p = pr(p, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : d = 0, Vr(e, i - 1, r - i + 3, p), r = i + p.length - d - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function l3(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = yx(i);
  let o;
  return s;
  function s(u) {
    return o = u, e.enter("attentionSequence"), l(u);
  }
  function l(u) {
    if (u === o)
      return e.consume(u), l;
    const p = e.exit("attentionSequence"), d = yx(u), f = !d || d === 2 && a || r.includes(u), h = !a || a === 2 && d || r.includes(i);
    return p._open = !!(o === 42 ? f : f && (a || !h)), p._close = !!(o === 42 ? h : h && (d || !f)), n(u);
  }
}
function gx(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const c3 = {
  name: "autolink",
  tokenize: u3
};
function u3(e, n, r) {
  let i = 0;
  return a;
  function a(v) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(v) {
    return Dr(v) ? (e.consume(v), s) : v === 64 ? r(v) : p(v);
  }
  function s(v) {
    return v === 43 || v === 45 || v === 46 || cr(v) ? (i = 1, l(v)) : p(v);
  }
  function l(v) {
    return v === 58 ? (e.consume(v), i = 0, u) : (v === 43 || v === 45 || v === 46 || cr(v)) && i++ < 32 ? (e.consume(v), l) : (i = 0, p(v));
  }
  function u(v) {
    return v === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : v === null || v === 32 || v === 60 || zh(v) ? r(v) : (e.consume(v), u);
  }
  function p(v) {
    return v === 64 ? (e.consume(v), d) : JV(v) ? (e.consume(v), p) : r(v);
  }
  function d(v) {
    return cr(v) ? f(v) : r(v);
  }
  function f(v) {
    return v === 46 ? (e.consume(v), i = 0, d) : v === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(v);
  }
  function h(v) {
    if ((v === 45 || cr(v)) && i++ < 63) {
      const F = v === 45 ? h : f;
      return e.consume(v), F;
    }
    return r(v);
  }
}
const Ll = {
  partial: !0,
  tokenize: d3
};
function d3(e, n, r) {
  return i;
  function i(o) {
    return Wn(o) ? rt(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || Fn(o) ? n(o) : r(o);
  }
}
const dC = {
  continuation: {
    tokenize: p3
  },
  exit: f3,
  name: "blockQuote",
  tokenize: m3
};
function m3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return Wn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function p3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return Wn(s) ? rt(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(dC, n, r)(s);
  }
}
function f3(e) {
  e.exit("blockQuote");
}
const mC = {
  name: "characterEscape",
  tokenize: h3
};
function h3(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return ZV(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const pC = {
  name: "characterReference",
  tokenize: y3
};
function y3(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), u;
  }
  function u(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), p) : (e.enter("characterReferenceValue"), o = 31, s = cr, d(f));
  }
  function p(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = XV, d) : (e.enter("characterReferenceValue"), o = 7, s = Uh, d(f));
  }
  function d(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === cr && !ig(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), d) : r(f);
  }
}
const vx = {
  partial: !0,
  tokenize: v3
}, kx = {
  concrete: !0,
  name: "codeFenced",
  tokenize: g3
};
function g3(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: I
  };
  let o = 0, s = 0, l;
  return u;
  function u(D) {
    return p(D);
  }
  function p(D) {
    const U = i.events[i.events.length - 1];
    return o = U && U[1].type === "linePrefix" ? U[2].sliceSerialize(U[1], !0).length : 0, l = D, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), d(D);
  }
  function d(D) {
    return D === l ? (s++, e.consume(D), d) : s < 3 ? r(D) : (e.exit("codeFencedFenceSequence"), Wn(D) ? rt(e, f, "whitespace")(D) : f(D));
  }
  function f(D) {
    return D === null || Fn(D) ? (e.exit("codeFencedFence"), i.interrupt ? n(D) : e.check(vx, N, T)(D)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(D));
  }
  function h(D) {
    return D === null || Fn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(D)) : Wn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), rt(e, v, "whitespace")(D)) : D === 96 && D === l ? r(D) : (e.consume(D), h);
  }
  function v(D) {
    return D === null || Fn(D) ? f(D) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), F(D));
  }
  function F(D) {
    return D === null || Fn(D) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(D)) : D === 96 && D === l ? r(D) : (e.consume(D), F);
  }
  function N(D) {
    return e.attempt(a, T, j)(D);
  }
  function j(D) {
    return e.enter("lineEnding"), e.consume(D), e.exit("lineEnding"), C;
  }
  function C(D) {
    return o > 0 && Wn(D) ? rt(e, g, "linePrefix", o + 1)(D) : g(D);
  }
  function g(D) {
    return D === null || Fn(D) ? e.check(vx, N, T)(D) : (e.enter("codeFlowValue"), z(D));
  }
  function z(D) {
    return D === null || Fn(D) ? (e.exit("codeFlowValue"), g(D)) : (e.consume(D), z);
  }
  function T(D) {
    return e.exit("codeFenced"), n(D);
  }
  function I(D, U, Q) {
    let X = 0;
    return re;
    function re(ee) {
      return D.enter("lineEnding"), D.consume(ee), D.exit("lineEnding"), G;
    }
    function G(ee) {
      return D.enter("codeFencedFence"), Wn(ee) ? rt(D, q, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ee) : q(ee);
    }
    function q(ee) {
      return ee === l ? (D.enter("codeFencedFenceSequence"), R(ee)) : Q(ee);
    }
    function R(ee) {
      return ee === l ? (X++, D.consume(ee), R) : X >= s ? (D.exit("codeFencedFenceSequence"), Wn(ee) ? rt(D, B, "whitespace")(ee) : B(ee)) : Q(ee);
    }
    function B(ee) {
      return ee === null || Fn(ee) ? (D.exit("codeFencedFence"), U(ee)) : Q(ee);
    }
  }
}
function v3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const em = {
  name: "codeIndented",
  tokenize: b3
}, k3 = {
  partial: !0,
  tokenize: _3
};
function b3(e, n, r) {
  const i = this;
  return a;
  function a(p) {
    return e.enter("codeIndented"), rt(e, o, "linePrefix", 5)(p);
  }
  function o(p) {
    const d = i.events[i.events.length - 1];
    return d && d[1].type === "linePrefix" && d[2].sliceSerialize(d[1], !0).length >= 4 ? s(p) : r(p);
  }
  function s(p) {
    return p === null ? u(p) : Fn(p) ? e.attempt(k3, s, u)(p) : (e.enter("codeFlowValue"), l(p));
  }
  function l(p) {
    return p === null || Fn(p) ? (e.exit("codeFlowValue"), s(p)) : (e.consume(p), l);
  }
  function u(p) {
    return e.exit("codeIndented"), n(p);
  }
}
function _3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : Fn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : rt(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : Fn(s) ? a(s) : r(s);
  }
}
const x3 = {
  name: "codeText",
  previous: N3,
  resolve: S3,
  tokenize: j3
};
function S3(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function N3(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function j3(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), u(f));
  }
  function u(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), u) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, d(f)) : Fn(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), u) : (e.enter("codeTextData"), p(f));
  }
  function p(f) {
    return f === null || f === 32 || f === 96 || Fn(f) ? (e.exit("codeTextData"), u(f)) : (e.consume(f), p);
  }
  function d(f) {
    return f === 96 ? (e.consume(f), a++, d) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", p(f));
  }
}
class w3 {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && Ha(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), Ha(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), Ha(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        Ha(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        Ha(this.left, r.reverse());
      }
  }
}
function Ha(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function fC(e) {
  const n = {};
  let r = -1, i, a, o, s, l, u, p;
  const d = new w3(e);
  for (; ++r < d.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = d.get(r), r && i[1].type === "chunkFlow" && d.get(r - 1)[1].type === "listItemPrefix" && (u = i[1]._tokenizer.events, o = 0, o < u.length && u[o][1].type === "lineEndingBlank" && (o += 2), o < u.length && u[o][1].type === "content"))
      for (; ++o < u.length && u[o][1].type !== "content"; )
        u[o][1].type === "chunkText" && (u[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, C3(d, r)), r = n[r], p = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = d.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (d.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...d.get(a)[1].start
      }, l = d.slice(a, r), l.unshift(i), d.splice(a, r - a + 1, l));
    }
  }
  return Vr(e, 0, Number.POSITIVE_INFINITY, d.slice(0)), !p;
}
function C3(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, u = [], p = {};
  let d, f, h = -1, v = r, F = 0, N = 0;
  const j = [N];
  for (; v; ) {
    for (; e.get(++a)[1] !== v; )
      ;
    o.push(a), v._tokenizer || (d = i.sliceStream(v), v.next || d.push(null), f && s.defineSkip(v.start), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(d), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = v, v = v.next;
  }
  for (v = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (N = h + 1, j.push(N), v._tokenizer = void 0, v.previous = void 0, v = v.next);
  for (s.events = [], v ? (v._tokenizer = void 0, v.previous = void 0) : j.pop(), h = j.length; h--; ) {
    const C = l.slice(j[h], j[h + 1]), g = o.pop();
    u.push([g, g + C.length - 1]), e.splice(g, 2, C);
  }
  for (u.reverse(), h = -1; ++h < u.length; )
    p[F + u[h][0]] = F + u[h][1], F += u[h][1] - u[h][0] - 1;
  return p;
}
const F3 = {
  resolve: $3,
  tokenize: E3
}, I3 = {
  partial: !0,
  tokenize: T3
};
function $3(e) {
  return fC(e), e;
}
function E3(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : Fn(l) ? e.check(I3, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function T3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), rt(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || Fn(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function hC(e, n, r, i, a, o, s, l, u) {
  const p = u || Number.POSITIVE_INFINITY;
  let d = 0;
  return f;
  function f(C) {
    return C === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(C), e.exit(o), h) : C === null || C === 32 || C === 41 || zh(C) ? r(C) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), N(C));
  }
  function h(C) {
    return C === 62 ? (e.enter(o), e.consume(C), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), v(C));
  }
  function v(C) {
    return C === 62 ? (e.exit("chunkString"), e.exit(l), h(C)) : C === null || C === 60 || Fn(C) ? r(C) : (e.consume(C), C === 92 ? F : v);
  }
  function F(C) {
    return C === 60 || C === 62 || C === 92 ? (e.consume(C), v) : v(C);
  }
  function N(C) {
    return !d && (C === null || C === 41 || nr(C)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(C)) : d < p && C === 40 ? (e.consume(C), d++, N) : C === 41 ? (e.consume(C), d--, N) : C === null || C === 32 || C === 40 || zh(C) ? r(C) : (e.consume(C), C === 92 ? j : N);
  }
  function j(C) {
    return C === 40 || C === 41 || C === 92 ? (e.consume(C), N) : N(C);
  }
}
function yC(e, n, r, i, a, o) {
  const s = this;
  let l = 0, u;
  return p;
  function p(v) {
    return e.enter(i), e.enter(a), e.consume(v), e.exit(a), e.enter(o), d;
  }
  function d(v) {
    return l > 999 || v === null || v === 91 || v === 93 && !u || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    v === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(v) : v === 93 ? (e.exit(o), e.enter(a), e.consume(v), e.exit(a), e.exit(i), n) : Fn(v) ? (e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), d) : (e.enter("chunkString", {
      contentType: "string"
    }), f(v));
  }
  function f(v) {
    return v === null || v === 91 || v === 93 || Fn(v) || l++ > 999 ? (e.exit("chunkString"), d(v)) : (e.consume(v), u || (u = !Wn(v)), v === 92 ? h : f);
  }
  function h(v) {
    return v === 91 || v === 92 || v === 93 ? (e.consume(v), l++, f) : f(v);
  }
}
function gC(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, u) : r(h);
  }
  function u(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), p(h));
  }
  function p(h) {
    return h === s ? (e.exit(o), u(s)) : h === null ? r(h) : Fn(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), rt(e, p, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), d(h));
  }
  function d(h) {
    return h === s || h === null || Fn(h) ? (e.exit("chunkString"), p(h)) : (e.consume(h), h === 92 ? f : d);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), d) : d(h);
  }
}
function So(e, n) {
  let r;
  return i;
  function i(a) {
    return Fn(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : Wn(a) ? rt(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const D3 = {
  name: "definition",
  tokenize: R3
}, O3 = {
  partial: !0,
  tokenize: P3
};
function R3(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(v) {
    return e.enter("definition"), s(v);
  }
  function s(v) {
    return yC.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(v);
  }
  function l(v) {
    return a = ua(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), v === 58 ? (e.enter("definitionMarker"), e.consume(v), e.exit("definitionMarker"), u) : r(v);
  }
  function u(v) {
    return nr(v) ? So(e, p)(v) : p(v);
  }
  function p(v) {
    return hC(
      e,
      d,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(v);
  }
  function d(v) {
    return e.attempt(O3, f, f)(v);
  }
  function f(v) {
    return Wn(v) ? rt(e, h, "whitespace")(v) : h(v);
  }
  function h(v) {
    return v === null || Fn(v) ? (e.exit("definition"), i.parser.defined.push(a), n(v)) : r(v);
  }
}
function P3(e, n, r) {
  return i;
  function i(l) {
    return nr(l) ? So(e, a)(l) : r(l);
  }
  function a(l) {
    return gC(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return Wn(l) ? rt(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || Fn(l) ? n(l) : r(l);
  }
}
const A3 = {
  name: "hardBreakEscape",
  tokenize: L3
};
function L3(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return Fn(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const V3 = {
  name: "headingAtx",
  resolve: z3,
  tokenize: U3
};
function z3(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Vr(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function U3(e, n, r) {
  let i = 0;
  return a;
  function a(d) {
    return e.enter("atxHeading"), o(d);
  }
  function o(d) {
    return e.enter("atxHeadingSequence"), s(d);
  }
  function s(d) {
    return d === 35 && i++ < 6 ? (e.consume(d), s) : d === null || nr(d) ? (e.exit("atxHeadingSequence"), l(d)) : r(d);
  }
  function l(d) {
    return d === 35 ? (e.enter("atxHeadingSequence"), u(d)) : d === null || Fn(d) ? (e.exit("atxHeading"), n(d)) : Wn(d) ? rt(e, l, "whitespace")(d) : (e.enter("atxHeadingText"), p(d));
  }
  function u(d) {
    return d === 35 ? (e.consume(d), u) : (e.exit("atxHeadingSequence"), l(d));
  }
  function p(d) {
    return d === null || d === 35 || nr(d) ? (e.exit("atxHeadingText"), l(d)) : (e.consume(d), p);
  }
}
const M3 = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], bx = ["pre", "script", "style", "textarea"], B3 = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: W3,
  tokenize: K3
}, q3 = {
  partial: !0,
  tokenize: Y3
}, H3 = {
  partial: !0,
  tokenize: G3
};
function W3(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function K3(e, n, r) {
  const i = this;
  let a, o, s, l, u;
  return p;
  function p(Y) {
    return d(Y);
  }
  function d(Y) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(Y), f;
  }
  function f(Y) {
    return Y === 33 ? (e.consume(Y), h) : Y === 47 ? (e.consume(Y), o = !0, N) : Y === 63 ? (e.consume(Y), a = 3, i.interrupt ? n : K) : Dr(Y) ? (e.consume(Y), s = String.fromCharCode(Y), j) : r(Y);
  }
  function h(Y) {
    return Y === 45 ? (e.consume(Y), a = 2, v) : Y === 91 ? (e.consume(Y), a = 5, l = 0, F) : Dr(Y) ? (e.consume(Y), a = 4, i.interrupt ? n : K) : r(Y);
  }
  function v(Y) {
    return Y === 45 ? (e.consume(Y), i.interrupt ? n : K) : r(Y);
  }
  function F(Y) {
    const qe = "CDATA[";
    return Y === qe.charCodeAt(l++) ? (e.consume(Y), l === qe.length ? i.interrupt ? n : q : F) : r(Y);
  }
  function N(Y) {
    return Dr(Y) ? (e.consume(Y), s = String.fromCharCode(Y), j) : r(Y);
  }
  function j(Y) {
    if (Y === null || Y === 47 || Y === 62 || nr(Y)) {
      const qe = Y === 47, Me = s.toLowerCase();
      return !qe && !o && bx.includes(Me) ? (a = 1, i.interrupt ? n(Y) : q(Y)) : M3.includes(s.toLowerCase()) ? (a = 6, qe ? (e.consume(Y), C) : i.interrupt ? n(Y) : q(Y)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(Y) : o ? g(Y) : z(Y));
    }
    return Y === 45 || cr(Y) ? (e.consume(Y), s += String.fromCharCode(Y), j) : r(Y);
  }
  function C(Y) {
    return Y === 62 ? (e.consume(Y), i.interrupt ? n : q) : r(Y);
  }
  function g(Y) {
    return Wn(Y) ? (e.consume(Y), g) : re(Y);
  }
  function z(Y) {
    return Y === 47 ? (e.consume(Y), re) : Y === 58 || Y === 95 || Dr(Y) ? (e.consume(Y), T) : Wn(Y) ? (e.consume(Y), z) : re(Y);
  }
  function T(Y) {
    return Y === 45 || Y === 46 || Y === 58 || Y === 95 || cr(Y) ? (e.consume(Y), T) : I(Y);
  }
  function I(Y) {
    return Y === 61 ? (e.consume(Y), D) : Wn(Y) ? (e.consume(Y), I) : z(Y);
  }
  function D(Y) {
    return Y === null || Y === 60 || Y === 61 || Y === 62 || Y === 96 ? r(Y) : Y === 34 || Y === 39 ? (e.consume(Y), u = Y, U) : Wn(Y) ? (e.consume(Y), D) : Q(Y);
  }
  function U(Y) {
    return Y === u ? (e.consume(Y), u = null, X) : Y === null || Fn(Y) ? r(Y) : (e.consume(Y), U);
  }
  function Q(Y) {
    return Y === null || Y === 34 || Y === 39 || Y === 47 || Y === 60 || Y === 61 || Y === 62 || Y === 96 || nr(Y) ? I(Y) : (e.consume(Y), Q);
  }
  function X(Y) {
    return Y === 47 || Y === 62 || Wn(Y) ? z(Y) : r(Y);
  }
  function re(Y) {
    return Y === 62 ? (e.consume(Y), G) : r(Y);
  }
  function G(Y) {
    return Y === null || Fn(Y) ? q(Y) : Wn(Y) ? (e.consume(Y), G) : r(Y);
  }
  function q(Y) {
    return Y === 45 && a === 2 ? (e.consume(Y), be) : Y === 60 && a === 1 ? (e.consume(Y), fe) : Y === 62 && a === 4 ? (e.consume(Y), xe) : Y === 63 && a === 3 ? (e.consume(Y), K) : Y === 93 && a === 5 ? (e.consume(Y), ge) : Fn(Y) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(q3, $e, R)(Y)) : Y === null || Fn(Y) ? (e.exit("htmlFlowData"), R(Y)) : (e.consume(Y), q);
  }
  function R(Y) {
    return e.check(H3, B, $e)(Y);
  }
  function B(Y) {
    return e.enter("lineEnding"), e.consume(Y), e.exit("lineEnding"), ee;
  }
  function ee(Y) {
    return Y === null || Fn(Y) ? R(Y) : (e.enter("htmlFlowData"), q(Y));
  }
  function be(Y) {
    return Y === 45 ? (e.consume(Y), K) : q(Y);
  }
  function fe(Y) {
    return Y === 47 ? (e.consume(Y), s = "", de) : q(Y);
  }
  function de(Y) {
    if (Y === 62) {
      const qe = s.toLowerCase();
      return bx.includes(qe) ? (e.consume(Y), xe) : q(Y);
    }
    return Dr(Y) && s.length < 8 ? (e.consume(Y), s += String.fromCharCode(Y), de) : q(Y);
  }
  function ge(Y) {
    return Y === 93 ? (e.consume(Y), K) : q(Y);
  }
  function K(Y) {
    return Y === 62 ? (e.consume(Y), xe) : Y === 45 && a === 2 ? (e.consume(Y), K) : q(Y);
  }
  function xe(Y) {
    return Y === null || Fn(Y) ? (e.exit("htmlFlowData"), $e(Y)) : (e.consume(Y), xe);
  }
  function $e(Y) {
    return e.exit("htmlFlow"), n(Y);
  }
}
function G3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return Fn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function Y3(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(Ll, n, r);
  }
}
const Q3 = {
  name: "htmlText",
  tokenize: J3
};
function J3(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(K) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(K), u;
  }
  function u(K) {
    return K === 33 ? (e.consume(K), p) : K === 47 ? (e.consume(K), I) : K === 63 ? (e.consume(K), z) : Dr(K) ? (e.consume(K), Q) : r(K);
  }
  function p(K) {
    return K === 45 ? (e.consume(K), d) : K === 91 ? (e.consume(K), o = 0, F) : Dr(K) ? (e.consume(K), g) : r(K);
  }
  function d(K) {
    return K === 45 ? (e.consume(K), v) : r(K);
  }
  function f(K) {
    return K === null ? r(K) : K === 45 ? (e.consume(K), h) : Fn(K) ? (s = f, fe(K)) : (e.consume(K), f);
  }
  function h(K) {
    return K === 45 ? (e.consume(K), v) : f(K);
  }
  function v(K) {
    return K === 62 ? be(K) : K === 45 ? h(K) : f(K);
  }
  function F(K) {
    const xe = "CDATA[";
    return K === xe.charCodeAt(o++) ? (e.consume(K), o === xe.length ? N : F) : r(K);
  }
  function N(K) {
    return K === null ? r(K) : K === 93 ? (e.consume(K), j) : Fn(K) ? (s = N, fe(K)) : (e.consume(K), N);
  }
  function j(K) {
    return K === 93 ? (e.consume(K), C) : N(K);
  }
  function C(K) {
    return K === 62 ? be(K) : K === 93 ? (e.consume(K), C) : N(K);
  }
  function g(K) {
    return K === null || K === 62 ? be(K) : Fn(K) ? (s = g, fe(K)) : (e.consume(K), g);
  }
  function z(K) {
    return K === null ? r(K) : K === 63 ? (e.consume(K), T) : Fn(K) ? (s = z, fe(K)) : (e.consume(K), z);
  }
  function T(K) {
    return K === 62 ? be(K) : z(K);
  }
  function I(K) {
    return Dr(K) ? (e.consume(K), D) : r(K);
  }
  function D(K) {
    return K === 45 || cr(K) ? (e.consume(K), D) : U(K);
  }
  function U(K) {
    return Fn(K) ? (s = U, fe(K)) : Wn(K) ? (e.consume(K), U) : be(K);
  }
  function Q(K) {
    return K === 45 || cr(K) ? (e.consume(K), Q) : K === 47 || K === 62 || nr(K) ? X(K) : r(K);
  }
  function X(K) {
    return K === 47 ? (e.consume(K), be) : K === 58 || K === 95 || Dr(K) ? (e.consume(K), re) : Fn(K) ? (s = X, fe(K)) : Wn(K) ? (e.consume(K), X) : be(K);
  }
  function re(K) {
    return K === 45 || K === 46 || K === 58 || K === 95 || cr(K) ? (e.consume(K), re) : G(K);
  }
  function G(K) {
    return K === 61 ? (e.consume(K), q) : Fn(K) ? (s = G, fe(K)) : Wn(K) ? (e.consume(K), G) : X(K);
  }
  function q(K) {
    return K === null || K === 60 || K === 61 || K === 62 || K === 96 ? r(K) : K === 34 || K === 39 ? (e.consume(K), a = K, R) : Fn(K) ? (s = q, fe(K)) : Wn(K) ? (e.consume(K), q) : (e.consume(K), B);
  }
  function R(K) {
    return K === a ? (e.consume(K), a = void 0, ee) : K === null ? r(K) : Fn(K) ? (s = R, fe(K)) : (e.consume(K), R);
  }
  function B(K) {
    return K === null || K === 34 || K === 39 || K === 60 || K === 61 || K === 96 ? r(K) : K === 47 || K === 62 || nr(K) ? X(K) : (e.consume(K), B);
  }
  function ee(K) {
    return K === 47 || K === 62 || nr(K) ? X(K) : r(K);
  }
  function be(K) {
    return K === 62 ? (e.consume(K), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(K);
  }
  function fe(K) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(K), e.exit("lineEnding"), de;
  }
  function de(K) {
    return Wn(K) ? rt(e, ge, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(K) : ge(K);
  }
  function ge(K) {
    return e.enter("htmlTextData"), s(K);
  }
}
const og = {
  name: "labelEnd",
  resolveAll: nz,
  resolveTo: tz,
  tokenize: rz
}, X3 = {
  tokenize: iz
}, Z3 = {
  tokenize: az
}, ez = {
  tokenize: oz
};
function nz(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Vr(e, 0, e.length, r), e;
}
function tz(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const u = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, p = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, d = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", u, n], ["enter", p, n]], l = pr(l, e.slice(o + 1, o + i + 3)), l = pr(l, [["enter", d, n]]), l = pr(l, ag(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = pr(l, [["exit", d, n], e[s - 2], e[s - 1], ["exit", p, n]]), l = pr(l, e.slice(s + 1)), l = pr(l, [["exit", u, n]]), Vr(e, o, e.length, l), e;
}
function rz(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(ua(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), u) : r(h);
  }
  function u(h) {
    return h === 40 ? e.attempt(X3, d, s ? d : f)(h) : h === 91 ? e.attempt(Z3, d, s ? p : f)(h) : s ? d(h) : f(h);
  }
  function p(h) {
    return e.attempt(ez, d, f)(h);
  }
  function d(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function iz(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return nr(f) ? So(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? d(f) : hC(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return nr(f) ? So(e, u)(f) : d(f);
  }
  function l(f) {
    return r(f);
  }
  function u(f) {
    return f === 34 || f === 39 || f === 40 ? gC(e, p, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : d(f);
  }
  function p(f) {
    return nr(f) ? So(e, d)(f) : d(f);
  }
  function d(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function az(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return yC.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(ua(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function oz(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const sz = {
  name: "labelStartImage",
  resolveAll: og.resolveAll,
  tokenize: lz
};
function lz(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const cz = {
  name: "labelStartLink",
  resolveAll: og.resolveAll,
  tokenize: uz
};
function uz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const nm = {
  name: "lineEnding",
  tokenize: dz
};
function dz(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), rt(e, n, "linePrefix");
  }
}
const Ms = {
  name: "thematicBreak",
  tokenize: mz
};
function mz(e, n, r) {
  let i = 0, a;
  return o;
  function o(p) {
    return e.enter("thematicBreak"), s(p);
  }
  function s(p) {
    return a = p, l(p);
  }
  function l(p) {
    return p === a ? (e.enter("thematicBreakSequence"), u(p)) : i >= 3 && (p === null || Fn(p)) ? (e.exit("thematicBreak"), n(p)) : r(p);
  }
  function u(p) {
    return p === a ? (e.consume(p), i++, u) : (e.exit("thematicBreakSequence"), Wn(p) ? rt(e, l, "whitespace")(p) : l(p));
  }
}
const Jt = {
  continuation: {
    tokenize: yz
  },
  exit: vz,
  name: "list",
  tokenize: hz
}, pz = {
  partial: !0,
  tokenize: kz
}, fz = {
  partial: !0,
  tokenize: gz
};
function hz(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(v) {
    const F = i.containerState.type || (v === 42 || v === 43 || v === 45 ? "listUnordered" : "listOrdered");
    if (F === "listUnordered" ? !i.containerState.marker || v === i.containerState.marker : Uh(v)) {
      if (i.containerState.type || (i.containerState.type = F, e.enter(F, {
        _container: !0
      })), F === "listUnordered")
        return e.enter("listItemPrefix"), v === 42 || v === 45 ? e.check(Ms, r, p)(v) : p(v);
      if (!i.interrupt || v === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), u(v);
    }
    return r(v);
  }
  function u(v) {
    return Uh(v) && ++s < 10 ? (e.consume(v), u) : (!i.interrupt || s < 2) && (i.containerState.marker ? v === i.containerState.marker : v === 41 || v === 46) ? (e.exit("listItemValue"), p(v)) : r(v);
  }
  function p(v) {
    return e.enter("listItemMarker"), e.consume(v), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || v, e.check(
      Ll,
      // Can’t be empty when interrupting.
      i.interrupt ? r : d,
      e.attempt(pz, h, f)
    );
  }
  function d(v) {
    return i.containerState.initialBlankLine = !0, o++, h(v);
  }
  function f(v) {
    return Wn(v) ? (e.enter("listItemPrefixWhitespace"), e.consume(v), e.exit("listItemPrefixWhitespace"), h) : r(v);
  }
  function h(v) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(v);
  }
}
function yz(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(Ll, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, rt(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !Wn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(fz, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, rt(e, e.attempt(Jt, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function gz(e, n, r) {
  const i = this;
  return rt(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function vz(e) {
  e.exit(this.containerState.type);
}
function kz(e, n, r) {
  const i = this;
  return rt(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !Wn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const _x = {
  name: "setextUnderline",
  resolveTo: bz,
  tokenize: _z
};
function bz(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function _z(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(p) {
    let d = i.events.length, f;
    for (; d--; )
      if (i.events[d][1].type !== "lineEnding" && i.events[d][1].type !== "linePrefix" && i.events[d][1].type !== "content") {
        f = i.events[d][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = p, s(p)) : r(p);
  }
  function s(p) {
    return e.enter("setextHeadingLineSequence"), l(p);
  }
  function l(p) {
    return p === a ? (e.consume(p), l) : (e.exit("setextHeadingLineSequence"), Wn(p) ? rt(e, u, "lineSuffix")(p) : u(p));
  }
  function u(p) {
    return p === null || Fn(p) ? (e.exit("setextHeadingLine"), n(p)) : r(p);
  }
}
const xz = {
  tokenize: Sz
};
function Sz(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    Ll,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, rt(e, e.attempt(this.parser.constructs.flow, a, e.attempt(F3, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const Nz = {
  resolveAll: kC()
}, jz = vC("string"), wz = vC("text");
function vC(e) {
  return {
    resolveAll: kC(e === "text" ? Cz : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(d) {
      return p(d) ? o(d) : l(d);
    }
    function l(d) {
      if (d === null) {
        r.consume(d);
        return;
      }
      return r.enter("data"), r.consume(d), u;
    }
    function u(d) {
      return p(d) ? (r.exit("data"), o(d)) : (r.consume(d), u);
    }
    function p(d) {
      if (d === null)
        return !0;
      const f = a[d];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const v = f[h];
          if (!v.previous || v.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function kC(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function Cz(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, u;
      for (; o--; ) {
        const p = a[o];
        if (typeof p == "string") {
          for (s = p.length; p.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (p === -2)
          u = !0, l++;
        else if (p !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const p = {
          type: r === e.length || u || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...p.start
        }, i.start.offset === i.end.offset ? Object.assign(i, p) : (e.splice(r, 0, ["enter", p, n], ["exit", p, n]), r += 2);
      }
      r++;
    }
  return e;
}
const Fz = {
  42: Jt,
  43: Jt,
  45: Jt,
  48: Jt,
  49: Jt,
  50: Jt,
  51: Jt,
  52: Jt,
  53: Jt,
  54: Jt,
  55: Jt,
  56: Jt,
  57: Jt,
  62: dC
}, Iz = {
  91: D3
}, $z = {
  [-2]: em,
  [-1]: em,
  32: em
}, Ez = {
  35: V3,
  42: Ms,
  45: [_x, Ms],
  60: B3,
  61: _x,
  95: Ms,
  96: kx,
  126: kx
}, Tz = {
  38: pC,
  92: mC
}, Dz = {
  [-5]: nm,
  [-4]: nm,
  [-3]: nm,
  33: sz,
  38: pC,
  42: Mh,
  60: [c3, Q3],
  91: cz,
  92: [A3, mC],
  93: og,
  95: Mh,
  96: x3
}, Oz = {
  null: [Mh, Nz]
}, Rz = {
  null: [42, 95]
}, Pz = {
  null: []
}, Az = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: Rz,
  contentInitial: Iz,
  disable: Pz,
  document: Fz,
  flow: Ez,
  flowInitial: $z,
  insideSpan: Oz,
  string: Tz,
  text: Dz
}, Symbol.toStringTag, { value: "Module" }));
function Lz(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const u = {
    attempt: U(I),
    check: U(D),
    consume: g,
    enter: z,
    exit: T,
    interrupt: U(D, {
      interrupt: !0
    })
  }, p = {
    code: null,
    containerState: {},
    defineSkip: N,
    events: [],
    now: F,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: v,
    write: f
  };
  let d = n.tokenize.call(p, u);
  return n.resolveAll && o.push(n), p;
  function f(G) {
    return s = pr(s, G), j(), s[s.length - 1] !== null ? [] : (Q(n, 0), p.events = ag(o, p.events, p), p.events);
  }
  function h(G, q) {
    return zz(v(G), q);
  }
  function v(G) {
    return Vz(s, G);
  }
  function F() {
    const {
      _bufferIndex: G,
      _index: q,
      line: R,
      column: B,
      offset: ee
    } = i;
    return {
      _bufferIndex: G,
      _index: q,
      line: R,
      column: B,
      offset: ee
    };
  }
  function N(G) {
    a[G.line] = G.column, re();
  }
  function j() {
    let G;
    for (; i._index < s.length; ) {
      const q = s[i._index];
      if (typeof q == "string")
        for (G = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === G && i._bufferIndex < q.length; )
          C(q.charCodeAt(i._bufferIndex));
      else
        C(q);
    }
  }
  function C(G) {
    d = d(G);
  }
  function g(G) {
    Fn(G) ? (i.line++, i.column = 1, i.offset += G === -3 ? 2 : 1, re()) : G !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), p.previous = G;
  }
  function z(G, q) {
    const R = q || {};
    return R.type = G, R.start = F(), p.events.push(["enter", R, p]), l.push(R), R;
  }
  function T(G) {
    const q = l.pop();
    return q.end = F(), p.events.push(["exit", q, p]), q;
  }
  function I(G, q) {
    Q(G, q.from);
  }
  function D(G, q) {
    q.restore();
  }
  function U(G, q) {
    return R;
    function R(B, ee, be) {
      let fe, de, ge, K;
      return Array.isArray(B) ? (
        /* c8 ignore next 1 */
        $e(B)
      ) : "tokenize" in B ? (
        // Looks like a construct.
        $e([
          /** @type {Construct} */
          B
        ])
      ) : xe(B);
      function xe(Le) {
        return Ue;
        function Ue(De) {
          const ze = De !== null && Le[De], Re = De !== null && Le.null, on = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(ze) ? ze : ze ? [ze] : [],
            ...Array.isArray(Re) ? Re : Re ? [Re] : []
          ];
          return $e(on)(De);
        }
      }
      function $e(Le) {
        return fe = Le, de = 0, Le.length === 0 ? be : Y(Le[de]);
      }
      function Y(Le) {
        return Ue;
        function Ue(De) {
          return K = X(), ge = Le, Le.partial || (p.currentConstruct = Le), Le.name && p.parser.constructs.disable.null.includes(Le.name) ? Me() : Le.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            q ? Object.assign(Object.create(p), q) : p,
            u,
            qe,
            Me
          )(De);
        }
      }
      function qe(Le) {
        return G(ge, K), ee;
      }
      function Me(Le) {
        return K.restore(), ++de < fe.length ? Y(fe[de]) : be;
      }
    }
  }
  function Q(G, q) {
    G.resolveAll && !o.includes(G) && o.push(G), G.resolve && Vr(p.events, q, p.events.length - q, G.resolve(p.events.slice(q), p)), G.resolveTo && (p.events = G.resolveTo(p.events, p));
  }
  function X() {
    const G = F(), q = p.previous, R = p.currentConstruct, B = p.events.length, ee = Array.from(l);
    return {
      from: B,
      restore: be
    };
    function be() {
      i = G, p.previous = q, p.currentConstruct = R, p.events.length = B, l = ee, re();
    }
  }
  function re() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function Vz(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function zz(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function Uz(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      GV([Az, ...(e || {}).extensions || []])
    ),
    content: a(t3),
    defined: [],
    document: a(i3),
    flow: a(xz),
    lazy: {},
    string: a(jz),
    text: a(wz)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return Lz(i, o, l);
    }
  }
}
function Mz(e) {
  for (; !fC(e); )
    ;
  return e;
}
const xx = /[\0\t\n\r]/g;
function Bz() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const u = [];
    let p, d, f, h, v;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (xx.lastIndex = f, p = xx.exec(o), h = p && p.index !== void 0 ? p.index : o.length, v = o.charCodeAt(h), !p) {
        n = o.slice(f);
        break;
      }
      if (v === 10 && f === h && i)
        u.push(-3), i = void 0;
      else
        switch (i && (u.push(-5), i = void 0), f < h && (u.push(o.slice(f, h)), e += h - f), v) {
          case 0: {
            u.push(65533), e++;
            break;
          }
          case 9: {
            for (d = Math.ceil(e / 4) * 4, u.push(-2); e++ < d; ) u.push(-1);
            break;
          }
          case 10: {
            u.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && u.push(-5), n && u.push(n), u.push(null)), u;
  }
}
const qz = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function Hz(e) {
  return e.replace(qz, Wz);
}
function Wz(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return uC(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return ig(r) || e;
}
const bC = {}.hasOwnProperty;
function Kz(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), Gz(r)(Mz(Uz(r).document().write(Bz()(e, n, !0))));
}
function Gz(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Oe),
      autolinkProtocol: X,
      autolinkEmail: X,
      atxHeading: o(se),
      blockQuote: o(Re),
      characterEscape: X,
      characterReference: X,
      codeFenced: o(on),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(on, s),
      codeText: o(Ee, s),
      codeTextData: X,
      data: X,
      codeFlowValue: X,
      definition: o(Qe),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(Xe),
      hardBreakEscape: o(ye),
      hardBreakTrailing: o(ye),
      htmlFlow: o(je, s),
      htmlFlowData: X,
      htmlText: o(je, s),
      htmlTextData: X,
      image: o(Ve),
      label: s,
      link: o(Oe),
      listItem: o(E),
      listItemValue: h,
      listOrdered: o(dn, f),
      listUnordered: o(dn),
      paragraph: o(_),
      reference: Y,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(se),
      strong: o(O),
      thematicBreak: o(J)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: I,
      autolink: u(),
      autolinkEmail: ze,
      autolinkProtocol: De,
      blockQuote: u(),
      characterEscapeValue: re,
      characterReferenceMarkerHexadecimal: Me,
      characterReferenceMarkerNumeric: Me,
      characterReferenceValue: Le,
      characterReference: Ue,
      codeFenced: u(j),
      codeFencedFence: N,
      codeFencedFenceInfo: v,
      codeFencedFenceMeta: F,
      codeFlowValue: re,
      codeIndented: u(C),
      codeText: u(ee),
      codeTextData: re,
      data: re,
      definition: u(),
      definitionDestinationString: T,
      definitionLabelString: g,
      definitionTitleString: z,
      emphasis: u(),
      hardBreakEscape: u(q),
      hardBreakTrailing: u(q),
      htmlFlow: u(R),
      htmlFlowData: re,
      htmlText: u(B),
      htmlTextData: re,
      image: u(fe),
      label: ge,
      labelText: de,
      lineEnding: G,
      link: u(be),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: qe,
      resourceDestinationString: K,
      resourceTitleString: xe,
      resource: $e,
      setextHeading: u(Q),
      setextHeadingLineSequence: U,
      setextHeadingText: D,
      strong: u(),
      thematicBreak: u()
    }
  };
  _C(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(L) {
    let M = {
      type: "root",
      children: []
    };
    const ie = {
      stack: [M],
      tokenStack: [],
      config: n,
      enter: l,
      exit: p,
      buffer: s,
      resume: d,
      data: r
    }, he = [];
    let Ne = -1;
    for (; ++Ne < L.length; )
      if (L[Ne][1].type === "listOrdered" || L[Ne][1].type === "listUnordered")
        if (L[Ne][0] === "enter")
          he.push(Ne);
        else {
          const nn = he.pop();
          Ne = a(L, nn, Ne);
        }
    for (Ne = -1; ++Ne < L.length; ) {
      const nn = n[L[Ne][0]];
      bC.call(nn, L[Ne][1].type) && nn[L[Ne][1].type].call(Object.assign({
        sliceSerialize: L[Ne][2].sliceSerialize
      }, ie), L[Ne][1]);
    }
    if (ie.tokenStack.length > 0) {
      const nn = ie.tokenStack[ie.tokenStack.length - 1];
      (nn[1] || Sx).call(ie, void 0, nn[0]);
    }
    for (M.position = {
      start: li(L.length > 0 ? L[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: li(L.length > 0 ? L[L.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Ne = -1; ++Ne < n.transforms.length; )
      M = n.transforms[Ne](M) || M;
    return M;
  }
  function a(L, M, ie) {
    let he = M - 1, Ne = -1, nn = !1, mn, Ze, sn, hn;
    for (; ++he <= ie; ) {
      const pn = L[he];
      switch (pn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          pn[0] === "enter" ? Ne++ : Ne--, hn = void 0;
          break;
        }
        case "lineEndingBlank": {
          pn[0] === "enter" && (mn && !hn && !Ne && !sn && (sn = he), hn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          hn = void 0;
      }
      if (!Ne && pn[0] === "enter" && pn[1].type === "listItemPrefix" || Ne === -1 && pn[0] === "exit" && (pn[1].type === "listUnordered" || pn[1].type === "listOrdered")) {
        if (mn) {
          let _n = he;
          for (Ze = void 0; _n--; ) {
            const Je = L[_n];
            if (Je[1].type === "lineEnding" || Je[1].type === "lineEndingBlank") {
              if (Je[0] === "exit") continue;
              Ze && (L[Ze][1].type = "lineEndingBlank", nn = !0), Je[1].type = "lineEnding", Ze = _n;
            } else if (!(Je[1].type === "linePrefix" || Je[1].type === "blockQuotePrefix" || Je[1].type === "blockQuotePrefixWhitespace" || Je[1].type === "blockQuoteMarker" || Je[1].type === "listItemIndent")) break;
          }
          sn && (!Ze || sn < Ze) && (mn._spread = !0), mn.end = Object.assign({}, Ze ? L[Ze][1].start : pn[1].end), L.splice(Ze || he, 0, ["exit", mn, pn[2]]), he++, ie++;
        }
        if (pn[1].type === "listItemPrefix") {
          const _n = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, pn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          mn = _n, L.splice(he, 0, ["enter", _n, pn[2]]), he++, ie++, sn = void 0, hn = !0;
        }
      }
    }
    return L[M][1]._spread = nn, ie;
  }
  function o(L, M) {
    return ie;
    function ie(he) {
      l.call(this, L(he), he), M && M.call(this, he);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(L, M, ie) {
    this.stack[this.stack.length - 1].children.push(L), this.stack.push(L), this.tokenStack.push([M, ie || void 0]), L.position = {
      start: li(M.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function u(L) {
    return M;
    function M(ie) {
      L && L.call(this, ie), p.call(this, ie);
    }
  }
  function p(L, M) {
    const ie = this.stack.pop(), he = this.tokenStack.pop();
    if (he)
      he[0].type !== L.type && (M ? M.call(this, L, he[0]) : (he[1] || Sx).call(this, L, he[0]));
    else throw new Error("Cannot close `" + L.type + "` (" + xo({
      start: L.start,
      end: L.end
    }) + "): it’s not open");
    ie.position.end = li(L.end);
  }
  function d() {
    return WV(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(L) {
    if (this.data.expectingFirstListItemValue) {
      const M = this.stack[this.stack.length - 2];
      M.start = Number.parseInt(this.sliceSerialize(L), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function v() {
    const L = this.resume(), M = this.stack[this.stack.length - 1];
    M.lang = L;
  }
  function F() {
    const L = this.resume(), M = this.stack[this.stack.length - 1];
    M.meta = L;
  }
  function N() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function j() {
    const L = this.resume(), M = this.stack[this.stack.length - 1];
    M.value = L.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function C() {
    const L = this.resume(), M = this.stack[this.stack.length - 1];
    M.value = L.replace(/(\r?\n|\r)$/g, "");
  }
  function g(L) {
    const M = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = M, ie.identifier = ua(this.sliceSerialize(L)).toLowerCase();
  }
  function z() {
    const L = this.resume(), M = this.stack[this.stack.length - 1];
    M.title = L;
  }
  function T() {
    const L = this.resume(), M = this.stack[this.stack.length - 1];
    M.url = L;
  }
  function I(L) {
    const M = this.stack[this.stack.length - 1];
    if (!M.depth) {
      const ie = this.sliceSerialize(L).length;
      M.depth = ie;
    }
  }
  function D() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function U(L) {
    const M = this.stack[this.stack.length - 1];
    M.depth = this.sliceSerialize(L).codePointAt(0) === 61 ? 1 : 2;
  }
  function Q() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function X(L) {
    const ie = this.stack[this.stack.length - 1].children;
    let he = ie[ie.length - 1];
    (!he || he.type !== "text") && (he = W(), he.position = {
      start: li(L.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ie.push(he)), this.stack.push(he);
  }
  function re(L) {
    const M = this.stack.pop();
    M.value += this.sliceSerialize(L), M.position.end = li(L.end);
  }
  function G(L) {
    const M = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ie = M.children[M.children.length - 1];
      ie.position.end = li(L.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(M.type) && (X.call(this, L), re.call(this, L));
  }
  function q() {
    this.data.atHardBreak = !0;
  }
  function R() {
    const L = this.resume(), M = this.stack[this.stack.length - 1];
    M.value = L;
  }
  function B() {
    const L = this.resume(), M = this.stack[this.stack.length - 1];
    M.value = L;
  }
  function ee() {
    const L = this.resume(), M = this.stack[this.stack.length - 1];
    M.value = L;
  }
  function be() {
    const L = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const M = this.data.referenceType || "shortcut";
      L.type += "Reference", L.referenceType = M, delete L.url, delete L.title;
    } else
      delete L.identifier, delete L.label;
    this.data.referenceType = void 0;
  }
  function fe() {
    const L = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const M = this.data.referenceType || "shortcut";
      L.type += "Reference", L.referenceType = M, delete L.url, delete L.title;
    } else
      delete L.identifier, delete L.label;
    this.data.referenceType = void 0;
  }
  function de(L) {
    const M = this.sliceSerialize(L), ie = this.stack[this.stack.length - 2];
    ie.label = Hz(M), ie.identifier = ua(M).toLowerCase();
  }
  function ge() {
    const L = this.stack[this.stack.length - 1], M = this.resume(), ie = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ie.type === "link") {
      const he = L.children;
      ie.children = he;
    } else
      ie.alt = M;
  }
  function K() {
    const L = this.resume(), M = this.stack[this.stack.length - 1];
    M.url = L;
  }
  function xe() {
    const L = this.resume(), M = this.stack[this.stack.length - 1];
    M.title = L;
  }
  function $e() {
    this.data.inReference = void 0;
  }
  function Y() {
    this.data.referenceType = "collapsed";
  }
  function qe(L) {
    const M = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = M, ie.identifier = ua(this.sliceSerialize(L)).toLowerCase(), this.data.referenceType = "full";
  }
  function Me(L) {
    this.data.characterReferenceType = L.type;
  }
  function Le(L) {
    const M = this.sliceSerialize(L), ie = this.data.characterReferenceType;
    let he;
    ie ? (he = uC(M, ie === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : he = ig(M);
    const Ne = this.stack[this.stack.length - 1];
    Ne.value += he;
  }
  function Ue(L) {
    const M = this.stack.pop();
    M.position.end = li(L.end);
  }
  function De(L) {
    re.call(this, L);
    const M = this.stack[this.stack.length - 1];
    M.url = this.sliceSerialize(L);
  }
  function ze(L) {
    re.call(this, L);
    const M = this.stack[this.stack.length - 1];
    M.url = "mailto:" + this.sliceSerialize(L);
  }
  function Re() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function on() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Ee() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Qe() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Xe() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function se() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function ye() {
    return {
      type: "break"
    };
  }
  function je() {
    return {
      type: "html",
      value: ""
    };
  }
  function Ve() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Oe() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function dn(L) {
    return {
      type: "list",
      ordered: L.type === "listOrdered",
      start: null,
      spread: L._spread,
      children: []
    };
  }
  function E(L) {
    return {
      type: "listItem",
      spread: L._spread,
      checked: null,
      children: []
    };
  }
  function _() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function O() {
    return {
      type: "strong",
      children: []
    };
  }
  function W() {
    return {
      type: "text",
      value: ""
    };
  }
  function J() {
    return {
      type: "thematicBreak"
    };
  }
}
function li(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function _C(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? _C(e, i) : Yz(e, i);
  }
}
function Yz(e, n) {
  let r;
  for (r in n)
    if (bC.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function Sx(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + xo({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + xo({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + xo({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function Qz(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return Kz(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function Jz(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function Xz(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function Zz(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function eU(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function nU(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function tU(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = wa(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const u = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, u);
  const p = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [u]
  };
  return e.patch(n, p), e.applyData(n, p);
}
function rU(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function iU(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function xC(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function aU(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return xC(e, n);
  const a = { src: wa(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function oU(e, n) {
  const r = { src: wa(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function sU(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function lU(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return xC(e, n);
  const a = { href: wa(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function cU(e, n) {
  const r = { href: wa(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function uU(e, n, r) {
  const i = e.all(n), a = r ? dU(r) : SC(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const d = i[0];
    let f;
    d && d.type === "element" && d.tagName === "p" ? f = d : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const d = i[l];
    (a || l !== 0 || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` }), d.type === "element" && d.tagName === "p" && !a ? s.push(...d.children) : s.push(d);
  }
  const u = i[i.length - 1];
  u && (a || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` });
  const p = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, p), e.applyData(n, p);
}
function dU(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = SC(r[i]);
  }
  return n;
}
function SC(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function mU(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function pU(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function fU(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function hU(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function yU(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = eg(n.children[1]), u = rC(n.children[n.children.length - 1]);
    l && u && (s.position = { start: l, end: u }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function gU(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let u = -1;
  const p = [];
  for (; ++u < l; ) {
    const f = n.children[u], h = {}, v = s ? s[u] : void 0;
    v && (h.align = v);
    let F = { type: "element", tagName: o, properties: h, children: [] };
    f && (F.children = e.all(f), e.patch(f, F), F = e.applyData(f, F)), p.push(F);
  }
  const d = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(p, !0)
  };
  return e.patch(n, d), e.applyData(n, d);
}
function vU(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const Nx = 9, jx = 32;
function kU(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      wx(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(wx(n.slice(a), a > 0, !1)), o.join("");
}
function wx(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === Nx || o === jx; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === Nx || o === jx; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function bU(e, n) {
  const r = { type: "text", value: kU(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function _U(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const xU = {
  blockquote: Jz,
  break: Xz,
  code: Zz,
  delete: eU,
  emphasis: nU,
  footnoteReference: tU,
  heading: rU,
  html: iU,
  imageReference: aU,
  image: oU,
  inlineCode: sU,
  linkReference: lU,
  link: cU,
  listItem: uU,
  list: mU,
  paragraph: pU,
  // @ts-expect-error: root is different, but hard to type.
  root: fU,
  strong: hU,
  table: yU,
  tableCell: vU,
  tableRow: gU,
  text: bU,
  thematicBreak: _U,
  toml: ss,
  yaml: ss,
  definition: ss,
  footnoteDefinition: ss
};
function ss() {
}
const NC = -1, Vl = 0, ol = 1, sl = 2, sg = 3, lg = 4, cg = 5, ug = 6, jC = 7, wC = 8, Cx = typeof self == "object" ? self : globalThis, SU = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case Vl:
      case NC:
        return r(s, a);
      case ol: {
        const l = r([], a);
        for (const u of s)
          l.push(i(u));
        return l;
      }
      case sl: {
        const l = r({}, a);
        for (const [u, p] of s)
          l[i(u)] = i(p);
        return l;
      }
      case sg:
        return r(new Date(s), a);
      case lg: {
        const { source: l, flags: u } = s;
        return r(new RegExp(l, u), a);
      }
      case cg: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [u, p] of s)
          l.set(i(u), i(p));
        return l;
      }
      case ug: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const u of s)
          l.add(i(u));
        return l;
      }
      case jC: {
        const { name: l, message: u } = s;
        return r(new Cx[l](u), a);
      }
      case wC:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new Cx[o](s), a);
  };
  return i;
}, Fx = (e) => SU(/* @__PURE__ */ new Map(), e)(0), Ki = "", { toString: NU } = {}, { keys: jU } = Object, Wa = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [Vl, n];
  const r = NU.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [ol, Ki];
    case "Object":
      return [sl, Ki];
    case "Date":
      return [sg, Ki];
    case "RegExp":
      return [lg, Ki];
    case "Map":
      return [cg, Ki];
    case "Set":
      return [ug, Ki];
  }
  return r.includes("Array") ? [ol, r] : r.includes("Error") ? [jC, r] : [sl, r];
}, ls = ([e, n]) => e === Vl && (n === "function" || n === "symbol"), wU = (e, n, r, i) => {
  const a = (s, l) => {
    const u = i.push(s) - 1;
    return r.set(l, u), u;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, u] = Wa(s);
    switch (l) {
      case Vl: {
        let d = s;
        switch (u) {
          case "bigint":
            l = wC, d = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + u);
            d = null;
            break;
          case "undefined":
            return a([NC], s);
        }
        return a([l, d], s);
      }
      case ol: {
        if (u)
          return a([u, [...s]], s);
        const d = [], f = a([l, d], s);
        for (const h of s)
          d.push(o(h));
        return f;
      }
      case sl: {
        if (u)
          switch (u) {
            case "BigInt":
              return a([u, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([u, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const d = [], f = a([l, d], s);
        for (const h of jU(s))
          (e || !ls(Wa(s[h]))) && d.push([o(h), o(s[h])]);
        return f;
      }
      case sg:
        return a([l, s.toISOString()], s);
      case lg: {
        const { source: d, flags: f } = s;
        return a([l, { source: d, flags: f }], s);
      }
      case cg: {
        const d = [], f = a([l, d], s);
        for (const [h, v] of s)
          (e || !(ls(Wa(h)) || ls(Wa(v)))) && d.push([o(h), o(v)]);
        return f;
      }
      case ug: {
        const d = [], f = a([l, d], s);
        for (const h of s)
          (e || !ls(Wa(h))) && d.push(o(h));
        return f;
      }
    }
    const { message: p } = s;
    return a([l, { name: u, message: p }], s);
  };
  return o;
}, Ix = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return wU(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, ll = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? Fx(Ix(e, n)) : structuredClone(e)
) : (e, n) => Fx(Ix(e, n));
function CU(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function FU(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function IU(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || CU, i = e.options.footnoteBackLabel || FU, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let u = -1;
  for (; ++u < e.footnoteOrder.length; ) {
    const p = e.footnoteById.get(
      e.footnoteOrder[u]
    );
    if (!p)
      continue;
    const d = e.all(p), f = String(p.identifier).toUpperCase(), h = wa(f.toLowerCase());
    let v = 0;
    const F = [], N = e.footnoteCounts.get(f);
    for (; N !== void 0 && ++v <= N; ) {
      F.length > 0 && F.push({ type: "text", value: " " });
      let g = typeof r == "string" ? r : r(u, v);
      typeof g == "string" && (g = { type: "text", value: g }), F.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (v > 1 ? "-" + v : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(u, v),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(g) ? g : [g]
      });
    }
    const j = d[d.length - 1];
    if (j && j.type === "element" && j.tagName === "p") {
      const g = j.children[j.children.length - 1];
      g && g.type === "text" ? g.value += " " : j.children.push({ type: "text", value: " " }), j.children.push(...F);
    } else
      d.push(...F);
    const C = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(d, !0)
    };
    e.patch(p, C), l.push(C);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...ll(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const CC = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return DU;
    if (typeof e == "function")
      return zl(e);
    if (typeof e == "object")
      return Array.isArray(e) ? $U(e) : EU(e);
    if (typeof e == "string")
      return TU(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function $U(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = CC(e[r]);
  return zl(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function EU(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return zl(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function TU(e) {
  return zl(n);
  function n(r) {
    return r && r.type === e;
  }
}
function zl(e) {
  return n;
  function n(r, i, a) {
    return !!(OU(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function DU() {
  return !0;
}
function OU(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const FC = [], RU = !0, $x = !1, PU = "skip";
function AU(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = CC(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(u, p, d) {
    const f = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof f.type == "string") {
      const v = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (u.type + (v ? "<" + v + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let v = FC, F, N, j;
      if ((!n || o(u, p, d[d.length - 1] || void 0)) && (v = LU(r(u, d)), v[0] === $x))
        return v;
      if ("children" in u && u.children) {
        const C = (
          /** @type {UnistParent} */
          u
        );
        if (C.children && v[0] !== PU)
          for (N = (i ? C.children.length : -1) + s, j = d.concat(C); N > -1 && N < C.children.length; ) {
            const g = C.children[N];
            if (F = l(g, N, j)(), F[0] === $x)
              return F;
            N = typeof F[1] == "number" ? F[1] : N + s;
          }
      }
      return v;
    }
  }
}
function LU(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [RU, e] : e == null ? FC : [e];
}
function IC(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), AU(e, o, l, a);
  function l(u, p) {
    const d = p[p.length - 1], f = d ? d.children.indexOf(u) : void 0;
    return s(u, f, d);
  }
}
const Bh = {}.hasOwnProperty, VU = {};
function zU(e, n) {
  const r = n || VU, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...xU, ...r.handlers }, l = {
    all: p,
    applyData: MU,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: u,
    options: r,
    patch: UU,
    wrap: qU
  };
  return IC(e, function(d) {
    if (d.type === "definition" || d.type === "footnoteDefinition") {
      const f = d.type === "definition" ? i : a, h = String(d.identifier).toUpperCase();
      f.has(h) || f.set(h, d);
    }
  }), l;
  function u(d, f) {
    const h = d.type, v = l.handlers[h];
    if (Bh.call(l.handlers, h) && v)
      return v(l, d, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in d) {
        const { children: N, ...j } = d, C = ll(j);
        return C.children = l.all(d), C;
      }
      return ll(d);
    }
    return (l.options.unknownHandler || BU)(l, d, f);
  }
  function p(d) {
    const f = [];
    if ("children" in d) {
      const h = d.children;
      let v = -1;
      for (; ++v < h.length; ) {
        const F = l.one(h[v], d);
        if (F) {
          if (v && h[v - 1].type === "break" && (!Array.isArray(F) && F.type === "text" && (F.value = Ex(F.value)), !Array.isArray(F) && F.type === "element")) {
            const N = F.children[0];
            N && N.type === "text" && (N.value = Ex(N.value));
          }
          Array.isArray(F) ? f.push(...F) : f.push(F);
        }
      }
    }
    return f;
  }
}
function UU(e, n) {
  e.position && (n.position = xV(e));
}
function MU(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, ll(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function BU(e, n) {
  const r = n.data || {}, i = "value" in n && !(Bh.call(r, "hProperties") || Bh.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function qU(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function Ex(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function Tx(e, n) {
  const r = zU(e, n), i = r.one(e, void 0), a = IU(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function HU(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      Tx(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      Tx(r, { file: i, ...e || n })
    );
  };
}
function Dx(e) {
  if (e)
    throw e;
}
var tm, Ox;
function WU() {
  if (Ox) return tm;
  Ox = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(p) {
    return typeof Array.isArray == "function" ? Array.isArray(p) : n.call(p) === "[object Array]";
  }, o = function(p) {
    if (!p || n.call(p) !== "[object Object]")
      return !1;
    var d = e.call(p, "constructor"), f = p.constructor && p.constructor.prototype && e.call(p.constructor.prototype, "isPrototypeOf");
    if (p.constructor && !d && !f)
      return !1;
    var h;
    for (h in p)
      ;
    return typeof h > "u" || e.call(p, h);
  }, s = function(p, d) {
    r && d.name === "__proto__" ? r(p, d.name, {
      enumerable: !0,
      configurable: !0,
      value: d.newValue,
      writable: !0
    }) : p[d.name] = d.newValue;
  }, l = function(p, d) {
    if (d === "__proto__")
      if (e.call(p, d)) {
        if (i)
          return i(p, d).value;
      } else return;
    return p[d];
  };
  return tm = function u() {
    var p, d, f, h, v, F, N = arguments[0], j = 1, C = arguments.length, g = !1;
    for (typeof N == "boolean" && (g = N, N = arguments[1] || {}, j = 2), (N == null || typeof N != "object" && typeof N != "function") && (N = {}); j < C; ++j)
      if (p = arguments[j], p != null)
        for (d in p)
          f = l(N, d), h = l(p, d), N !== h && (g && h && (o(h) || (v = a(h))) ? (v ? (v = !1, F = f && a(f) ? f : []) : F = f && o(f) ? f : {}, s(N, { name: d, newValue: u(g, F, h) })) : typeof h < "u" && s(N, { name: d, newValue: h }));
    return N;
  }, tm;
}
var KU = WU();
const rm = /* @__PURE__ */ yy(KU);
function qh(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function GU() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(u, ...p) {
      const d = e[++o];
      let f = -1;
      if (u) {
        s(u);
        return;
      }
      for (; ++f < a.length; )
        (p[f] === null || p[f] === void 0) && (p[f] = a[f]);
      a = p, d ? YU(d, l)(...p) : s(null, ...p);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function YU(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let u;
    l && s.push(a);
    try {
      u = e.apply(this, s);
    } catch (p) {
      const d = (
        /** @type {Error} */
        p
      );
      if (l && r)
        throw d;
      return a(d);
    }
    l || (u instanceof Promise ? u.then(o, a) : u instanceof Error ? a(u) : o(u));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Er = { basename: QU, dirname: JU, extname: XU, join: ZU, sep: "/" };
function QU(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  Ho(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function JU(e) {
  if (Ho(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function XU(e) {
  Ho(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function ZU(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    Ho(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : e4(r);
}
function e4(e) {
  Ho(e);
  const n = e.codePointAt(0) === 47;
  let r = n4(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function n4(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, u;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (u = r.lastIndexOf("/"), u !== r.length - 1) {
              u < 0 ? (r = "", i = 0) : (r = r.slice(0, u), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function Ho(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const t4 = { cwd: r4 };
function r4() {
  return "/";
}
function Hh(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function i4(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Hh(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return a4(e);
}
function a4(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const im = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class $C {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? Hh(n) ? r = { path: n } : typeof n == "string" || o4(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : t4.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < im.length; ) {
      const o = im[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      im.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Er.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    om(n, "basename"), am(n, "basename"), this.path = Er.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Er.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    Rx(this.basename, "dirname"), this.path = Er.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Er.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (am(n, "extname"), Rx(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Er.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    Hh(n) && (n = i4(n)), om(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Er.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    om(n, "stem"), am(n, "stem"), this.path = Er.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new Vt(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function am(e, n) {
  if (e && e.includes(Er.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Er.sep + "`"
    );
}
function om(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function Rx(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function o4(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const s4 = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), l4 = {}.hasOwnProperty;
class dg extends s4 {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = GU();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new dg()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(rm(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (cm("data", this.frozen), this.namespace[n] = r, this) : l4.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (cm("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = cs(n), i = this.parser || this.Parser;
    return sm("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), sm("process", this.parser || this.Parser), lm("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = cs(n), u = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(u, l, function(d, f, h) {
        if (d || !f || !h)
          return p(d);
        const v = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), F = i.stringify(v, h);
        d4(F) ? h.value = F : h.result = F, p(
          d,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function p(d, f) {
        d || !f ? s(d) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), sm("processSync", this.parser || this.Parser), lm("processSync", this.compiler || this.Compiler), this.process(n, a), Ax("processSync", "process", r), i;
    function a(o, s) {
      r = !0, Dx(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    Px(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const u = cs(r);
      a.run(n, u, p);
      function p(d, f, h) {
        const v = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        d ? l(d) : s ? s(v) : i(void 0, v, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), Ax("runSync", "run", i), a;
    function o(s, l) {
      Dx(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = cs(r), a = this.compiler || this.Compiler;
    return lm("stringify", a), Px(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (cm("use", this.frozen), n != null) if (typeof n == "function")
      u(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(p) {
      if (typeof p == "function")
        u(p, []);
      else if (typeof p == "object")
        if (Array.isArray(p)) {
          const [d, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            p
          );
          u(d, f);
        } else
          s(p);
      else
        throw new TypeError("Expected usable value, not `" + p + "`");
    }
    function s(p) {
      if (!("plugins" in p) && !("settings" in p))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(p.plugins), p.settings && (a.settings = rm(!0, a.settings, p.settings));
    }
    function l(p) {
      let d = -1;
      if (p != null) if (Array.isArray(p))
        for (; ++d < p.length; ) {
          const f = p[d];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + p + "`");
    }
    function u(p, d) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === p) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([p, ...d]);
      else if (d.length > 0) {
        let [v, ...F] = d;
        const N = i[h][1];
        qh(N) && qh(v) && (v = rm(!0, N, v)), i[h] = [p, v, ...F];
      }
    }
  }
}
const c4 = new dg().freeze();
function sm(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function lm(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function cm(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Px(e) {
  if (!qh(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Ax(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function cs(e) {
  return u4(e) ? e : new $C(e);
}
function u4(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function d4(e) {
  return typeof e == "string" || m4(e);
}
function m4(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const p4 = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Lx = [], Vx = { allowDangerousHtml: !0 }, f4 = /^(https?|ircs?|mailto|xmpp)$/i, h4 = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function y4(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || Lx, u = e.remarkPlugins || Lx, p = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Vx } : Vx, d = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || g4, v = c4().use(Qz).use(u).use(HU, p).use(l), F = new $C();
  typeof i == "string" && (F.value = i);
  for (const g of h4)
    Object.hasOwn(e, g.from) && ("" + g.from + (g.to ? "use `" + g.to + "` instead" : "remove it") + p4 + g.id, void 0);
  const N = v.parse(F);
  let j = v.runSync(N, F);
  return a && (j = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      j.type === "root" ? j.children : [j]
    )
  }), IC(j, C), FV(j, {
    Fragment: Be.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: Be.jsx,
    jsxs: Be.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function C(g, z, T) {
    if (g.type === "raw" && T && typeof z == "number")
      return d ? T.children.splice(z, 1) : T.children[z] = { type: "text", value: g.value }, z;
    if (g.type === "element") {
      let I;
      for (I in Zd)
        if (Object.hasOwn(Zd, I) && Object.hasOwn(g.properties, I)) {
          const D = g.properties[I], U = Zd[I];
          (U === null || U.includes(g.tagName)) && (g.properties[I] = h(String(D || ""), I, g));
        }
    }
    if (g.type === "element") {
      let I = n ? !n.includes(g.tagName) : s ? s.includes(g.tagName) : !1;
      if (!I && r && typeof z == "number" && (I = !r(g, z, T)), I && T && typeof z == "number")
        return f && g.children ? T.children.splice(z, 1, ...g.children) : T.children.splice(z, 1), z;
    }
  }
}
function g4(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    f4.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var um = { exports: {} }, Ka = {}, zx;
function v4() {
  if (zx) return Ka;
  zx = 1;
  var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ka.Fragment = r, Ka.jsx = s, Ka.jsxs = s, Ka;
}
var us = {}, Ux;
function k4() {
  return Ux || (Ux = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[N];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        z("error", t, m);
      }
    }
    function z(t, c, m) {
      {
        var y = C.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var P = m.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var T = !1, I = !1, D = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || U || t === v || T || I || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function q(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return q(c) + ".Consumer";
          case s:
            var m = t;
            return q(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return R(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, be, fe, de, ge, K, xe, $e;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          be = console.log, fe = console.info, de = console.warn, ge = console.error, K = console.group, xe = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: be
            }),
            info: B({}, t, {
              value: fe
            }),
            warn: B({}, t, {
              value: de
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: K
            }),
            groupCollapsed: B({}, t, {
              value: xe
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = C.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var ze = !1, Re;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new on();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var m = Re.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      ze = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Le.current, Le.current = null, qe();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var S = te.stack.split(`
`), ne = y.stack.split(`
`), H = S.length - 1, x = ne.length - 1; H >= 1 && x >= 0 && S[H] !== ne[x]; )
            x--;
          for (; H >= 1 && x >= 0; H--, x--)
            if (S[H] !== ne[x]) {
              if (H !== 1 || x !== 1)
                do
                  if (H--, x--, x < 0 || S[H] !== ne[x]) {
                    var Z = `
` + S[H].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (H >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Le.current = P, Me(), Error.prepareStackTrace = $;
      }
      var ue = t ? t.displayName || t.name : "", _e = ue ? De(ue) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Qe(t, c, m) {
      return Ee(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Xe(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case d:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Qe(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return se(P($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, je = {}, Ve = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function dn(t, c, m, y, $) {
      {
        var P = Function.call.bind(ye);
        for (var w in t)
          if (P(t, w)) {
            var S = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + m + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[w](c, w, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              S = H;
            }
            S && !(S instanceof Error) && (Oe($), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, w, typeof S), Oe(null)), S instanceof Error && !(S.message in je) && (je[S.message] = !0, Oe($), g("Failed %s type: %s", m, S.message), Oe(null));
          }
      }
    }
    var E = Array.isArray;
    function _(t) {
      return E(t);
    }
    function O(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function W(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function L(t) {
      if (W(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", O(t)), J(t);
    }
    var M = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Ze(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function sn(t, c) {
      {
        var m = function() {
          he || (he = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function hn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, m, y, $, P, w) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function _n(t, c, m, y, $) {
      {
        var P, w = {}, S = null, ne = null;
        m !== void 0 && (L(m), S = "" + m), mn(c) && (L(c.key), S = "" + c.key), nn(c) && (ne = c.ref, Ze(c));
        for (P in c)
          ye.call(c, P) && !ie.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var H = t.defaultProps;
          for (P in H)
            w[P] === void 0 && (w[P] = H[P]);
        }
        if (S || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && sn(w, x), ne && hn(w, x);
        }
        return pn(t, S, ne, $, y, M.current, w);
      }
    }
    var Je = C.ReactCurrentOwner, Nn = C.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(m);
      } else
        Nn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (Je.current) {
          var t = R(Je.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Mn(t) {
      return "";
    }
    var jn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = kn(c);
        if (jn[m])
          return;
        jn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Je.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ae(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ae(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            cn(y) && gn(y, c);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              cn(w.value) && gn(w.value, c);
        }
      }
    }
    function zn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = R(c);
          dn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var $ = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function An(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ae(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var xn = {};
    function Sn(t, c, m, y, $, P) {
      {
        var w = re(t);
        if (!w) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = Mn();
          ne ? S += ne : S += vn();
          var H;
          t === null ? H = "null" : _(t) ? H = "array" : t !== void 0 && t.$$typeof === n ? (H = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : H = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, S);
        }
        var x = _n(t, c, m, $, P);
        if (x == null)
          return x;
        if (w) {
          var Z = c.children;
          if (Z !== void 0)
            if (y)
              if (_(Z)) {
                for (var ue = 0; ue < Z.length; ue++)
                  wn(Z[ue], t);
                Object.freeze && Object.freeze(Z);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = R(t), te = Object.keys(c).filter(function($n) {
            return $n !== "key";
          }), Ke = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? An(x) : zn(x), x;
      }
    }
    function Bn(t, c, m) {
      return Sn(t, c, m, !0);
    }
    function On(t, c, m) {
      return Sn(t, c, m, !1);
    }
    var Rn = On, Un = Bn;
    us.Fragment = i, us.jsx = Rn, us.jsxs = Un;
  })()), us;
}
var Mx;
function b4() {
  return Mx || (Mx = 1, process.env.NODE_ENV === "production" ? um.exports = v4() : um.exports = k4()), um.exports;
}
var ae = b4();
const _4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, x4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, S4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, N4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, j4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, w4 = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": _4,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": x4,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": S4,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": N4,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": j4
};
function Wo(e) {
  return w4[e] ?? {};
}
const C4 = Wo(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), F4 = Wo(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), ds = ({
  title: e,
  children: n
}) => /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), I4 = "_issueAvatar_kc0sw_1", $4 = "_issueField_kc0sw_9", E4 = "_issueDescription_kc0sw_12", ms = {
  issueAvatar: I4,
  issueField: $4,
  issueDescription: E4
}, EC = ({ issue: e }) => /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
  /* @__PURE__ */ ae.jsx(ds, { title: "Assignee", children: /* @__PURE__ */ ae.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: ms.issueAvatar,
      children: [
        /* @__PURE__ */ ae.jsx(
          py,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ ae.jsx(ds, { title: "Team", children: /* @__PURE__ */ ae.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: ms.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ ae.jsx(ds, { title: "Project", children: /* @__PURE__ */ ae.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: ms.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ ae.jsx(ds, { title: "Description", children: /* @__PURE__ */ ae.jsx(y4, { className: ms.issueDescription, children: e.description }) })
] }), T4 = /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ ae.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ ae.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ ae.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), D4 = /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ ae.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), O4 = /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ ae.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), R4 = /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ ae.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), P4 = /* @__PURE__ */ ae.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), TC = {
  0: T4,
  1: P4,
  2: R4,
  3: O4,
  4: D4
}, A4 = (e) => e in TC, cl = ({ priority: e }) => A4(e) ? TC[e] : /* @__PURE__ */ ae.jsx(qn, { "data-testid": "defaultPriorityTag", children: e }), L4 = (e, n) => /* @__PURE__ */ ae.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), V4 = (e, n) => /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ ae.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ ae.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), z4 = (e, n) => /* @__PURE__ */ ae.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ ae.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ ae.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), U4 = (e, n) => /* @__PURE__ */ ae.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), M4 = (e, n) => /* @__PURE__ */ ae.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), B4 = (e, n) => /* @__PURE__ */ ae.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), Wh = {
  backlog: (e, n) => L4(e, n),
  unstarted: (e, n) => V4(e, n),
  started: (e, n) => z4(e, n),
  done: (e, n) => U4(e, n),
  canceled: (e, n) => M4(e, n),
  completed: (e, n) => B4(e, n)
}, q4 = (e) => e in Wh, ul = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => q4(e) ? Wh[e](n, r) : Wh.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), H4 = "_wrapper_e0qj3_1", W4 = "_resultTitle_e0qj3_21", K4 = "_resultTooltipTitle_e0qj3_28", G4 = "_resultLinkIcon_e0qj3_31", Ga = {
  wrapper: H4,
  resultTitle: W4,
  resultTooltipTitle: K4,
  resultLinkIcon: G4
}, Y4 = ({
  issue: e
}) => {
  const [n, r] = le(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = dy(jI()), o = lt(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ ae.jsx(
    Ge,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "300", className: Ga.wrapper, children: [
        /* @__PURE__ */ ae.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ ae.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ ae.jsx(
              ul,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ ae.jsx(cl, { priority: e.priority })
          ] }),
          /* @__PURE__ */ ae.jsx(qn, { children: e.state.name })
        ] }),
        /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ ae.jsx(
            A.Heading,
            {
              variant: "heading-3",
              className: Ga.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ ae.jsx(EC, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ ae.jsx(
        mt.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: Ga.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ ae.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ ae.jsx(
                    ul,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ ae.jsx(cl, { priority: e.priority })
                ] }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", className: Ga.resultTitle, children: e.title }),
                n && /* @__PURE__ */ ae.jsx(
                  pe,
                  {
                    className: Ga.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, Q4 = "_loader_13xpk_1", J4 = "_dropdown_13xpk_8", X4 = "_loadMore_13xpk_13", dm = {
  loader: Q4,
  dropdown: J4,
  loadMore: X4
}, Z4 = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = le(), [a, o] = le([]), [s, l] = le(""), [u, p] = le(!1), { useLazyQuery: d } = yn(), [f, { data: h, loading: v, networkStatus: F }] = d(
    C4,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  Pi(
    () => {
      !v && s !== "" && F === rr.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), Ye(() => {
    v || o([]);
  }, [s]), Ye(() => {
    if (h && Object.keys(h).length > 0) {
      const j = h.Linear.searchIssues.edges.map(
        ({ node: T }) => T
      ), C = a.filter(
        (T) => !n.find((I) => I.id === T.id)
      ), g = C.filter(
        (T) => !j.find(
          (I) => I.id === T.id
        )
      ), z = j.filter(
        (T) => !n.find((I) => I.id === T.id)
      );
      n.length > 0 ? o(
        u ? [...g, ...z] : z
      ) : h?.Linear?.searchIssues?.edges && o(
        u ? [...C, ...j] : j
      ), h.Linear.searchIssues.pageInfo.hasNextPage && p(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const N = () => {
    !v && s !== "" && F === rr.ready ? (p(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ ae.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ ae.jsxs(
    ui,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (j) => j?.title,
      onChange: (j) => e(j.selectedValues[0]),
      dropdownProps: { className: dm.dropdown },
      filter: {
        value: s,
        onChange: (j) => {
          const C = j.target.value;
          l(C);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((j) => /* @__PURE__ */ ae.jsx(Y4, { issue: j }, j.id)),
        r?.hasNextPage && !v && s !== "" && a.length && /* @__PURE__ */ ae.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => N(),
            className: dm.loadMore,
            children: /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        v && s !== "" && /* @__PURE__ */ ae.jsx(b, { justifyContent: "center", className: dm.loader, children: /* @__PURE__ */ ae.jsx(fn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ ae.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !v && /* @__PURE__ */ ae.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, eM = "_collapse_su0f9_1", nM = "_collapseHeader_su0f9_8", tM = "_collapseContent_su0f9_31", rM = "_url_su0f9_35", iM = "_externalLink_su0f9_51", aM = "_emptyState_su0f9_55", ci = {
  collapse: eM,
  collapseHeader: nM,
  collapseContent: tM,
  url: rM,
  externalLink: iM,
  emptyState: aM
}, oM = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (d, f) => ({ ...d, [f.id]: !1 }),
    {}
  ), [l, u] = le(s), { track: p } = Cn();
  return n ? /* @__PURE__ */ ae.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ ae.jsx(fn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ ae.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ ae.jsx(
          A.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: ci.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ ae.jsx(
          Rt,
          {
            slotEnd: /* @__PURE__ */ ae.jsx(pe, { name: "external-link" }),
            variant: "tertiary",
            className: ci.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ ae.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((d) => {
          const f = l[d.id];
          return /* @__PURE__ */ ae.jsxs(
            hr,
            {
              "data-testid": "collapseCard",
              onToggle: () => u({ ...l, [d.id]: !l[d.id] }),
              isOpen: f,
              className: ci.collapse,
              children: [
                /* @__PURE__ */ ae.jsx(hr.Header, { className: ci.collapseHeader, children: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ ae.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ ae.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ ae.jsx(Ge, { content: /* @__PURE__ */ ae.jsx(b, { children: d.state.name }), children: /* @__PURE__ */ ae.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ ae.jsx(
                        ul,
                        {
                          type: d.state.type,
                          color: d.state.color,
                          name: d.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ ae.jsxs(
                        A.ExternalLink,
                        {
                          className: ci.url,
                          href: d.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            d.identifier,
                            /* @__PURE__ */ ae.jsx(pe, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ ae.jsx(Ge, { content: /* @__PURE__ */ ae.jsx(b, { children: d.priorityLabel }), children: /* @__PURE__ */ ae.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ ae.jsx(cl, { priority: d.priority }) }) })
                    ] }),
                    /* @__PURE__ */ ae.jsx(qn, { children: d.state.name })
                  ] }),
                  d.title
                ] }) }),
                /* @__PURE__ */ ae.jsx(hr.Content, { className: ci.collapseContent, children: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  d?.labels && d?.labels?.edges?.length > 0 && /* @__PURE__ */ ae.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: d.labels?.edges.map((h) => /* @__PURE__ */ ae.jsx(qn, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ ae.jsx(EC, { issue: d }),
                  /* @__PURE__ */ ae.jsx(
                    Yn,
                    {
                      slotStart: /* @__PURE__ */ ae.jsx(pe, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(d.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ ae.jsxs(
                    Rt,
                    {
                      slotEnd: /* @__PURE__ */ ae.jsx(pe, { name: "external-link" }),
                      variant: "tertiary",
                      className: ci.externalLink,
                      onClick: () => {
                        p("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: d.id
                        });
                      },
                      navigate: () => window.open(d.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        d.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            d.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ ae.jsx(
          Yn,
          {
            slotStart: /* @__PURE__ */ ae.jsx(pe, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ ae.jsx(
          Rt,
          {
            slotEnd: /* @__PURE__ */ ae.jsx(pe, { name: "external-link" }),
            variant: "tertiary",
            className: ci.externalLink,
            onClick: () => {
              p("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, sM = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, DC = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => DC(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, lM = "_modalBody_iv3ua_1", cM = "_error_iv3ua_5", uM = "_dropdown_iv3ua_16", Gi = {
  modalBody: lM,
  error: cM,
  dropdown: uM
}, dM = Wo(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), mM = Wo(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), pM = Wo(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), fM = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: u } = yn(), { control: p, handleSubmit: d, reset: f } = gt(), [h, v] = le([]), [F, N] = le(), [j, C] = le([]), [g, z] = le(), [T, I] = le([]), [D, U] = le(), [Q, X] = le([]), [re, G] = le(), [q, R] = le([]), [B, ee] = le(), [be, fe] = le(!1), { useMutation: de } = yn(), { track: ge } = Cn(), [K, { loading: xe }] = de(
    dM,
    {
      onError: () => {
        fe(!1), u({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (Ee) => {
        const Qe = {
          identifier: Ee.Linear?.issueCreate?.issue?.identifier,
          url: Ee.Linear?.issueCreate?.issue?.url
        };
        Ee.Linear && Ee.Linear?.issueCreate?.issue?.id && (a(Ee.Linear?.issueCreate?.issue?.id), ze(Qe), fe(!1), u({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${Ee.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), ge("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    $e,
    { data: Y, loading: qe, error: Me }
  ] = l(mM, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => u({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ee) => {
      const Qe = Ee.Linear.teams.edges.map(
        ({ node: Xe }) => Xe
      );
      v(Qe), X(Ee.Linear.issuePriorityValues), s(`${SM}${Ee.Linear.organization.urlKey}`);
    }
  }), [Le, { data: Ue, loading: De }] = l(pM, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => u({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ee) => {
      const Qe = Ee?.Linear?.team?.projects?.edges?.map(
        ({ node: ye }) => ye
      );
      C(Qe);
      const Xe = Ee?.Linear?.team?.states?.edges?.map(
        ({ node: ye }) => ye
      );
      I(Xe);
      const se = Ee?.Linear?.team?.templates?.edges?.map(
        ({ node: ye }) => ye
      );
      R(
        se.filter(
          (ye) => ye.type === "issue"
        )
      );
    }
  }), ze = (Ee) => {
    r(!1), z(void 0), N(void 0), U(void 0), G(void 0), ee(void 0), Ee && (e(Ee), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, Re = (Ee) => {
    Y && !qe && (K({
      variables: {
        issueTitle: Ee.title,
        issueDescription: Ee?.description,
        teamId: Ee.team.id,
        projectId: Ee?.project?.id,
        statusId: Ee?.status?.id,
        priority: Ee?.priority?.priority
      }
    }), fe(!0));
  };
  Ye(() => {
    n && $e();
  }, [n]);
  const on = () => {
    ge("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ ae.jsxs(
    jt,
    {
      isOpen: n,
      onClose: () => {
        on(), ze();
      },
      children: [
        /* @__PURE__ */ ae.jsx(
          wt,
          {
            title: "Create new Linear issue",
            onClose: () => {
              on(), ze();
            }
          }
        ),
        /* @__PURE__ */ ae.jsx(
          Ct,
          {
            className: Gi.modalBody,
            "data-testid": "createIssueModalBody",
            children: Me ? /* @__PURE__ */ ae.jsx(In, { error: Me }) : /* @__PURE__ */ ae.jsx("form", { onSubmit: d(Re), id: "issueCreationForm", children: /* @__PURE__ */ ae.jsxs(at, { children: [
              /* @__PURE__ */ ae.jsx(me, { span: 3, children: /* @__PURE__ */ ae.jsx(
                Ot,
                {
                  control: p,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: Ee, onChange: Qe },
                    fieldState: { error: Xe }
                  }) => /* @__PURE__ */ ae.jsx(
                    en,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: Xe?.message ?? null
                      },
                      children: /* @__PURE__ */ ae.jsx(
                        ui,
                        {
                          dropdownProps: { className: Gi.dropdown },
                          placeholder: "Select Linear team",
                          className: it({ [Gi.error]: Xe }),
                          getItemTitleByValue: (se) => se?.name,
                          onChange: (se) => {
                            z(void 0), U(void 0), G(void 0), ee(void 0), N(se.selectedValues[0]), Le({
                              variables: { teamId: se.selectedValues[0].id }
                            }), Qe(se.selectedValues[0]);
                          },
                          value: F ? [Ee] : void 0,
                          children: h?.map((se) => /* @__PURE__ */ ae.jsx(
                            mt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ae.jsx(A.Paragraph, { children: se.name })
                            },
                            se.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ ae.jsx(me, { span: 3, children: /* @__PURE__ */ ae.jsx(
                Ot,
                {
                  control: p,
                  name: "project",
                  render: ({ field: { value: Ee, onChange: Qe } }) => {
                    const Xe = De ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ ae.jsx(en, { label: "Project", children: /* @__PURE__ */ ae.jsx(
                      ui,
                      {
                        dropdownProps: { className: Gi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.name,
                        disabled: F === void 0,
                        placeholder: F ? "Select Linear project" : "Select a Team first",
                        onChange: (se) => {
                          z(se.selectedValues[0]), Qe(se.selectedValues[0]);
                        },
                        value: g ? [Ee] : Xe,
                        children: /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
                          De && /* @__PURE__ */ ae.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ ae.jsx(fn, { size: 24 })
                            }
                          ),
                          Ue && !De && j.map((se) => /* @__PURE__ */ ae.jsx(
                            mt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ae.jsx(A.Paragraph, { children: se.name })
                            },
                            se.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ ae.jsx(me, { span: 6, children: /* @__PURE__ */ ae.jsx(en, { label: "Template", children: /* @__PURE__ */ ae.jsx(
                ui,
                {
                  clearable: !0,
                  dropdownProps: { className: Gi.dropdown },
                  disabled: !F || De,
                  placeholder: F ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (Ee) => Ee?.name,
                  onChange: (Ee) => {
                    if (Ee.selectedValues.length > 0) {
                      ee(Ee.selectedValues[0]);
                      const Qe = JSON.parse(
                        Ee.selectedValues[0].templateData
                      ), Xe = Q.filter(
                        (Ve) => Ve.priority === Qe.priority
                      );
                      G(
                        Xe ? Xe[0] : void 0
                      );
                      const se = T.filter(
                        (Ve) => Ve.id === Qe.stateId
                      );
                      U(
                        se ? se[0] : void 0
                      );
                      const ye = j.filter(
                        (Ve) => Ve.id === Qe.projectId
                      );
                      z(
                        ye ? ye[0] : void 0
                      );
                      const je = Qe.description;
                      f({
                        title: Qe?.title,
                        priority: Xe[0],
                        status: se[0],
                        project: ye[0],
                        description: je ? DC(je, sM) : "",
                        team: F
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: F
                      }), z(void 0), G(void 0), U(void 0), ee(void 0);
                  },
                  value: B ? [B] : void 0,
                  children: q?.map((Ee) => /* @__PURE__ */ ae.jsx(
                    mt.Item,
                    {
                      value: Ee,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ ae.jsx(A.Paragraph, { children: Ee.name })
                    },
                    Ee.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ ae.jsx(me, { span: 6, children: /* @__PURE__ */ ae.jsx(
                Ot,
                {
                  control: p,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: Ee, value: Qe },
                    fieldState: { error: Xe }
                  }) => /* @__PURE__ */ ae.jsx(
                    tr,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: Qe || "",
                        onChange: Ee
                      },
                      meta: {
                        error: Xe?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ ae.jsx(me, { span: 3, children: /* @__PURE__ */ ae.jsx(
                Ot,
                {
                  control: p,
                  name: "status",
                  render: ({ field: { value: Ee, onChange: Qe } }) => {
                    const Xe = De ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ ae.jsx(en, { label: "Status", children: /* @__PURE__ */ ae.jsx(
                      ui,
                      {
                        dropdownProps: { className: Gi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.name,
                        disabled: F === void 0,
                        placeholder: F ? "Select Issue status" : "Select a Team first",
                        onChange: (se) => {
                          U(se.selectedValues[0]), Qe(se.selectedValues[0]);
                        },
                        value: D ? [Ee] : Xe,
                        children: /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
                          De && /* @__PURE__ */ ae.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ ae.jsx(fn, { size: 24 })
                            }
                          ),
                          Ue && !De && T.map((se) => /* @__PURE__ */ ae.jsx(
                            mt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ae.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ ae.jsx(
                                      ul,
                                      {
                                        type: se.type,
                                        color: se.color,
                                        name: se.name
                                      }
                                    ),
                                    /* @__PURE__ */ ae.jsx(A.Paragraph, { children: se.name })
                                  ]
                                }
                              )
                            },
                            se.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ ae.jsx(me, { span: 3, children: /* @__PURE__ */ ae.jsx(
                Ot,
                {
                  control: p,
                  name: "priority",
                  render: ({ field: { value: Ee, onChange: Qe } }) => {
                    const Xe = qe ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ ae.jsx(en, { label: "Priority", children: /* @__PURE__ */ ae.jsx(
                      ui,
                      {
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.label,
                        disabled: F === void 0,
                        placeholder: F ? "Select Issue priority" : "Select a Team first",
                        onChange: (se) => {
                          G(se.selectedValues[0]), Qe(se.selectedValues[0]);
                        },
                        value: re ? [Ee] : Xe,
                        children: /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
                          De && /* @__PURE__ */ ae.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ ae.jsx(fn, { size: 24 })
                            }
                          ),
                          Y && !qe && Q.map((se) => /* @__PURE__ */ ae.jsx(
                            mt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ae.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ ae.jsx(
                                      cl,
                                      {
                                        priority: se.priority
                                      }
                                    ),
                                    /* @__PURE__ */ ae.jsx(A.Paragraph, { children: se.label })
                                  ]
                                }
                              )
                            },
                            se.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ ae.jsx(me, { children: /* @__PURE__ */ ae.jsx(
                Ot,
                {
                  control: p,
                  name: "description",
                  render: ({
                    field: { onChange: Ee, value: Qe },
                    fieldState: { error: Xe }
                  }) => /* @__PURE__ */ ae.jsx(
                    SI,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: Qe || "",
                        onChange: Ee
                      },
                      meta: {
                        error: Xe?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ ae.jsx(
          Pt,
          {
            confirmOnClick: d(Re),
            confirmProps: {
              disabled: xe || !Y,
              isLoading: be || qe || De,
              loadingIndicator: /* @__PURE__ */ ae.jsx(fn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              on(), ze();
            }
          }
        )
      ]
    }
  );
}, hM = "_modalWrapper_4kh9u_1", yM = "_copyButton_4kh9u_6", gM = "_copyWrapper_4kh9u_15", vM = "_copyField_4kh9u_24", kM = "_externalLink_4kh9u_47", bM = "_externalLinkIcon_4kh9u_52", _M = "_textWrapper_4kh9u_56", ki = {
  modalWrapper: hM,
  copyButton: yM,
  copyWrapper: gM,
  copyField: vM,
  externalLink: kM,
  externalLinkIcon: bM,
  textWrapper: _M
}, xM = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ ae.jsxs(
  jt,
  {
    isOpen: !!n && e,
    className: ki.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ ae.jsx(
        wt,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ ae.jsx(Ct, { children: /* @__PURE__ */ ae.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ ae.jsxs(A.Paragraph, { className: ki.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ ae.jsxs(
                A.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: ki.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ ae.jsx(pe, { name: "external-link", className: ki.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ ae.jsx(en, { label: "Linear issue link", children: /* @__PURE__ */ ae.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: ki.copyWrapper,
                children: [
                  /* @__PURE__ */ ae.jsx(
                    fr,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: ki.copyField
                    }
                  ),
                  /* @__PURE__ */ ae.jsx(
                    NI,
                    {
                      className: ki.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ ae.jsx(
        Pt,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), SM = "https://linear.app/", NM = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = le([]), [a, o] = le([]), [s, l] = le(!1), [u, p] = le(!1), [d, f] = le(!1), [h, v] = le(), { useLazyQuery: F } = yn(), [N, j] = le(""), C = n?.enableCreateIssue, g = !!n?.enableUnlinkAll, { track: z } = Cn(), {
    loading: T,
    data: I,
    error: D,
    store: U
  } = uy(e?.conversationId ?? null), [
    Q,
    {
      data: X,
      loading: re,
      networkStatus: G,
      error: q
    }
  ] = F(F4, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Ye(() => {
    !T && !D && I && I?.linear?.issues?.length > 0 ? (o(I.linear.issues), Q({
      variables: {
        linkedIssues: I.linear.issues
      }
    })) : !T && !D && (i([]), o([]));
  }, [I, T, D]), Ye(() => {
    X && X?.Linear && !re && G === rr.ready && Object.keys(X).length > 0 && i(X.Linear.issues?.edges?.map(({ node: fe }) => fe));
  }, [X, re, G]);
  const R = (fe) => {
    fe && fe?.team?.organization?.urlKey && z("linear:link:issue:clicked", {
      linearInstanceUrl: N,
      linearIssueKey: fe.id
    });
    const de = (ge) => ge.id === fe?.id;
    r.some((ge) => ge && de(ge)) || (I && a.length === 0 && o([]), U({
      linear: {
        issues: [...a, fe.id]
      }
    }));
  }, B = (fe) => {
    const de = I?.linear.issues.filter((ge) => ge !== fe) || [];
    z("linear:unlink:issue:clicked", {
      linearInstanceUrl: N,
      linearIssueKey: fe
    }), i(r.filter(({ id: ge }) => ge !== fe)), o(de), U({
      linear: {
        issues: de
      }
    });
  }, ee = () => {
    l(!1), i([]), o([]), U({
      linear: {
        issues: []
      }
    });
  }, be = T || re || !I && !D || (I?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !T && !re && (q || D) ? /* @__PURE__ */ ae.jsx(In, { error: q || D }) : /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ ae.jsxs(
      jt,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ ae.jsx(
            wt,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ ae.jsx(Ct, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ ae.jsx(
            Pt,
            {
              confirmOnClick: () => ee(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ ae.jsx(
      fM,
      {
        isCreateIssueModalOpen: u,
        setIsCreateIssueModalOpen: (fe) => p(fe),
        setIsCreationSuccessfulModalOpen: (fe) => f(fe),
        addToLinkedIssueIds: (fe) => {
          U({
            linear: {
              issues: [...a, fe]
            }
          });
        },
        setCreatedIssue: (fe) => v(fe),
        organizationUrl: N,
        setOrganizationUrl: (fe) => j(fe)
      }
    ),
    /* @__PURE__ */ ae.jsx(
      xM,
      {
        isCreationSuccessfulModalOpen: d,
        setIsCreationSuccessfulModalOpen: (fe) => f(fe),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ ae.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          C && /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
            /* @__PURE__ */ ae.jsx(
              Yn,
              {
                variant: "primary",
                onClick: () => {
                  z("linear:create:new:issue:clicked", {
                    linearInstanceUrl: N
                  }), p(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ ae.jsx(Z4, { handleSelect: R, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ ae.jsx(
      oM,
      {
        linkedIssues: r,
        isLoading: be,
        handleUnlinkIssue: B,
        showUnlinkAllModal: (fe) => l(fe),
        showUnlinkAllButton: g,
        organizationUrl: N
      }
    )
  ] });
}, Kh = [
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], bi = "LINEAR", jM = {
  enabled: !1,
  name: "",
  enableCreateIssue: !0,
  enableUnlinkAll: !0
}, wM = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = gt({
    mode: "onChange",
    defaultValues: jM
  }), {
    create: u,
    update: p,
    remove: d,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: F
  } = Xr({
    integrationId: e,
    integrationType: bi,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: C,
    refetch: g,
    widgetConfiguration: z
  } = Zr({
    integrationId: e,
    fieldDefinitions: Kh,
    form: l,
    onMisconfigured: F
  }), { renderConditions: T, setRenderConditions: I, renderConditionsForSubmit: D } = ei({
    integrationId: e,
    widgetConfiguration: z,
    renderConditionsEditor: o
  }), U = (X) => ti(X, {
    fieldDefinitions: Kh,
    isCreationMode: s,
    create: u,
    update: p,
    renderConditions: D
  }), Q = l.watch("name");
  return /* @__PURE__ */ ae.jsxs(
    ni,
    {
      form: l,
      integrationId: e,
      onValidSubmit: U,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: C,
      children: [
        v && /* @__PURE__ */ ae.jsx(ri, { cause: v }),
        /* @__PURE__ */ ae.jsxs(at, { children: [
          /* @__PURE__ */ ae.jsx(me, { children: /* @__PURE__ */ ae.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ae.jsx(
            Pn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(me, { span: 3, children: /* @__PURE__ */ ae.jsx(
            Qn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ae.jsx(me, { span: 3 }),
          /* @__PURE__ */ ae.jsx(me, { span: 3, children: /* @__PURE__ */ ae.jsx(en, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ ae.jsx(
            Pn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(me, { span: 3 }),
          /* @__PURE__ */ ae.jsx(me, { span: 3, children: /* @__PURE__ */ ae.jsx(en, { label: 'Enable the "Unlink all" button', children: /* @__PURE__ */ ae.jsx(
            Pn,
            {
              name: "enableUnlinkAll",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(me, { span: 3 }),
          !s && e && /* @__PURE__ */ ae.jsx(
            ga,
            {
              configuration: n,
              integrationId: e,
              integrationType: bi,
              label: "Authorize with OAuth"
            }
          ),
          o && T !== null && /* @__PURE__ */ ae.jsx(me, { children: o({
            value: T,
            onChange: I,
            configurationKey: z?.id
          }) })
        ] }),
        /* @__PURE__ */ ae.jsx(
          ii,
          {
            integrationType: bi,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => d(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ ae.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ ae.jsx(
                pe,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ ae.jsxs(A.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  bi,
                  " integration, all links between Dixa and ",
                  bi,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ ae.jsxs(A.Paragraph, { children: [
                  "All data in ",
                  bi,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ ae.jsxs(A.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  bi,
                  " ",
                  'integration "',
                  Q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var mm = { exports: {} }, Ya = {}, Bx;
function CM() {
  if (Bx) return Ya;
  Bx = 1;
  var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ya.Fragment = r, Ya.jsx = s, Ya.jsxs = s, Ya;
}
var ps = {}, qx;
function FM() {
  return qx || (qx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[N];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        z("error", t, m);
      }
    }
    function z(t, c, m) {
      {
        var y = C.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var P = m.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var T = !1, I = !1, D = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || U || t === v || T || I || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function q(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return q(c) + ".Consumer";
          case s:
            var m = t;
            return q(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return R(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, be, fe, de, ge, K, xe, $e;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          be = console.log, fe = console.info, de = console.warn, ge = console.error, K = console.group, xe = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: be
            }),
            info: B({}, t, {
              value: fe
            }),
            warn: B({}, t, {
              value: de
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: K
            }),
            groupCollapsed: B({}, t, {
              value: xe
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = C.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var ze = !1, Re;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new on();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var m = Re.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      ze = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Le.current, Le.current = null, qe();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var S = te.stack.split(`
`), ne = y.stack.split(`
`), H = S.length - 1, x = ne.length - 1; H >= 1 && x >= 0 && S[H] !== ne[x]; )
            x--;
          for (; H >= 1 && x >= 0; H--, x--)
            if (S[H] !== ne[x]) {
              if (H !== 1 || x !== 1)
                do
                  if (H--, x--, x < 0 || S[H] !== ne[x]) {
                    var Z = `
` + S[H].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (H >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Le.current = P, Me(), Error.prepareStackTrace = $;
      }
      var ue = t ? t.displayName || t.name : "", _e = ue ? De(ue) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Qe(t, c, m) {
      return Ee(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Xe(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case d:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Qe(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return se(P($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, je = {}, Ve = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function dn(t, c, m, y, $) {
      {
        var P = Function.call.bind(ye);
        for (var w in t)
          if (P(t, w)) {
            var S = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + m + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[w](c, w, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              S = H;
            }
            S && !(S instanceof Error) && (Oe($), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, w, typeof S), Oe(null)), S instanceof Error && !(S.message in je) && (je[S.message] = !0, Oe($), g("Failed %s type: %s", m, S.message), Oe(null));
          }
      }
    }
    var E = Array.isArray;
    function _(t) {
      return E(t);
    }
    function O(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function W(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function L(t) {
      if (W(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", O(t)), J(t);
    }
    var M = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Ze(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function sn(t, c) {
      {
        var m = function() {
          he || (he = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function hn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, m, y, $, P, w) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function _n(t, c, m, y, $) {
      {
        var P, w = {}, S = null, ne = null;
        m !== void 0 && (L(m), S = "" + m), mn(c) && (L(c.key), S = "" + c.key), nn(c) && (ne = c.ref, Ze(c));
        for (P in c)
          ye.call(c, P) && !ie.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var H = t.defaultProps;
          for (P in H)
            w[P] === void 0 && (w[P] = H[P]);
        }
        if (S || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && sn(w, x), ne && hn(w, x);
        }
        return pn(t, S, ne, $, y, M.current, w);
      }
    }
    var Je = C.ReactCurrentOwner, Nn = C.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(m);
      } else
        Nn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (Je.current) {
          var t = R(Je.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Mn(t) {
      return "";
    }
    var jn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = kn(c);
        if (jn[m])
          return;
        jn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Je.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ae(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ae(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            cn(y) && gn(y, c);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              cn(w.value) && gn(w.value, c);
        }
      }
    }
    function zn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = R(c);
          dn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var $ = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function An(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ae(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var xn = {};
    function Sn(t, c, m, y, $, P) {
      {
        var w = re(t);
        if (!w) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = Mn();
          ne ? S += ne : S += vn();
          var H;
          t === null ? H = "null" : _(t) ? H = "array" : t !== void 0 && t.$$typeof === n ? (H = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : H = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, S);
        }
        var x = _n(t, c, m, $, P);
        if (x == null)
          return x;
        if (w) {
          var Z = c.children;
          if (Z !== void 0)
            if (y)
              if (_(Z)) {
                for (var ue = 0; ue < Z.length; ue++)
                  wn(Z[ue], t);
                Object.freeze && Object.freeze(Z);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = R(t), te = Object.keys(c).filter(function($n) {
            return $n !== "key";
          }), Ke = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? An(x) : zn(x), x;
      }
    }
    function Bn(t, c, m) {
      return Sn(t, c, m, !0);
    }
    function On(t, c, m) {
      return Sn(t, c, m, !1);
    }
    var Rn = On, Un = Bn;
    ps.Fragment = i, ps.jsx = Rn, ps.jsxs = Un;
  })()), ps;
}
var Hx;
function IM() {
  return Hx || (Hx = 1, process.env.NODE_ENV === "production" ? mm.exports = CM() : mm.exports = FM()), mm.exports;
}
var Fe = IM();
const $M = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, EM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, TM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, DM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, OM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, RM = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": $M,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": EM,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": TM,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": DM,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": OM
};
function Ul(e) {
  return RM[e] ?? {};
}
const PM = Ul(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), AM = Ul(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), LM = Ul(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), VM = Ul(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function pm(e = !1, n) {
  const [r, i] = le(e);
  return Ye(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const zM = "_wrapper_27vny_1", UM = "_copyIcon_27vny_12", Qa = {
  wrapper: zM,
  copyIcon: UM
}, MM = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = pm(), { isCopied: i, copy: a } = pm(), { isCopied: o, copy: s } = pm();
  if (!e)
    return null;
  const l = 14, {
    email: u,
    properties: p,
    metadata: d,
    birthday: f,
    created_at: h,
    enrolled: v,
    enrolled_at: F,
    referral_url: N
  } = e, j = f ? Hn(f).isSame(Date.now(), "day") : !1, { name: C, first_name: g, last_name: z } = p ?? {}, T = C ?? (`${g} ${z}`.trim() || "A customer has no name"), I = d?.shopify_source_url ? d.shopify_source_url.startsWith("https://") ? d.shopify_source_url : `https://${d.shopify_source_url}` : "";
  return /* @__PURE__ */ Fe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Fe.jsxs(b, { className: Qa.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: Qa.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-2", children: T }),
          j && /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: Hn(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    v && /* @__PURE__ */ Fe.jsx(b, { gap: "200", children: /* @__PURE__ */ Fe.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Hn(F).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Fe.jsx(pe, { size: l, name: "mail" }),
        /* @__PURE__ */ Fe.jsx(A.ExternalLink, { href: `mailto:${u}`, children: u })
      ] }),
      /* @__PURE__ */ Fe.jsx(Ge, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ Fe.jsx(
        pe,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(u),
          className: Qa.copyIcon
        }
      ) })
    ] }),
    I && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Fe.jsx(pe, { size: l, name: "link" }),
        /* @__PURE__ */ Fe.jsx(Ge, { content: "Shopify shop", children: /* @__PURE__ */ Fe.jsx(
          A.ExternalLink,
          {
            href: I,
            target: "_blank",
            rel: "noreferrer",
            children: I.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Fe.jsx(Ge, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ Fe.jsx(
        pe,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(I),
          className: Qa.copyIcon
        }
      ) })
    ] }),
    N && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Fe.jsx(pe, { size: l, name: "external-link" }),
        /* @__PURE__ */ Fe.jsx(Ge, { content: "Referral link", children: /* @__PURE__ */ Fe.jsx(
          A.ExternalLink,
          {
            href: N,
            target: "_blank",
            rel: "noreferrer",
            children: N.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Fe.jsx(Ge, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ Fe.jsx(
        pe,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(N),
          className: Qa.copyIcon
        }
      ) })
    ] })
  ] }) });
}, BM = "_list_1q5b5_5", qM = "_listItem_1q5b5_8", HM = "_listItemEdit_1q5b5_15", WM = "_notificationText_1q5b5_19", ha = {
  list: BM,
  listItem: qM,
  listItemEdit: HM,
  notificationText: WM
}, KM = "_modalBody_1clhs_1", GM = {
  modalBody: KM
}, YM = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = yn(), { track: l } = Cn(), [u, p] = le(n), [d, f] = le(""), [h, v] = le(), [F, { loading: N }] = o(
    LM,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), G();
      }
    }
  ), [j, { loading: C }] = o(VM), g = N || C, z = !!h, T = n === u ? "Change the value to update the points" : "", I = isNaN(u), D = I ? "Points can not be empty" : "", U = u > n && u - n > 1e6, Q = U ? "Points can not exceed 1,000,000" : "", X = () => {
    if (!r) {
      v(["Merchant information is missing."]), u > n ? l("loyaltylion:add:points:failed") : u < n && l("loyaltylion:remove:points:failed");
      return;
    }
    u > n && F({
      variables: {
        input: {
          points: u - n,
          reason: d
        },
        merchantId: r
      }
    }).catch((q) => {
      const R = q?.networkError;
      (R ? R?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), G()) : (l("loyaltylion:add:points:failed"), v(["Failed to add points, try again later."]));
    }), u < n && j({
      variables: {
        input: {
          points: n - u,
          reason: d
        },
        merchantId: r
      }
    }).then((q) => {
      q.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), G()) : "errors" in q && (l("loyaltylion:remove:points:failed"), v(
        q.errors?.map((R) => R.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), v(["Failed to remove points, try again later."]);
    });
  }, re = () => {
    I && p(n), f(""), i();
  }, G = () => {
    a(), re();
  };
  return /* @__PURE__ */ Fe.jsxs(
    jt,
    {
      isOpen: e,
      onClose: re,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ Fe.jsx(wt, { title: "Change points", onClose: re }),
        /* @__PURE__ */ Fe.jsxs(Ct, { className: GM.modalBody, children: [
          /* @__PURE__ */ Fe.jsxs(at, { children: [
            /* @__PURE__ */ Fe.jsx(me, { span: 6, children: /* @__PURE__ */ Fe.jsx(
              tr,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: Q || D,
                  warning: T
                },
                input: {
                  name: "points",
                  value: u.toString(),
                  onChange: (q) => p(q?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ Fe.jsx(me, { span: 6, children: /* @__PURE__ */ Fe.jsx(
              tr,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: d,
                  onChange: (q) => f(q?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !g && z && /* @__PURE__ */ Fe.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ Fe.jsx(We, { children: h?.map((q, R) => /* @__PURE__ */ Fe.jsx(
            We.Item,
            {
              variant: "dense",
              title: q,
              contentLeft: /* @__PURE__ */ Fe.jsx(
                pe,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            R
          )) }) })
        ] }),
        /* @__PURE__ */ Fe.jsx(
          Pt,
          {
            confirmName: "Save",
            confirmOnClick: () => X(),
            confirmProps: {
              isLoading: g,
              disabled: I || U || n === u,
              loadingIndicator: /* @__PURE__ */ Fe.jsx(fn, { size: 16 })
            },
            cancelOnClick: re
          }
        )
      ]
    }
  );
}, QM = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ Fe.jsx(We.Text, { variant: "dense", className: ha.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(pe, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ Fe.jsx(Ge, { content: "Edit points", children: /* @__PURE__ */ Fe.jsx(
        pe,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: ha.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ Fe.jsx(Vn, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, JM = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = le(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: u
  } = e, p = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: u ?? 0
    }
  ];
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ Fe.jsx(We, { className: ha.list, children: p.map(({ id: d, points: f, label: h, setIsModalOpen: v }) => /* @__PURE__ */ Fe.jsx(
      QM,
      {
        points: f,
        label: h,
        setIsModalOpen: v
      },
      d
    )) }),
    /* @__PURE__ */ Fe.jsx(
      YM,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, XM = "_reward_1wxia_1", ZM = {
  reward: XM
}, eB = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ Fe.jsx(b, { gap: "100", flexDirection: "column", className: ZM.reward, children: /* @__PURE__ */ Fe.jsx(Ge, { content: a ?? "No description", children: /* @__PURE__ */ Fe.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(pe, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ Fe.jsxs(Vn, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ Fe.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(pe, { size: 14, name: "external-link" }),
      /* @__PURE__ */ Fe.jsx(
        A.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, nB = ({ customer: e }) => {
  const { useQuery: n } = yn(), [r, i] = le(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(AM, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (Ye(() => {
    if (l?.LoyaltyLion) {
      const u = l.LoyaltyLion?.getAvailableRewards?.rewards;
      u && i(u);
    }
  }, [l]), s) {
    const u = s.graphQLErrors;
    return va({ errors: u }) ? /* @__PURE__ */ Fe.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: ha.notificationText,
        children: "No rewards found"
      }
    ) : yw({ errors: u }) ? /* @__PURE__ */ Fe.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: ha.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ Fe.jsx(In, { error: s });
  }
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Fe.jsx(fn, {}) }) : /* @__PURE__ */ Fe.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((u) => /* @__PURE__ */ Fe.jsx(eB, { reward: u }, u.id)) })
  ] });
}, tB = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ Fe.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Fe.jsx(qn, { children: /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(
        pe,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ Fe.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Fe.jsx(qn, { children: /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(pe, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ Fe.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Fe.jsx(Ge, { content: "Insights segment", children: /* @__PURE__ */ Fe.jsx(qn, { children: /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(pe, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, rB = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = yn(), { track: i } = Cn(), [a, o] = le(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: u,
    showPointsBalance: p,
    showAvailableRewards: d
  } = n, f = !l && !u && !p && !d, {
    loading: h,
    error: v,
    data: F,
    refetch: N
  } = r(PM, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return Ye(() => {
    if (F && !h) {
      const j = (F?.LoyaltyLion?.getCustomers).customers;
      j && j.length > 0 && (o(j[0]), i("loyaltylion:customer:received"));
    }
  }, [F, h]), s?.email ? v ? va({
    errors: v.graphQLErrors
  }) ? /* @__PURE__ */ Fe.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: ha.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ Fe.jsx(In, { error: v }) : h ? /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Fe.jsx(fn, {}) }) : f ? /* @__PURE__ */ Fe.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ Fe.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ Fe.jsxs(Fe.Fragment, { children: [
        l && /* @__PURE__ */ Fe.jsx(MM, { customer: a }),
        u && /* @__PURE__ */ Fe.jsx(tB, { customer: a }),
        p && /* @__PURE__ */ Fe.jsx(
          JM,
          {
            customer: a,
            refetchCustomerData: N
          }
        ),
        d && /* @__PURE__ */ Fe.jsx(nB, { customer: a })
      ] }) : /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ Fe.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, Gh = [
  {
    key: "basicAuthorization",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerSummary",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showTags",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], Wx = "LOYALTYLION", iB = {
  enabled: !1,
  name: "",
  basicAuthorization: "",
  showCustomerSummary: !0,
  showTags: !0,
  showPointsBalance: !0,
  showAvailableRewards: !0
}, aB = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = gt({
    mode: "onChange",
    defaultValues: iB
  }), {
    create: l,
    update: u,
    remove: p,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = Xr({
    integrationId: e,
    integrationType: Wx,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: N,
    isWidgetUnknown: j,
    refetch: C,
    widgetConfiguration: g
  } = Zr({
    integrationId: e,
    fieldDefinitions: Gh,
    form: s,
    onMisconfigured: v
  }), { renderConditions: z, setRenderConditions: T, renderConditionsForSubmit: I } = ei({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), D = (Q) => ti(Q, {
    fieldDefinitions: Gh,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: I
  }), U = s.watch("name");
  return /* @__PURE__ */ Fe.jsxs(
    ni,
    {
      form: s,
      integrationId: e,
      onValidSubmit: D,
      error: N ?? f,
      onRetry: N ? C : void 0,
      isLoading: d || F,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ Fe.jsx(ri, { cause: h }),
        /* @__PURE__ */ Fe.jsxs(at, { children: [
          /* @__PURE__ */ Fe.jsx(me, { children: /* @__PURE__ */ Fe.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Fe.jsx(
            Pn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(me, { span: 3, children: /* @__PURE__ */ Fe.jsx(
            Qn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Fe.jsx(me, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(me, { span: 3, children: /* @__PURE__ */ Fe.jsx(
            cI,
            {
              name: "basicAuthorization",
              label: "LoyaltyLion authorization",
              control: s.control,
              isCreationMode: o,
              rules: { required: "Please insert a value for both fields" },
              usernameLabel: "Token",
              passwordLabel: "Secret",
              usernamePlaceholder: "Insert your token",
              passwordPlaceholder: "Insert your secret"
            }
          ) }),
          /* @__PURE__ */ Fe.jsx(me, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(me, { span: 3, children: /* @__PURE__ */ Fe.jsx(en, { label: "Show customer summary", children: /* @__PURE__ */ Fe.jsx(
            Pn,
            {
              name: "showCustomerSummary",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(me, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(me, { span: 3, children: /* @__PURE__ */ Fe.jsx(en, { label: "Show tags", children: /* @__PURE__ */ Fe.jsx(
            Pn,
            {
              name: "showTags",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(me, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(me, { span: 3, children: /* @__PURE__ */ Fe.jsx(en, { label: "Show points balance", children: /* @__PURE__ */ Fe.jsx(
            Pn,
            {
              name: "showPointsBalance",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(me, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(me, { span: 3, children: /* @__PURE__ */ Fe.jsx(en, { label: "Show available rewards", children: /* @__PURE__ */ Fe.jsx(
            Pn,
            {
              name: "showAvailableRewards",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(me, { span: 3 }),
          a && z !== null && /* @__PURE__ */ Fe.jsx(me, { children: a({
            value: z,
            onChange: T,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ Fe.jsx(
          ii,
          {
            integrationType: Wx,
            integrationId: e,
            widgetName: U,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var fm = { exports: {} }, Ja = {}, Kx;
function oB() {
  if (Kx) return Ja;
  Kx = 1;
  var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ja.Fragment = r, Ja.jsx = s, Ja.jsxs = s, Ja;
}
var fs = {}, Gx;
function sB() {
  return Gx || (Gx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[N];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        z("error", t, m);
      }
    }
    function z(t, c, m) {
      {
        var y = C.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var P = m.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var T = !1, I = !1, D = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || U || t === v || T || I || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function q(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return q(c) + ".Consumer";
          case s:
            var m = t;
            return q(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return R(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, be, fe, de, ge, K, xe, $e;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          be = console.log, fe = console.info, de = console.warn, ge = console.error, K = console.group, xe = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: be
            }),
            info: B({}, t, {
              value: fe
            }),
            warn: B({}, t, {
              value: de
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: K
            }),
            groupCollapsed: B({}, t, {
              value: xe
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = C.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var ze = !1, Re;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new on();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var m = Re.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      ze = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Le.current, Le.current = null, qe();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var S = te.stack.split(`
`), ne = y.stack.split(`
`), H = S.length - 1, x = ne.length - 1; H >= 1 && x >= 0 && S[H] !== ne[x]; )
            x--;
          for (; H >= 1 && x >= 0; H--, x--)
            if (S[H] !== ne[x]) {
              if (H !== 1 || x !== 1)
                do
                  if (H--, x--, x < 0 || S[H] !== ne[x]) {
                    var Z = `
` + S[H].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (H >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Le.current = P, Me(), Error.prepareStackTrace = $;
      }
      var ue = t ? t.displayName || t.name : "", _e = ue ? De(ue) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Qe(t, c, m) {
      return Ee(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Xe(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case d:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Qe(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return se(P($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, je = {}, Ve = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function dn(t, c, m, y, $) {
      {
        var P = Function.call.bind(ye);
        for (var w in t)
          if (P(t, w)) {
            var S = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + m + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[w](c, w, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              S = H;
            }
            S && !(S instanceof Error) && (Oe($), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, w, typeof S), Oe(null)), S instanceof Error && !(S.message in je) && (je[S.message] = !0, Oe($), g("Failed %s type: %s", m, S.message), Oe(null));
          }
      }
    }
    var E = Array.isArray;
    function _(t) {
      return E(t);
    }
    function O(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function W(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function L(t) {
      if (W(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", O(t)), J(t);
    }
    var M = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Ze(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function sn(t, c) {
      {
        var m = function() {
          he || (he = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function hn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, m, y, $, P, w) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function _n(t, c, m, y, $) {
      {
        var P, w = {}, S = null, ne = null;
        m !== void 0 && (L(m), S = "" + m), mn(c) && (L(c.key), S = "" + c.key), nn(c) && (ne = c.ref, Ze(c));
        for (P in c)
          ye.call(c, P) && !ie.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var H = t.defaultProps;
          for (P in H)
            w[P] === void 0 && (w[P] = H[P]);
        }
        if (S || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && sn(w, x), ne && hn(w, x);
        }
        return pn(t, S, ne, $, y, M.current, w);
      }
    }
    var Je = C.ReactCurrentOwner, Nn = C.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(m);
      } else
        Nn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (Je.current) {
          var t = R(Je.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Mn(t) {
      return "";
    }
    var jn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = kn(c);
        if (jn[m])
          return;
        jn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Je.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ae(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ae(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            cn(y) && gn(y, c);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              cn(w.value) && gn(w.value, c);
        }
      }
    }
    function zn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = R(c);
          dn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var $ = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function An(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ae(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var xn = {};
    function Sn(t, c, m, y, $, P) {
      {
        var w = re(t);
        if (!w) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = Mn();
          ne ? S += ne : S += vn();
          var H;
          t === null ? H = "null" : _(t) ? H = "array" : t !== void 0 && t.$$typeof === n ? (H = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : H = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, S);
        }
        var x = _n(t, c, m, $, P);
        if (x == null)
          return x;
        if (w) {
          var Z = c.children;
          if (Z !== void 0)
            if (y)
              if (_(Z)) {
                for (var ue = 0; ue < Z.length; ue++)
                  wn(Z[ue], t);
                Object.freeze && Object.freeze(Z);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = R(t), te = Object.keys(c).filter(function($n) {
            return $n !== "key";
          }), Ke = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? An(x) : zn(x), x;
      }
    }
    function Bn(t, c, m) {
      return Sn(t, c, m, !0);
    }
    function On(t, c, m) {
      return Sn(t, c, m, !1);
    }
    var Rn = On, Un = Bn;
    fs.Fragment = i, fs.jsx = Rn, fs.jsxs = Un;
  })()), fs;
}
var Yx;
function lB() {
  return Yx || (Yx = 1, process.env.NODE_ENV === "production" ? fm.exports = oB() : fm.exports = sB()), fm.exports;
}
var un = lB();
const cB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, uB = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": cB
};
function dB(e) {
  return uB[e] ?? {};
}
const {
  entries: OC,
  setPrototypeOf: Qx,
  isFrozen: mB,
  getPrototypeOf: pB,
  getOwnPropertyDescriptor: fB
} = Object;
let {
  freeze: Yt,
  seal: yr,
  create: ta
} = Object, {
  apply: Yh,
  construct: Qh
} = typeof Reflect < "u" && Reflect;
Yt || (Yt = function(e) {
  return e;
});
yr || (yr = function(e) {
  return e;
});
Yh || (Yh = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
Qh || (Qh = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const Xa = kt(Array.prototype.forEach), hB = kt(Array.prototype.lastIndexOf), Jx = kt(Array.prototype.pop), Za = kt(Array.prototype.push), yB = kt(Array.prototype.splice), Ut = Array.isArray, go = kt(String.prototype.toLowerCase), hm = kt(String.prototype.toString), Xx = kt(String.prototype.match), Yi = kt(String.prototype.replace), Zx = kt(String.prototype.indexOf), gB = kt(String.prototype.trim), vB = kt(Number.prototype.toString), kB = kt(Boolean.prototype.toString), eS = typeof BigInt > "u" ? null : kt(BigInt.prototype.toString), nS = typeof Symbol > "u" ? null : kt(Symbol.prototype.toString), st = kt(Object.prototype.hasOwnProperty), eo = kt(Object.prototype.toString), It = kt(RegExp.prototype.test), hs = bB(TypeError);
function kt(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return Yh(e, n, i);
  };
}
function bB(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return Qh(e, r);
  };
}
function Dn(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : go;
  if (Qx && Qx(e, null), !Ut(n))
    return e;
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (mB(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function _B(e) {
  for (let n = 0; n < e.length; n++)
    st(e, n) || (e[n] = null);
  return e;
}
function Xt(e) {
  const n = ta(null);
  for (const [r, i] of OC(e))
    st(e, r) && (Ut(i) ? n[r] = _B(i) : i && typeof i == "object" && i.constructor === Object ? n[r] = Xt(i) : n[r] = i);
  return n;
}
function xB(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return vB(e);
    case "boolean":
      return kB(e);
    case "bigint":
      return eS ? eS(e) : "0";
    case "symbol":
      return nS ? nS(e) : "Symbol()";
    case "undefined":
      return eo(e);
    case "function":
    case "object": {
      if (e === null)
        return eo(e);
      const n = e, r = ra(n, "toString");
      if (typeof r == "function") {
        const i = r(n);
        return typeof i == "string" ? i : eo(i);
      }
      return eo(e);
    }
    default:
      return eo(e);
  }
}
function ra(e, n) {
  for (; e !== null; ) {
    const i = fB(e, n);
    if (i) {
      if (i.get)
        return kt(i.get);
      if (typeof i.value == "function")
        return kt(i.value);
    }
    e = pB(e);
  }
  function r() {
    return null;
  }
  return r;
}
function SB(e) {
  try {
    return It(e, ""), !0;
  } catch {
    return !1;
  }
}
const tS = Yt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), ym = Yt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), gm = Yt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), NB = Yt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), vm = Yt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), jB = Yt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), rS = Yt(["#text"]), iS = Yt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), km = Yt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), aS = Yt(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), ys = Yt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), wB = yr(/\{\{[\w\W]*|[\w\W]*\}\}/gm), CB = yr(/<%[\w\W]*|[\w\W]*%>/gm), FB = yr(/\$\{[\w\W]*/gm), IB = yr(/^data-[\-\w.\u00B7-\uFFFF]+$/), $B = yr(/^aria-[\-\w]+$/), RC = yr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), EB = yr(/^(?:\w+script|data):/i), TB = yr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), PC = yr(/^html$/i), DB = yr(/^[a-z][.\w]*(-[.\w]+)+$/i);
var oS = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: $B,
  ATTR_WHITESPACE: TB,
  CUSTOM_ELEMENT: DB,
  DATA_ATTR: IB,
  DOCTYPE_NAME: PC,
  ERB_EXPR: CB,
  IS_ALLOWED_URI: RC,
  IS_SCRIPT_OR_DATA: EB,
  MUSTACHE_EXPR: wB,
  TMPLIT_EXPR: FB
});
const no = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, OB = function() {
  return typeof window > "u" ? null : window;
}, RB = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, sS = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function AC() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : OB();
  const n = (x) => AC(x);
  if (n.version = "3.4.2", n.removed = [], !e || !e.document || e.document.nodeType !== no.document || !e.Element)
    return n.isSupported = !1, n;
  let {
    document: r
  } = e;
  const i = r, a = i.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: s,
    Node: l,
    Element: u,
    NodeFilter: p,
    NamedNodeMap: d = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: f,
    DOMParser: h,
    trustedTypes: v
  } = e, F = u.prototype, N = ra(F, "cloneNode"), j = ra(F, "remove"), C = ra(F, "nextSibling"), g = ra(F, "childNodes"), z = ra(F, "parentNode");
  if (typeof s == "function") {
    const x = r.createElement("template");
    x.content && x.content.ownerDocument && (r = x.content.ownerDocument);
  }
  let T, I = "";
  const {
    implementation: D,
    createNodeIterator: U,
    createDocumentFragment: Q,
    getElementsByTagName: X
  } = r, {
    importNode: re
  } = i;
  let G = sS();
  n.isSupported = typeof OC == "function" && typeof z == "function" && D && D.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: q,
    ERB_EXPR: R,
    TMPLIT_EXPR: B,
    DATA_ATTR: ee,
    ARIA_ATTR: be,
    IS_SCRIPT_OR_DATA: fe,
    ATTR_WHITESPACE: de,
    CUSTOM_ELEMENT: ge
  } = oS;
  let {
    IS_ALLOWED_URI: K
  } = oS, xe = null;
  const $e = Dn({}, [...tS, ...ym, ...gm, ...vm, ...rS]);
  let Y = null;
  const qe = Dn({}, [...iS, ...km, ...aS, ...ys]);
  let Me = Object.seal(ta(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Le = null, Ue = null;
  const De = Object.seal(ta(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let ze = !0, Re = !0, on = !1, Ee = !0, Qe = !1, Xe = !0, se = !1, ye = !1, je = !1, Ve = !1, Oe = !1, dn = !1, E = !0, _ = !1;
  const O = "user-content-";
  let W = !0, J = !1, L = {}, M = null;
  const ie = Dn({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let he = null;
  const Ne = Dn({}, ["audio", "video", "img", "source", "image", "track"]);
  let nn = null;
  const mn = Dn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Ze = "http://www.w3.org/1998/Math/MathML", sn = "http://www.w3.org/2000/svg", hn = "http://www.w3.org/1999/xhtml";
  let pn = hn, _n = !1, Je = null;
  const Nn = Dn({}, [Ze, sn, hn], hm);
  let Ae = Dn({}, ["mi", "mo", "mn", "ms", "mtext"]), ln = Dn({}, ["annotation-xml"]);
  const cn = Dn({}, ["title", "style", "font", "a", "script"]);
  let vn = null;
  const Mn = ["application/xhtml+xml", "text/html"], jn = "text/html";
  let kn = null, gn = null;
  const wn = r.createElement("form"), zn = function(x) {
    return x instanceof RegExp || x instanceof Function;
  }, An = function() {
    let x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (gn && gn === x)
      return;
    (!x || typeof x != "object") && (x = {}), x = Xt(x), vn = // eslint-disable-next-line unicorn/prefer-includes
    Mn.indexOf(x.PARSER_MEDIA_TYPE) === -1 ? jn : x.PARSER_MEDIA_TYPE, kn = vn === "application/xhtml+xml" ? hm : go, xe = st(x, "ALLOWED_TAGS") && Ut(x.ALLOWED_TAGS) ? Dn({}, x.ALLOWED_TAGS, kn) : $e, Y = st(x, "ALLOWED_ATTR") && Ut(x.ALLOWED_ATTR) ? Dn({}, x.ALLOWED_ATTR, kn) : qe, Je = st(x, "ALLOWED_NAMESPACES") && Ut(x.ALLOWED_NAMESPACES) ? Dn({}, x.ALLOWED_NAMESPACES, hm) : Nn, nn = st(x, "ADD_URI_SAFE_ATTR") && Ut(x.ADD_URI_SAFE_ATTR) ? Dn(Xt(mn), x.ADD_URI_SAFE_ATTR, kn) : mn, he = st(x, "ADD_DATA_URI_TAGS") && Ut(x.ADD_DATA_URI_TAGS) ? Dn(Xt(Ne), x.ADD_DATA_URI_TAGS, kn) : Ne, M = st(x, "FORBID_CONTENTS") && Ut(x.FORBID_CONTENTS) ? Dn({}, x.FORBID_CONTENTS, kn) : ie, Le = st(x, "FORBID_TAGS") && Ut(x.FORBID_TAGS) ? Dn({}, x.FORBID_TAGS, kn) : Xt({}), Ue = st(x, "FORBID_ATTR") && Ut(x.FORBID_ATTR) ? Dn({}, x.FORBID_ATTR, kn) : Xt({}), L = st(x, "USE_PROFILES") ? x.USE_PROFILES && typeof x.USE_PROFILES == "object" ? Xt(x.USE_PROFILES) : x.USE_PROFILES : !1, ze = x.ALLOW_ARIA_ATTR !== !1, Re = x.ALLOW_DATA_ATTR !== !1, on = x.ALLOW_UNKNOWN_PROTOCOLS || !1, Ee = x.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Qe = x.SAFE_FOR_TEMPLATES || !1, Xe = x.SAFE_FOR_XML !== !1, se = x.WHOLE_DOCUMENT || !1, Ve = x.RETURN_DOM || !1, Oe = x.RETURN_DOM_FRAGMENT || !1, dn = x.RETURN_TRUSTED_TYPE || !1, je = x.FORCE_BODY || !1, E = x.SANITIZE_DOM !== !1, _ = x.SANITIZE_NAMED_PROPS || !1, W = x.KEEP_CONTENT !== !1, J = x.IN_PLACE || !1, K = SB(x.ALLOWED_URI_REGEXP) ? x.ALLOWED_URI_REGEXP : RC, pn = typeof x.NAMESPACE == "string" ? x.NAMESPACE : hn, Ae = st(x, "MATHML_TEXT_INTEGRATION_POINTS") && x.MATHML_TEXT_INTEGRATION_POINTS && typeof x.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Xt(x.MATHML_TEXT_INTEGRATION_POINTS) : Dn({}, ["mi", "mo", "mn", "ms", "mtext"]), ln = st(x, "HTML_INTEGRATION_POINTS") && x.HTML_INTEGRATION_POINTS && typeof x.HTML_INTEGRATION_POINTS == "object" ? Xt(x.HTML_INTEGRATION_POINTS) : Dn({}, ["annotation-xml"]);
    const Z = st(x, "CUSTOM_ELEMENT_HANDLING") && x.CUSTOM_ELEMENT_HANDLING && typeof x.CUSTOM_ELEMENT_HANDLING == "object" ? Xt(x.CUSTOM_ELEMENT_HANDLING) : ta(null);
    if (Me = ta(null), st(Z, "tagNameCheck") && zn(Z.tagNameCheck) && (Me.tagNameCheck = Z.tagNameCheck), st(Z, "attributeNameCheck") && zn(Z.attributeNameCheck) && (Me.attributeNameCheck = Z.attributeNameCheck), st(Z, "allowCustomizedBuiltInElements") && typeof Z.allowCustomizedBuiltInElements == "boolean" && (Me.allowCustomizedBuiltInElements = Z.allowCustomizedBuiltInElements), Qe && (Re = !1), Oe && (Ve = !0), L && (xe = Dn({}, rS), Y = ta(null), L.html === !0 && (Dn(xe, tS), Dn(Y, iS)), L.svg === !0 && (Dn(xe, ym), Dn(Y, km), Dn(Y, ys)), L.svgFilters === !0 && (Dn(xe, gm), Dn(Y, km), Dn(Y, ys)), L.mathMl === !0 && (Dn(xe, vm), Dn(Y, aS), Dn(Y, ys))), De.tagCheck = null, De.attributeCheck = null, st(x, "ADD_TAGS") && (typeof x.ADD_TAGS == "function" ? De.tagCheck = x.ADD_TAGS : Ut(x.ADD_TAGS) && (xe === $e && (xe = Xt(xe)), Dn(xe, x.ADD_TAGS, kn))), st(x, "ADD_ATTR") && (typeof x.ADD_ATTR == "function" ? De.attributeCheck = x.ADD_ATTR : Ut(x.ADD_ATTR) && (Y === qe && (Y = Xt(Y)), Dn(Y, x.ADD_ATTR, kn))), st(x, "ADD_URI_SAFE_ATTR") && Ut(x.ADD_URI_SAFE_ATTR) && Dn(nn, x.ADD_URI_SAFE_ATTR, kn), st(x, "FORBID_CONTENTS") && Ut(x.FORBID_CONTENTS) && (M === ie && (M = Xt(M)), Dn(M, x.FORBID_CONTENTS, kn)), st(x, "ADD_FORBID_CONTENTS") && Ut(x.ADD_FORBID_CONTENTS) && (M === ie && (M = Xt(M)), Dn(M, x.ADD_FORBID_CONTENTS, kn)), W && (xe["#text"] = !0), se && Dn(xe, ["html", "head", "body"]), xe.table && (Dn(xe, ["tbody"]), delete Le.tbody), x.TRUSTED_TYPES_POLICY) {
      if (typeof x.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw hs('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof x.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw hs('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      T = x.TRUSTED_TYPES_POLICY, I = T.createHTML("");
    } else
      T === void 0 && (T = RB(v, a)), T !== null && typeof I == "string" && (I = T.createHTML(""));
    Yt && Yt(x), gn = x;
  }, xn = Dn({}, [...ym, ...gm, ...NB]), Sn = Dn({}, [...vm, ...jB]), Bn = function(x) {
    let Z = z(x);
    (!Z || !Z.tagName) && (Z = {
      namespaceURI: pn,
      tagName: "template"
    });
    const ue = go(x.tagName), _e = go(Z.tagName);
    return Je[x.namespaceURI] ? x.namespaceURI === sn ? Z.namespaceURI === hn ? ue === "svg" : Z.namespaceURI === Ze ? ue === "svg" && (_e === "annotation-xml" || Ae[_e]) : !!xn[ue] : x.namespaceURI === Ze ? Z.namespaceURI === hn ? ue === "math" : Z.namespaceURI === sn ? ue === "math" && ln[_e] : !!Sn[ue] : x.namespaceURI === hn ? Z.namespaceURI === sn && !ln[_e] || Z.namespaceURI === Ze && !Ae[_e] ? !1 : !Sn[ue] && (cn[ue] || !xn[ue]) : !!(vn === "application/xhtml+xml" && Je[x.namespaceURI]) : !1;
  }, On = function(x) {
    Za(n.removed, {
      element: x
    });
    try {
      z(x).removeChild(x);
    } catch {
      j(x);
    }
  }, Rn = function(x, Z) {
    try {
      Za(n.removed, {
        attribute: Z.getAttributeNode(x),
        from: Z
      });
    } catch {
      Za(n.removed, {
        attribute: null,
        from: Z
      });
    }
    if (Z.removeAttribute(x), x === "is")
      if (Ve || Oe)
        try {
          On(Z);
        } catch {
        }
      else
        try {
          Z.setAttribute(x, "");
        } catch {
        }
  }, Un = function(x) {
    let Z = null, ue = null;
    if (je)
      x = "<remove></remove>" + x;
    else {
      const Ke = Xx(x, /^[\r\n\t ]+/);
      ue = Ke && Ke[0];
    }
    vn === "application/xhtml+xml" && pn === hn && (x = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + x + "</body></html>");
    const _e = T ? T.createHTML(x) : x;
    if (pn === hn)
      try {
        Z = new h().parseFromString(_e, vn);
      } catch {
      }
    if (!Z || !Z.documentElement) {
      Z = D.createDocument(pn, "template", null);
      try {
        Z.documentElement.innerHTML = _n ? I : _e;
      } catch {
      }
    }
    const te = Z.body || Z.documentElement;
    return x && ue && te.insertBefore(r.createTextNode(ue), te.childNodes[0] || null), pn === hn ? X.call(Z, se ? "html" : "body")[0] : se ? Z.documentElement : te;
  }, t = function(x) {
    return U.call(
      x.ownerDocument || x,
      x,
      // eslint-disable-next-line no-bitwise
      p.SHOW_ELEMENT | p.SHOW_COMMENT | p.SHOW_TEXT | p.SHOW_PROCESSING_INSTRUCTION | p.SHOW_CDATA_SECTION,
      null
    );
  }, c = function(x) {
    return x instanceof f && (typeof x.nodeName != "string" || typeof x.textContent != "string" || typeof x.removeChild != "function" || !(x.attributes instanceof d) || typeof x.removeAttribute != "function" || typeof x.setAttribute != "function" || typeof x.namespaceURI != "string" || typeof x.insertBefore != "function" || typeof x.hasChildNodes != "function");
  }, m = function(x) {
    return typeof l == "function" && x instanceof l;
  };
  function y(x, Z, ue) {
    Xa(x, (_e) => {
      _e.call(n, Z, ue, gn);
    });
  }
  const $ = function(x) {
    let Z = null;
    if (y(G.beforeSanitizeElements, x, null), c(x))
      return On(x), !0;
    const ue = kn(x.nodeName);
    if (y(G.uponSanitizeElement, x, {
      tagName: ue,
      allowedTags: xe
    }), Xe && x.hasChildNodes() && !m(x.firstElementChild) && It(/<[/\w!]/g, x.innerHTML) && It(/<[/\w!]/g, x.textContent) || Xe && x.namespaceURI === hn && ue === "style" && m(x.firstElementChild) || x.nodeType === no.progressingInstruction || Xe && x.nodeType === no.comment && It(/<[/\w]/g, x.data))
      return On(x), !0;
    if (Le[ue] || !(De.tagCheck instanceof Function && De.tagCheck(ue)) && !xe[ue]) {
      if (!Le[ue] && S(ue) && (Me.tagNameCheck instanceof RegExp && It(Me.tagNameCheck, ue) || Me.tagNameCheck instanceof Function && Me.tagNameCheck(ue)))
        return !1;
      if (W && !M[ue]) {
        const _e = z(x) || x.parentNode, te = g(x) || x.childNodes;
        if (te && _e) {
          const Ke = te.length;
          for (let Tn = Ke - 1; Tn >= 0; --Tn) {
            const $n = N(te[Tn], !0);
            _e.insertBefore($n, C(x));
          }
        }
      }
      return On(x), !0;
    }
    return x instanceof u && !Bn(x) || (ue === "noscript" || ue === "noembed" || ue === "noframes") && It(/<\/no(script|embed|frames)/i, x.innerHTML) ? (On(x), !0) : (Qe && x.nodeType === no.text && (Z = x.textContent, Xa([q, R, B], (_e) => {
      Z = Yi(Z, _e, " ");
    }), x.textContent !== Z && (Za(n.removed, {
      element: x.cloneNode()
    }), x.textContent = Z)), y(G.afterSanitizeElements, x, null), !1);
  }, P = function(x, Z, ue) {
    if (Ue[Z] || E && (Z === "id" || Z === "name") && (ue in r || ue in wn))
      return !1;
    const _e = Y[Z] || De.attributeCheck instanceof Function && De.attributeCheck(Z, x);
    if (!(Re && !Ue[Z] && It(ee, Z)) && !(ze && It(be, Z))) {
      if (!_e || Ue[Z]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(S(x) && (Me.tagNameCheck instanceof RegExp && It(Me.tagNameCheck, x) || Me.tagNameCheck instanceof Function && Me.tagNameCheck(x)) && (Me.attributeNameCheck instanceof RegExp && It(Me.attributeNameCheck, Z) || Me.attributeNameCheck instanceof Function && Me.attributeNameCheck(Z, x)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          Z === "is" && Me.allowCustomizedBuiltInElements && (Me.tagNameCheck instanceof RegExp && It(Me.tagNameCheck, ue) || Me.tagNameCheck instanceof Function && Me.tagNameCheck(ue)))
        ) return !1;
      } else if (!nn[Z] && !It(K, Yi(ue, de, "")) && !((Z === "src" || Z === "xlink:href" || Z === "href") && x !== "script" && Zx(ue, "data:") === 0 && he[x]) && !(on && !It(fe, Yi(ue, de, ""))) && ue)
        return !1;
    }
    return !0;
  }, w = Dn({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), S = function(x) {
    return !w[go(x)] && It(ge, x);
  }, ne = function(x) {
    y(G.beforeSanitizeAttributes, x, null);
    const {
      attributes: Z
    } = x;
    if (!Z || c(x))
      return;
    const ue = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: Y,
      forceKeepAttr: void 0
    };
    let _e = Z.length;
    for (; _e--; ) {
      const te = Z[_e], {
        name: Ke,
        namespaceURI: Tn,
        value: $n
      } = te, zt = kn(Ke), si = $n;
      let Nt = Ke === "value" ? si : gB(si);
      if (ue.attrName = zt, ue.attrValue = Nt, ue.keepAttr = !0, ue.forceKeepAttr = void 0, y(G.uponSanitizeAttribute, x, ue), Nt = ue.attrValue, _ && (zt === "id" || zt === "name") && Zx(Nt, O) !== 0 && (Rn(Ke, x), Nt = O + Nt), Xe && It(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, Nt)) {
        Rn(Ke, x);
        continue;
      }
      if (zt === "attributename" && Xx(Nt, "href")) {
        Rn(Ke, x);
        continue;
      }
      if (ue.forceKeepAttr)
        continue;
      if (!ue.keepAttr) {
        Rn(Ke, x);
        continue;
      }
      if (!Ee && It(/\/>/i, Nt)) {
        Rn(Ke, x);
        continue;
      }
      Qe && Xa([q, R, B], (QF) => {
        Nt = Yi(Nt, QF, " ");
      });
      const Kg = kn(x.nodeName);
      if (!P(Kg, zt, Nt)) {
        Rn(Ke, x);
        continue;
      }
      if (T && typeof v == "object" && typeof v.getAttributeType == "function" && !Tn)
        switch (v.getAttributeType(Kg, zt)) {
          case "TrustedHTML": {
            Nt = T.createHTML(Nt);
            break;
          }
          case "TrustedScriptURL": {
            Nt = T.createScriptURL(Nt);
            break;
          }
        }
      if (Nt !== si)
        try {
          Tn ? x.setAttributeNS(Tn, Ke, Nt) : x.setAttribute(Ke, Nt), c(x) ? On(x) : Jx(n.removed);
        } catch {
          Rn(Ke, x);
        }
    }
    y(G.afterSanitizeAttributes, x, null);
  }, H = function(x) {
    let Z = null;
    const ue = t(x);
    for (y(G.beforeSanitizeShadowDOM, x, null); Z = ue.nextNode(); )
      y(G.uponSanitizeShadowNode, Z, null), $(Z), ne(Z), Z.content instanceof o && H(Z.content);
    y(G.afterSanitizeShadowDOM, x, null);
  };
  return n.sanitize = function(x) {
    let Z = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ue = null, _e = null, te = null, Ke = null;
    if (_n = !x, _n && (x = "<!-->"), typeof x != "string" && !m(x) && (x = xB(x), typeof x != "string"))
      throw hs("dirty is not a string, aborting");
    if (!n.isSupported)
      return x;
    if (ye || An(Z), n.removed = [], typeof x == "string" && (J = !1), J) {
      const zt = x.nodeName;
      if (typeof zt == "string") {
        const si = kn(zt);
        if (!xe[si] || Le[si])
          throw hs("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (x instanceof l)
      ue = Un("<!---->"), _e = ue.ownerDocument.importNode(x, !0), _e.nodeType === no.element && _e.nodeName === "BODY" || _e.nodeName === "HTML" ? ue = _e : ue.appendChild(_e);
    else {
      if (!Ve && !Qe && !se && // eslint-disable-next-line unicorn/prefer-includes
      x.indexOf("<") === -1)
        return T && dn ? T.createHTML(x) : x;
      if (ue = Un(x), !ue)
        return Ve ? null : dn ? I : "";
    }
    ue && je && On(ue.firstChild);
    const Tn = t(J ? x : ue);
    for (; te = Tn.nextNode(); )
      $(te), ne(te), te.content instanceof o && H(te.content);
    if (J)
      return x;
    if (Ve) {
      if (Qe) {
        ue.normalize();
        let zt = ue.innerHTML;
        Xa([q, R, B], (si) => {
          zt = Yi(zt, si, " ");
        }), ue.innerHTML = zt;
      }
      if (Oe)
        for (Ke = Q.call(ue.ownerDocument); ue.firstChild; )
          Ke.appendChild(ue.firstChild);
      else
        Ke = ue;
      return (Y.shadowroot || Y.shadowrootmode) && (Ke = re.call(i, Ke, !0)), Ke;
    }
    let $n = se ? ue.outerHTML : ue.innerHTML;
    return se && xe["!doctype"] && ue.ownerDocument && ue.ownerDocument.doctype && ue.ownerDocument.doctype.name && It(PC, ue.ownerDocument.doctype.name) && ($n = "<!DOCTYPE " + ue.ownerDocument.doctype.name + `>
` + $n), Qe && Xa([q, R, B], (zt) => {
      $n = Yi($n, zt, " ");
    }), T && dn ? T.createHTML($n) : $n;
  }, n.setConfig = function() {
    let x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    An(x), ye = !0;
  }, n.clearConfig = function() {
    gn = null, ye = !1;
  }, n.isValidAttribute = function(x, Z, ue) {
    gn || An({});
    const _e = kn(x), te = kn(Z);
    return P(_e, te, ue);
  }, n.addHook = function(x, Z) {
    typeof Z == "function" && Za(G[x], Z);
  }, n.removeHook = function(x, Z) {
    if (Z !== void 0) {
      const ue = hB(G[x], Z);
      return ue === -1 ? void 0 : yB(G[x], ue, 1)[0];
    }
    return Jx(G[x]);
  }, n.removeHooks = function(x) {
    G[x] = [];
  }, n.removeAllHooks = function() {
    G = sS();
  }, n;
}
var PB = AC();
const AB = "_messageContainer_1rxr4_1", LB = "_chip_1rxr4_7", VB = "_chipLabel_1rxr4_10", zB = "_chipValue_1rxr4_13", gs = {
  messageContainer: AB,
  chip: LB,
  chipLabel: VB,
  chipValue: zB
}, lS = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, UB = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  Ye(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: u,
      email: p,
      phone_number: d
    } = i.customer;
    return s ?? l ?? u ?? p ?? d ?? o;
  };
  return /* @__PURE__ */ un.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ un.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ un.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ un.jsx(Ge, { content: "Conversation Attributes", children: /* @__PURE__ */ un.jsx(
        py,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ un.jsx(b, { alignItems: "center", children: /* @__PURE__ */ un.jsx(qn, { className: gs.chip, children: /* @__PURE__ */ un.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ un.jsxs(tt, { className: gs.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ un.jsx(tt, { className: gs.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ un.jsx(
      b,
      {
        className: gs.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? lS[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? lS[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ un.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ un.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ un.jsx(A.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ un.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ un.jsx(wI, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ un.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: PB.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ un.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ un.jsx(
      CI,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ un.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, MB = "_conversation_1draa_1", BB = "_conversationSubLine_1draa_9", qB = "_modal_1draa_14", bm = {
  conversation: MB,
  conversationSubLine: BB,
  modal: qB
}, HB = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), WB = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), KB = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = le(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ un.jsxs(b, { className: bm.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ un.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ un.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ un.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ un.jsx(A.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ un.jsx(Vn, { size: "small", variant: "info", children: Hn(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ un.jsx(
          A.Heading,
          {
            variant: "heading-4",
            className: bm.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ un.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ un.jsx(qn, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ un.jsx(Ge, { content: "Show conversation preview", children: /* @__PURE__ */ un.jsx(
        ir,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ un.jsxs(
      jt,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: bm.modal,
        children: [
          /* @__PURE__ */ un.jsx(
            wt,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ un.jsx(Ct, { children: /* @__PURE__ */ un.jsx(
            UB,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: HB(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: WB(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, GB = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = le(!1), o = r > 0 ? r : 1, s = e?.length > o, l = Kn(
    () => e?.sort((u, p) => p?.created_at.localeCompare(u?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ un.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((u, p) => /* @__PURE__ */ un.jsx(
      KB,
      {
        conversation: u,
        conversationContext: n
      },
      `${p}-${u?.id}`
    )),
    s && /* @__PURE__ */ un.jsxs(
      Yn,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, YB = dB(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), QB = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = le([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((d) => !!d).map((d) => `'${d}'`).join(","), { useQuery: s } = yn(), { data: l, loading: u, error: p } = s(YB, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return Ye(() => {
    if (l?.Miuros) {
      const d = l?.Miuros?.findTickets?.data;
      d && i(d);
    }
  }, [l]), p ? /* @__PURE__ */ un.jsx(In, { error: p }) : u ? /* @__PURE__ */ un.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ un.jsx(fn, {}) }) : r?.length === 0 ? /* @__PURE__ */ un.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ un.jsx(
    GB,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, Jh = [
  {
    key: "miurosClientId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "miurosClientSecret",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "amountOfConversationsToShow",
    type: "string",
    secret: !1,
    defaultValue: "1"
  }
], _m = "MIUROS", JB = {
  enabled: !1,
  name: "",
  miurosClientId: "",
  miurosClientSecret: "",
  amountOfConversationsToShow: "1"
}, XB = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = gt({
    mode: "onChange",
    defaultValues: JB
  }), {
    create: u,
    update: p,
    remove: d,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: F
  } = Xr({
    integrationId: e,
    integrationType: _m,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: C,
    refetch: g,
    widgetConfiguration: z
  } = Zr({
    integrationId: e,
    fieldDefinitions: Jh,
    form: l,
    onMisconfigured: F
  }), { renderConditions: T, setRenderConditions: I, renderConditionsForSubmit: D } = ei({
    integrationId: e,
    widgetConfiguration: z,
    renderConditionsEditor: o
  }), U = (X) => ti(X, {
    fieldDefinitions: Jh,
    isCreationMode: s,
    create: u,
    update: p,
    renderConditions: D
  }), Q = l.watch("name");
  return /* @__PURE__ */ un.jsxs(
    ni,
    {
      form: l,
      integrationId: e,
      onValidSubmit: U,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: C,
      children: [
        v && /* @__PURE__ */ un.jsx(ri, { cause: v }),
        /* @__PURE__ */ un.jsxs(at, { children: [
          /* @__PURE__ */ un.jsx(me, { children: /* @__PURE__ */ un.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ un.jsx(
            Pn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ un.jsx(me, { span: 3, children: /* @__PURE__ */ un.jsx(
            Qn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ un.jsx(me, { span: 3 }),
          /* @__PURE__ */ un.jsx(me, { span: 3, children: /* @__PURE__ */ un.jsx(
            Qn,
            {
              name: "miurosClientId",
              label: "Authorization: Client ID",
              control: l.control,
              rules: { required: "Client ID is required" },
              componentProps: {
                placeholder: "Insert client ID",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ un.jsx(me, { span: 3 }),
          /* @__PURE__ */ un.jsx(me, { span: 3, children: /* @__PURE__ */ un.jsx(
            Ro,
            {
              name: "miurosClientSecret",
              label: "Authorization: Client secret",
              control: l.control,
              isCreationMode: s,
              rules: { required: "Client secret is required" },
              componentProps: {
                placeholder: "Insert client secret",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ un.jsx(me, { span: 3 }),
          /* @__PURE__ */ un.jsx(me, { span: 3, children: /* @__PURE__ */ un.jsx(
            Qn,
            {
              name: "amountOfConversationsToShow",
              label: "Number of conversation to show before the fold",
              control: l.control,
              rules: {
                required: "Please enter a number",
                validate: (X) => !Number.isNaN(Number.parseInt(X, 10)) || "Please enter a number"
              },
              componentProps: {
                placeholder: "Enter number",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ un.jsx(me, { span: 3 }),
          !s && e && /* @__PURE__ */ un.jsx(
            ga,
            {
              configuration: n,
              integrationId: e,
              integrationType: _m,
              label: "Authorize"
            }
          ),
          o && T !== null && /* @__PURE__ */ un.jsx(me, { children: o({
            value: T,
            onChange: I,
            configurationKey: z?.id
          }) })
        ] }),
        /* @__PURE__ */ un.jsx(
          ii,
          {
            integrationType: _m,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => d()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var xm = { exports: {} }, to = {}, cS;
function ZB() {
  if (cS) return to;
  cS = 1;
  var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return to.Fragment = r, to.jsx = s, to.jsxs = s, to;
}
var vs = {}, uS;
function e5() {
  return uS || (uS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[N];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        z("error", t, m);
      }
    }
    function z(t, c, m) {
      {
        var y = C.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var P = m.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var T = !1, I = !1, D = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || U || t === v || T || I || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function q(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return q(c) + ".Consumer";
          case s:
            var m = t;
            return q(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return R(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, be, fe, de, ge, K, xe, $e;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          be = console.log, fe = console.info, de = console.warn, ge = console.error, K = console.group, xe = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: be
            }),
            info: B({}, t, {
              value: fe
            }),
            warn: B({}, t, {
              value: de
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: K
            }),
            groupCollapsed: B({}, t, {
              value: xe
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = C.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var ze = !1, Re;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new on();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var m = Re.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      ze = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Le.current, Le.current = null, qe();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var S = te.stack.split(`
`), ne = y.stack.split(`
`), H = S.length - 1, x = ne.length - 1; H >= 1 && x >= 0 && S[H] !== ne[x]; )
            x--;
          for (; H >= 1 && x >= 0; H--, x--)
            if (S[H] !== ne[x]) {
              if (H !== 1 || x !== 1)
                do
                  if (H--, x--, x < 0 || S[H] !== ne[x]) {
                    var Z = `
` + S[H].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (H >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Le.current = P, Me(), Error.prepareStackTrace = $;
      }
      var ue = t ? t.displayName || t.name : "", _e = ue ? De(ue) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Qe(t, c, m) {
      return Ee(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Xe(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case d:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Qe(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return se(P($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, je = {}, Ve = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function dn(t, c, m, y, $) {
      {
        var P = Function.call.bind(ye);
        for (var w in t)
          if (P(t, w)) {
            var S = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + m + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[w](c, w, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              S = H;
            }
            S && !(S instanceof Error) && (Oe($), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, w, typeof S), Oe(null)), S instanceof Error && !(S.message in je) && (je[S.message] = !0, Oe($), g("Failed %s type: %s", m, S.message), Oe(null));
          }
      }
    }
    var E = Array.isArray;
    function _(t) {
      return E(t);
    }
    function O(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function W(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function L(t) {
      if (W(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", O(t)), J(t);
    }
    var M = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Ze(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function sn(t, c) {
      {
        var m = function() {
          he || (he = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function hn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, m, y, $, P, w) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function _n(t, c, m, y, $) {
      {
        var P, w = {}, S = null, ne = null;
        m !== void 0 && (L(m), S = "" + m), mn(c) && (L(c.key), S = "" + c.key), nn(c) && (ne = c.ref, Ze(c));
        for (P in c)
          ye.call(c, P) && !ie.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var H = t.defaultProps;
          for (P in H)
            w[P] === void 0 && (w[P] = H[P]);
        }
        if (S || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && sn(w, x), ne && hn(w, x);
        }
        return pn(t, S, ne, $, y, M.current, w);
      }
    }
    var Je = C.ReactCurrentOwner, Nn = C.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(m);
      } else
        Nn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (Je.current) {
          var t = R(Je.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Mn(t) {
      return "";
    }
    var jn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = kn(c);
        if (jn[m])
          return;
        jn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Je.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ae(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ae(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            cn(y) && gn(y, c);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              cn(w.value) && gn(w.value, c);
        }
      }
    }
    function zn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = R(c);
          dn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var $ = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function An(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ae(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var xn = {};
    function Sn(t, c, m, y, $, P) {
      {
        var w = re(t);
        if (!w) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = Mn();
          ne ? S += ne : S += vn();
          var H;
          t === null ? H = "null" : _(t) ? H = "array" : t !== void 0 && t.$$typeof === n ? (H = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : H = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, S);
        }
        var x = _n(t, c, m, $, P);
        if (x == null)
          return x;
        if (w) {
          var Z = c.children;
          if (Z !== void 0)
            if (y)
              if (_(Z)) {
                for (var ue = 0; ue < Z.length; ue++)
                  wn(Z[ue], t);
                Object.freeze && Object.freeze(Z);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = R(t), te = Object.keys(c).filter(function($n) {
            return $n !== "key";
          }), Ke = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? An(x) : zn(x), x;
      }
    }
    function Bn(t, c, m) {
      return Sn(t, c, m, !0);
    }
    function On(t, c, m) {
      return Sn(t, c, m, !1);
    }
    var Rn = On, Un = Bn;
    vs.Fragment = i, vs.jsx = Rn, vs.jsxs = Un;
  })()), vs;
}
var dS;
function n5() {
  return dS || (dS = 1, process.env.NODE_ENV === "production" ? xm.exports = ZB() : xm.exports = e5()), xm.exports;
}
var Ce = n5();
const t5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, r5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, i5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, a5 = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": t5,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": r5,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": i5
};
function mg(e) {
  return a5[e] ?? {};
}
const o5 = mg(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), s5 = mg(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), l5 = mg(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function Xh(e = !1, n) {
  const [r, i] = le(e);
  return Ye(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const c5 = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, LC = "DD MMM YYYY @ HH:mm", u5 = "_list_2c4dq_1", d5 = "_listItem_2c4dq_4", m5 = "_copyIcon_2c4dq_12", Ti = {
  list: u5,
  listItem: d5,
  copyIcon: m5
}, Zh = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = Xh(), l = 14, {
    first_name: u,
    last_name: p,
    address1: d,
    address2: f,
    city: h,
    zip: v,
    country_code: F
  } = e ?? {}, N = `${u} ${p}`.trim() || void 0, j = `${h} ${v}`.trim() || void 0, C = [N, d, f, j, F].filter(
    Boolean
  );
  return /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Ce.jsx(pe, { size: l, name: n }),
      i ? /* @__PURE__ */ Ce.jsx(fn, { size: l }) : /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: C.map((g, z) => /* @__PURE__ */ Ce.jsx(tt, { children: g }, z)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Ce.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ Ce.jsx(Ge, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Ce.jsx(
        pe,
        {
          size: l,
          name: "exclamation",
          className: Ti.copyIcon
        }
      ) }),
      /* @__PURE__ */ Ce.jsx(Ge, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ Ce.jsx(
        pe,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(C.join(", ")),
          className: Ti.copyIcon
        }
      ) })
    ] })
  ] });
}, p5 = "_wrapper_1nher_1", f5 = {
  wrapper: p5
}, h5 = ({
  customer: e,
  store: n
}) => {
  const { track: r } = Cn(), { isCopied: i, copy: a } = Xh(), { isCopied: o, copy: s } = Xh(), { useQuery: l } = yn(), u = e?.id, {
    loading: p,
    error: d,
    data: f
  } = l(s5, {
    skip: !u,
    variables: {
      customerId: u?.toString()
    }
  }), h = f?.Recharge?.getAddresses, v = !p && h?.addresses?.[0] ? h.addresses[0] : void 0, F = (h?.addresses?.length ?? 0) > 1;
  if (Ye(() => {
    v && r("recharge:profile:received");
  }, [v, r]), d)
    return /* @__PURE__ */ Ce.jsx(In, { error: d });
  if (!e)
    return null;
  const {
    id: N,
    phone: j,
    email: C,
    first_name: g,
    last_name: z,
    created_at: T,
    has_valid_payment_method: I
  } = e, D = 14, U = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${N}` : null, Q = `${g || ""} ${z || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ce.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ce.jsxs(b, { className: f5.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-2", children: Q }),
    T && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: Hn(T).format(LC) })
    ] }),
    C && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(pe, { size: D, name: "mail" }),
        /* @__PURE__ */ Ce.jsx(A.ExternalLink, { href: `mailto:${C}`, children: C })
      ] }),
      /* @__PURE__ */ Ce.jsx(Ge, { content: "Copy email", children: /* @__PURE__ */ Ce.jsx(
        pe,
        {
          size: D,
          name: i ? "done" : "copy",
          onClick: () => a(C),
          className: Ti.copyIcon
        }
      ) })
    ] }),
    j && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(pe, { size: D, name: "phone" }),
        /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: j })
      ] }),
      /* @__PURE__ */ Ce.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ Ce.jsx(
        pe,
        {
          size: D,
          name: o ? "done" : "copy",
          onClick: () => s(j),
          className: Ti.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Ce.jsx(
      Zh,
      {
        address: v,
        icon: "home",
        isLoading: p,
        hasMultipleAddresses: F
      }
    ),
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(pe, { size: D, name: "credit-card" }),
        /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Ce.jsx(
        pe,
        {
          size: D,
          name: I ? "check-circle" : "close-circle-filled",
          color: I ? "green.500" : "red.500"
        }
      )
    ] }),
    U && /* @__PURE__ */ Ce.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Ce.jsx(pe, { size: D, name: "external-link" }),
      /* @__PURE__ */ Ce.jsx(
        A.ExternalLink,
        {
          href: U,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, y5 = "_order_1dlaa_1", g5 = "_orderIsOpen_1dlaa_9", v5 = "_orderHeader_1dlaa_12", k5 = "_note_1dlaa_16", ks = {
  order: y5,
  orderIsOpen: g5,
  orderHeader: v5,
  note: k5
}, b5 = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = Cn(), [a, o] = le(n), {
    id: s,
    status: l,
    charge: u,
    currency: p,
    note: d,
    created_at: f,
    billing_address: h,
    shipping_address: v,
    total_price: F,
    is_prepaid: N
  } = e, j = 14, C = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, g = u?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Ce.jsxs(
    b,
    {
      className: it(ks.order, {
        [ks.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Ce.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ks.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: Hn(f).format(LC) }) }),
                /* @__PURE__ */ Ce.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Ce.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          d && /* @__PURE__ */ Ce.jsx(Ge, { content: "Note", children: /* @__PURE__ */ Ce.jsx(
            A.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: ks.note,
              children: d
            }
          ) }),
          l && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(pe, { size: j, name: "activity" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: c5(l) })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(pe, { size: j, name: "credit-card" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: N ? "Yes" : "No" })
            ] })
          ] }),
          g && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(pe, { size: j, name: "cog" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: g })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(pe, { size: j, name: "chart-bar" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Ce.jsxs(A.Paragraph, { variant: "4", children: [
                F,
                " ",
                p
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsx(
            Zh,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Ce.jsx(
            Zh,
            {
              address: v,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          C && /* @__PURE__ */ Ce.jsx(
            Rt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(C, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Ce.jsx(pe, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, _5 = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = Cn(), { useQuery: i } = yn(), {
    loading: a,
    error: o,
    data: s
  } = i(l5, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, u = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ Ce.jsx(In, { error: o });
  const p = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ Ce.jsx(Vn, { variant: "success", size: "small", children: u.length })
    ] }),
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ce.jsx(fn, {}) }),
      !a && u.length === 0 && /* @__PURE__ */ Ce.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Ce.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && u.length > 0 && /* @__PURE__ */ Ce.jsx(b, { gap: "200", flexDirection: "column", children: u.map((d, f) => /* @__PURE__ */ Ce.jsx(
        b5,
        {
          order: d,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${d.id}`
      )) }),
      p && /* @__PURE__ */ Ce.jsx(
        Rt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(p, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Ce.jsx(pe, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, x5 = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Ce.jsxs(We, { className: Ti.list, children: [
      /* @__PURE__ */ Ce.jsx(We.Text, { variant: "dense", className: Ti.listItem, children: /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Ce.jsx(We.Text, { variant: "dense", className: Ti.listItem, children: /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, S5 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = yn(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: u,
    error: p,
    data: d
  } = r(o5, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !u && d ? d?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !u && d ? d?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (p) {
    const v = p.graphQLErrors;
    return kl({ errors: v }) ? /* @__PURE__ */ Ce.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : bl({ errors: v }) ? /* @__PURE__ */ Ce.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Ce.jsx(In, { error: p });
  }
  return u ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ce.jsx(fn, {}) }) : f ? l ? /* @__PURE__ */ Ce.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Ce.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ Ce.jsx(h5, { customer: f, store: h }),
        o && /* @__PURE__ */ Ce.jsx(x5, { customer: f }),
        s && /* @__PURE__ */ Ce.jsx(_5, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ Ce.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, ey = [
  {
    key: "rechargeAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], N5 = {
  enabled: !1,
  name: "",
  rechargeAccessToken: "",
  displayCustomerDetails: !0,
  displaysubscriptionOverview: !0,
  displayOrders: !0
}, j5 = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = gt({
    mode: "onChange",
    defaultValues: N5
  }), {
    create: l,
    update: u,
    remove: p,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = Xr({
    integrationId: e,
    integrationType: "RECHARGE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: N,
    isWidgetUnknown: j,
    refetch: C,
    widgetConfiguration: g
  } = Zr({
    integrationId: e,
    fieldDefinitions: ey,
    form: s,
    onMisconfigured: v
  }), { renderConditions: z, setRenderConditions: T, renderConditionsForSubmit: I } = ei({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), D = (Q) => ti(Q, {
    fieldDefinitions: ey,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: I
  }), U = s.watch("name");
  return /* @__PURE__ */ Ce.jsxs(
    ni,
    {
      form: s,
      integrationId: e,
      onValidSubmit: D,
      error: N ?? f,
      onRetry: N ? C : void 0,
      isLoading: d || F,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ Ce.jsx(ri, { cause: h }),
        /* @__PURE__ */ Ce.jsxs(at, { children: [
          /* @__PURE__ */ Ce.jsx(me, { children: /* @__PURE__ */ Ce.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ce.jsx(
            Pn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(me, { span: 3, children: /* @__PURE__ */ Ce.jsx(
            Qn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(me, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(me, { span: 3, children: /* @__PURE__ */ Ce.jsx(
            Ro,
            {
              name: "rechargeAccessToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "Insert the Admin API token for Recharge",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(me, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(me, { span: 3, children: /* @__PURE__ */ Ce.jsx(en, { label: "Displays details of a customer", children: /* @__PURE__ */ Ce.jsx(
            Pn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(me, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(me, { span: 3, children: /* @__PURE__ */ Ce.jsx(en, { label: "Displays the subscription overview", children: /* @__PURE__ */ Ce.jsx(
            Pn,
            {
              name: "displaysubscriptionOverview",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(me, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(me, { span: 3, children: /* @__PURE__ */ Ce.jsx(en, { label: "Displays the last 5 orders", children: /* @__PURE__ */ Ce.jsx(
            Pn,
            {
              name: "displayOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(me, { span: 3 }),
          a && z !== null && /* @__PURE__ */ Ce.jsx(me, { children: a({
            value: z,
            onChange: T,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ Ce.jsx(
          ii,
          {
            integrationType: "RECHARGE",
            integrationId: e,
            widgetName: U,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_1lmjg_48{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1lmjg_53{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1lmjg_61{text-align:center}._inputSeparator_1lmjg_65{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1lmjg_70{color:var(--dixa-typography-color-link)}._noIssuesFound_1lmjg_74{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._list_1lmjg_79{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1lmjg_89{background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_1lmjg_89:last-child{box-shadow:none}._listItemHighlighted_1lmjg_97{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._listItemEdit_1lmjg_100{cursor:pointer}._fullWidth_1lmjg_104{width:100%}._boxWrapper_1lmjg_108{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._clickableIcon_1lmjg_114{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._list_rxh85_1{padding:0;overflow-y:auto;max-height:230px}._listItem_rxh85_6{cursor:pointer;font-size:var(--dixa-typography-size-100);background-color:transparent;padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_rxh85_6:last-child{box-shadow:none}._listItemHighlighted_rxh85_16{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._modalBody_1clhs_1{width:400px}._reward_1gmba_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1gmba_1:hover{border-color:var(--dixa-color-neutral-400)}._clickable_1gmba_10{cursor:pointer}._voucherCode_1gmba_14{font-family:monospace}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Sm = { exports: {} }, ro = {}, mS;
function w5() {
  if (mS) return ro;
  mS = 1;
  var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ro.Fragment = r, ro.jsx = s, ro.jsxs = s, ro;
}
var bs = {}, pS;
function C5() {
  return pS || (pS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[N];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        z("error", t, m);
      }
    }
    function z(t, c, m) {
      {
        var y = C.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var P = m.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var T = !1, I = !1, D = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || U || t === v || T || I || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function q(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return q(c) + ".Consumer";
          case s:
            var m = t;
            return q(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return R(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, be, fe, de, ge, K, xe, $e;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          be = console.log, fe = console.info, de = console.warn, ge = console.error, K = console.group, xe = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: be
            }),
            info: B({}, t, {
              value: fe
            }),
            warn: B({}, t, {
              value: de
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: K
            }),
            groupCollapsed: B({}, t, {
              value: xe
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = C.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var ze = !1, Re;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new on();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var m = Re.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      ze = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Le.current, Le.current = null, qe();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var S = te.stack.split(`
`), ne = y.stack.split(`
`), H = S.length - 1, x = ne.length - 1; H >= 1 && x >= 0 && S[H] !== ne[x]; )
            x--;
          for (; H >= 1 && x >= 0; H--, x--)
            if (S[H] !== ne[x]) {
              if (H !== 1 || x !== 1)
                do
                  if (H--, x--, x < 0 || S[H] !== ne[x]) {
                    var Z = `
` + S[H].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (H >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Le.current = P, Me(), Error.prepareStackTrace = $;
      }
      var ue = t ? t.displayName || t.name : "", _e = ue ? De(ue) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Qe(t, c, m) {
      return Ee(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Xe(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case d:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Qe(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return se(P($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, je = {}, Ve = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function dn(t, c, m, y, $) {
      {
        var P = Function.call.bind(ye);
        for (var w in t)
          if (P(t, w)) {
            var S = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + m + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[w](c, w, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              S = H;
            }
            S && !(S instanceof Error) && (Oe($), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, w, typeof S), Oe(null)), S instanceof Error && !(S.message in je) && (je[S.message] = !0, Oe($), g("Failed %s type: %s", m, S.message), Oe(null));
          }
      }
    }
    var E = Array.isArray;
    function _(t) {
      return E(t);
    }
    function O(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function W(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function L(t) {
      if (W(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", O(t)), J(t);
    }
    var M = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Ze(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function sn(t, c) {
      {
        var m = function() {
          he || (he = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function hn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, m, y, $, P, w) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function _n(t, c, m, y, $) {
      {
        var P, w = {}, S = null, ne = null;
        m !== void 0 && (L(m), S = "" + m), mn(c) && (L(c.key), S = "" + c.key), nn(c) && (ne = c.ref, Ze(c));
        for (P in c)
          ye.call(c, P) && !ie.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var H = t.defaultProps;
          for (P in H)
            w[P] === void 0 && (w[P] = H[P]);
        }
        if (S || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && sn(w, x), ne && hn(w, x);
        }
        return pn(t, S, ne, $, y, M.current, w);
      }
    }
    var Je = C.ReactCurrentOwner, Nn = C.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(m);
      } else
        Nn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (Je.current) {
          var t = R(Je.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Mn(t) {
      return "";
    }
    var jn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = kn(c);
        if (jn[m])
          return;
        jn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Je.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ae(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ae(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            cn(y) && gn(y, c);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              cn(w.value) && gn(w.value, c);
        }
      }
    }
    function zn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = R(c);
          dn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var $ = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function An(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ae(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var xn = {};
    function Sn(t, c, m, y, $, P) {
      {
        var w = re(t);
        if (!w) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = Mn();
          ne ? S += ne : S += vn();
          var H;
          t === null ? H = "null" : _(t) ? H = "array" : t !== void 0 && t.$$typeof === n ? (H = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : H = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, S);
        }
        var x = _n(t, c, m, $, P);
        if (x == null)
          return x;
        if (w) {
          var Z = c.children;
          if (Z !== void 0)
            if (y)
              if (_(Z)) {
                for (var ue = 0; ue < Z.length; ue++)
                  wn(Z[ue], t);
                Object.freeze && Object.freeze(Z);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = R(t), te = Object.keys(c).filter(function($n) {
            return $n !== "key";
          }), Ke = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? An(x) : zn(x), x;
      }
    }
    function Bn(t, c, m) {
      return Sn(t, c, m, !0);
    }
    function On(t, c, m) {
      return Sn(t, c, m, !1);
    }
    var Rn = On, Un = Bn;
    bs.Fragment = i, bs.jsx = Rn, bs.jsxs = Un;
  })()), bs;
}
var fS;
function F5() {
  return fS || (fS = 1, process.env.NODE_ENV === "production" ? Sm.exports = w5() : Sm.exports = C5()), Sm.exports;
}
var ve = F5(), VC = /* @__PURE__ */ ((e) => (e.CustomAction = "custom_action", e.FacebookLike = "facebook_like", e.FacebookShare = "facebook_share", e.InstagramFollow = "instagram_follow", e.Manual = "manual", e.ReferralComplete = "referral_complete", e.TiktokFollow = "tiktok_follow", e.TwitterFollow = "twitter_follow", e.TwitterShare = "twitter_share", e.VisitUrl = "visit_url", e))(VC || {}), da = /* @__PURE__ */ ((e) => (e.Excluded = "excluded", e.Guest = "guest", e.Member = "member", e))(da || {});
const I5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "adjustCustomerPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "RivoLoyalty_adjust_customer_points_request_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "adjust_customer_points" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, $5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "return_customer" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_identifier" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "StringValue", value: "lifetime_earnings_tally,next_vip_tier", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "accepts_marketing" } }, { kind: "Field", name: { kind: "Name", value: "orders_count" } }, { kind: "Field", name: { kind: "Name", value: "verified_email" } }, { kind: "Field", name: { kind: "Name", value: "total_spent" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_status" } }, { kind: "Field", name: { kind: "Name", value: "points_tally" } }, { kind: "Field", name: { kind: "Name", value: "credits_tally" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }] } }, { kind: "Field", name: { kind: "Name", value: "points_expire_at" } }, { kind: "Field", name: { kind: "Name", value: "next_vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }, { kind: "Field", name: { kind: "Name", value: "to_spend_or_earn" } }] } }, { kind: "Field", name: { kind: "Name", value: "lifetime_earnings_tally" } }] } }] } }] } }] } }] } }] }, E5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFavoriteProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_customer_favorite_products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "data_source" }, value: { kind: "EnumValue", value: "shopify" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "product_id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "handle" } }] } }] } }] } }] } }] }, T5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPointsRedemptions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_points_redemptions" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "used_at" } }, { kind: "Field", name: { kind: "Name", value: "refunded_at" } }, { kind: "Field", name: { kind: "Name", value: "revoked_at" } }] } }] } }] } }] } }] } }] }, D5 = {
  "\n  mutation adjustCustomerPoints(\n    $input: RivoLoyalty_adjust_customer_points_request_Input\n  ) {\n    RivoLoyalty {\n      adjust_customer_points(input: $input)\n    }\n  }\n": I5,
  '\n  query getCustomer($email: String!) {\n    RivoLoyalty {\n      return_customer(\n        customer_identifier: $email\n        fields: "lifetime_earnings_tally,next_vip_tier"\n      ) {\n        data {\n          attributes {\n            id\n            email\n            first_name\n            last_name\n            accepts_marketing\n            orders_count\n            verified_email\n            total_spent\n            loyalty_status\n            points_tally\n            credits_tally\n            vip_tier {\n              name\n              threshold\n            }\n            points_expire_at\n            next_vip_tier {\n              name\n              threshold\n              to_spend_or_earn\n            }\n            lifetime_earnings_tally\n          }\n        }\n      }\n    }\n  }\n': $5,
  "\n  query getFavoriteProducts($customerId: String!) {\n    RivoLoyalty {\n      list_customer_favorite_products(\n        customer_id: $customerId\n        data_source: shopify\n      ) {\n        data {\n          product_id\n          title\n          handle\n        }\n      }\n    }\n  }\n": E5,
  "\n  query getPointsRedemptions($customerId: String!) {\n    RivoLoyalty {\n      list_points_redemptions(\n        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId\n      ) {\n        data {\n          id\n          attributes {\n            points_amount\n            name\n            code\n            expires_at\n            used_at\n            refunded_at\n            revoked_at\n          }\n        }\n      }\n    }\n  }\n": T5
};
function Ml(e) {
  return D5[e] ?? {};
}
const O5 = Ml(
  /* GraphQL */
  `
  query getCustomer($email: String!) {
    RivoLoyalty {
      return_customer(
        customer_identifier: $email
        fields: "lifetime_earnings_tally,next_vip_tier"
      ) {
        data {
          attributes {
            id
            email
            first_name
            last_name
            accepts_marketing
            orders_count
            verified_email
            total_spent
            loyalty_status
            points_tally
            credits_tally
            vip_tier {
              name
              threshold
            }
            points_expire_at
            next_vip_tier {
              name
              threshold
              to_spend_or_earn
            }
            lifetime_earnings_tally
          }
        }
      }
    }
  }
`
), R5 = Ml(
  /* GraphQL */
  `
  query getFavoriteProducts($customerId: String!) {
    RivoLoyalty {
      list_customer_favorite_products(
        customer_id: $customerId
        data_source: shopify
      ) {
        data {
          product_id
          title
          handle
        }
      }
    }
  }
`
), P5 = Ml(
  /* GraphQL */
  `
  query getPointsRedemptions($customerId: String!) {
    RivoLoyalty {
      list_points_redemptions(
        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId
      ) {
        data {
          id
          attributes {
            points_amount
            name
            code
            expires_at
            used_at
            refunded_at
            revoked_at
          }
        }
      }
    }
  }
`
), A5 = Ml(
  /* GraphQL */
  `
  mutation adjustCustomerPoints(
    $input: RivoLoyalty_adjust_customer_points_request_Input
  ) {
    RivoLoyalty {
      adjust_customer_points(input: $input)
    }
  }
`
), L5 = "_list_1lmjg_79", V5 = "_listItem_1lmjg_89", z5 = "_listItemHighlighted_1lmjg_97", U5 = "_listItemEdit_1lmjg_100", M5 = "_clickableIcon_1lmjg_114", xr = {
  list: L5,
  listItem: V5,
  listItemHighlighted: z5,
  listItemEdit: U5,
  clickableIcon: M5
}, pg = "rivoLoyaltyShopifyApiHostName", zC = "https://admin.shopify.com";
function UC(e) {
  return e.split(".")[0];
}
const B5 = "_wrapper_1xucg_1", hS = {
  wrapper: B5
}, q5 = ({
  customerDetails: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { track: r } = Cn(), { isCopied: i, copy: a } = Gt(), { attributes: o } = e, {
    first_name: s,
    last_name: l,
    email: u,
    verified_email: p
  } = o, d = 14, f = `${s || ""} ${l || ""}`.trim() || "No name found for customer";
  return /* @__PURE__ */ ve.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ve.jsxs(b, { className: hS.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ve.jsx(
      b,
      {
        justifyContent: "space-between",
        className: hS.block,
        alignItems: "center",
        children: /* @__PURE__ */ ve.jsx(A.Heading, { variant: "heading-2", children: f })
      }
    ),
    u && /* @__PURE__ */ ve.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ ve.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ ve.jsx(pe, { size: d, name: "mail" }),
        /* @__PURE__ */ ve.jsx(A.ExternalLink, { href: `mailto:${u}`, children: u }),
        /* @__PURE__ */ ve.jsx(
          Ge,
          {
            content: p ? "Verified email" : "Email is not verified",
            children: /* @__PURE__ */ ve.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ve.jsx(
              pe,
              {
                size: d,
                color: p ? "green.500" : "red.500",
                name: p ? "check-circle" : "exclamation"
              }
            ) })
          }
        )
      ] }),
      /* @__PURE__ */ ve.jsx(Ge, { content: "Copy Email", children: /* @__PURE__ */ ve.jsx(
        pe,
        {
          size: d,
          name: i ? "done" : "copy",
          onClick: () => a(u),
          className: xr.clickableIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ ve.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ve.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ve.jsx(pe, { size: d, name: "sign-in" }),
        /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "2", children: "Marketing consent" })
      ] }),
      /* @__PURE__ */ ve.jsx(
        pe,
        {
          name: o.accepts_marketing ? "check-circle-filled" : "close-circle-filled",
          color: o.accepts_marketing ? "green.500" : "neutral.500"
        }
      )
    ] }),
    /* @__PURE__ */ ve.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ ve.jsx(pe, { size: d, name: "external-link" }),
      /* @__PURE__ */ ve.jsx(
        A.ExternalLink,
        {
          href: H5(n, o.id),
          target: "_blank",
          rel: "noreferrer",
          onClick: () => {
            r("rivoloyalty:customer:clicked", {});
          },
          children: "View customer in Rivo Loyalty"
        }
      )
    ] })
  ] }) });
};
function H5(e, n) {
  const r = UC(e);
  return `${zC}/store/${r}/apps/rivo-loyalty/customers/${n}`;
}
const W5 = "_list_rxh85_1", K5 = "_listItem_rxh85_6", yS = {
  list: W5,
  listItem: K5
}, G5 = ({
  customerId: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { useQuery: r } = yn(), {
    loading: i,
    error: a,
    data: o
  } = r(R5, {
    skip: !e,
    variables: {
      customerId: e?.toString()
    }
  }), s = !i && o ? o.RivoLoyalty?.list_customer_favorite_products?.data ?? [] : [], l = 14, u = () => a ? /* @__PURE__ */ ve.jsx(In, { error: a }) : i ? /* @__PURE__ */ ve.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ve.jsx(fn, {}) }) : s.length === 0 ? /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No favorite products found." }) : /* @__PURE__ */ ve.jsx(We, { className: yS.list, children: s.map((p) => /* @__PURE__ */ ve.jsxs(
    b,
    {
      alignItems: "center",
      gap: "200",
      className: yS.listItem,
      children: [
        /* @__PURE__ */ ve.jsx(pe, { size: l, name: "external-link" }),
        /* @__PURE__ */ ve.jsx(
          A.ExternalLink,
          {
            href: Y5(
              n,
              p.product_id
            ),
            target: "_blank",
            rel: "noreferrer",
            children: p.title
          }
        )
      ]
    },
    p.product_id
  )) });
  return /* @__PURE__ */ ve.jsx(ve.Fragment, { children: /* @__PURE__ */ ve.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ve.jsx(A.Heading, { variant: "heading-3", children: "Favorite products" }),
    u()
  ] }) });
};
function Y5(e, n) {
  const r = UC(e);
  return `${zC}/store/${r}/products/${n}`;
}
const Q5 = "_modalBody_1clhs_1", J5 = {
  modalBody: Q5
};
function X5(e, n) {
  if (isNaN(e))
    return "Points can not be empty";
  if (e < n.min)
    return `Points cannot be below ${n.min}`;
  if (e > n.max)
    return `Points can not exceed ${n.max}`;
}
function Z5(e, n) {
  if (e === n)
    return "Change the value to update the points";
}
const eq = VC, _s = {
  addPoints: {
    successEventName: "rivoloyalty:points:add:succeeded",
    successEventText: "Added points successfully",
    failEventName: "rivoloyalty:points:add:failed",
    failEventText: "Failed to add points, try again later."
  },
  removePoints: {
    successEventName: "rivoloyalty:points:remove:succeeded",
    successEventText: "Removed points successfully",
    failEventName: "rivoloyalty:points:remove:failed",
    failEventText: "Failed to remove points, try again later."
  }
}, nq = ({
  customerIdentifier: e,
  isOpen: n,
  points: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = yn(), { track: l } = Cn(), [u, p] = le(r), [d, f] = le(""), [h, v] = le(!0), [F, N] = le(), j = {
    min: 0,
    max: 1e5
  }, [C, { loading: g }] = o(
    A5,
    {
      onCompleted: () => {
        const re = u > r ? _s.addPoints : _s.removePoints;
        s({
          title: "Success",
          text: re.successEventText,
          icon: "check-circle-filled",
          severity: "success"
        }), l(re.successEventName), X();
      }
    }
  ), z = () => {
    p(r), f(""), v(!0), N(void 0);
  };
  Ye(() => {
    n && z();
  }, [n]);
  const T = !!F, I = X5(u, j), D = Z5(r, u), U = () => {
    if (u !== r) {
      const re = u > r ? _s.addPoints : _s.removePoints, G = !h;
      C({
        variables: {
          input: {
            // eslint-disable-next-line camelcase
            points_amount: u - r,
            // eslint-disable-next-line camelcase
            ...d && { internal_note: d },
            // eslint-disable-next-line camelcase
            customer_identifier: e?.toString(),
            source: eq.Manual,
            // eslint-disable-next-line camelcase
            skip_email: G
          }
        }
      }).catch(() => {
        l(re.failEventName), N([re.failEventText]);
      });
    }
  }, Q = () => {
    z(), i();
  }, X = () => {
    a(), Q();
  };
  return /* @__PURE__ */ ve.jsxs(
    jt,
    {
      isOpen: n,
      onClose: Q,
      "data-testid": "rivo-loyalty-change-points-modal",
      children: [
        /* @__PURE__ */ ve.jsx(wt, { title: "Change points", onClose: Q }),
        /* @__PURE__ */ ve.jsxs(Ct, { className: J5.modalBody, children: [
          /* @__PURE__ */ ve.jsxs(at, { children: [
            /* @__PURE__ */ ve.jsx(me, { span: 6, "data-testid": "rivo-loyalty-points-input", children: /* @__PURE__ */ ve.jsx(
              tr,
              {
                label: "New points balance",
                type: "number",
                placeholder: "Insert points balance",
                min: j.min,
                max: j.max,
                meta: {
                  error: I,
                  warning: D
                },
                input: {
                  name: "points",
                  value: u.toString(),
                  onChange: (re) => p(re?.target.valueAsNumber ?? 0)
                }
              }
            ) }),
            /* @__PURE__ */ ve.jsx(me, { span: 6, children: /* @__PURE__ */ ve.jsx(
              tr,
              {
                label: "Internal note",
                placeholder: "Insert an internal note (optional)",
                input: {
                  name: "internalNote",
                  value: d,
                  onChange: (re) => f(re?.target.value ?? "")
                }
              }
            ) }),
            /* @__PURE__ */ ve.jsx(me, { span: 6, children: /* @__PURE__ */ ve.jsx(en, { label: "Notify the customer by email", children: /* @__PURE__ */ ve.jsx(
              fy,
              {
                input: {
                  name: "sendEmail",
                  value: "sendEmail",
                  checked: h,
                  onChange: () => v(!h)
                }
              }
            ) }) })
          ] }),
          !g && T && /* @__PURE__ */ ve.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ ve.jsx(We, { children: F?.map((re, G) => /* @__PURE__ */ ve.jsx(
            We.Item,
            {
              variant: "dense",
              title: re,
              contentLeft: /* @__PURE__ */ ve.jsx(
                pe,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            G
          )) }) })
        ] }),
        /* @__PURE__ */ ve.jsx(
          Pt,
          {
            confirmName: "Save",
            confirmOnClick: () => U(),
            confirmProps: {
              isLoading: g,
              loadingIndicator: /* @__PURE__ */ ve.jsx(fn, { size: 16 }),
              disabled: !!(I || D)
            },
            cancelOnClick: Q
          }
        )
      ]
    }
  );
}, Qi = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = vw(n);
  return /* @__PURE__ */ ve.jsx(
    We.Text,
    {
      variant: "dense",
      className: it(xr.listItem, {
        [xr.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ ve.jsx(Ge, { content: r, children: /* @__PURE__ */ ve.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", children: e }),
        a ? n : Oi(n)
      ] }) })
    }
  );
}, gS = {
  [da.Guest]: {
    name: "Guest",
    tooltip: "Customers who can participate in your loyalty program without creating a full account. They can earn and redeem points through email verification or one-time codes.",
    badgeColor: "info"
  },
  [da.Member]: {
    name: "Member",
    tooltip: "Customers who have activated their loyalty membership and have full access to all program features, including account dashboards and advanced features.",
    badgeColor: "success"
  },
  [da.Excluded]: {
    name: "Excluded",
    tooltip: "Customers who have been excluded from the loyalty program (typically through the “Rivo Excluded” tag or manual exclusion).",
    badgeColor: "warning"
  }
}, tq = ({
  customer: e,
  allowAdjustLoyaltyPoints: n,
  refetchCustomerData: r
}) => {
  const { attributes: i } = e, a = i.loyalty_status ? gS[i.loyalty_status] : gS[da.Guest], o = a?.name === da.Excluded, s = i.lifetime_earnings_tally, l = i.total_spent ?? 0, u = i.points_tally ?? 0, p = i.next_vip_tier, d = i.next_vip_tier?.to_spend_or_earn, f = p?.name ?? "None", [h, v] = le(!1), F = 10, N = () => /* @__PURE__ */ ve.jsx(
    We.Text,
    {
      variant: "dense",
      className: it(xr.listItem),
      children: /* @__PURE__ */ ve.jsx(Ge, { content: a.tooltip, children: /* @__PURE__ */ ve.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", children: "Loyalty status" }),
        /* @__PURE__ */ ve.jsx(Vn, { variant: a.badgeColor, size: "small", children: a.name })
      ] }) })
    }
  ), j = () => o ? N() : /* @__PURE__ */ ve.jsxs(ve.Fragment, { children: [
    /* @__PURE__ */ ve.jsx(
      We.Text,
      {
        variant: "dense",
        className: it(
          xr.listItem,
          xr.listItemHighlighted,
          {
            [xr.listItemEdit]: n
          }
        ),
        onClick: () => n ? v(!0) : void 0,
        children: /* @__PURE__ */ ve.jsx(Ge, { content: "The current balance of loyalty points for the customer.", children: /* @__PURE__ */ ve.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", children: "Points balance" }),
          /* @__PURE__ */ ve.jsxs(
            b,
            {
              alignItems: "center",
              justifyContent: "space-between",
              gap: "100",
              children: [
                n && /* @__PURE__ */ ve.jsx(
                  pe,
                  {
                    name: "pen",
                    size: F,
                    "aria-label": "Edit points"
                  }
                ),
                /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", children: Oi(u) })
              ]
            }
          )
        ] }) })
      }
    ),
    d != null && f && /* @__PURE__ */ ve.jsx(
      Qi,
      {
        description: `Points until ${f} tier`,
        tooltip: `Loyalty points until the customer advances to ${f} tier`,
        content: d
      }
    ),
    /* @__PURE__ */ ve.jsx(
      Qi,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: i.points_expire_at ?? "No expiry"
      }
    ),
    /* @__PURE__ */ ve.jsx(
      Qi,
      {
        description: "Total points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: s
      }
    ),
    /* @__PURE__ */ ve.jsx(
      Qi,
      {
        description: "Total points spent",
        tooltip: "The total number of loyalty points spent by the customer.",
        content: l
      }
    ),
    N(),
    /* @__PURE__ */ ve.jsx(
      Qi,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: i.vip_tier?.name ?? "None"
      }
    ),
    /* @__PURE__ */ ve.jsx(
      Qi,
      {
        description: "Next VIP tier",
        tooltip: "The name of the customer's next VIP tier status.",
        content: f
      }
    )
  ] });
  return /* @__PURE__ */ ve.jsxs(ve.Fragment, { children: [
    /* @__PURE__ */ ve.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ ve.jsx(A.Heading, { variant: "heading-3", children: "Loyalty" }),
      /* @__PURE__ */ ve.jsx(We, { className: xr.list, children: j() })
    ] }),
    /* @__PURE__ */ ve.jsx(
      nq,
      {
        customerIdentifier: i.id,
        isOpen: h,
        points: u,
        onClose: () => v(!1),
        refetchCustomerData: r
      }
    )
  ] });
}, rq = ({
  ordersCount: e
}) => /* @__PURE__ */ ve.jsx(ve.Fragment, { children: /* @__PURE__ */ ve.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ ve.jsx(A.Heading, { variant: "heading-3", children: "Orders overview" }),
  /* @__PURE__ */ ve.jsx(We, { className: xr.list, children: /* @__PURE__ */ ve.jsx(We.Text, { variant: "dense", className: xr.listItem, children: /* @__PURE__ */ ve.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", children: "Total orders" }),
    /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", children: e ?? 0 })
  ] }) }) })
] }) }), iq = "_reward_1gmba_1", aq = "_voucherCode_1gmba_14", vS = {
  reward: iq,
  voucherCode: aq
}, oq = ({
  pointsRedemption: e
}) => {
  const { isCopied: n, copy: r } = Gt(), {
    name: i,
    code: a,
    points_amount: o
  } = e.attributes;
  return /* @__PURE__ */ ve.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ ve.jsxs(b, { gap: "100", flexDirection: "column", className: vS.reward, children: [
    /* @__PURE__ */ ve.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ve.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ ve.jsx(pe, { name: "star", size: 12, color: "neutral.500" }),
        i
      ] }),
      /* @__PURE__ */ ve.jsxs(Vn, { size: "small", variant: "info", children: [
        o ?? 0,
        " points"
      ] })
    ] }),
    /* @__PURE__ */ ve.jsxs(
      b,
      {
        gap: "100",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ ve.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ ve.jsx(pe, { size: 14, name: "tag" }),
            /* @__PURE__ */ ve.jsx(b, { children: /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", className: vS.voucherCode, children: a }) })
          ] }),
          /* @__PURE__ */ ve.jsx(Ge, { content: "Copy reward code", children: /* @__PURE__ */ ve.jsx(
            pe,
            {
              size: 14,
              name: n ? "done" : "copy",
              className: xr.clickableIcon,
              onClick: () => r(a)
            }
          ) })
        ]
      }
    )
  ] }) });
}, sq = ({
  customer: e
}) => {
  const { useQuery: n } = yn(), {
    loading: r,
    error: i,
    data: a
  } = n(P5, {
    skip: !e,
    variables: {
      customerId: e.attributes.id.toString()
    }
  }), o = (!r && e && a ? a?.RivoLoyalty?.list_points_redemptions?.data ?? [] : []).filter(
    ({ attributes: l }) => lq({
      usedAt: l.used_at,
      revokedAt: l.revoked_at,
      refundedAt: l.refunded_at
    }) === "Issued"
  ), s = () => i ? /* @__PURE__ */ ve.jsx(In, { error: i }) : r ? /* @__PURE__ */ ve.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ve.jsx(fn, {}) }) : o.length > 0 ? /* @__PURE__ */ ve.jsx(b, { gap: "200", flexDirection: "column", children: o.map((l) => /* @__PURE__ */ ve.jsx(
    oq,
    {
      pointsRedemption: l
    },
    l.id
  )) }) : /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No loyalty rewards found." });
  return /* @__PURE__ */ ve.jsx(ve.Fragment, { children: /* @__PURE__ */ ve.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ve.jsx(A.Heading, { variant: "heading-3", children: "Available rewards" }),
    s()
  ] }) });
};
function lq(e) {
  return e.usedAt ? "Used" : e.revokedAt ? "Revoked" : e.refundedAt ? "Refunded" : "Issued";
}
const cq = (e) => {
  const { conversationContext: n, settings: r } = e, {
    rivoLoyaltyShowOrders: i,
    rivoLoyaltyShowLoyalty: a,
    rivoLoyaltyAdjustLoyaltyPoints: o,
    rivoLoyaltyShowFavoriteProducts: s,
    rivoLoyaltyShowPointsRedemptions: l
  } = r, u = r[pg].toString(), { useQuery: p } = yn(), { track: d } = Cn(), [f, h] = le(!1), v = n?.customer?.email, {
    loading: F,
    error: N,
    data: j,
    refetch: C
  } = p(O5, {
    skip: !v,
    variables: {
      email: v
    }
  }), g = !F && j ? j.RivoLoyalty?.return_customer?.data : void 0;
  Ye(() => {
    !F && g && !f && (d("rivoloyalty:customer:received"), h(!0));
  }, [F, g]);
  const z = () => /* @__PURE__ */ ve.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ ve.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (N) {
    const T = N.graphQLErrors;
    return va({ errors: T }) ? z() : kl({ errors: T }) ? /* @__PURE__ */ ve.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : bl({ errors: T }) ? /* @__PURE__ */ ve.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Rivo Loyalty. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ve.jsx(In, { error: N });
  }
  return F ? /* @__PURE__ */ ve.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ve.jsx(fn, {}) }) : !v || !g ? z() : /* @__PURE__ */ ve.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ ve.jsx(
          q5,
          {
            customerDetails: g,
            rivoLoyaltyShopifyApiHostName: u
          }
        ),
        i && /* @__PURE__ */ ve.jsx(
          rq,
          {
            ordersCount: g.attributes?.orders_count ?? 0
          }
        ),
        a && /* @__PURE__ */ ve.jsx(
          tq,
          {
            customer: g,
            refetchCustomerData: C,
            allowAdjustLoyaltyPoints: !!o
          }
        ),
        s && /* @__PURE__ */ ve.jsx(
          G5,
          {
            customerId: g.attributes.id,
            rivoLoyaltyShopifyApiHostName: u
          }
        ),
        l && /* @__PURE__ */ ve.jsx(sq, { customer: g })
      ]
    }
  );
};
var Ko = (e) => e.type === "checkbox", Ci = (e) => e instanceof Date, Wt = (e) => e == null;
const MC = (e) => typeof e == "object";
var ft = (e) => !Wt(e) && !Array.isArray(e) && MC(e) && !Ci(e), BC = (e) => ft(e) && e.target ? Ko(e.target) ? e.target.checked : e.target.value : e, uq = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, qC = (e, n) => e.has(uq(n)), dq = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return ft(n) && n.hasOwnProperty("isPrototypeOf");
}, fg = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Tt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(fg && (e instanceof Blob || i)) && (r || ft(e)))
    if (n = r ? [] : {}, !r && !dq(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Tt(e[a]));
  else
    return e;
  return n;
}
var Bl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ut = (e) => e === void 0, rn = (e, n, r) => {
  if (!n || !ft(e))
    return r;
  const i = Bl(n.split(/[,[\].]+?/)).reduce((a, o) => Wt(a) ? a : a[o], e);
  return ut(i) || i === e ? ut(e[n]) ? r : e[n] : i;
}, sr = (e) => typeof e == "boolean", hg = (e) => /^\w*$/.test(e), HC = (e) => Bl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Xn = (e, n, r) => {
  let i = -1;
  const a = hg(n) ? [n] : HC(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let u = r;
    if (i !== s) {
      const p = e[l];
      u = ft(p) || Array.isArray(p) ? p : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = u, e = e[l];
  }
};
const dl = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Sr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Kr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, mq = Ie.createContext(null), yg = () => Ie.useContext(mq);
var WC = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== Sr.all && (n._proxyFormState[s] = !i || Sr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function pq(e) {
  const n = yg(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Ie.useState(r._formState), u = Ie.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), p = Ie.useRef(a);
  return p.current = a, Ie.useEffect(() => r._subscribe({
    name: p.current,
    formState: u.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...r._formState,
        ...d
      });
    }
  }), [r, i, o]), Ie.useEffect(() => {
    u.current.isValid && r._setValid(!0);
  }, [r]), Ie.useMemo(() => WC(s, r, u.current, !1), [s, r]);
}
var Pr = (e) => typeof e == "string", KC = (e, n, r, i, a) => Pr(e) ? (i && n.watch.add(e), rn(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), rn(r, o))) : (i && (n.watchAll = !0), r);
function fq(e) {
  const n = yg(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Ie.useRef(i), u = Ie.useRef(a);
  l.current = i, Ie.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && d(KC(l.current, r._names, f.values || r._formValues, !1, u.current))
  }), [r, o, s]);
  const [p, d] = Ie.useState(r._getWatch(i, a));
  return Ie.useEffect(() => r._removeUnmounted()), p;
}
function hq(e) {
  const n = yg(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = qC(a._names.array, r), l = fq({
    control: a,
    name: r,
    defaultValue: rn(a._formValues, r, rn(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), u = pq({
    control: a,
    name: r,
    exact: !0
  }), p = Ie.useRef(e), d = Ie.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...sr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Ie.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!rn(u.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!rn(u.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!rn(u.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!rn(u.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => rn(u.errors, r)
    }
  }), [u, r]), h = Ie.useCallback((j) => d.current.onChange({
    target: {
      value: BC(j),
      name: r
    },
    type: dl.CHANGE
  }), [r]), v = Ie.useCallback(() => d.current.onBlur({
    target: {
      value: rn(a._formValues, r),
      name: r
    },
    type: dl.BLUR
  }), [r, a._formValues]), F = Ie.useCallback((j) => {
    const C = rn(a._fields, r);
    C && j && (C._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (g) => j.setCustomValidity(g),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), N = Ie.useMemo(() => ({
    name: r,
    value: l,
    ...sr(i) || u.disabled ? { disabled: u.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: F
  }), [r, i, u.disabled, h, v, F, l]);
  return Ie.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...p.current.rules,
      ...sr(p.current.disabled) ? { disabled: p.current.disabled } : {}
    });
    const C = (g, z) => {
      const T = rn(a._fields, g);
      T && T._f && (T._f.mount = z);
    };
    if (C(r, !0), j) {
      const g = Tt(rn(a._options.defaultValues, r));
      Xn(a._defaultValues, r, g), ut(rn(a._formValues, r)) && Xn(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : C(r, !1);
    };
  }, [r, a, s, o]), Ie.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Ie.useMemo(() => ({
    field: N,
    formState: u,
    fieldState: f
  }), [N, u, f]);
}
var yq = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, No = (e) => Array.isArray(e) ? e : [e], kS = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, ny = (e) => Wt(e) || !MC(e);
function mi(e, n) {
  if (ny(e) || ny(n))
    return e === n;
  if (Ci(e) && Ci(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Ci(o) && Ci(s) || ft(o) && ft(s) || Array.isArray(o) && Array.isArray(s) ? !mi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Bt = (e) => ft(e) && !Object.keys(e).length, gg = (e) => e.type === "file", Nr = (e) => typeof e == "function", ml = (e) => {
  if (!fg)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, GC = (e) => e.type === "select-multiple", vg = (e) => e.type === "radio", gq = (e) => vg(e) || Ko(e), Nm = (e) => ml(e) && e.isConnected;
function vq(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = ut(e) ? i++ : e[n[i++]];
  return e;
}
function kq(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ut(e[n]))
      return !1;
  return !0;
}
function _t(e, n) {
  const r = Array.isArray(n) ? n : hg(n) ? [n] : HC(n), i = r.length === 1 ? e : vq(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (ft(i) && Bt(i) || Array.isArray(i) && kq(i)) && _t(e, r.slice(0, -1)), e;
}
var YC = (e) => {
  for (const n in e)
    if (Nr(e[n]))
      return !0;
  return !1;
};
function pl(e, n = {}) {
  const r = Array.isArray(e);
  if (ft(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || ft(e[i]) && !YC(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, pl(e[i], n[i])) : Wt(e[i]) || (n[i] = !0);
  return n;
}
function QC(e, n, r) {
  const i = Array.isArray(e);
  if (ft(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || ft(e[a]) && !YC(e[a]) ? ut(n) || ny(r[a]) ? r[a] = Array.isArray(e[a]) ? pl(e[a], []) : { ...pl(e[a]) } : QC(e[a], Wt(n) ? {} : n[a], r[a]) : r[a] = !mi(e[a], n[a]);
  return r;
}
var io = (e, n) => QC(e, n, pl(n));
const bS = {
  value: !1,
  isValid: !1
}, _S = { value: !0, isValid: !0 };
var JC = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ut(e[0].attributes.value) ? ut(e[0].value) || e[0].value === "" ? _S : { value: e[0].value, isValid: !0 } : _S
    ) : bS;
  }
  return bS;
}, XC = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => ut(e) ? e : n ? e === "" ? NaN : e && +e : r && Pr(e) ? new Date(e) : i ? i(e) : e;
const xS = {
  isValid: !1,
  value: null
};
var ZC = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, xS) : xS;
function SS(e) {
  const n = e.ref;
  return gg(n) ? n.files : vg(n) ? ZC(e.refs).value : GC(n) ? [...n.selectedOptions].map(({ value: r }) => r) : Ko(n) ? JC(e.refs).value : XC(ut(n.value) ? e.ref.value : n.value, e);
}
var bq = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = rn(n, o);
    s && Xn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, fl = (e) => e instanceof RegExp, ao = (e) => ut(e) ? e : fl(e) ? e.source : ft(e) ? fl(e.value) ? e.value.source : e.value : e, NS = (e) => ({
  isOnSubmit: !e || e === Sr.onSubmit,
  isOnBlur: e === Sr.onBlur,
  isOnChange: e === Sr.onChange,
  isOnAll: e === Sr.all,
  isOnTouch: e === Sr.onTouched
});
const jS = "AsyncFunction";
var _q = (e) => !!e && !!e.validate && !!(Nr(e.validate) && e.validate.constructor.name === jS || ft(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === jS)), xq = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), wS = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const jo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = rn(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (jo(l, n))
          break;
      } else if (ft(l) && jo(l, n))
        break;
    }
  }
};
function CS(e, n, r) {
  const i = rn(e, r);
  if (i || hg(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = rn(n, o), l = rn(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var Sq = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Bt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || Sr.all));
}, Nq = (e, n, r) => !e || !n || e === n || No(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), jq = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, wq = (e, n) => !Bl(rn(e, n)).length && _t(e, n), Cq = (e, n, r) => {
  const i = No(rn(e, r));
  return Xn(i, "root", n[r]), Xn(e, r, i), e;
}, Bs = (e) => Pr(e);
function FS(e, n, r = "validate") {
  if (Bs(e) || Array.isArray(e) && e.every(Bs) || sr(e) && !e)
    return {
      type: r,
      message: Bs(e) ? e : "",
      ref: n
    };
}
var Ji = (e) => ft(e) && !fl(e) ? e : {
  value: e,
  message: ""
}, IS = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: u, maxLength: p, minLength: d, min: f, max: h, pattern: v, validate: F, name: N, valueAsNumber: j, mount: C } = e._f, g = rn(r, N);
  if (!C || n.has(N))
    return {};
  const z = l ? l[0] : s, T = (q) => {
    a && z.reportValidity && (z.setCustomValidity(sr(q) ? "" : q || ""), z.reportValidity());
  }, I = {}, D = vg(s), U = Ko(s), Q = D || U, X = (j || gg(s)) && ut(s.value) && ut(g) || ml(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, re = yq.bind(null, N, i, I), G = (q, R, B, ee = Kr.maxLength, be = Kr.minLength) => {
    const fe = q ? R : B;
    I[N] = {
      type: q ? ee : be,
      message: fe,
      ref: s,
      ...re(q ? ee : be, fe)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : u && (!Q && (X || Wt(g)) || sr(g) && !g || U && !JC(l).isValid || D && !ZC(l).isValid)) {
    const { value: q, message: R } = Bs(u) ? { value: !!u, message: u } : Ji(u);
    if (q && (I[N] = {
      type: Kr.required,
      message: R,
      ref: z,
      ...re(Kr.required, R)
    }, !i))
      return T(R), I;
  }
  if (!X && (!Wt(f) || !Wt(h))) {
    let q, R;
    const B = Ji(h), ee = Ji(f);
    if (!Wt(g) && !isNaN(g)) {
      const be = s.valueAsNumber || g && +g;
      Wt(B.value) || (q = be > B.value), Wt(ee.value) || (R = be < ee.value);
    } else {
      const be = s.valueAsDate || new Date(g), fe = (K) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + K), de = s.type == "time", ge = s.type == "week";
      Pr(B.value) && g && (q = de ? fe(g) > fe(B.value) : ge ? g > B.value : be > new Date(B.value)), Pr(ee.value) && g && (R = de ? fe(g) < fe(ee.value) : ge ? g < ee.value : be < new Date(ee.value));
    }
    if ((q || R) && (G(!!q, B.message, ee.message, Kr.max, Kr.min), !i))
      return T(I[N].message), I;
  }
  if ((p || d) && !X && (Pr(g) || o && Array.isArray(g))) {
    const q = Ji(p), R = Ji(d), B = !Wt(q.value) && g.length > +q.value, ee = !Wt(R.value) && g.length < +R.value;
    if ((B || ee) && (G(B, q.message, R.message), !i))
      return T(I[N].message), I;
  }
  if (v && !X && Pr(g)) {
    const { value: q, message: R } = Ji(v);
    if (fl(q) && !g.match(q) && (I[N] = {
      type: Kr.pattern,
      message: R,
      ref: s,
      ...re(Kr.pattern, R)
    }, !i))
      return T(R), I;
  }
  if (F) {
    if (Nr(F)) {
      const q = await F(g, r), R = FS(q, z);
      if (R && (I[N] = {
        ...R,
        ...re(Kr.validate, R.message)
      }, !i))
        return T(R.message), I;
    } else if (ft(F)) {
      let q = {};
      for (const R in F) {
        if (!Bt(q) && !i)
          break;
        const B = FS(await F[R](g, r), z, R);
        B && (q = {
          ...B,
          ...re(R, B.message)
        }, T(B.message), i && (I[N] = q));
      }
      if (!Bt(q) && (I[N] = {
        ref: z,
        ...q
      }, !i))
        return I;
    }
  }
  return T(!0), I;
};
const Fq = {
  mode: Sr.onSubmit,
  reValidateMode: Sr.onChange,
  shouldFocusError: !0
};
function Iq(e = {}) {
  let n = {
    ...Fq,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Nr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = ft(n.defaultValues) || ft(n.values) ? Tt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Tt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, p = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...d
  };
  const h = {
    array: kS(),
    state: kS()
  }, v = NS(n.mode), F = NS(n.reValidateMode), N = n.criteriaMode === Sr.all, j = (E) => (_) => {
    clearTimeout(p), p = setTimeout(E, _);
  }, C = async (E) => {
    if (!n.disabled && (d.isValid || f.isValid || E)) {
      const _ = n.resolver ? Bt((await X()).errors) : await G(i, !0);
      _ !== r.isValid && h.state.next({
        isValid: _
      });
    }
  }, g = (E, _) => {
    !n.disabled && (d.isValidating || d.validatingFields || f.isValidating || f.validatingFields) && ((E || Array.from(l.mount)).forEach((O) => {
      O && (_ ? Xn(r.validatingFields, O, _) : _t(r.validatingFields, O));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Bt(r.validatingFields)
    }));
  }, z = (E, _ = [], O, W, J = !0, L = !0) => {
    if (W && O && !n.disabled) {
      if (s.action = !0, L && Array.isArray(rn(i, E))) {
        const M = O(rn(i, E), W.argA, W.argB);
        J && Xn(i, E, M);
      }
      if (L && Array.isArray(rn(r.errors, E))) {
        const M = O(rn(r.errors, E), W.argA, W.argB);
        J && Xn(r.errors, E, M), wq(r.errors, E);
      }
      if ((d.touchedFields || f.touchedFields) && L && Array.isArray(rn(r.touchedFields, E))) {
        const M = O(rn(r.touchedFields, E), W.argA, W.argB);
        J && Xn(r.touchedFields, E, M);
      }
      (d.dirtyFields || f.dirtyFields) && (r.dirtyFields = io(a, o)), h.state.next({
        name: E,
        isDirty: R(E, _),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Xn(o, E, _);
  }, T = (E, _) => {
    Xn(r.errors, E, _), h.state.next({
      errors: r.errors
    });
  }, I = (E) => {
    r.errors = E, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (E, _, O, W) => {
    const J = rn(i, E);
    if (J) {
      const L = rn(o, E, ut(O) ? rn(a, E) : O);
      ut(L) || W && W.defaultChecked || _ ? Xn(o, E, _ ? L : SS(J._f)) : be(E, L), s.mount && C();
    }
  }, U = (E, _, O, W, J) => {
    let L = !1, M = !1;
    const ie = {
      name: E
    };
    if (!n.disabled) {
      if (!O || W) {
        (d.isDirty || f.isDirty) && (M = r.isDirty, r.isDirty = ie.isDirty = R(), L = M !== ie.isDirty);
        const he = mi(rn(a, E), _);
        M = !!rn(r.dirtyFields, E), he ? _t(r.dirtyFields, E) : Xn(r.dirtyFields, E, !0), ie.dirtyFields = r.dirtyFields, L = L || (d.dirtyFields || f.dirtyFields) && M !== !he;
      }
      if (O) {
        const he = rn(r.touchedFields, E);
        he || (Xn(r.touchedFields, E, O), ie.touchedFields = r.touchedFields, L = L || (d.touchedFields || f.touchedFields) && he !== O);
      }
      L && J && h.state.next(ie);
    }
    return L ? ie : {};
  }, Q = (E, _, O, W) => {
    const J = rn(r.errors, E), L = (d.isValid || f.isValid) && sr(_) && r.isValid !== _;
    if (n.delayError && O ? (u = j(() => T(E, O)), u(n.delayError)) : (clearTimeout(p), u = null, O ? Xn(r.errors, E, O) : _t(r.errors, E)), (O ? !mi(J, O) : J) || !Bt(W) || L) {
      const M = {
        ...W,
        ...L && sr(_) ? { isValid: _ } : {},
        errors: r.errors,
        name: E
      };
      r = {
        ...r,
        ...M
      }, h.state.next(M);
    }
  }, X = async (E) => {
    g(E, !0);
    const _ = await n.resolver(o, n.context, bq(E || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(E), _;
  }, re = async (E) => {
    const { errors: _ } = await X(E);
    if (E)
      for (const O of E) {
        const W = rn(_, O);
        W ? Xn(r.errors, O, W) : _t(r.errors, O);
      }
    else
      r.errors = _;
    return _;
  }, G = async (E, _, O = {
    valid: !0
  }) => {
    for (const W in E) {
      const J = E[W];
      if (J) {
        const { _f: L, ...M } = J;
        if (L) {
          const ie = l.array.has(L.name), he = J._f && _q(J._f);
          he && d.validatingFields && g([W], !0);
          const Ne = await IS(J, l.disabled, o, N, n.shouldUseNativeValidation && !_, ie);
          if (he && d.validatingFields && g([W]), Ne[L.name] && (O.valid = !1, _))
            break;
          !_ && (rn(Ne, L.name) ? ie ? Cq(r.errors, Ne, L.name) : Xn(r.errors, L.name, Ne[L.name]) : _t(r.errors, L.name));
        }
        !Bt(M) && await G(M, _, O);
      }
    }
    return O.valid;
  }, q = () => {
    for (const E of l.unMount) {
      const _ = rn(i, E);
      _ && (_._f.refs ? _._f.refs.every((O) => !Nm(O)) : !Nm(_._f.ref)) && ze(E);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (E, _) => !n.disabled && (E && _ && Xn(o, E, _), !mi($e(), a)), B = (E, _, O) => KC(E, l, {
    ...s.mount ? o : ut(_) ? a : Pr(E) ? { [E]: _ } : _
  }, O, _), ee = (E) => Bl(rn(s.mount ? o : a, E, n.shouldUnregister ? rn(a, E, []) : [])), be = (E, _, O = {}) => {
    const W = rn(i, E);
    let J = _;
    if (W) {
      const L = W._f;
      L && (!L.disabled && Xn(o, E, XC(_, L)), J = ml(L.ref) && Wt(_) ? "" : _, GC(L.ref) ? [...L.ref.options].forEach((M) => M.selected = J.includes(M.value)) : L.refs ? Ko(L.ref) ? L.refs.length > 1 ? L.refs.forEach((M) => (!M.defaultChecked || !M.disabled) && (M.checked = Array.isArray(J) ? !!J.find((ie) => ie === M.value) : J === M.value)) : L.refs[0] && (L.refs[0].checked = !!J) : L.refs.forEach((M) => M.checked = M.value === J) : gg(L.ref) ? L.ref.value = "" : (L.ref.value = J, L.ref.type || h.state.next({
        name: E,
        values: Tt(o)
      })));
    }
    (O.shouldDirty || O.shouldTouch) && U(E, J, O.shouldTouch, O.shouldDirty, !0), O.shouldValidate && xe(E);
  }, fe = (E, _, O) => {
    for (const W in _) {
      const J = _[W], L = `${E}.${W}`, M = rn(i, L);
      (l.array.has(E) || ft(J) || M && !M._f) && !Ci(J) ? fe(L, J, O) : be(L, J, O);
    }
  }, de = (E, _, O = {}) => {
    const W = rn(i, E), J = l.array.has(E), L = Tt(_);
    Xn(o, E, L), J ? (h.array.next({
      name: E,
      values: Tt(o)
    }), (d.isDirty || d.dirtyFields || f.isDirty || f.dirtyFields) && O.shouldDirty && h.state.next({
      name: E,
      dirtyFields: io(a, o),
      isDirty: R(E, L)
    })) : W && !W._f && !Wt(L) ? fe(E, L, O) : be(E, L, O), wS(E, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? E : void 0,
      values: Tt(o)
    });
  }, ge = async (E) => {
    s.mount = !0;
    const _ = E.target;
    let O = _.name, W = !0;
    const J = rn(i, O), L = (M) => {
      W = Number.isNaN(M) || Ci(M) && isNaN(M.getTime()) || mi(M, rn(o, O, M));
    };
    if (J) {
      let M, ie;
      const he = _.type ? SS(J._f) : BC(E), Ne = E.type === dl.BLUR || E.type === dl.FOCUS_OUT, nn = !xq(J._f) && !n.resolver && !rn(r.errors, O) && !J._f.deps || jq(Ne, rn(r.touchedFields, O), r.isSubmitted, F, v), mn = wS(O, l, Ne);
      Xn(o, O, he), Ne ? (J._f.onBlur && J._f.onBlur(E), u && u(0)) : J._f.onChange && J._f.onChange(E);
      const Ze = U(O, he, Ne), sn = !Bt(Ze) || mn;
      if (!Ne && h.state.next({
        name: O,
        type: E.type,
        values: Tt(o)
      }), nn)
        return (d.isValid || f.isValid) && (n.mode === "onBlur" ? Ne && C() : Ne || C()), sn && h.state.next({ name: O, ...mn ? {} : Ze });
      if (!Ne && mn && h.state.next({ ...r }), n.resolver) {
        const { errors: hn } = await X([O]);
        if (L(he), W) {
          const pn = CS(r.errors, i, O), _n = CS(hn, i, pn.name || O);
          M = _n.error, O = _n.name, ie = Bt(hn);
        }
      } else
        g([O], !0), M = (await IS(J, l.disabled, o, N, n.shouldUseNativeValidation))[O], g([O]), L(he), W && (M ? ie = !1 : (d.isValid || f.isValid) && (ie = await G(i, !0)));
      W && (J._f.deps && xe(J._f.deps), Q(O, ie, M, Ze));
    }
  }, K = (E, _) => {
    if (rn(r.errors, _) && E.focus)
      return E.focus(), 1;
  }, xe = async (E, _ = {}) => {
    let O, W;
    const J = No(E);
    if (n.resolver) {
      const L = await re(ut(E) ? E : J);
      O = Bt(L), W = E ? !J.some((M) => rn(L, M)) : O;
    } else E ? (W = (await Promise.all(J.map(async (L) => {
      const M = rn(i, L);
      return await G(M && M._f ? { [L]: M } : M);
    }))).every(Boolean), !(!W && !r.isValid) && C()) : W = O = await G(i);
    return h.state.next({
      ...!Pr(E) || (d.isValid || f.isValid) && O !== r.isValid ? {} : { name: E },
      ...n.resolver || !E ? { isValid: O } : {},
      errors: r.errors
    }), _.shouldFocus && !W && jo(i, K, E ? J : l.mount), W;
  }, $e = (E) => {
    const _ = {
      ...s.mount ? o : a
    };
    return ut(E) ? _ : Pr(E) ? rn(_, E) : E.map((O) => rn(_, O));
  }, Y = (E, _) => ({
    invalid: !!rn((_ || r).errors, E),
    isDirty: !!rn((_ || r).dirtyFields, E),
    error: rn((_ || r).errors, E),
    isValidating: !!rn(r.validatingFields, E),
    isTouched: !!rn((_ || r).touchedFields, E)
  }), qe = (E) => {
    E && No(E).forEach((_) => _t(r.errors, _)), h.state.next({
      errors: E ? r.errors : {}
    });
  }, Me = (E, _, O) => {
    const W = (rn(i, E, { _f: {} })._f || {}).ref, J = rn(r.errors, E) || {}, { ref: L, message: M, type: ie, ...he } = J;
    Xn(r.errors, E, {
      ...he,
      ..._,
      ref: W
    }), h.state.next({
      name: E,
      errors: r.errors,
      isValid: !1
    }), O && O.shouldFocus && W && W.focus && W.focus();
  }, Le = (E, _) => Nr(E) ? h.state.subscribe({
    next: (O) => E(B(void 0, _), O)
  }) : B(E, _, !0), Ue = (E) => h.state.subscribe({
    next: (_) => {
      Nq(E.name, _.name, E.exact) && Sq(_, E.formState || d, Oe, E.reRenderRoot) && E.callback({
        values: { ...o },
        ...r,
        ..._
      });
    }
  }).unsubscribe, De = (E) => (s.mount = !0, f = {
    ...f,
    ...E.formState
  }, Ue({
    ...E,
    formState: f
  })), ze = (E, _ = {}) => {
    for (const O of E ? No(E) : l.mount)
      l.mount.delete(O), l.array.delete(O), _.keepValue || (_t(i, O), _t(o, O)), !_.keepError && _t(r.errors, O), !_.keepDirty && _t(r.dirtyFields, O), !_.keepTouched && _t(r.touchedFields, O), !_.keepIsValidating && _t(r.validatingFields, O), !n.shouldUnregister && !_.keepDefaultValue && _t(a, O);
    h.state.next({
      values: Tt(o)
    }), h.state.next({
      ...r,
      ..._.keepDirty ? { isDirty: R() } : {}
    }), !_.keepIsValid && C();
  }, Re = ({ disabled: E, name: _ }) => {
    (sr(E) && s.mount || E || l.disabled.has(_)) && (E ? l.disabled.add(_) : l.disabled.delete(_));
  }, on = (E, _ = {}) => {
    let O = rn(i, E);
    const W = sr(_.disabled) || sr(n.disabled);
    return Xn(i, E, {
      ...O || {},
      _f: {
        ...O && O._f ? O._f : { ref: { name: E } },
        name: E,
        mount: !0,
        ..._
      }
    }), l.mount.add(E), O ? Re({
      disabled: sr(_.disabled) ? _.disabled : n.disabled,
      name: E
    }) : D(E, !0, _.value), {
      ...W ? { disabled: _.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!_.required,
        min: ao(_.min),
        max: ao(_.max),
        minLength: ao(_.minLength),
        maxLength: ao(_.maxLength),
        pattern: ao(_.pattern)
      } : {},
      name: E,
      onChange: ge,
      onBlur: ge,
      ref: (J) => {
        if (J) {
          on(E, _), O = rn(i, E);
          const L = ut(J.value) && J.querySelectorAll && J.querySelectorAll("input,select,textarea")[0] || J, M = gq(L), ie = O._f.refs || [];
          if (M ? ie.find((he) => he === L) : L === O._f.ref)
            return;
          Xn(i, E, {
            _f: {
              ...O._f,
              ...M ? {
                refs: [
                  ...ie.filter(Nm),
                  L,
                  ...Array.isArray(rn(a, E)) ? [{}] : []
                ],
                ref: { type: L.type, name: E }
              } : { ref: L }
            }
          }), D(E, !1, void 0, L);
        } else
          O = rn(i, E, {}), O._f && (O._f.mount = !1), (n.shouldUnregister || _.shouldUnregister) && !(qC(l.array, E) && s.action) && l.unMount.add(E);
      }
    };
  }, Ee = () => n.shouldFocusError && jo(i, K, l.mount), Qe = (E) => {
    sr(E) && (h.state.next({ disabled: E }), jo(i, (_, O) => {
      const W = rn(i, O);
      W && (_.disabled = W._f.disabled || E, Array.isArray(W._f.refs) && W._f.refs.forEach((J) => {
        J.disabled = W._f.disabled || E;
      }));
    }, 0, !1));
  }, Xe = (E, _) => async (O) => {
    let W;
    O && (O.preventDefault && O.preventDefault(), O.persist && O.persist());
    let J = Tt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: L, values: M } = await X();
      r.errors = L, J = M;
    } else
      await G(i);
    if (l.disabled.size)
      for (const L of l.disabled)
        Xn(J, L, void 0);
    if (_t(r.errors, "root"), Bt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await E(J, O);
      } catch (L) {
        W = L;
      }
    } else
      _ && await _({ ...r.errors }, O), Ee(), setTimeout(Ee);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Bt(r.errors) && !W,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), W)
      throw W;
  }, se = (E, _ = {}) => {
    rn(i, E) && (ut(_.defaultValue) ? de(E, Tt(rn(a, E))) : (de(E, _.defaultValue), Xn(a, E, Tt(_.defaultValue))), _.keepTouched || _t(r.touchedFields, E), _.keepDirty || (_t(r.dirtyFields, E), r.isDirty = _.defaultValue ? R(E, Tt(rn(a, E))) : R()), _.keepError || (_t(r.errors, E), d.isValid && C()), h.state.next({ ...r }));
  }, ye = (E, _ = {}) => {
    const O = E ? Tt(E) : a, W = Tt(O), J = Bt(E), L = J ? a : W;
    if (_.keepDefaultValues || (a = O), !_.keepValues) {
      if (_.keepDirtyValues) {
        const M = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(io(a, o))
        ]);
        for (const ie of Array.from(M))
          rn(r.dirtyFields, ie) ? Xn(L, ie, rn(o, ie)) : de(ie, rn(L, ie));
      } else {
        if (fg && ut(E))
          for (const M of l.mount) {
            const ie = rn(i, M);
            if (ie && ie._f) {
              const he = Array.isArray(ie._f.refs) ? ie._f.refs[0] : ie._f.ref;
              if (ml(he)) {
                const Ne = he.closest("form");
                if (Ne) {
                  Ne.reset();
                  break;
                }
              }
            }
          }
        for (const M of l.mount)
          de(M, rn(L, M));
      }
      o = Tt(L), h.array.next({
        values: { ...L }
      }), h.state.next({
        values: { ...L }
      });
    }
    l = {
      mount: _.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!_.keepIsValid || !!_.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? r.submitCount : 0,
      isDirty: J ? !1 : _.keepDirty ? r.isDirty : !!(_.keepDefaultValues && !mi(E, a)),
      isSubmitted: _.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: J ? {} : _.keepDirtyValues ? _.keepDefaultValues && o ? io(a, o) : r.dirtyFields : _.keepDefaultValues && E ? io(a, E) : _.keepDirty ? r.dirtyFields : {},
      touchedFields: _.keepTouched ? r.touchedFields : {},
      errors: _.keepErrors ? r.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, je = (E, _) => ye(Nr(E) ? E(o) : E, _), Ve = (E, _ = {}) => {
    const O = rn(i, E), W = O && O._f;
    if (W) {
      const J = W.refs ? W.refs[0] : W.ref;
      J.focus && (J.focus(), _.shouldSelect && Nr(J.select) && J.select());
    }
  }, Oe = (E) => {
    r = {
      ...r,
      ...E
    };
  }, dn = {
    control: {
      register: on,
      unregister: ze,
      getFieldState: Y,
      handleSubmit: Xe,
      setError: Me,
      _subscribe: Ue,
      _runSchema: X,
      _getWatch: B,
      _getDirty: R,
      _setValid: C,
      _setFieldArray: z,
      _setDisabledField: Re,
      _setErrors: I,
      _getFieldArray: ee,
      _reset: ye,
      _resetDefaultValues: () => Nr(n.defaultValues) && n.defaultValues().then((E) => {
        je(E, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: q,
      _disableForm: Qe,
      _subjects: h,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(E) {
        s = E;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(E) {
        l = E;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(E) {
        n = {
          ...n,
          ...E
        };
      }
    },
    subscribe: De,
    trigger: xe,
    register: on,
    handleSubmit: Xe,
    watch: Le,
    setValue: de,
    getValues: $e,
    reset: je,
    resetField: se,
    clearErrors: qe,
    unregister: ze,
    setError: Me,
    setFocus: Ve,
    getFieldState: Y
  };
  return {
    ...dn,
    formControl: dn
  };
}
function $q(e = {}) {
  const n = Ie.useRef(void 0), r = Ie.useRef(void 0), [i, a] = Ie.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Nr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Nr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : Iq(e),
    formState: i
  }, e.formControl && e.defaultValues && !Nr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Ie.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Ie.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Ie.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Ie.useEffect(() => {
    e.values && !mi(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Ie.useEffect(() => {
    e.errors && !Bt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Ie.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Ie.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = WC(i, o), n.current;
}
var xs = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function eF(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var jm = { exports: {} }, oo = {}, $S;
function Eq() {
  if ($S) return oo;
  $S = 1;
  var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return oo.Fragment = r, oo.jsx = s, oo.jsxs = s, oo;
}
var Ss = {}, ES;
function Tq() {
  return ES || (ES = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[N];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        z("error", t, m);
      }
    }
    function z(t, c, m) {
      {
        var y = C.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var P = m.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var T = !1, I = !1, D = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || U || t === v || T || I || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function q(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return q(c) + ".Consumer";
          case s:
            var m = t;
            return q(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return R(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, be, fe, de, ge, K, xe, $e;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          be = console.log, fe = console.info, de = console.warn, ge = console.error, K = console.group, xe = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: be
            }),
            info: B({}, t, {
              value: fe
            }),
            warn: B({}, t, {
              value: de
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: K
            }),
            groupCollapsed: B({}, t, {
              value: xe
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = C.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var ze = !1, Re;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new on();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var m = Re.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      ze = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Le.current, Le.current = null, qe();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var S = te.stack.split(`
`), ne = y.stack.split(`
`), H = S.length - 1, x = ne.length - 1; H >= 1 && x >= 0 && S[H] !== ne[x]; )
            x--;
          for (; H >= 1 && x >= 0; H--, x--)
            if (S[H] !== ne[x]) {
              if (H !== 1 || x !== 1)
                do
                  if (H--, x--, x < 0 || S[H] !== ne[x]) {
                    var Z = `
` + S[H].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (H >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Le.current = P, Me(), Error.prepareStackTrace = $;
      }
      var ue = t ? t.displayName || t.name : "", _e = ue ? De(ue) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Qe(t, c, m) {
      return Ee(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Xe(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case d:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Qe(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return se(P($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, je = {}, Ve = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function dn(t, c, m, y, $) {
      {
        var P = Function.call.bind(ye);
        for (var w in t)
          if (P(t, w)) {
            var S = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + m + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[w](c, w, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              S = H;
            }
            S && !(S instanceof Error) && (Oe($), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, w, typeof S), Oe(null)), S instanceof Error && !(S.message in je) && (je[S.message] = !0, Oe($), g("Failed %s type: %s", m, S.message), Oe(null));
          }
      }
    }
    var E = Array.isArray;
    function _(t) {
      return E(t);
    }
    function O(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function W(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function L(t) {
      if (W(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", O(t)), J(t);
    }
    var M = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Ze(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function sn(t, c) {
      {
        var m = function() {
          he || (he = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function hn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, m, y, $, P, w) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function _n(t, c, m, y, $) {
      {
        var P, w = {}, S = null, ne = null;
        m !== void 0 && (L(m), S = "" + m), mn(c) && (L(c.key), S = "" + c.key), nn(c) && (ne = c.ref, Ze(c));
        for (P in c)
          ye.call(c, P) && !ie.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var H = t.defaultProps;
          for (P in H)
            w[P] === void 0 && (w[P] = H[P]);
        }
        if (S || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && sn(w, x), ne && hn(w, x);
        }
        return pn(t, S, ne, $, y, M.current, w);
      }
    }
    var Je = C.ReactCurrentOwner, Nn = C.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(m);
      } else
        Nn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (Je.current) {
          var t = R(Je.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Mn(t) {
      return "";
    }
    var jn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = kn(c);
        if (jn[m])
          return;
        jn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Je.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ae(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ae(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            cn(y) && gn(y, c);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              cn(w.value) && gn(w.value, c);
        }
      }
    }
    function zn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = R(c);
          dn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var $ = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function An(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ae(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var xn = {};
    function Sn(t, c, m, y, $, P) {
      {
        var w = re(t);
        if (!w) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = Mn();
          ne ? S += ne : S += vn();
          var H;
          t === null ? H = "null" : _(t) ? H = "array" : t !== void 0 && t.$$typeof === n ? (H = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : H = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, S);
        }
        var x = _n(t, c, m, $, P);
        if (x == null)
          return x;
        if (w) {
          var Z = c.children;
          if (Z !== void 0)
            if (y)
              if (_(Z)) {
                for (var ue = 0; ue < Z.length; ue++)
                  wn(Z[ue], t);
                Object.freeze && Object.freeze(Z);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = R(t), te = Object.keys(c).filter(function($n) {
            return $n !== "key";
          }), Ke = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? An(x) : zn(x), x;
      }
    }
    function Bn(t, c, m) {
      return Sn(t, c, m, !0);
    }
    function On(t, c, m) {
      return Sn(t, c, m, !1);
    }
    var Rn = On, Un = Bn;
    Ss.Fragment = i, Ss.jsx = Rn, Ss.jsxs = Un;
  })()), Ss;
}
var TS;
function Dq() {
  return TS || (TS = 1, process.env.NODE_ENV === "production" ? jm.exports = Eq() : jm.exports = Tq()), jm.exports;
}
var wo = Dq();
function Oq(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var wm, DS;
function yi() {
  if (DS) return wm;
  DS = 1;
  var e = Array.isArray;
  return wm = e, wm;
}
var Cm, OS;
function nF() {
  if (OS) return Cm;
  OS = 1;
  var e = typeof xs == "object" && xs && xs.Object === Object && xs;
  return Cm = e, Cm;
}
var Fm, RS;
function Mr() {
  if (RS) return Fm;
  RS = 1;
  var e = nF(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return Fm = r, Fm;
}
var Im, PS;
function Go() {
  if (PS) return Im;
  PS = 1;
  var e = Mr(), n = e.Symbol;
  return Im = n, Im;
}
var $m, AS;
function Rq() {
  if (AS) return $m;
  AS = 1;
  var e = Go(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), u = s[a];
    try {
      s[a] = void 0;
      var p = !0;
    } catch {
    }
    var d = i.call(s);
    return p && (l ? s[a] = u : delete s[a]), d;
  }
  return $m = o, $m;
}
var Em, LS;
function Pq() {
  if (LS) return Em;
  LS = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Em = r, Em;
}
var Tm, VS;
function Ca() {
  if (VS) return Tm;
  VS = 1;
  var e = Go(), n = Rq(), r = Pq(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Tm = s, Tm;
}
var Dm, zS;
function Ui() {
  if (zS) return Dm;
  zS = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Dm = e, Dm;
}
var Om, US;
function kg() {
  if (US) return Om;
  US = 1;
  var e = Ca(), n = Ui(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return Om = i, Om;
}
var Rm, MS;
function Aq() {
  if (MS) return Rm;
  MS = 1;
  var e = yi(), n = kg(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return Rm = a, Rm;
}
var Pm, BS;
function Fa() {
  if (BS) return Pm;
  BS = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return Pm = e, Pm;
}
var Am, qS;
function tF() {
  if (qS) return Am;
  qS = 1;
  var e = Ca(), n = Fa(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var u = e(l);
    return u == i || u == a || u == r || u == o;
  }
  return Am = s, Am;
}
var Lm, HS;
function Lq() {
  if (HS) return Lm;
  HS = 1;
  var e = Mr(), n = e["__core-js_shared__"];
  return Lm = n, Lm;
}
var Vm, WS;
function Vq() {
  if (WS) return Vm;
  WS = 1;
  var e = Lq(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return Vm = r, Vm;
}
var zm, KS;
function rF() {
  if (KS) return zm;
  KS = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return zm = r, zm;
}
var Um, GS;
function zq() {
  if (GS) return Um;
  GS = 1;
  var e = tF(), n = Vq(), r = Fa(), i = rF(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, u = s.toString, p = l.hasOwnProperty, d = RegExp(
    "^" + u.call(p).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var v = e(h) ? d : o;
    return v.test(i(h));
  }
  return Um = f, Um;
}
var Mm, YS;
function Uq() {
  if (YS) return Mm;
  YS = 1;
  function e(n, r) {
    return n?.[r];
  }
  return Mm = e, Mm;
}
var Bm, QS;
function Mi() {
  if (QS) return Bm;
  QS = 1;
  var e = zq(), n = Uq();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Bm = r, Bm;
}
var qm, JS;
function ql() {
  if (JS) return qm;
  JS = 1;
  var e = Mi(), n = e(Object, "create");
  return qm = n, qm;
}
var Hm, XS;
function Mq() {
  if (XS) return Hm;
  XS = 1;
  var e = ql();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Hm = n, Hm;
}
var Wm, ZS;
function Bq() {
  if (ZS) return Wm;
  ZS = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return Wm = e, Wm;
}
var Km, e0;
function qq() {
  if (e0) return Km;
  e0 = 1;
  var e = ql(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Km = a, Km;
}
var Gm, n0;
function Hq() {
  if (n0) return Gm;
  n0 = 1;
  var e = ql(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Gm = i, Gm;
}
var Ym, t0;
function Wq() {
  if (t0) return Ym;
  t0 = 1;
  var e = ql(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return Ym = r, Ym;
}
var Qm, r0;
function Kq() {
  if (r0) return Qm;
  r0 = 1;
  var e = Mq(), n = Bq(), r = qq(), i = Hq(), a = Wq();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Qm = o, Qm;
}
var Jm, i0;
function Gq() {
  if (i0) return Jm;
  i0 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Jm = e, Jm;
}
var Xm, a0;
function iF() {
  if (a0) return Xm;
  a0 = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return Xm = e, Xm;
}
var Zm, o0;
function Hl() {
  if (o0) return Zm;
  o0 = 1;
  var e = iF();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return Zm = n, Zm;
}
var ep, s0;
function Yq() {
  if (s0) return ep;
  s0 = 1;
  var e = Hl(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return ep = i, ep;
}
var np, l0;
function Qq() {
  if (l0) return np;
  l0 = 1;
  var e = Hl();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return np = n, np;
}
var tp, c0;
function Jq() {
  if (c0) return tp;
  c0 = 1;
  var e = Hl();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return tp = n, tp;
}
var rp, u0;
function Xq() {
  if (u0) return rp;
  u0 = 1;
  var e = Hl();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return rp = n, rp;
}
var ip, d0;
function Wl() {
  if (d0) return ip;
  d0 = 1;
  var e = Gq(), n = Yq(), r = Qq(), i = Jq(), a = Xq();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, ip = o, ip;
}
var ap, m0;
function bg() {
  if (m0) return ap;
  m0 = 1;
  var e = Mi(), n = Mr(), r = e(n, "Map");
  return ap = r, ap;
}
var op, p0;
function Zq() {
  if (p0) return op;
  p0 = 1;
  var e = Kq(), n = Wl(), r = bg();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return op = i, op;
}
var sp, f0;
function e6() {
  if (f0) return sp;
  f0 = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return sp = e, sp;
}
var lp, h0;
function Kl() {
  if (h0) return lp;
  h0 = 1;
  var e = e6();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return lp = n, lp;
}
var cp, y0;
function n6() {
  if (y0) return cp;
  y0 = 1;
  var e = Kl();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return cp = n, cp;
}
var up, g0;
function t6() {
  if (g0) return up;
  g0 = 1;
  var e = Kl();
  function n(r) {
    return e(this, r).get(r);
  }
  return up = n, up;
}
var dp, v0;
function r6() {
  if (v0) return dp;
  v0 = 1;
  var e = Kl();
  function n(r) {
    return e(this, r).has(r);
  }
  return dp = n, dp;
}
var mp, k0;
function i6() {
  if (k0) return mp;
  k0 = 1;
  var e = Kl();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return mp = n, mp;
}
var pp, b0;
function aF() {
  if (b0) return pp;
  b0 = 1;
  var e = Zq(), n = n6(), r = t6(), i = r6(), a = i6();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var p = s[l];
      this.set(p[0], p[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, pp = o, pp;
}
var fp, _0;
function a6() {
  if (_0) return fp;
  _0 = 1;
  var e = aF(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], u = o.cache;
      if (u.has(l))
        return u.get(l);
      var p = i.apply(this, s);
      return o.cache = u.set(l, p) || u, p;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, fp = r, fp;
}
var hp, x0;
function o6() {
  if (x0) return hp;
  x0 = 1;
  var e = a6(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return hp = r, hp;
}
var yp, S0;
function s6() {
  if (S0) return yp;
  S0 = 1;
  var e = o6(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, u, p) {
      o.push(u ? p.replace(r, "$1") : l || s);
    }), o;
  });
  return yp = i, yp;
}
var gp, N0;
function oF() {
  if (N0) return gp;
  N0 = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return gp = e, gp;
}
var vp, j0;
function l6() {
  if (j0) return vp;
  j0 = 1;
  var e = Go(), n = oF(), r = yi(), i = kg(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var u = l + "";
    return u == "0" && 1 / l == -1 / 0 ? "-0" : u;
  }
  return vp = s, vp;
}
var kp, w0;
function c6() {
  if (w0) return kp;
  w0 = 1;
  var e = l6();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return kp = n, kp;
}
var bp, C0;
function Ia() {
  if (C0) return bp;
  C0 = 1;
  var e = yi(), n = Aq(), r = s6(), i = c6();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return bp = a, bp;
}
var _p, F0;
function Gl() {
  if (F0) return _p;
  F0 = 1;
  var e = kg();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return _p = n, _p;
}
var xp, I0;
function sF() {
  if (I0) return xp;
  I0 = 1;
  var e = Ia(), n = Gl();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return xp = r, xp;
}
var Sp, $0;
function lF() {
  if ($0) return Sp;
  $0 = 1;
  var e = Mi(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Sp = n, Sp;
}
var Np, E0;
function cF() {
  if (E0) return Np;
  E0 = 1;
  var e = lF();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return Np = n, Np;
}
var jp, T0;
function _g() {
  if (T0) return jp;
  T0 = 1;
  var e = cF(), n = iF(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var u = o[s];
    (!(i.call(o, s) && n(u, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return jp = a, jp;
}
var wp, D0;
function xg() {
  if (D0) return wp;
  D0 = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return wp = r, wp;
}
var Cp, O0;
function u6() {
  if (O0) return Cp;
  O0 = 1;
  var e = _g(), n = Ia(), r = xg(), i = Fa(), a = Gl();
  function o(s, l, u, p) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var d = -1, f = l.length, h = f - 1, v = s; v != null && ++d < f; ) {
      var F = a(l[d]), N = u;
      if (F === "__proto__" || F === "constructor" || F === "prototype")
        return s;
      if (d != h) {
        var j = v[F];
        N = p ? p(j, F, v) : void 0, N === void 0 && (N = i(j) ? j : r(l[d + 1]) ? [] : {});
      }
      e(v, F, N), v = v[F];
    }
    return s;
  }
  return Cp = o, Cp;
}
var Fp, R0;
function d6() {
  if (R0) return Fp;
  R0 = 1;
  var e = sF(), n = u6(), r = Ia();
  function i(a, o, s) {
    for (var l = -1, u = o.length, p = {}; ++l < u; ) {
      var d = o[l], f = e(a, d);
      s(f, d) && n(p, r(d, a), f);
    }
    return p;
  }
  return Fp = i, Fp;
}
var Ip, P0;
function m6() {
  if (P0) return Ip;
  P0 = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Ip = e, Ip;
}
var $p, A0;
function p6() {
  if (A0) return $p;
  A0 = 1;
  var e = Ca(), n = Ui(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return $p = i, $p;
}
var Ep, L0;
function Sg() {
  if (L0) return Ep;
  L0 = 1;
  var e = p6(), n = Ui(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Ep = o, Ep;
}
var Tp, V0;
function Ng() {
  if (V0) return Tp;
  V0 = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Tp = n, Tp;
}
var Dp, z0;
function f6() {
  if (z0) return Dp;
  z0 = 1;
  var e = Ia(), n = Sg(), r = yi(), i = xg(), a = Ng(), o = Gl();
  function s(l, u, p) {
    u = e(u, l);
    for (var d = -1, f = u.length, h = !1; ++d < f; ) {
      var v = o(u[d]);
      if (!(h = l != null && p(l, v)))
        break;
      l = l[v];
    }
    return h || ++d != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (r(l) || n(l)));
  }
  return Dp = s, Dp;
}
var Op, U0;
function h6() {
  if (U0) return Op;
  U0 = 1;
  var e = m6(), n = f6();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return Op = r, Op;
}
var Rp, M0;
function y6() {
  if (M0) return Rp;
  M0 = 1;
  var e = d6(), n = h6();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return Rp = r, Rp;
}
var Pp, B0;
function jg() {
  if (B0) return Pp;
  B0 = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return Pp = e, Pp;
}
var Ap, q0;
function g6() {
  if (q0) return Ap;
  q0 = 1;
  var e = Go(), n = Sg(), r = yi(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return Ap = a, Ap;
}
var Lp, H0;
function v6() {
  if (H0) return Lp;
  H0 = 1;
  var e = jg(), n = g6();
  function r(i, a, o, s, l) {
    var u = -1, p = i.length;
    for (o || (o = n), l || (l = []); ++u < p; ) {
      var d = i[u];
      a > 0 && o(d) ? a > 1 ? r(d, a - 1, o, s, l) : e(l, d) : s || (l[l.length] = d);
    }
    return l;
  }
  return Lp = r, Lp;
}
var Vp, W0;
function k6() {
  if (W0) return Vp;
  W0 = 1;
  var e = v6();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return Vp = n, Vp;
}
var zp, K0;
function b6() {
  if (K0) return zp;
  K0 = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return zp = e, zp;
}
var Up, G0;
function _6() {
  if (G0) return Up;
  G0 = 1;
  var e = b6(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, u = n(s.length - a, 0), p = Array(u); ++l < u; )
        p[l] = s[a + l];
      l = -1;
      for (var d = Array(a + 1); ++l < a; )
        d[l] = s[l];
      return d[a] = o(p), e(i, this, d);
    };
  }
  return Up = r, Up;
}
var Mp, Y0;
function x6() {
  if (Y0) return Mp;
  Y0 = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Mp = e, Mp;
}
var Bp, Q0;
function uF() {
  if (Q0) return Bp;
  Q0 = 1;
  function e(n) {
    return n;
  }
  return Bp = e, Bp;
}
var qp, J0;
function S6() {
  if (J0) return qp;
  J0 = 1;
  var e = x6(), n = lF(), r = uF(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return qp = i, qp;
}
var Hp, X0;
function N6() {
  if (X0) return Hp;
  X0 = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), u = n - (l - s);
      if (s = l, u > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Hp = i, Hp;
}
var Wp, Z0;
function j6() {
  if (Z0) return Wp;
  Z0 = 1;
  var e = S6(), n = N6(), r = n(e);
  return Wp = r, Wp;
}
var Kp, eN;
function dF() {
  if (eN) return Kp;
  eN = 1;
  var e = k6(), n = _6(), r = j6();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Kp = i, Kp;
}
var Gp, nN;
function w6() {
  if (nN) return Gp;
  nN = 1;
  var e = y6(), n = dF(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Gp = r, Gp;
}
var C6 = w6();
const mF = /* @__PURE__ */ eF(C6), F6 = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function pF(e) {
  const n = mF(e, F6);
  return {
    controller: hq(n),
    controllerProps: n
  };
}
const I6 = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function $6(e) {
  const { controller: n, controllerProps: r } = pF(e), i = {
    ...mF(e, I6),
    required: Oq(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var Yp, tN;
function E6() {
  if (tN) return Yp;
  tN = 1;
  var e = Wl();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return Yp = n, Yp;
}
var Qp, rN;
function T6() {
  if (rN) return Qp;
  rN = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return Qp = e, Qp;
}
var Jp, iN;
function D6() {
  if (iN) return Jp;
  iN = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return Jp = e, Jp;
}
var Xp, aN;
function O6() {
  if (aN) return Xp;
  aN = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return Xp = e, Xp;
}
var Zp, oN;
function R6() {
  if (oN) return Zp;
  oN = 1;
  var e = Wl(), n = bg(), r = aF(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var u = l.__data__;
      if (!n || u.length < i - 1)
        return u.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(u);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return Zp = a, Zp;
}
var ef, sN;
function P6() {
  if (sN) return ef;
  sN = 1;
  var e = Wl(), n = E6(), r = T6(), i = D6(), a = O6(), o = R6();
  function s(l) {
    var u = this.__data__ = new e(l);
    this.size = u.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, ef = s, ef;
}
var nf, lN;
function A6() {
  if (lN) return nf;
  lN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return nf = e, nf;
}
var tf, cN;
function Yo() {
  if (cN) return tf;
  cN = 1;
  var e = _g(), n = cF();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var u = -1, p = a.length; ++u < p; ) {
      var d = a[u], f = s ? s(o[d], i[d], d, o, i) : void 0;
      f === void 0 && (f = i[d]), l ? n(o, d, f) : e(o, d, f);
    }
    return o;
  }
  return tf = r, tf;
}
var rf, uN;
function L6() {
  if (uN) return rf;
  uN = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return rf = e, rf;
}
var qs = { exports: {} }, af, dN;
function V6() {
  if (dN) return af;
  dN = 1;
  function e() {
    return !1;
  }
  return af = e, af;
}
qs.exports;
var mN;
function fF() {
  return mN || (mN = 1, (function(e, n) {
    var r = Mr(), i = V6(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, u = l ? l.isBuffer : void 0, p = u || i;
    e.exports = p;
  })(qs, qs.exports)), qs.exports;
}
var of, pN;
function z6() {
  if (pN) return of;
  pN = 1;
  var e = Ca(), n = Ng(), r = Ui(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", u = "[object Function]", p = "[object Map]", d = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", F = "[object String]", N = "[object WeakMap]", j = "[object ArrayBuffer]", C = "[object DataView]", g = "[object Float32Array]", z = "[object Float64Array]", T = "[object Int8Array]", I = "[object Int16Array]", D = "[object Int32Array]", U = "[object Uint8Array]", Q = "[object Uint8ClampedArray]", X = "[object Uint16Array]", re = "[object Uint32Array]", G = {};
  G[g] = G[z] = G[T] = G[I] = G[D] = G[U] = G[Q] = G[X] = G[re] = !0, G[i] = G[a] = G[j] = G[o] = G[C] = G[s] = G[l] = G[u] = G[p] = G[d] = G[f] = G[h] = G[v] = G[F] = G[N] = !1;
  function q(R) {
    return r(R) && n(R.length) && !!G[e(R)];
  }
  return of = q, of;
}
var sf, fN;
function wg() {
  if (fN) return sf;
  fN = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return sf = e, sf;
}
var Hs = { exports: {} };
Hs.exports;
var hN;
function Cg() {
  return hN || (hN = 1, (function(e, n) {
    var r = nF(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var u = a && a.require && a.require("util").types;
        return u || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(Hs, Hs.exports)), Hs.exports;
}
var lf, yN;
function U6() {
  if (yN) return lf;
  yN = 1;
  var e = z6(), n = wg(), r = Cg(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return lf = a, lf;
}
var cf, gN;
function hF() {
  if (gN) return cf;
  gN = 1;
  var e = L6(), n = Sg(), r = yi(), i = fF(), a = xg(), o = U6(), s = Object.prototype, l = s.hasOwnProperty;
  function u(p, d) {
    var f = r(p), h = !f && n(p), v = !f && !h && i(p), F = !f && !h && !v && o(p), N = f || h || v || F, j = N ? e(p.length, String) : [], C = j.length;
    for (var g in p)
      (d || l.call(p, g)) && !(N && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      F && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, C))) && j.push(g);
    return j;
  }
  return cf = u, cf;
}
var uf, vN;
function Fg() {
  if (vN) return uf;
  vN = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return uf = n, uf;
}
var df, kN;
function yF() {
  if (kN) return df;
  kN = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return df = e, df;
}
var mf, bN;
function M6() {
  if (bN) return mf;
  bN = 1;
  var e = yF(), n = e(Object.keys, Object);
  return mf = n, mf;
}
var pf, _N;
function B6() {
  if (_N) return pf;
  _N = 1;
  var e = Fg(), n = M6(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return pf = a, pf;
}
var ff, xN;
function gF() {
  if (xN) return ff;
  xN = 1;
  var e = tF(), n = Ng();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return ff = r, ff;
}
var hf, SN;
function Ig() {
  if (SN) return hf;
  SN = 1;
  var e = hF(), n = B6(), r = gF();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return hf = i, hf;
}
var yf, NN;
function q6() {
  if (NN) return yf;
  NN = 1;
  var e = Yo(), n = Ig();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return yf = r, yf;
}
var gf, jN;
function H6() {
  if (jN) return gf;
  jN = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return gf = e, gf;
}
var vf, wN;
function W6() {
  if (wN) return vf;
  wN = 1;
  var e = Fa(), n = Fg(), r = H6(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), u = [];
    for (var p in s)
      p == "constructor" && (l || !a.call(s, p)) || u.push(p);
    return u;
  }
  return vf = o, vf;
}
var kf, CN;
function $g() {
  if (CN) return kf;
  CN = 1;
  var e = hF(), n = W6(), r = gF();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return kf = i, kf;
}
var bf, FN;
function K6() {
  if (FN) return bf;
  FN = 1;
  var e = Yo(), n = $g();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return bf = r, bf;
}
var Ws = { exports: {} };
Ws.exports;
var IN;
function G6() {
  return IN || (IN = 1, (function(e, n) {
    var r = Mr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function u(p, d) {
      if (d)
        return p.slice();
      var f = p.length, h = l ? l(f) : new p.constructor(f);
      return p.copy(h), h;
    }
    e.exports = u;
  })(Ws, Ws.exports)), Ws.exports;
}
var _f, $N;
function Y6() {
  if ($N) return _f;
  $N = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return _f = e, _f;
}
var xf, EN;
function Q6() {
  if (EN) return xf;
  EN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return xf = e, xf;
}
var Sf, TN;
function vF() {
  if (TN) return Sf;
  TN = 1;
  function e() {
    return [];
  }
  return Sf = e, Sf;
}
var Nf, DN;
function Eg() {
  if (DN) return Nf;
  DN = 1;
  var e = Q6(), n = vF(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Nf = o, Nf;
}
var jf, ON;
function J6() {
  if (ON) return jf;
  ON = 1;
  var e = Yo(), n = Eg();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return jf = r, jf;
}
var wf, RN;
function Tg() {
  if (RN) return wf;
  RN = 1;
  var e = yF(), n = e(Object.getPrototypeOf, Object);
  return wf = n, wf;
}
var Cf, PN;
function kF() {
  if (PN) return Cf;
  PN = 1;
  var e = jg(), n = Tg(), r = Eg(), i = vF(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return Cf = o, Cf;
}
var Ff, AN;
function X6() {
  if (AN) return Ff;
  AN = 1;
  var e = Yo(), n = kF();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Ff = r, Ff;
}
var If, LN;
function bF() {
  if (LN) return If;
  LN = 1;
  var e = jg(), n = yi();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return If = r, If;
}
var $f, VN;
function Z6() {
  if (VN) return $f;
  VN = 1;
  var e = bF(), n = Eg(), r = Ig();
  function i(a) {
    return e(a, r, n);
  }
  return $f = i, $f;
}
var Ef, zN;
function _F() {
  if (zN) return Ef;
  zN = 1;
  var e = bF(), n = kF(), r = $g();
  function i(a) {
    return e(a, r, n);
  }
  return Ef = i, Ef;
}
var Tf, UN;
function eH() {
  if (UN) return Tf;
  UN = 1;
  var e = Mi(), n = Mr(), r = e(n, "DataView");
  return Tf = r, Tf;
}
var Df, MN;
function nH() {
  if (MN) return Df;
  MN = 1;
  var e = Mi(), n = Mr(), r = e(n, "Promise");
  return Df = r, Df;
}
var Of, BN;
function tH() {
  if (BN) return Of;
  BN = 1;
  var e = Mi(), n = Mr(), r = e(n, "Set");
  return Of = r, Of;
}
var Rf, qN;
function rH() {
  if (qN) return Rf;
  qN = 1;
  var e = Mi(), n = Mr(), r = e(n, "WeakMap");
  return Rf = r, Rf;
}
var Pf, HN;
function Dg() {
  if (HN) return Pf;
  HN = 1;
  var e = eH(), n = bg(), r = nH(), i = tH(), a = rH(), o = Ca(), s = rF(), l = "[object Map]", u = "[object Object]", p = "[object Promise]", d = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), F = s(n), N = s(r), j = s(i), C = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != p || i && g(new i()) != d || a && g(new a()) != f) && (g = function(z) {
    var T = o(z), I = T == u ? z.constructor : void 0, D = I ? s(I) : "";
    if (D)
      switch (D) {
        case v:
          return h;
        case F:
          return l;
        case N:
          return p;
        case j:
          return d;
        case C:
          return f;
      }
    return T;
  }), Pf = g, Pf;
}
var Af, WN;
function iH() {
  if (WN) return Af;
  WN = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Af = r, Af;
}
var Lf, KN;
function aH() {
  if (KN) return Lf;
  KN = 1;
  var e = Mr(), n = e.Uint8Array;
  return Lf = n, Lf;
}
var Vf, GN;
function Og() {
  if (GN) return Vf;
  GN = 1;
  var e = aH();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return Vf = n, Vf;
}
var zf, YN;
function oH() {
  if (YN) return zf;
  YN = 1;
  var e = Og();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return zf = n, zf;
}
var Uf, QN;
function sH() {
  if (QN) return Uf;
  QN = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return Uf = n, Uf;
}
var Mf, JN;
function lH() {
  if (JN) return Mf;
  JN = 1;
  var e = Go(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return Mf = i, Mf;
}
var Bf, XN;
function cH() {
  if (XN) return Bf;
  XN = 1;
  var e = Og();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Bf = n, Bf;
}
var qf, ZN;
function uH() {
  if (ZN) return qf;
  ZN = 1;
  var e = Og(), n = oH(), r = sH(), i = lH(), a = cH(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", u = "[object Number]", p = "[object RegExp]", d = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", F = "[object DataView]", N = "[object Float32Array]", j = "[object Float64Array]", C = "[object Int8Array]", g = "[object Int16Array]", z = "[object Int32Array]", T = "[object Uint8Array]", I = "[object Uint8ClampedArray]", D = "[object Uint16Array]", U = "[object Uint32Array]";
  function Q(X, re, G) {
    var q = X.constructor;
    switch (re) {
      case v:
        return e(X);
      case o:
      case s:
        return new q(+X);
      case F:
        return n(X, G);
      case N:
      case j:
      case C:
      case g:
      case z:
      case T:
      case I:
      case D:
      case U:
        return a(X, G);
      case l:
        return new q();
      case u:
      case f:
        return new q(X);
      case p:
        return r(X);
      case d:
        return new q();
      case h:
        return i(X);
    }
  }
  return qf = Q, qf;
}
var Hf, ej;
function dH() {
  if (ej) return Hf;
  ej = 1;
  var e = Fa(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Hf = r, Hf;
}
var Wf, nj;
function mH() {
  if (nj) return Wf;
  nj = 1;
  var e = dH(), n = Tg(), r = Fg();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Wf = i, Wf;
}
var Kf, tj;
function pH() {
  if (tj) return Kf;
  tj = 1;
  var e = Dg(), n = Ui(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Kf = i, Kf;
}
var Gf, rj;
function fH() {
  if (rj) return Gf;
  rj = 1;
  var e = pH(), n = wg(), r = Cg(), i = r && r.isMap, a = i ? n(i) : e;
  return Gf = a, Gf;
}
var Yf, ij;
function hH() {
  if (ij) return Yf;
  ij = 1;
  var e = Dg(), n = Ui(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Yf = i, Yf;
}
var Qf, aj;
function yH() {
  if (aj) return Qf;
  aj = 1;
  var e = hH(), n = wg(), r = Cg(), i = r && r.isSet, a = i ? n(i) : e;
  return Qf = a, Qf;
}
var Jf, oj;
function gH() {
  if (oj) return Jf;
  oj = 1;
  var e = P6(), n = A6(), r = _g(), i = q6(), a = K6(), o = G6(), s = Y6(), l = J6(), u = X6(), p = Z6(), d = _F(), f = Dg(), h = iH(), v = uH(), F = mH(), N = yi(), j = fF(), C = fH(), g = Fa(), z = yH(), T = Ig(), I = $g(), D = 1, U = 2, Q = 4, X = "[object Arguments]", re = "[object Array]", G = "[object Boolean]", q = "[object Date]", R = "[object Error]", B = "[object Function]", ee = "[object GeneratorFunction]", be = "[object Map]", fe = "[object Number]", de = "[object Object]", ge = "[object RegExp]", K = "[object Set]", xe = "[object String]", $e = "[object Symbol]", Y = "[object WeakMap]", qe = "[object ArrayBuffer]", Me = "[object DataView]", Le = "[object Float32Array]", Ue = "[object Float64Array]", De = "[object Int8Array]", ze = "[object Int16Array]", Re = "[object Int32Array]", on = "[object Uint8Array]", Ee = "[object Uint8ClampedArray]", Qe = "[object Uint16Array]", Xe = "[object Uint32Array]", se = {};
  se[X] = se[re] = se[qe] = se[Me] = se[G] = se[q] = se[Le] = se[Ue] = se[De] = se[ze] = se[Re] = se[be] = se[fe] = se[de] = se[ge] = se[K] = se[xe] = se[$e] = se[on] = se[Ee] = se[Qe] = se[Xe] = !0, se[R] = se[B] = se[Y] = !1;
  function ye(je, Ve, Oe, dn, E, _) {
    var O, W = Ve & D, J = Ve & U, L = Ve & Q;
    if (Oe && (O = E ? Oe(je, dn, E, _) : Oe(je)), O !== void 0)
      return O;
    if (!g(je))
      return je;
    var M = N(je);
    if (M) {
      if (O = h(je), !W)
        return s(je, O);
    } else {
      var ie = f(je), he = ie == B || ie == ee;
      if (j(je))
        return o(je, W);
      if (ie == de || ie == X || he && !E) {
        if (O = J || he ? {} : F(je), !W)
          return J ? u(je, a(O, je)) : l(je, i(O, je));
      } else {
        if (!se[ie])
          return E ? je : {};
        O = v(je, ie, W);
      }
    }
    _ || (_ = new e());
    var Ne = _.get(je);
    if (Ne)
      return Ne;
    _.set(je, O), z(je) ? je.forEach(function(Ze) {
      O.add(ye(Ze, Ve, Oe, Ze, je, _));
    }) : C(je) && je.forEach(function(Ze, sn) {
      O.set(sn, ye(Ze, Ve, Oe, sn, je, _));
    });
    var nn = L ? J ? d : p : J ? I : T, mn = M ? void 0 : nn(je);
    return n(mn || je, function(Ze, sn) {
      mn && (sn = Ze, Ze = je[sn]), r(O, sn, ye(Ze, Ve, Oe, sn, je, _));
    }), O;
  }
  return Jf = ye, Jf;
}
var Xf, sj;
function vH() {
  if (sj) return Xf;
  sj = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return Xf = e, Xf;
}
var Zf, lj;
function kH() {
  if (lj) return Zf;
  lj = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return Zf = e, Zf;
}
var eh, cj;
function bH() {
  if (cj) return eh;
  cj = 1;
  var e = sF(), n = kH();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return eh = r, eh;
}
var nh, uj;
function _H() {
  if (uj) return nh;
  uj = 1;
  var e = Ia(), n = vH(), r = bH(), i = Gl(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, u) {
    u = e(u, l);
    var p = -1, d = u.length;
    if (!d)
      return !0;
    for (; ++p < d; ) {
      var f = i(u[p]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && p < d - 1)
        return !1;
    }
    var h = r(l, u);
    return h == null || delete h[i(n(u))];
  }
  return nh = s, nh;
}
var th, dj;
function xH() {
  if (dj) return th;
  dj = 1;
  var e = Ca(), n = Tg(), r = Ui(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, u = s.call(Object);
  function p(d) {
    if (!r(d) || e(d) != i)
      return !1;
    var f = n(d);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == u;
  }
  return th = p, th;
}
var rh, mj;
function SH() {
  if (mj) return rh;
  mj = 1;
  var e = xH();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return rh = n, rh;
}
var ih, pj;
function NH() {
  if (pj) return ih;
  pj = 1;
  var e = oF(), n = gH(), r = _H(), i = Ia(), a = Yo(), o = SH(), s = dF(), l = _F(), u = 1, p = 2, d = 4, f = s(function(h, v) {
    var F = {};
    if (h == null)
      return F;
    var N = !1;
    v = e(v, function(C) {
      return C = i(C, h), N || (N = C.length > 1), C;
    }), a(h, l(h), F), N && (F = n(F, u | p | d, o));
    for (var j = v.length; j--; )
      r(F, v[j]);
    return F;
  });
  return ih = f, ih;
}
NH();
var jH = uF();
const wH = /* @__PURE__ */ eF(jH), Xi = ({
  transformValue: e = wH,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = pF(a);
  return /* @__PURE__ */ wo.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ wo.jsx(
      Qs,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ wo.jsx(bw, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, fj = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = $6(e);
  return /* @__PURE__ */ wo.jsx(en, { ...i, children: /* @__PURE__ */ wo.jsx(
    fr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: en.getStatus(i.meta)
    }
  ) });
}, ty = [
  {
    key: "rivoLoyaltyApiKey",
    defaultValue: "",
    secret: !0,
    type: "string"
  },
  {
    key: pg,
    defaultValue: "",
    secret: !1,
    type: "string"
  },
  {
    key: "rivoLoyaltyShowOrders",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowLoyalty",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyAdjustLoyaltyPoints",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowFavoriteProducts",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowPointsRedemptions",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  }
], hj = "RIVOLOYALTY", Ns = "Rivo Loyalty", CH = {
  enabled: !1,
  name: "",
  rivoLoyaltyApiKey: "",
  [pg]: "",
  rivoLoyaltyShowOrders: !0,
  rivoLoyaltyShowLoyalty: !0,
  rivoLoyaltyAdjustLoyaltyPoints: !0,
  rivoLoyaltyShowFavoriteProducts: !0,
  rivoLoyaltyShowPointsRedemptions: !0
}, FH = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = $q({
    mode: "onChange",
    defaultValues: CH
  }), {
    create: l,
    update: u,
    remove: p,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = Xr({
    integrationId: e,
    integrationType: hj,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: N,
    isWidgetUnknown: j,
    refetch: C,
    widgetConfiguration: g
  } = Zr({
    integrationId: e,
    fieldDefinitions: ty,
    form: s,
    onMisconfigured: v
  }), { renderConditions: z, setRenderConditions: T, renderConditionsForSubmit: I } = ei({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), D = (Q) => ti(Q, {
    fieldDefinitions: ty,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: I
  }), U = s.watch("name");
  return /* @__PURE__ */ ve.jsxs(
    ni,
    {
      form: s,
      integrationId: e,
      onValidSubmit: D,
      error: N ?? f,
      onRetry: N ? C : void 0,
      isLoading: d || F,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ ve.jsx(ri, { cause: h }),
        /* @__PURE__ */ ve.jsxs(at, { children: [
          /* @__PURE__ */ ve.jsx(me, { children: /* @__PURE__ */ ve.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ve.jsx(
            Xi,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ve.jsx(me, { span: 3, children: /* @__PURE__ */ ve.jsx(
            fj,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ve.jsx(me, { span: 3 }),
          /* @__PURE__ */ ve.jsx(me, { span: 3, children: /* @__PURE__ */ ve.jsx(
            fj,
            {
              name: "rivoLoyaltyShopifyApiHostName",
              label: "Shopify API host name",
              control: s.control,
              rules: {
                required: "Shopify API host name is required",
                validate: (Q) => cy(Q) ?? void 0
              },
              componentProps: {
                placeholder: 'Host name of your Shopify shop, e.g. "my-webshop.myshopify.com"',
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ ve.jsx(me, { span: 3 }),
          /* @__PURE__ */ ve.jsx(me, { span: 3, children: /* @__PURE__ */ ve.jsx(
            Ro,
            {
              name: "rivoLoyaltyApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "Insert your Rivo API key",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ve.jsx(me, { span: 3 }),
          /* @__PURE__ */ ve.jsx(me, { span: 3, children: /* @__PURE__ */ ve.jsx(en, { label: "Show orders overview", children: /* @__PURE__ */ ve.jsx(
            Xi,
            {
              name: "rivoLoyaltyShowOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ve.jsx(me, { span: 3 }),
          /* @__PURE__ */ ve.jsx(me, { span: 3, children: /* @__PURE__ */ ve.jsx(en, { label: "Show loyalty", children: /* @__PURE__ */ ve.jsx(
            Xi,
            {
              name: "rivoLoyaltyShowLoyalty",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ve.jsx(me, { span: 3 }),
          /* @__PURE__ */ ve.jsx(me, { span: 3, children: /* @__PURE__ */ ve.jsx(en, { label: "Allow adjusting loyalty points", children: /* @__PURE__ */ ve.jsx(
            Xi,
            {
              name: "rivoLoyaltyAdjustLoyaltyPoints",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ve.jsx(me, { span: 3 }),
          /* @__PURE__ */ ve.jsx(me, { span: 3, children: /* @__PURE__ */ ve.jsx(en, { label: "Show favorite products", children: /* @__PURE__ */ ve.jsx(
            Xi,
            {
              name: "rivoLoyaltyShowFavoriteProducts",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ve.jsx(me, { span: 3 }),
          /* @__PURE__ */ ve.jsx(me, { span: 3, children: /* @__PURE__ */ ve.jsx(en, { label: "Show available rewards", children: /* @__PURE__ */ ve.jsx(
            Xi,
            {
              name: "rivoLoyaltyShowPointsRedemptions",
              control: s.control
            }
          ) }) }),
          a && z !== null && /* @__PURE__ */ ve.jsx(me, { children: a({
            value: z,
            onChange: T,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ ve.jsx(
          ii,
          {
            integrationType: hj,
            integrationId: e,
            widgetName: U,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ ve.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ ve.jsx(
                pe,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ ve.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ ve.jsxs(A.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Ns,
                  " integration, all links between Dixa and ",
                  Ns,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ ve.jsxs(A.Paragraph, { children: [
                  "All data in ",
                  Ns,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ ve.jsxs(A.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Ns,
                  " ",
                  'integration "',
                  U,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._modal_1mprq_1{width:900px}._copyIcon_1dlzg_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._modal_21e62_1{max-width:900px}._modal_al73g_1{width:600px}._editIcon_1yp2k_1,._copyIcon_1yp2k_2,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._copyIcon_yc0fe_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._order_yc0fe_6{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_yc0fe_6:hover,._orderIsOpen_yc0fe_14{border-color:var(--dixa-color-neutral-400)}._orderHeader_yc0fe_17{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ah = { exports: {} }, so = {}, yj;
function IH() {
  if (yj) return so;
  yj = 1;
  var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return so.Fragment = r, so.jsx = s, so.jsxs = s, so;
}
var js = {}, gj;
function $H() {
  return gj || (gj = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[N];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        z("error", t, m);
      }
    }
    function z(t, c, m) {
      {
        var y = C.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var P = m.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var T = !1, I = !1, D = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || U || t === v || T || I || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function q(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return q(c) + ".Consumer";
          case s:
            var m = t;
            return q(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return R(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, be, fe, de, ge, K, xe, $e;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          be = console.log, fe = console.info, de = console.warn, ge = console.error, K = console.group, xe = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: be
            }),
            info: B({}, t, {
              value: fe
            }),
            warn: B({}, t, {
              value: de
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: K
            }),
            groupCollapsed: B({}, t, {
              value: xe
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = C.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var ze = !1, Re;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new on();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var m = Re.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      ze = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Le.current, Le.current = null, qe();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var S = te.stack.split(`
`), ne = y.stack.split(`
`), H = S.length - 1, x = ne.length - 1; H >= 1 && x >= 0 && S[H] !== ne[x]; )
            x--;
          for (; H >= 1 && x >= 0; H--, x--)
            if (S[H] !== ne[x]) {
              if (H !== 1 || x !== 1)
                do
                  if (H--, x--, x < 0 || S[H] !== ne[x]) {
                    var Z = `
` + S[H].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (H >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Le.current = P, Me(), Error.prepareStackTrace = $;
      }
      var ue = t ? t.displayName || t.name : "", _e = ue ? De(ue) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Qe(t, c, m) {
      return Ee(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Xe(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case d:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Qe(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return se(P($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, je = {}, Ve = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function dn(t, c, m, y, $) {
      {
        var P = Function.call.bind(ye);
        for (var w in t)
          if (P(t, w)) {
            var S = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + m + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[w](c, w, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              S = H;
            }
            S && !(S instanceof Error) && (Oe($), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, w, typeof S), Oe(null)), S instanceof Error && !(S.message in je) && (je[S.message] = !0, Oe($), g("Failed %s type: %s", m, S.message), Oe(null));
          }
      }
    }
    var E = Array.isArray;
    function _(t) {
      return E(t);
    }
    function O(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function W(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function L(t) {
      if (W(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", O(t)), J(t);
    }
    var M = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Ze(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function sn(t, c) {
      {
        var m = function() {
          he || (he = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function hn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, m, y, $, P, w) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function _n(t, c, m, y, $) {
      {
        var P, w = {}, S = null, ne = null;
        m !== void 0 && (L(m), S = "" + m), mn(c) && (L(c.key), S = "" + c.key), nn(c) && (ne = c.ref, Ze(c));
        for (P in c)
          ye.call(c, P) && !ie.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var H = t.defaultProps;
          for (P in H)
            w[P] === void 0 && (w[P] = H[P]);
        }
        if (S || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && sn(w, x), ne && hn(w, x);
        }
        return pn(t, S, ne, $, y, M.current, w);
      }
    }
    var Je = C.ReactCurrentOwner, Nn = C.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(m);
      } else
        Nn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (Je.current) {
          var t = R(Je.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Mn(t) {
      return "";
    }
    var jn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = kn(c);
        if (jn[m])
          return;
        jn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Je.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ae(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ae(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            cn(y) && gn(y, c);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              cn(w.value) && gn(w.value, c);
        }
      }
    }
    function zn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = R(c);
          dn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var $ = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function An(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ae(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var xn = {};
    function Sn(t, c, m, y, $, P) {
      {
        var w = re(t);
        if (!w) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = Mn();
          ne ? S += ne : S += vn();
          var H;
          t === null ? H = "null" : _(t) ? H = "array" : t !== void 0 && t.$$typeof === n ? (H = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : H = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, S);
        }
        var x = _n(t, c, m, $, P);
        if (x == null)
          return x;
        if (w) {
          var Z = c.children;
          if (Z !== void 0)
            if (y)
              if (_(Z)) {
                for (var ue = 0; ue < Z.length; ue++)
                  wn(Z[ue], t);
                Object.freeze && Object.freeze(Z);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = R(t), te = Object.keys(c).filter(function($n) {
            return $n !== "key";
          }), Ke = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? An(x) : zn(x), x;
      }
    }
    function Bn(t, c, m) {
      return Sn(t, c, m, !0);
    }
    function On(t, c, m) {
      return Sn(t, c, m, !1);
    }
    var Rn = On, Un = Bn;
    js.Fragment = i, js.jsx = Rn, js.jsxs = Un;
  })()), js;
}
var vj;
function EH() {
  return vj || (vj = 1, process.env.NODE_ENV === "production" ? ah.exports = IH() : ah.exports = $H()), ah.exports;
}
var k = EH();
const kj = "__PairingContext__", TH = () => globalThis[kj] ?? (() => {
  const e = kw({});
  return globalThis[kj] = e, e;
})(), DH = TH(), OH = () => dy(DH), RH = "_banner_d9pot_1", PH = "_list_d9pot_8", bj = {
  banner: RH,
  list: PH
}, _j = "https://apps.shopify.com/dixa-dashboard", AH = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, xF = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = OH(), [i, a] = le(!1), [o, s] = le(null), l = AH[n], u = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const d = await r();
        window.open(
          d ?? _j,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(_j, "_blank", "noopener,noreferrer");
  }, p = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", className: bj.banner, children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(pe, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { as: "div", children: /* @__PURE__ */ k.jsx(p, { className: bj.list, children: l.listItems.map((d, f) => /* @__PURE__ */ k.jsx("li", { children: d }, f)) }) })
    ] }),
    o && /* @__PURE__ */ k.jsx(A.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ k.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ k.jsx(
      Yn,
      {
        onClick: u,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(fn, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, LH = (e) => /* @__PURE__ */ k.jsx(xF, { ...e, bannerVariant: "install" }), VH = (e) => /* @__PURE__ */ k.jsx(xF, { ...e, bannerVariant: "migration" }), zH = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], UH = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], MH = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: LH
  }
], BH = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], xj = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: VH,
    additionalProperties: { renderAboveForm: !0 }
  }
], SF = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], Sj = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => cy(e)
  },
  ...SF
];
var ia = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(ia || {}), Di = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(Di || {}), Or = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Or || {}), NF = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(NF || {}), Ni = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(Ni || {}), Yr = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Yr || {}), Ks = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(Ks || {}), jF = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))(jF || {});
const qH = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, HH = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, WH = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, KH = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, GH = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, YH = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, QH = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, JH = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refuncLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, XH = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, ZH = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, eW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, nW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, tW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, rW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "readDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, iW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, aW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, oW = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": qH,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": HH,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": WH,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": KH,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": GH,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": YH,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": QH,
  "\n  mutation refuncLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": JH,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": XH,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": ZH,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": eW,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": nW,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": tW,
  "\n  query readDiscountCodes($first: Int) {\n    Shopify {\n      codeDiscountNodes(first: $first) {\n        nodes {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeApp {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": rW,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": iW,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": aW
};
function vr(e) {
  return oW[e] ?? {};
}
const sW = vr(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), lW = vr(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), cW = vr(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), uW = vr(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), Rg = vr(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), dW = vr(
  /* GraphQL */
  `
  query readDiscountCodes($first: Int) {
    Shopify {
      codeDiscountNodes(first: $first) {
        nodes {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeApp {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), mW = vr(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), pW = vr(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), fW = vr(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), hW = vr(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), yW = vr(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), gW = vr(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), wF = Sl`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, vW = Sl`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, kW = ({
  conversationContext: e
}) => {
  const { useQuery: n } = yn(), r = e.customer?.email, i = e.customer?.phone_number, a = r ? `email:"${r}"` : null, o = i ? `phone:"${i}"` : null, s = a ?? o ?? null, {
    loading: l,
    error: u,
    data: p,
    refetch: d,
    networkStatus: f
  } = n(sW, {
    skip: !s,
    variables: {
      query: s
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: l,
    customerError: u,
    customerData: p,
    refetchCustomer: d,
    customerNetworkStatus: f
  };
}, bW = () => {
  const { useLazyQuery: e } = yn(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(lW);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function Lr(e = !1, n) {
  const [r, i] = le(e);
  return Ye(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const _W = "_list_alvh6_1", xW = "_listItem_alvh6_4", SW = "_fullWidth_alvh6_15", NW = "_boxWrapper_alvh6_19", Lt = {
  list: _W,
  listItem: xW,
  fullWidth: SW,
  boxWrapper: NW
}, jW = "_modal_1vkwz_1", wW = "_disabled_1vkwz_5", oh = {
  modal: jW,
  disabled: wW
}, Nj = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: Di.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: Di.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: Di.Unknown
  }
], jj = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: Or.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: Or.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: Or.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: Or.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: Or.Unsubscribed
  }
], CW = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = Cn(), { useMutation: l, showNotification: u } = yn(), [p, d] = le(), [f, h] = le(), [v, F] = Iv(!0), [N, j] = Iv(!0), C = !!p, g = e.customer?.email, z = e.customer?.phone_number, T = e.customer?.given_name, I = e.customer?.family_name, D = {
    email: g ?? "",
    phone: z ?? "",
    firstName: T ?? "",
    lastName: I ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, U = gt({
    defaultValues: D
  });
  Ye(() => {
    f?.forEach((R) => {
      const B = R?.field?.[0];
      B && (U.setError(B, {
        type: "server",
        message: R.message
      }), U.setFocus(B));
    });
  }, [f, U]);
  const [Q, { error: X, reset: re }] = l(yW, {
    onError: (R) => {
      d(R.message), a(!1), u({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (R) => {
      const B = R?.Shopify?.customerCreate?.userErrors || [];
      B.length > 0 ? (h(B), a(!1), u({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), u({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), G = lt(
    (R) => {
      a(!0), d(void 0), Q({
        variables: {
          input: {
            firstName: R.firstName,
            lastName: R.lastName,
            ...v && { email: R.email },
            ...N && { phone: R.phone },
            ...R.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: R.smsMarketingState,
                marketingOptInLevel: R.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [Q, a, N, v]
  ), q = () => {
    r(!1), re(), d(void 0), U.reset(D);
  };
  return /* @__PURE__ */ k.jsxs(jt, { isOpen: n, onClose: q, className: oh.modal, children: [
    /* @__PURE__ */ k.jsx(wt, { title: "Create new customer", onClose: q }),
    /* @__PURE__ */ k.jsx(Ct, { children: /* @__PURE__ */ k.jsxs(at, { children: [
      /* @__PURE__ */ k.jsx(me, { span: 3, children: /* @__PURE__ */ k.jsx(
        Qn,
        {
          label: "First name",
          name: "firstName",
          control: U.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(me, { span: 3, children: /* @__PURE__ */ k.jsx(
        Qn,
        {
          label: "Last name",
          name: "lastName",
          control: U.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(
        Qn,
        {
          label: "Email",
          name: "email",
          control: U.control,
          rules: {
            required: v ? "Email is required" : void 0
          },
          componentProps: {
            className: it({
              [oh.disabled]: !v
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                Qs,
                {
                  disabled: !N,
                  name: "hasEmail",
                  value: "email",
                  checked: v,
                  onChange: () => F()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(
        Qn,
        {
          label: "Phone",
          name: "phone",
          control: U.control,
          rules: {
            required: N ? "Phone is required" : void 0
          },
          componentProps: {
            className: it({
              [oh.disabled]: !N
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                Qs,
                {
                  disabled: !v,
                  name: "hasPhone",
                  value: "phone",
                  checked: N,
                  onChange: () => j()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(
        Cr,
        {
          control: U.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (R, B) => R === B,
            getItemTitleByValue: (R) => {
              const B = jj.find(
                (ee) => ee.value === R
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: B.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: B.description })
                  ]
                }
              );
            }
          },
          children: jj.map((R) => /* @__PURE__ */ k.jsx(mt.Item, { value: R.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: R.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: R.description })
          ] }) }, R.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(
        Cr,
        {
          control: U.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (R, B) => R === B,
            getItemTitleByValue: (R) => {
              const B = Nj.find(
                (ee) => ee.value === R
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: B.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: B.description })
                  ]
                }
              );
            }
          },
          children: Nj.map((R) => /* @__PURE__ */ k.jsx(mt.Item, { value: R.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: R.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: R.description })
          ] }) }, R.value))
        }
      ) }),
      C && /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(pe, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { children: p })
      ] }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      Pt,
      {
        confirmProps: {
          disabled: !(U.formState.isValid && U.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ k.jsx(fn, { size: 16 })
        },
        confirmOnClick: U.handleSubmit(G),
        cancelOnClick: q,
        confirmName: X ? "Close" : "Save",
        cancelName: X ? void 0 : "Cancel"
      }
    )
  ] });
}, FW = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = le(!1), [a, o] = le(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsx(
      Yn,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ k.jsx(fn, { size: 16 }),
        slotStart: /* @__PURE__ */ k.jsx(pe, { size: 14, name: "user-plus", color: "green.500" }),
        className: Lt.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ k.jsx(
      CW,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, Pg = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, ry = "DD MMM YYYY @ HH:mm", IW = "_wrapper_10fld_1", $W = "_copyIcon_10fld_7", ws = {
  wrapper: IW,
  copyIcon: $W
}, EW = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = Lr(), { isCopied: l, copy: u } = Lr(), { track: p } = Cn();
  if (!e)
    return null;
  const {
    id: d,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: v,
    tags: F = [],
    verifiedEmail: N
  } = e, j = h?.emailAddress, C = v?.phoneNumber, g = Pg(d), z = `https://${n}/admin/customers/${g ?? ""}`, T = i && a === rr.refetch, I = 14;
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { className: ws.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: f }),
        T ? /* @__PURE__ */ k.jsx(fn, { size: I }) : /* @__PURE__ */ k.jsx(Ge, { content: "Reload customer", children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: I,
            name: "sync",
            onClick: () => {
              p("shopify:refreshed", { shopifyId: d }), r();
            },
            className: ws.copyIcon
          }
        ) })
      ] }),
      j && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(pe, { size: I, name: "mail" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `mailto:${j}`, children: j }),
          /* @__PURE__ */ k.jsx(
            Ge,
            {
              content: N ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(
                pe,
                {
                  size: I,
                  color: N ? "green.500" : "red.500",
                  name: N ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ k.jsx(Ge, { content: "Copy Email", children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: I,
            name: o ? "done" : "copy",
            onClick: () => s(j),
            className: ws.copyIcon
          }
        ) })
      ] }),
      C && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(pe, { size: I, name: "phone" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `tel:${C}`, children: C })
        ] }),
        /* @__PURE__ */ k.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: I,
            name: l ? "done" : "copy",
            onClick: () => u(C),
            className: ws.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ k.jsx(pe, { size: I, name: "external-link" }),
        /* @__PURE__ */ k.jsx(
          A.ExternalLink,
          {
            href: z,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    F.length > 0 && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: F.map((D) => /* @__PURE__ */ k.jsx(qn, { children: D }, `${d}-${D}`)) })
    ] })
  ] });
}, TW = "_creationModal_pbe64_1", DW = "_detailsModal_pbe64_5", OW = "_percentageSuffix_pbe64_9", sh = {
  creationModal: TW,
  detailsModal: DW,
  percentageSuffix: OW
}, RW = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, PW = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      case "none":
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: NF.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, wj = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], Cj = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], Fj = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], AW = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = Gt(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ k.jsxs(We, { children: [
      /* @__PURE__ */ k.jsx(We.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ k.jsx(We.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(
            pe,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ k.jsx(We.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ k.jsx(We.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ k.jsx(We.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: Hn(e?.startsAt).format(St) })
      ] }) })
    ] }),
    /* @__PURE__ */ k.jsx(en, { label: "Discount code", children: /* @__PURE__ */ k.jsx(
      fr,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, LW = "shopify-discount-code-form", Ij = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, VW = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = Cn(), { useMutation: i, showNotification: a } = yn(), [o, s] = le(
    []
  ), [l, u] = le(), p = gt({
    mode: "all",
    defaultValues: Ij
  });
  Ye(() => {
    o?.forEach((I) => {
      const D = I?.field?.[1];
      D && p.setError(D, {
        type: "server",
        message: I.message
      });
    });
  }, [o, p]);
  const d = !!l, f = p.watch("minimumRequirementOption"), h = p.watch("customerGetsOption"), v = Kn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      case "none":
      default:
        return "";
    }
  }, [f]), [
    F,
    {
      loading: N,
      error: j,
      reset: C
    }
  ] = i(gW, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (I) => {
      const D = I?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (D && D.length > 0)
        s(D);
      else {
        const U = I?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        U && "codes" in U && u(U), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), g = () => {
    p.setValue("code", RW(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, z = (I) => {
    F({
      variables: {
        input: PW(I)
      }
    });
  }, T = () => {
    p.reset(Ij), s([]), C(), u(void 0), n(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    jt,
    {
      isOpen: e,
      onClose: T,
      className: it({
        [sh.creationModal]: !d,
        [sh.detailsModal]: d
      }),
      children: [
        /* @__PURE__ */ k.jsx(
          wt,
          {
            title: d ? "Discount code details" : "Create new discount code",
            onClose: T
          }
        ),
        /* @__PURE__ */ k.jsxs(Ct, { children: [
          d && /* @__PURE__ */ k.jsx(AW, { codeDiscount: l }),
          !d && /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: LW, onSubmit: p.handleSubmit(z), children: [
            /* @__PURE__ */ k.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ k.jsx(
              xl,
              {
                variant: "info",
                description: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ k.jsxs(at, { children: [
              /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(
                Qn,
                {
                  label: "Title",
                  name: "title",
                  control: p.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(me, { span: 3, children: /* @__PURE__ */ k.jsx(
                Cr,
                {
                  control: p.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (I, D) => I === D,
                    onChange: () => {
                      p.setValue("customerGets", void 0), p.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (I) => {
                      const D = wj.find(
                        (U) => U.value === I
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: wj.map((I) => /* @__PURE__ */ k.jsx(mt.Item, { value: I.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(me, { span: 3, children: /* @__PURE__ */ k.jsx(
                Qn,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: p.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (I) => {
                      if (I) {
                        if (h === "percentage" && (I < 0 || I > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && I < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ k.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: sh.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(
                Qn,
                {
                  label: "Code",
                  name: "code",
                  control: p.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: g
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(me, { span: 3, children: /* @__PURE__ */ k.jsx(
                Cr,
                {
                  control: p.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (I, D) => I === D,
                    onChange: () => {
                      p.setValue("minimumRequirementValue", void 0), p.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (I) => {
                      const D = Cj.find(
                        (U) => U.value === I
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: Cj.map((I) => /* @__PURE__ */ k.jsx(mt.Item, { value: I.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(me, { span: 3, children: /* @__PURE__ */ k.jsx(
                Qn,
                {
                  name: "minimumRequirementValue",
                  label: v,
                  control: p.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (I) => {
                      if (I && f !== "none" && I < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(
                Cr,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: p.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (I, D) => I === D,
                    getItemTitleByValue: (I) => {
                      const D = Fj.find(
                        (U) => U.value === I
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: D?.label }) });
                    }
                  },
                  children: Fj.map((I) => /* @__PURE__ */ k.jsx(mt.Item, { value: I.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) })
            ] })
          ] }),
          j && /* @__PURE__ */ k.jsx(In, { error: j })
        ] }),
        /* @__PURE__ */ k.jsx(
          Pt,
          {
            confirmProps: {
              disabled: !d && !(p.formState.isValid && p.formState.isDirty),
              isLoading: N,
              loadingIndicator: /* @__PURE__ */ k.jsx(fn, { size: 16 })
            },
            confirmName: d ? "Close" : "Save",
            confirmOnClick: d ? T : p.handleSubmit(z),
            cancelOnClick: d ? void 0 : T
          }
        )
      ]
    }
  );
}, zW = ({ code: e }) => {
  const { isCopied: n, copy: r } = Lr();
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(pe, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ k.jsx(
          ir,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, UW = ({
  discountCode: e
}) => {
  const { codeDiscount: n } = e;
  if (!("codes" in n))
    return null;
  const r = "summary" in n, i = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: n.title }),
    r && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: n.summary }),
    /* @__PURE__ */ k.jsx(We, { children: i.map((a) => /* @__PURE__ */ k.jsx(We.Item, { className: Lt.listItem, children: /* @__PURE__ */ k.jsx(zW, { code: a.code }, a.id) }, a.id)) })
  ] });
}, MW = "_modal_11d6e_1", BW = "_modalBody_11d6e_4", qW = "_codeContainer_11d6e_9", lh = {
  modal: MW,
  modalBody: BW,
  codeContainer: qW
}, HW = [50, 100, 250], CF = 50, WW = {
  maxNumberOfCodesToDisplay: CF
}, KW = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { useQuery: r } = yn(), [i, a] = le(
    CF
  ), [o, s] = le([]), l = o.length === 0, u = o.length > i, p = gt({
    mode: "all",
    defaultValues: WW
  }), { loading: d, error: f } = r(dW, {
    variables: {
      first: i
    },
    onCompleted: (v) => {
      const F = v?.Shopify?.codeDiscountNodes?.nodes ?? [];
      F && F.length > 0 && s(F);
    }
  }), h = () => {
    n(!1);
  };
  return /* @__PURE__ */ k.jsxs(jt, { isOpen: e, onClose: h, className: lh.modal, children: [
    /* @__PURE__ */ k.jsx(wt, { title: "Discount codes", onClose: h }),
    /* @__PURE__ */ k.jsxs(Ct, { className: lh.modalBody, children: [
      u && /* @__PURE__ */ k.jsx(at, { children: /* @__PURE__ */ k.jsx(me, { span: 3, children: /* @__PURE__ */ k.jsx(
        Cr,
        {
          control: p.control,
          label: "Number of codes to display",
          name: "maxNumberOfCodesToDisplay",
          componentProps: {
            placeholder: "Select a number of codes to display",
            onChange: (v) => {
              a(v.selectedValues[0]);
            },
            getItemTitleByValue: (v) => /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: v }) })
          },
          children: HW.map((v) => /* @__PURE__ */ k.jsx(mt.Item, { value: v, children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: v }) }, v))
        }
      ) }) }),
      d && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(fn, {}) }),
      f && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "Something went wrong while fetching discount codes." }) }),
      !d && l && /* @__PURE__ */ k.jsx(
        Js,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !d && !f && !l && o.map((v) => /* @__PURE__ */ k.jsx("div", { className: lh.codeContainer, children: /* @__PURE__ */ k.jsx(UW, { discountCode: v }) }, v.id))
    ] }),
    /* @__PURE__ */ k.jsx(Pt, { confirmName: "Close", confirmOnClick: h })
  ] });
}, GW = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = le(!1), [i, a] = le(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Yn,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Yn,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      KW,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ k.jsx(
      VW,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, YW = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? hw(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case ia.Invalid:
      case ia.NotSubscribed:
      case Or.NotSubscribed:
        return "red.500";
      case ia.Pending:
      case Or.Pending:
      case ia.Unsubscribed:
      case Or.Unsubscribed:
        return "orange.500";
      case ia.Subscribed:
      case Or.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case Di.SingleOptIn:
      case Di.ConfirmedOptIn:
        return "green.500";
      case Di.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: u
  } = n ?? {}, {
    marketingState: p,
    marketingUpdatedAt: d,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(pe, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ k.jsx(Ge, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Vn, { size: "small", variant: "info", children: Hn(l).format(ry) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ge, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(qn, { color: o(u), children: i(u) }) }),
        /* @__PURE__ */ k.jsx(Ge, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(qn, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(pe, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      d && /* @__PURE__ */ k.jsx(Ge, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Vn, { size: "small", variant: "info", children: Hn(d).format(ry) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ge, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(qn, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ k.jsx(Ge, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(qn, { color: a(p), children: i(p) }) })
      ] })
    ] })
  ] });
}, QW = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: r.suggestedRefund?.suggestedTransactions?.map(
        ({ amountSet: i, gateway: a, parentTransaction: o }) => ({
          amount: i?.presentmentMoney?.amount || "0.00",
          gateway: a ?? "",
          kind: jF.Refund,
          orderId: r.id,
          parentId: o?.id
        })
      ),
      shipping: {
        fullRefund: !0
      }
    },
    trackingInfos: n(r),
    shippingLines: r.shippingLines?.edges?.map(({ node: i }) => i),
    tags: r.tags,
    refunds: r.refunds
  }));
}, $j = [
  {
    value: Yr.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Yr.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Yr.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: Yr.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: Yr.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: Yr.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: Yr.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], Ej = [
  {
    value: Ks.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: Ks.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: Ks.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], FF = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), aa = (e) => JW(XW(e)), JW = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), XW = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, _i = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ k.jsx(
  Ot,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ k.jsx(
      tr,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), ZW = "_modal_1wlra_1", e9 = {
  modal: ZW
};
function Tj(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const Dj = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], Oj = "shopify-shiping-address-form", n9 = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: u
}) => {
  const { useMutation: p, showNotification: d } = yn(), { track: f } = Cn(), [h, v] = le(!1), [F, N] = le({}), j = !l, [
    C,
    { error: g, reset: z }
  ] = p(mW, {
    onError: () => {
      v(!1), d({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (G) => {
      v(!1);
      const q = G?.Shopify?.orderUpdate?.userErrors;
      if (q != null && q.length > 0) {
        const R = q.reduce(
          (B, ee) => {
            const be = ee.field;
            if (be == null || be.length === 0)
              return B;
            const fe = be[be.length - 1];
            return fe != null && (B[fe] = ee.message), B;
          },
          {}
        );
        N(R);
      } else
        d({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), u(), re();
    }
  }), T = lt(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: Dj.find(
        (G) => G === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: I, handleSubmit: D, formState: U, reset: Q } = gt({
    mode: "all",
    defaultValues: T()
  }), X = D((G) => {
    if (j) {
      if (v(!0), !o || !a) {
        v(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: q, ...R } = G, B = {
        ...R,
        countryCode: q
      };
      C({
        variables: {
          input: {
            id: a,
            shippingAddress: B
          }
        }
      });
    } else
      l(G), re();
  });
  Ye(() => {
    r && Q(T());
  }, [r, n, Q, T]);
  const re = () => {
    Q(T()), N({}), z(), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    jt,
    {
      isOpen: r,
      onClose: re,
      className: e9.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ k.jsx(wt, { title: e, onClose: () => re() }),
        /* @__PURE__ */ k.jsx(Ct, { children: /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: Oj, onSubmit: X, children: [
          g && /* @__PURE__ */ k.jsx(In, { error: g }),
          /* @__PURE__ */ k.jsxs(at, { children: [
            /* @__PURE__ */ k.jsx(me, { span: 3, children: /* @__PURE__ */ k.jsx(
              _i,
              {
                required: !0,
                control: I,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ k.jsx(me, { span: 3, children: /* @__PURE__ */ k.jsx(
              _i,
              {
                required: !0,
                control: I,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ k.jsx(me, { span: 6, children: /* @__PURE__ */ k.jsx(
              _i,
              {
                control: I,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ k.jsx(me, { span: 6, children: /* @__PURE__ */ k.jsx(
              _i,
              {
                required: !0,
                control: I,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ k.jsx(me, { span: 6, children: /* @__PURE__ */ k.jsx(
              _i,
              {
                control: I,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ k.jsx(me, { span: 3, children: /* @__PURE__ */ k.jsx(
              _i,
              {
                required: !0,
                control: I,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ k.jsx(me, { span: 3, children: /* @__PURE__ */ k.jsx(
              _i,
              {
                required: !0,
                control: I,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ k.jsx(me, { span: 6, children: /* @__PURE__ */ k.jsx(
              Cr,
              {
                name: "countryCodeV2",
                control: I,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (G) => G ? Tj(G) : ""
                },
                children: Dj.filter((G) => s.includes(G)).map((G) => /* @__PURE__ */ k.jsx(mt.Item, { value: G, children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: Tj(G) }) }, G))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ k.jsx(
          Pt,
          {
            confirmProps: {
              disabled: !(U.isValid && U.isDirty),
              type: "submit",
              form: Oj,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ k.jsx(fn, { size: 16 })
            },
            confirmOnClick: () => {
              g && re();
            },
            cancelOnClick: () => {
              o && a && !g && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), re();
            },
            confirmName: g ? "Close" : "Save",
            cancelName: g ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, t9 = "_clickableIcon_33mqm_1", ch = {
  clickableIcon: t9
}, Rj = ({
  formFieldName: e,
  ...n
}) => {
  const r = zr(), { field: i } = $y({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ k.jsx(
    iy,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, iy = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: u,
  openByDefault: p = !1
}) => {
  const [d, f] = le(!1), [h, v] = le(p), { isCopied: F, copy: N } = Lr(), { track: j } = Cn(), C = 14, g = o && (!!r || !!l), z = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), T = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), I = n?.countryCodeV2 && uI(n.countryCodeV2), D = lt(() => [
    T,
    n?.company,
    n?.address1,
    n?.address2,
    z,
    n?.province,
    I
  ].filter(Boolean).join(`
`), [n, T, z, I]);
  if (!n)
    return null;
  const U = () => {
    i && r && j("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(pe, { size: C, name: s, color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => v(!h),
              className: ch.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ k.jsx(
                  pe,
                  {
                    size: C,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
            T && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: T }),
            n?.company && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address2 }),
            z && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: z }),
            n?.province && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.province }),
            I && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: I })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        g && /* @__PURE__ */ k.jsx(Ge, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: C,
            name: "pen",
            onClick: () => U(),
            className: ch.clickableIcon
          }
        ) }),
        /* @__PURE__ */ k.jsx(Ge, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: C,
            name: F ? "done" : "copy",
            onClick: () => N(D()),
            className: ch.clickableIcon
          }
        ) })
      ] })
    ] }),
    g && /* @__PURE__ */ k.jsx(
      n9,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: d,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: u
      }
    )
  ] });
}, Ag = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = zr(), i = ko({ control: r.control, name: "lineItems" }), a = ko({
    control: r.control,
    name: "billingAddress"
  }), o = ko({
    control: r.control,
    name: "shippingAddress"
  }), s = Kn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (p) => n.includes(p.id)
  ) : i, [i, n]), l = Kn(() => !s || s.length === 0 ? 0 : s.reduce((p, d) => {
    const f = d.priceRangeV2?.minVariantPrice?.amount || 0, h = d.quantity || 0;
    return p + f * h;
  }, 0), [s]), u = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ k.jsx(
        Rj,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ k.jsx(
        Rj,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${l.toFixed(2)} ${u}` })
    ] }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, r9 = "_productTableHeader_6h6pl_1", i9 = "_productImage_6h6pl_5", Co = {
  productTableHeader: r9,
  productImage: i9
}, Lg = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, a9 = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = zr(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), u = Lg(e);
  return /* @__PURE__ */ k.jsxs(et.Tr, { children: [
    /* @__PURE__ */ k.jsx(et.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
      u && /* @__PURE__ */ k.jsx(
        ka,
        {
          src: u,
          alt: e.title,
          className: Co.productImage
        }
      ),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ k.jsx(et.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ k.jsx(et.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ k.jsx(et.Td, { children: /* @__PURE__ */ k.jsx(
      Qn,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ k.jsx(et.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ k.jsx(et.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(ir, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, o9 = 300, lo = 2, s9 = 25, l9 = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = yn(), [i, a] = le(""), [o, s] = le([]), l = zr(), u = l.watch("selectedProductId"), [p, { loading: d, networkStatus: f }] = n(Rg, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (N) => {
      const j = N?.Shopify?.products?.nodes || [];
      s(
        j.filter((C) => !!C).sort((C, g) => C.title.localeCompare(g.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  Pi(
    () => {
      i.trim().length >= lo && !d && f === rr.ready ? p({
        variables: {
          query: i.trim(),
          productCount: s9,
          mediaCount: 1
        }
      }) : i.trim().length < lo && s([]);
    },
    o9,
    [i]
  ), Ye(() => {
    if (!u) return;
    const N = o.find(
      (j) => j.id === u
    );
    N && e(N), l.setValue("selectedProductId", void 0);
  }, [u, o, l, e]);
  const h = d && f !== rr.ready, v = i.trim().length >= lo, F = !o.length && !h && v;
  return /* @__PURE__ */ k.jsx(
    Cr,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${lo} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (N) => {
          const j = o.find(
            (C) => C.id === N
          );
          return j ? /* @__PURE__ */ k.jsx(A.Paragraph, { children: j.title }) : null;
        },
        filter: {
          value: i,
          onChange: (N) => {
            a(N.target.value);
          }
        },
        onToggleDropdown: (N) => {
          !N && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        h && /* @__PURE__ */ k.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ k.jsx(fn, {}) }) }),
        !h && o.map((N) => {
          const j = N.totalInventory <= 0, C = Lg(N);
          return /* @__PURE__ */ k.jsx(
            mt.Item,
            {
              value: N.id,
              isDisabled: j,
              children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                  C && /* @__PURE__ */ k.jsx(
                    ka,
                    {
                      src: C,
                      alt: N.title,
                      className: Co.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ k.jsx(
                    FI,
                    {
                      text: N.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: N.title })
                ] }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", children: j ? "Out of stock" : `${N.totalInventory} in stock` })
              ] })
            },
            N.id
          );
        }),
        F && /* @__PURE__ */ k.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          Js,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !v && !h && /* @__PURE__ */ k.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          Js,
          {
            title: "Search for products",
            description: `Type at least ${lo} characters to search.`
          }
        ) })
      ] })
    }
  );
}, Vg = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: u
}) => {
  const p = zr(), d = p.watch("lineItems"), f = !!d?.length, h = n && f ? d.filter(
    (j) => !o.includes(j?.id)
  ) : [], v = h.length > 0 && h.every(
    (j) => a.includes(j?.id)
  ), F = h.some(
    (j) => a.includes(j?.id)
  ) && !v, N = lt(
    (j) => {
      const C = p.getValues("lineItems"), g = C.findIndex(
        (z) => z?.id === j.id
      );
      if (g > -1) {
        const z = p.getValues(`lineItems.${g}.quantity`) || 0, T = [...C];
        T[g] = {
          ...T[g],
          quantity: z + 1
        }, p.setValue("lineItems", T);
      } else
        p.setValue("lineItems", [
          ...C,
          { ...j, quantity: 1 }
        ]);
    },
    [p]
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ k.jsx(l9, { onProductSelected: N }),
    !f && e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: Lt.boxWrapper,
        children: /* @__PURE__ */ k.jsx(fn, {})
      }
    ),
    !f && !e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Lt.boxWrapper,
        children: /* @__PURE__ */ k.jsx(
          Js,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ k.jsx(b, { margin: "300 0", children: /* @__PURE__ */ k.jsxs(
      et,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: Co.productTable,
        children: [
          /* @__PURE__ */ k.jsx(et.Thead, { className: Co.productTableHeader, children: /* @__PURE__ */ k.jsxs(et.Tr, { children: [
            n && /* @__PURE__ */ k.jsx(et.Th, { children: /* @__PURE__ */ k.jsx(
              Gg,
              {
                checked: v,
                indeterminate: F,
                onChange: () => u?.(!v)
              }
            ) }),
            /* @__PURE__ */ k.jsx(et.Th, { children: "Product" }),
            /* @__PURE__ */ k.jsx(et.Th, { children: "In stock" }),
            /* @__PURE__ */ k.jsx(et.Th, { children: "Price" }),
            /* @__PURE__ */ k.jsx(et.Th, { children: "Quantity" }),
            /* @__PURE__ */ k.jsx(et.Th, { children: "Total" }),
            !r && /* @__PURE__ */ k.jsx(et.Th, {})
          ] }) }),
          /* @__PURE__ */ k.jsx(et.Tbody, { children: d?.map((j, C) => {
            if (!n)
              return /* @__PURE__ */ k.jsx(
                a9,
                {
                  product: j,
                  index: C,
                  onRemove: () => {
                    const q = d.filter(
                      (R, B) => B !== C
                    );
                    p.setValue("lineItems", q);
                  }
                },
                `${j?.id}-${C}`
              );
            const g = j, z = g.priceRangeV2.minVariantPrice.amount, T = g.priceRangeV2.minVariantPrice.currencyCode, I = `lineItems.${C}.quantity`, D = p.watch(I) || 0, U = z * D, Q = Lg(g), X = a.includes(g.id), re = o.includes(g.id), G = s?.[g.id] ?? g.totalInventory;
            return /* @__PURE__ */ k.jsxs(
              et.Tr,
              {
                style: re ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ k.jsx(et.Td, { children: /* @__PURE__ */ k.jsx(
                    Gg,
                    {
                      checked: X,
                      disabled: re,
                      onChange: () => l?.(g.id, !X)
                    }
                  ) }),
                  /* @__PURE__ */ k.jsx(et.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                    Q && /* @__PURE__ */ k.jsx(
                      ka,
                      {
                        src: Q,
                        alt: g.title,
                        className: Co.productImage
                      }
                    ),
                    /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: g.title }),
                      re && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ k.jsx(et.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: g.totalInventory }) }),
                  /* @__PURE__ */ k.jsx(et.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${z} ${T}` }) }),
                  /* @__PURE__ */ k.jsx(et.Td, { children: /* @__PURE__ */ k.jsx(
                    Qn,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: re || G <= 1,
                      name: I,
                      control: p.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: G,
                        tabIndex: 0
                      }
                    },
                    `${I}-${p.watch(I)}`
                  ) }),
                  /* @__PURE__ */ k.jsx(et.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${U} ${T}` }) }),
                  !r && /* @__PURE__ */ k.jsx(et.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(
                    ir,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const q = d.filter(
                          (R, B) => B !== C
                        );
                        p.setValue("lineItems", q), X && l?.(g.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${g.id}-${C}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, IF = ({
  previousOrderStatus: e
} = {}) => {
  const n = zr();
  return /* @__PURE__ */ k.jsx(
    Cr,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = $j.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ k.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: $j.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ k.jsx(mt.Item, { value: r.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, $F = () => {
  const e = zr();
  return /* @__PURE__ */ k.jsx(
    Cr,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = Ej.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: Ej.map((n) => /* @__PURE__ */ k.jsx(mt.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, c9 = "_modal_1mprq_1", u9 = {
  modal: c9
}, uh = "create-shopify-order-form", d9 = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = yn(), { track: l } = Cn(), [u, p] = le(!1), [
    d,
    f
  ] = le(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, v = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Yr.Pending,
    fulfillmentStatus: void 0
  }, [F, N] = le([]), j = gt({
    mode: "all",
    defaultValues: v
  }), C = j.watch("lineItems").length > 0, g = () => {
    j.reset(v), N([]), i(!1);
  };
  Ye(() => {
    F.length > 0 && j.setValue("tags", F, { shouldDirty: !0 });
  }, [F, j]);
  const [z, { error: T }] = o(
    wF,
    {
      onError: () => {
        p(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), g();
      },
      onCompleted: () => {
        a(), p(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), g();
      }
    }
  ), [I, { error: D }] = o(
    vW,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), g();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), g();
      }
    }
  ), U = (X) => {
    const re = X.lineItems.map((R) => ({
      productId: R.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: R.priceRangeV2.maxVariantPrice.amount,
          currencyCode: R.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: R.quantity
    }));
    p(!0);
    const G = aa(X?.billingAddress), q = aa(
      X?.shippingAddress
    );
    z({
      variables: {
        order: {
          lineItems: re,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: X.customNote,
          tags: X.tags,
          financialStatus: X.financialStatus,
          fulfillmentStatus: X.fulfillmentStatus,
          shippingAddress: q,
          billingAddress: G
        }
      }
    });
  }, Q = (X) => {
    const re = X.lineItems.map((R) => ({
      title: R.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: R.priceRangeV2.maxVariantPrice.amount,
        currencyCode: R.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: R.quantity
    }));
    f(!0);
    const G = aa(X?.billingAddress), q = aa(
      X?.shippingAddress
    );
    I({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: X.customNote,
          tags: X.tags,
          lineItems: re,
          shippingAddress: q,
          billingAddress: G
        }
      }
    });
  };
  return /* @__PURE__ */ k.jsxs(
    jt,
    {
      isOpen: e,
      onClose: g,
      className: u9.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(wt, { title: "Create new order", onClose: g }),
        /* @__PURE__ */ k.jsxs(Ct, { children: [
          /* @__PURE__ */ k.jsx(Iy, { ...j, children: /* @__PURE__ */ k.jsx("form", { id: uh, children: /* @__PURE__ */ k.jsxs(at, { children: [
            /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(Vg, {}) }),
            /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(
              Ot,
              {
                name: "tags",
                render: ({ fieldState: { error: X } }) => /* @__PURE__ */ k.jsx(
                  en,
                  {
                    label: "Tags",
                    meta: {
                      error: X?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (re) => {
                          re.key === "Enter" && (re.preventDefault(), re.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          _l,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: F,
                            onChange: (re) => {
                              N(re);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(me, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(IF, {}),
              /* @__PURE__ */ k.jsx($F, {}),
              /* @__PURE__ */ k.jsx(
                Qn,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(me, { span: 2, children: /* @__PURE__ */ k.jsx(en, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Lt.boxWrapper,
                children: /* @__PURE__ */ k.jsx(Ag, {})
              }
            ) }) })
          ] }) }) }),
          (T || D) && /* @__PURE__ */ k.jsx(In, { error: T || D })
        ] }),
        /* @__PURE__ */ k.jsx(
          Pt,
          {
            confirmProps: {
              type: "submit",
              form: uh,
              disabled: !C || u,
              isLoading: u,
              loadingIndicator: /* @__PURE__ */ k.jsx(fn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: j.handleSubmit(U),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                j.handleSubmit(Q)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: uh,
                disabled: !C || d,
                isLoading: d,
                loadingIndicator: /* @__PURE__ */ k.jsx(fn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, m9 = "_modal_al73g_1", p9 = {
  modal: m9
}, Pj = [
  {
    label: "Customer",
    value: Ni.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: Ni.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: Ni.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: Ni.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: Ni.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: Ni.Staff,
    description: "Staff made an error."
  }
], f9 = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = Cn(), { useMutation: u, showNotification: p } = yn(), [d, f] = le([]), h = d.length > 0, v = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, F = gt({
    defaultValues: v
  }), [N, { error: j, reset: C }] = u(fW, {
    onError: () => {
      o(!1), p({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (T) => {
      const I = T.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (I.length > 0)
        o(!1), f(I), p({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const D = T.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, D ? 0 : 4e3), p({
          title: "Success",
          text: `${D ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), g = lt(
    (T) => {
      T.reason != null && (o(!0), N({
        variables: {
          orderId: T.orderId,
          reason: T.reason,
          refundMethod: T.refundMethod,
          restock: T.restock,
          notifyCustomer: T.notifyCustomer,
          staffNote: T.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), z = () => {
    i(!1), C(), f([]), F.reset(v);
  };
  return /* @__PURE__ */ k.jsxs(jt, { isOpen: n, onClose: z, className: p9.modal, children: [
    /* @__PURE__ */ k.jsx(wt, { title: `Cancel order ${r}`, onClose: z }),
    /* @__PURE__ */ k.jsx(Ct, { children: /* @__PURE__ */ k.jsxs(at, { children: [
      /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(
        Cr,
        {
          control: F.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (T, I) => T === I,
            getItemTitleByValue: (T) => {
              if (!T)
                return "";
              const I = Pj.find(
                (D) => D.value === T
              );
              return /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: I.label }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: I.description })
              ] });
            }
          },
          children: Pj.map((T) => /* @__PURE__ */ k.jsx(mt.Item, { value: T.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: T.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: T.description })
          ] }) }, T.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(en, { label: "Refund order", children: /* @__PURE__ */ k.jsx(
        Pn,
        {
          control: F.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(en, { label: "Restock items", children: /* @__PURE__ */ k.jsx(Pn, { control: F.control, name: "restock" }) }) }),
      /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(en, { label: "Notify the customer", children: /* @__PURE__ */ k.jsx(Pn, { control: F.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(
        Qn,
        {
          name: "staffNote",
          label: "Staff note",
          control: F.control
        }
      ) }),
      h && /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: d.map((T) => /* @__PURE__ */ k.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ k.jsx(pe, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: T.code }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
              "(",
              T.field?.join(","),
              ") ",
              T.message
            ] })
          ]
        },
        T.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      Pt,
      {
        confirmProps: {
          disabled: !(F.formState.isValid && F.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ k.jsx(fn, { size: 16 })
        },
        confirmOnClick: F.handleSubmit(g),
        cancelOnClick: z,
        confirmName: j ? "Close" : "Cancel order",
        cancelName: j ? void 0 : "Cancel"
      }
    )
  ] });
}, h9 = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = le(!1), [s, l] = le(!1);
  return /* @__PURE__ */ k.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ k.jsx(
      Yn,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ k.jsx(fn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Lt.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ k.jsx(
      f9,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, y9 = "_modal_1mprq_1", g9 = {
  modal: y9
}, v9 = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: u } = yn(), { track: p } = Cn(), [d, f] = le(!1), [h, v] = le(e?.tags || []), F = "duplicate-shopify-order-form", N = (q) => ({
    firstName: q?.firstName,
    lastName: q?.lastName,
    company: q?.company,
    address1: q?.address1,
    address2: q?.address2,
    city: q?.city,
    provinceCode: q?.provinceCode,
    zip: q?.zip,
    countryCode: q?.countryCodeV2,
    phone: q?.phone
  }), j = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: N(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: N(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0
  }, C = gt({
    mode: "all",
    defaultValues: j
  }), g = C.watch("lineItems").length > 0, z = Kn(
    () => (e?.lineItems || []).map((q) => q.product?.id).filter((q) => !!q),
    [e]
  ), T = Kn(
    () => FF(z),
    [z]
  ), {
    data: I,
    loading: D,
    error: U
  } = u(Rg, {
    skip: !T,
    variables: {
      query: T,
      productCount: z.length,
      mediaCount: 1
    }
  });
  Ye(() => {
    U && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [U, l]), Ye(() => {
    if (!r || D || !I || C.getValues("lineItems")?.length)
      return;
    const q = I?.Shopify?.products?.nodes || [], R = [];
    e?.lineItems?.forEach((B) => {
      const ee = q.find(
        (be) => be.id === B.product?.id
      );
      ee && R.push({
        ...ee,
        quantity: B.quantity || 1,
        sku: B.sku,
        discountedUnitPrice: B.discountedUnitPriceSet?.shopMoney
      });
    }), R.length > 0 && C.setValue("lineItems", R, { shouldDirty: !0 });
  }, [r, I, D, e, C]), Ye(() => {
    (h.length > 0 || (C.getValues("tags") || []).length > 0) && C.setValue("tags", h, { shouldDirty: !0 });
  }, [h, C]);
  const [Q, { error: X }] = s(
    wF,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), p("shopify:order:duplicate:failed"), G();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), p("shopify:order:duplicate:succeeded"), G();
      }
    }
  ), re = (q) => {
    const R = q.lineItems.map((ee) => ({
      productId: ee.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: ee.discountedUnitPrice?.amount ?? ee.priceRangeV2.maxVariantPrice.amount,
          currencyCode: ee.discountedUnitPrice?.currencyCode ?? ee.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: ee.quantity,
      sku: ee.sku
    })), B = (e?.shippingLines ?? []).map(
      (ee) => ({
        title: ee.title,
        code: ee.code,
        source: ee.source,
        priceSet: {
          shopMoney: {
            amount: ee.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: ee.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0), Q({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: R,
          shippingLines: B,
          note: q.customNote,
          tags: q.tags,
          financialStatus: q.financialStatus,
          fulfillmentStatus: q.fulfillmentStatus,
          shippingAddress: aa(q?.shippingAddress),
          billingAddress: aa(q?.billingAddress)
        }
      }
    });
  }, G = () => {
    C.reset(j), v(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    jt,
    {
      isOpen: r,
      onClose: G,
      className: g9.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(wt, { title: `Duplicate order ${n}`, onClose: G }),
        /* @__PURE__ */ k.jsxs(Ct, { children: [
          /* @__PURE__ */ k.jsx(Iy, { ...C, children: /* @__PURE__ */ k.jsx("form", { id: F, children: /* @__PURE__ */ k.jsxs(at, { children: [
            /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(Vg, { loading: D }) }),
            /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(
              Ot,
              {
                name: "tags",
                render: ({ fieldState: { error: q } }) => /* @__PURE__ */ k.jsx(
                  en,
                  {
                    label: "Tags",
                    meta: {
                      error: q?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (R) => {
                          R.key === "Enter" && (R.preventDefault(), R.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          _l,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (R) => {
                              v(R);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(me, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(
                IF,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ k.jsx($F, {}),
              /* @__PURE__ */ k.jsx(
                Qn,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(me, { span: 2, children: /* @__PURE__ */ k.jsx(en, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Lt.boxWrapper,
                children: /* @__PURE__ */ k.jsx(Ag, {})
              }
            ) }) })
          ] }) }) }),
          X && /* @__PURE__ */ k.jsx(In, { error: X })
        ] }),
        /* @__PURE__ */ k.jsx(
          Pt,
          {
            confirmProps: {
              type: "submit",
              form: F,
              disabled: !g || d || D,
              isLoading: d || D,
              loadingIndicator: /* @__PURE__ */ k.jsx(fn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: C.handleSubmit(re)
          }
        )
      ]
    }
  );
}, k9 = "_copyIcon_1dlzg_1", b9 = {
  copyIcon: k9
}, _9 = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  const { isCopied: i, copy: a } = Lr();
  if (!n || n?.length === 0)
    return null;
  const o = Object.values(r).some(
    (l) => l > 0
  ), s = n.map(
    ({ title: l, quantity: u, variantTitle: p }) => p ? `${u}x ${l} (${p})` : `${u}x ${l}`
  ).join(`
`);
  return /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(
      b,
      {
        gap: "250",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(pe, { size: 14, name: "shopify", color: "green.500" }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Line items" })
          ] }),
          /* @__PURE__ */ k.jsx(Ge, { content: "Copy line items", children: /* @__PURE__ */ k.jsx(
            pe,
            {
              size: 14,
              name: i ? "done" : "copy",
              onClick: () => a(s),
              className: b9.copyIcon
            }
          ) })
        ]
      }
    ),
    o && /* @__PURE__ */ k.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ k.jsx(qn, { color: "red.500", children: "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ k.jsx(We, { children: n.map(({ id: l, title: u, quantity: p, variantTitle: d, image: f }) => {
      const h = r[l], v = h > 0, F = h > 1 ? `Refunded (${h} items)` : "Refunded";
      return /* @__PURE__ */ k.jsx(
        We.Item,
        {
          contentLeft: /* @__PURE__ */ k.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: p }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "4", children: [
            u,
            " ",
            d && `(${d})`,
            v && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", color: "red.500", children: F })
          ] }),
          contentRight: f?.url && /* @__PURE__ */ k.jsx(ka, { src: `${f?.url}&height=48`, alt: u })
        },
        `list-${e}-${l}`
      );
    }) })
  ] });
}, x9 = Sl`
  mutation refuncLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, S9 = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, EF = (e) => {
  const n = {}, r = S9(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, N9 = "_modal_21e62_1", j9 = {
  modal: N9
}, Aj = "partial-refund-shopify-order-form", w9 = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = yn(), { track: l } = Cn(), { useQuery: u } = yn(), [p, d] = le(!1), [f, h] = le([]), v = Kn(
    () => e?.refunds ? EF(e) : {},
    [e]
  ), F = Kn(
    () => (e?.lineItems || []).filter((q) => (v[q.id] || 0) >= (q.quantity || 0)).map((q) => q.product?.id).filter((q) => !!q),
    [e, v]
  ), N = Kn(() => {
    const q = {};
    return (e?.lineItems || []).forEach((R) => {
      if (R.product?.id) {
        const B = v[R.id] || 0, ee = Math.max(
          0,
          (R.quantity || 0) - B
        );
        q[R.product.id] = ee;
      }
    }), q;
  }, [e, v]), j = Kn(
    () => (e?.lineItems || []).map((q) => q.product?.id).filter((q) => !!q),
    [e]
  ), C = Kn(
    () => FF(j),
    [j]
  ), {
    data: g,
    loading: z,
    error: T
  } = u(Rg, {
    skip: !C,
    variables: {
      query: C,
      productCount: j.length,
      mediaCount: 1
    }
  });
  Ye(() => {
    T && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [T, s]);
  const I = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, D = gt({
    mode: "all",
    defaultValues: I
  }), U = f.length > 0, [Q, { error: X }] = o(
    x9,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), G();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), G();
      }
    }
  );
  Ye(() => {
    if (!r || z || !g || D.getValues("lineItems")?.length)
      return;
    const q = g?.Shopify?.products?.nodes || [], R = [];
    e?.lineItems?.forEach((B) => {
      const ee = q.find(
        (be) => be.id === B.product?.id
      );
      if (ee) {
        const be = v[B.id] || 0, fe = (B.quantity || 1) - be;
        R.push({
          ...ee,
          quantity: fe > 0 ? fe : B.quantity || 1
        });
      }
    }), R.length > 0 && (D.setValue("lineItems", R, { shouldDirty: !0 }), h([]));
  }, [
    r,
    g,
    z,
    e,
    D,
    v
  ]);
  const re = (q) => {
    d(!0);
    const R = (q.lineItems || []).filter(
      (B) => f.includes(B.id)
    ).map((B) => {
      const ee = e?.lineItems?.find(
        (ge) => ge.product?.id === B.id
      ), be = v[ee?.id || ""] || 0, fe = (ee?.quantity || 0) - be, de = Math.max(
        0,
        Math.min(fe, B.quantity || 0)
      );
      return ee && de > 0 ? { lineItemId: ee.id, quantity: de } : void 0;
    }).filter((B) => !!B);
    Q({
      variables: {
        input: {
          orderId: e.id,
          refundLineItems: R,
          note: q.customNote || void 0,
          notify: !0
        }
      }
    });
  }, G = () => {
    D.reset(I), d(!1), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(jt, { isOpen: r, onClose: G, className: j9.modal, children: [
    /* @__PURE__ */ k.jsx(wt, { title: `Refund order ${n}`, onClose: G }),
    /* @__PURE__ */ k.jsxs(Ct, { children: [
      /* @__PURE__ */ k.jsx(Iy, { ...D, children: /* @__PURE__ */ k.jsx("form", { id: Aj, children: /* @__PURE__ */ k.jsxs(at, { children: [
        /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(
          Vg,
          {
            loading: z,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: F,
            maxQuantities: N,
            onToggleSelect: (q, R) => {
              h((B) => R ? Array.from(/* @__PURE__ */ new Set([...B, q])) : B.filter((ee) => ee !== q));
            },
            onToggleSelectAll: (q) => {
              const R = (D.getValues("lineItems") || []).map((B) => B.id).filter((B) => !F.includes(B));
              h(q ? R : []);
            }
          }
        ) }),
        /* @__PURE__ */ k.jsx(me, { span: 4, children: /* @__PURE__ */ k.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ k.jsx(
          Qn,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ k.jsx(me, { span: 2, children: /* @__PURE__ */ k.jsx(en, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Lt.boxWrapper,
            children: /* @__PURE__ */ k.jsx(
              Ag,
              {
                withAddresses: !1,
                selectedProductIds: f
              }
            )
          }
        ) }) })
      ] }) }) }),
      X && /* @__PURE__ */ k.jsx(In, { error: X })
    ] }),
    /* @__PURE__ */ k.jsx(
      Pt,
      {
        confirmProps: {
          type: "submit",
          form: Aj,
          disabled: !U || p || z,
          isLoading: p || z,
          loadingIndicator: /* @__PURE__ */ k.jsx(fn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: D.handleSubmit(re)
      }
    )
  ] });
}, C9 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { useMutation: a, showNotification: o, showModal: s } = yn(), { track: l } = Cn(), { suggestedRefund: u, currencyCode: p, id: d, name: f } = e, h = parseFloat(String(u?.amount)), v = !isNaN(h) && h > 0, [F] = a(pW, {
    onError: (C) => {
      setTimeout(() => j(C), 500);
    },
    onCompleted: (C) => {
      const g = C.Shopify?.refundCreate?.userErrors;
      g && g.length > 0 ? j(
        new Nw({
          graphQLErrors: g.map((z) => ({
            message: z.message
          }))
        })
      ) : (o({
        title: "Order refunded",
        text: `You refunded order ${f}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), N = lt(() => {
    l("shopify:order:refund:requested", { shopifyId: n, orderId: d });
    const { amount: C, ...g } = u;
    s(v ? {
      headline: `Refund Order ${f}?`,
      children: /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
        "You are about to refund ",
        C,
        " ",
        p,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        l("shopify:order:refund:confirmed", { shopifyId: n, orderId: d }), F({
          variables: {
            input: g
          }
        });
      },
      onCancel: () => l("shopify:order:refund:canceled", { shopifyId: n, orderId: d })
    } : {
      headline: `Refund Order ${f}`,
      children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [
    n,
    d,
    f,
    p,
    u,
    v,
    s,
    F,
    l
  ]), j = lt(
    (C) => {
      s({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(In, { error: C }),
          /* @__PURE__ */ k.jsx(
            Rt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(r, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(pe, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [r]
  );
  return /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
    Yn,
    {
      variant: "secondary",
      onClick: N,
      disabled: u?.refundLineItems?.length === 0 || !v,
      slotStart: /* @__PURE__ */ k.jsx(pe, { size: 14, name: "undo" }),
      className: Lt.fullWidth,
      children: "Full refund"
    }
  ) });
}, F9 = "_modal_al73g_1", I9 = {
  modal: F9
}, $9 = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = Cn(), { useMutation: s, showNotification: l } = yn(), [u, p] = le(n), [d, f] = le(!1), h = gt({
    defaultValues: {
      tags: n
    }
  });
  Ye(() => {
    u && h.setValue("tags", u, { shouldDirty: !0 });
  }, [u]);
  const [v, { error: F, reset: N }] = s(hW, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), j = lt(
    (g) => {
      f(!0), v({
        variables: {
          input: {
            id: e,
            tags: g.tags
          }
        }
      }).then((z) => {
        const T = z.data?.Shopify?.orderUpdate?.order?.tags ?? g.tags;
        h.reset({ tags: T });
      });
    },
    [e, h, v]
  ), C = () => {
    i(!1), N();
  };
  return /* @__PURE__ */ k.jsxs(jt, { isOpen: r, onClose: C, className: I9.modal, children: [
    /* @__PURE__ */ k.jsx(wt, { title: "Manage tags for order", onClose: C }),
    /* @__PURE__ */ k.jsxs(Ct, { children: [
      /* @__PURE__ */ k.jsx(at, { children: /* @__PURE__ */ k.jsx(me, { children: /* @__PURE__ */ k.jsx(
        Ot,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: g } }) => /* @__PURE__ */ k.jsx(
            en,
            {
              label: "Tags",
              meta: {
                error: g?.message
              },
              children: /* @__PURE__ */ k.jsx(
                _l,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (z) => p(z)
                }
              )
            }
          )
        }
      ) }) }),
      F && /* @__PURE__ */ k.jsx(In, { error: F })
    ] }),
    /* @__PURE__ */ k.jsx(
      Pt,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: d,
          loadingIndicator: /* @__PURE__ */ k.jsx(fn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(j),
        cancelOnClick: C,
        confirmName: F ? "Close" : "Save",
        cancelName: F ? void 0 : "Cancel"
      }
    )
  ] });
}, E9 = "_editIcon_1yp2k_1", T9 = "_copyIcon_1yp2k_2", Lj = {
  editIcon: E9,
  copyIcon: T9
}, D9 = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = le(!1), { isCopied: o, copy: s } = Lr(), l = 14, u = n.length > 0;
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(pe, { size: l, name: "tag", color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !u && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            u && n.map((p, d) => /* @__PURE__ */ k.jsx(Vn, { size: "small", variant: "primary", children: p }, d))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ge, { content: "Edit tags", children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: l,
            name: "pen",
            className: Lj.editIcon,
            onClick: () => a(!0)
          }
        ) }),
        u && /* @__PURE__ */ k.jsx(Ge, { content: "Copy tags", children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: l,
            name: o ? "done" : "copy",
            className: Lj.copyIcon,
            onClick: () => s(n.join(", "))
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      $9,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, O9 = "_icon_cddi1_1", R9 = "_link_cddi1_6", Vj = {
  icon: O9,
  link: R9
}, P9 = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = Lr(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ k.jsx(
    We.Item,
    {
      contentLeft: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ k.jsx(
        A.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: Vj.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ k.jsx(Ge, { content: "Copy tracking code", children: /* @__PURE__ */ k.jsx(
        pe,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: Vj.icon
        }
      ) })
    }
  );
}, A9 = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ k.jsx(pe, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ k.jsx(We, { children: e.map((n) => /* @__PURE__ */ k.jsx(P9, { trackingInfo: n }, n.number)) })
] }), L9 = "_copyIcon_yc0fe_1", V9 = "_order_yc0fe_6", z9 = "_orderIsOpen_yc0fe_14", U9 = "_orderHeader_yc0fe_17", Zi = {
  copyIcon: L9,
  order: V9,
  orderIsOpen: z9,
  orderHeader: U9
}, M9 = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: u,
  displayPartialRefundOrder: p,
  refetchOrders: d
}) => {
  const { track: f } = Cn(), { isCopied: h, copy: v } = Lr(), { isCopied: F, copy: N } = Lr(), { isCopied: j, copy: C } = Lr(), [g, z] = le(!1), [T, I] = le(!1), [D, U] = le(r), {
    id: Q,
    name: X,
    createdAt: re,
    status: G,
    currentTotalPriceSet: q,
    currencyCode: R,
    lineItems: B,
    billingAddress: ee,
    shippingAddress: be,
    trackingInfos: fe,
    tags: de
  } = e, ge = !!be, K = Pg(Q), xe = `https://${l}/admin/orders/${K ?? ""}`, $e = q?.shopMoney?.amount ?? 0, Y = G.includes("cancelled"), qe = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: R
  }).format($e), Me = e?.refunds ? EF(e) : {}, Le = !!B?.length && B.every((Ue) => (Me[Ue.id] || 0) >= (Ue.quantity || 0));
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      className: it(Zi.order, {
        [Zi.orderIsOpen]: D
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ k.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Zi.orderHeader,
            onClick: () => U(!D),
            children: [
              /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
                re && /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: Hn(re).format(ry) }) }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order ",
                  X
                ] })
              ] }),
              /* @__PURE__ */ k.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: D ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        D && /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(pe, { size: 14, name: "info", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order number" }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: X.replace("#", "") })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(Ge, { content: "Copy order number", children: /* @__PURE__ */ k.jsx(
                  pe,
                  {
                    size: 14,
                    name: h ? "done" : "copy",
                    onClick: () => v(X.replace("#", "")),
                    className: Zi.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(pe, { size: 14, name: "activity", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: G })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(Ge, { content: "Copy order status", children: /* @__PURE__ */ k.jsx(
                  pe,
                  {
                    size: 14,
                    name: j ? "done" : "copy",
                    onClick: () => C(G),
                    className: Zi.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(pe, { size: 14, name: "chart-bar", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: qe })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(Ge, { content: "Copy order value", children: /* @__PURE__ */ k.jsx(
                  pe,
                  {
                    size: 14,
                    name: F ? "done" : "copy",
                    onClick: () => N($e),
                    className: Zi.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsx(
            D9,
            {
              orderId: Q,
              tags: de,
              refetchOrders: d
            }
          ),
          /* @__PURE__ */ k.jsx(
            iy,
            {
              openByDefault: !ge,
              labelText: "Billing address",
              address: ee,
              shippingCountryCodes: i,
              refetchOrders: d
            }
          ),
          /* @__PURE__ */ k.jsx(
            iy,
            {
              openByDefault: ge,
              shopifyId: n,
              orderId: Q,
              icon: "map-pin",
              labelText: "Shipping address",
              address: be,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: d
            }
          ),
          /* @__PURE__ */ k.jsx(
            _9,
            {
              orderId: Q,
              lineItems: B,
              refundedQuantities: Me
            }
          ),
          /* @__PURE__ */ k.jsx(A9, { trackingInfos: fe }),
          (o || p) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ k.jsx(
              C9,
              {
                order: e,
                shopifyId: n,
                refetchOrders: d,
                orderLink: xe
              }
            ),
            p && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Yn,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => I(!0),
                className: Lt.fullWidth,
                disabled: Y || Le,
                children: "Partial refund"
              }
            ) })
          ] }),
          (u || s) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            u && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Yn,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => z(!0),
                className: Lt.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ k.jsx(
              h9,
              {
                orderId: Q,
                orderName: X,
                disabled: Y,
                refetchOrders: d
              }
            )
          ] }),
          /* @__PURE__ */ k.jsx(
            Rt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(xe, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(pe, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: Q
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        g && /* @__PURE__ */ k.jsx(
          v9,
          {
            order: e,
            shopifyId: n,
            orderName: X,
            isOpen: g,
            setIsOpen: z,
            refetchOrders: d
          }
        ),
        T && /* @__PURE__ */ k.jsx(
          w9,
          {
            order: e,
            orderName: X,
            isOpen: T,
            setIsOpen: I,
            refetchOrders: () => {
              d();
            }
          }
        )
      ]
    }
  );
}, B9 = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: u,
  shopifyCustomer: p
}) => {
  const { track: d } = Cn(), [f, h] = le([]), [v, F] = le(!1), N = Pg(p?.id), j = `https://${n}/admin/orders?customer_id=${N ?? ""}`, {
    getCustomerOrders: C,
    isCustomerOrdersLoading: g,
    customerOrdersError: z,
    customerOrders: T,
    refetchCustomerOrders: I
  } = bW();
  return Ye(() => {
    !g && N && C({
      variables: {
        query: `customer_id:${N}`
      }
    });
  }, [N]), Ye(() => {
    const D = T?.Shopify?.orders?.edges;
    D && h(QW({ ordersData: D }));
  }, [T]), p ? z ? /* @__PURE__ */ k.jsx(In, { error: z }) : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !g && /* @__PURE__ */ k.jsx(Vn, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ k.jsx(
      Yn,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => F(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      g && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(fn, {}) }),
      !g && f.length === 0 && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !g && f.length > 0 && /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: f.map((D, U) => /* @__PURE__ */ k.jsx(
        M9,
        {
          order: D,
          openByDefault: U === 0,
          shopifyId: p?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: u,
          customerCountryCodes: e,
          refetchOrders: I,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${U}-${D.id}`
      )) }),
      /* @__PURE__ */ k.jsx(
        Rt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(j, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ k.jsx(pe, { name: "external-link" }),
          onClick: () => d("shopify:view:all:orders:clicked", {
            shopifyId: p?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ k.jsx(
      d9,
      {
        isOpen: v,
        setIsOpen: F,
        shopifyCustomer: p,
        refetchCustomerOrders: I,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, q9 = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ k.jsx(k.Fragment, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ k.jsxs(We, { className: Lt.list, children: [
      /* @__PURE__ */ k.jsx(We.Text, { variant: "dense", className: Lt.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ k.jsx(We.Text, { variant: "dense", className: Lt.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, H9 = "_segmentName_1dkhk_1", W9 = {
  segmentName: H9
}, K9 = 100, Cs = 10, G9 = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = yn(), [i, a] = le([]), [o, s] = le(Cs), [l, u] = le(!1), p = Kn(
    () => i.filter((N) => N.isMember).length,
    [i]
  ), { loading: d, error: f } = n(
    cW,
    {
      skip: !e,
      variables: {
        first: K9
      },
      onCompleted: (N) => {
        const j = N?.Shopify?.segments?.edges;
        if (j && j.length > 0) {
          const C = j.map(({ node: g }) => ({
            ...g,
            isMember: !1
          })).sort((g, z) => g.name.localeCompare(z.name));
          a(C), h({
            variables: {
              customerId: e,
              segmentIds: C.map((g) => g.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: v, error: F }
  ] = r(uW, {
    onCompleted: (N) => {
      const j = N?.Shopify?.customerSegmentMembership?.memberships;
      if (j && j.length > 0) {
        const C = i.map((g) => {
          const z = j.find(
            (T) => T.segmentId === g.id
          );
          return {
            ...g,
            ...z?.isMember && { isMember: z.isMember }
          };
        }).sort(
          (g, z) => g.isMember === z.isMember ? 0 : g.isMember ? -1 : 1
        );
        a(C);
      }
    }
  });
  return Ye(() => {
    s(l ? i.length : Cs);
  }, [l]), e ? /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Segment membership" }),
      !d && /* @__PURE__ */ k.jsx(Vn, { variant: "success", size: "small", children: p })
    ] }),
    d && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(fn, {}) }),
    !d && i.length === 0 && /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ k.jsx(In, { error: f }),
    F && /* @__PURE__ */ k.jsx(In, { error: F }),
    !d && i.length > 0 && /* @__PURE__ */ k.jsxs(We, { className: Lt.list, children: [
      i.slice(0, o).map(({ id: N, name: j, isMember: C }) => /* @__PURE__ */ k.jsx(We.Text, { className: Lt.listItem, children: /* @__PURE__ */ k.jsx(
        Ge,
        {
          content: `${C ? "Member of" : "Not a member of"} ${j}`,
          children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", className: W9.segmentName, children: j }),
            v && /* @__PURE__ */ k.jsx(fn, { size: 12 }),
            !v && /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(
              pe,
              {
                color: C ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, N)),
      i.length > Cs && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ k.jsx(
        Yn,
        {
          variant: "secondary",
          onClick: () => u(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - Cs} more`
        }
      ) })
    ] })
  ] }) : null;
}, Y9 = ({
  conversationContext: e,
  settings: n
}) => {
  const {
    isCustomerLoading: r,
    customerError: i,
    customerData: a,
    refetchCustomer: o,
    customerNetworkStatus: s
  } = kW({ conversationContext: e }), [l, u] = le(), [p, d] = le(
    []
  ), f = n.apiHostName, h = n.displayRefundOrder ?? !1, v = n.displayCancelOrder ?? !1, F = n.enableEditShippingAddress ?? !1, N = n.displayEmailMarketingConsent ?? !1, j = n.displayOrdersOverview ?? !1, C = n.displaySegmentMembership ?? !1, g = n.displayDiscountCodeCreation ?? !1, z = n.displayDiscountCodes ?? !1, T = n.displayCreateOrder ?? !1, I = n.displayDuplicateOrder ?? !1, D = n.displayCreateDraftOrder ?? !1, U = n.displayPartialRefundOrder ?? !1;
  if (Ye(() => {
    const Q = a?.Shopify?.customers?.edges[0]?.node;
    Q && !r ? (d(
      a?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), u(Q)) : u(void 0);
  }, [a]), !r && i)
    return /* @__PURE__ */ k.jsx(In, { error: i, retry: o });
  if (!r && !i && !l) {
    const Q = `https://${f}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ k.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ k.jsx(
              FW,
              {
                refetchCustomer: o,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ k.jsx(
              Rt,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(Q, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ k.jsx(pe, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return r && s !== rr.refetch ? /* @__PURE__ */ k.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ k.jsx(fn, {}) }) : /* @__PURE__ */ k.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ k.jsx(
          EW,
          {
            customer: l,
            shopifyDomain: f,
            refresh: o,
            loading: r,
            networkStatus: s
          }
        ),
        j && /* @__PURE__ */ k.jsx(
          q9,
          {
            totalOrders: l?.numberOfOrders,
            amountSpent: l?.amountSpent
          }
        ),
        C && /* @__PURE__ */ k.jsx(G9, { shopifyId: l?.id }),
        N && /* @__PURE__ */ k.jsx(YW, { customer: l }),
        z && /* @__PURE__ */ k.jsx(
          GW,
          {
            displayDiscountCodeCreation: g
          }
        ),
        /* @__PURE__ */ k.jsx(
          B9,
          {
            shopifyCustomer: l,
            shopifyDomain: f,
            displayRefund: h,
            displayCancel: v,
            displayCreateOrder: T,
            displayCreateDraftOrder: D,
            enableEditShippingAddress: F,
            customerCountryCodes: p,
            displayDuplicateOrder: I,
            displayPartialRefundOrder: U
          }
        )
      ]
    }
  );
}, $t = [];
for (let e = 0; e < 256; ++e)
  $t.push((e + 256).toString(16).slice(1));
function Q9(e, n = 0) {
  return ($t[e[n + 0]] + $t[e[n + 1]] + $t[e[n + 2]] + $t[e[n + 3]] + "-" + $t[e[n + 4]] + $t[e[n + 5]] + "-" + $t[e[n + 6]] + $t[e[n + 7]] + "-" + $t[e[n + 8]] + $t[e[n + 9]] + "-" + $t[e[n + 10]] + $t[e[n + 11]] + $t[e[n + 12]] + $t[e[n + 13]] + $t[e[n + 14]] + $t[e[n + 15]]).toLowerCase();
}
const J9 = new Uint8Array(16);
function X9() {
  return crypto.getRandomValues(J9);
}
function Z9(e, n, r) {
  return crypto.randomUUID ? crypto.randomUUID() : e7(e);
}
function e7(e, n, r) {
  e = e || {};
  const i = e.random ?? e.rng?.() ?? X9();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, Q9(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._pointer_ls8kj_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_ls8kj_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_ls8kj_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ls8kj_63:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_unsvt_48{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_unsvt_48:hover,._messageIsOpen_unsvt_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_unsvt_60{cursor:pointer}._messageText_unsvt_64{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_unsvt_64::-webkit-scrollbar{width:7px;height:7px}._messageText_unsvt_64::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_unsvt_64::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._buttonLink_unsvt_86{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var dh = { exports: {} }, co = {}, zj;
function n7() {
  if (zj) return co;
  zj = 1;
  var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return co.Fragment = r, co.jsx = s, co.jsxs = s, co;
}
var Fs = {}, Uj;
function t7() {
  return Uj || (Uj = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[N];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        z("error", t, m);
      }
    }
    function z(t, c, m) {
      {
        var y = C.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var P = m.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var T = !1, I = !1, D = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || U || t === v || T || I || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function q(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return q(c) + ".Consumer";
          case s:
            var m = t;
            return q(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return R(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, be, fe, de, ge, K, xe, $e;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          be = console.log, fe = console.info, de = console.warn, ge = console.error, K = console.group, xe = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: be
            }),
            info: B({}, t, {
              value: fe
            }),
            warn: B({}, t, {
              value: de
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: K
            }),
            groupCollapsed: B({}, t, {
              value: xe
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = C.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var ze = !1, Re;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new on();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var m = Re.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      ze = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Le.current, Le.current = null, qe();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var S = te.stack.split(`
`), ne = y.stack.split(`
`), H = S.length - 1, x = ne.length - 1; H >= 1 && x >= 0 && S[H] !== ne[x]; )
            x--;
          for (; H >= 1 && x >= 0; H--, x--)
            if (S[H] !== ne[x]) {
              if (H !== 1 || x !== 1)
                do
                  if (H--, x--, x < 0 || S[H] !== ne[x]) {
                    var Z = `
` + S[H].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (H >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Le.current = P, Me(), Error.prepareStackTrace = $;
      }
      var ue = t ? t.displayName || t.name : "", _e = ue ? De(ue) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Qe(t, c, m) {
      return Ee(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Xe(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case d:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Qe(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return se(P($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, je = {}, Ve = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function dn(t, c, m, y, $) {
      {
        var P = Function.call.bind(ye);
        for (var w in t)
          if (P(t, w)) {
            var S = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + m + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[w](c, w, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              S = H;
            }
            S && !(S instanceof Error) && (Oe($), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, w, typeof S), Oe(null)), S instanceof Error && !(S.message in je) && (je[S.message] = !0, Oe($), g("Failed %s type: %s", m, S.message), Oe(null));
          }
      }
    }
    var E = Array.isArray;
    function _(t) {
      return E(t);
    }
    function O(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function W(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function L(t) {
      if (W(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", O(t)), J(t);
    }
    var M = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Ze(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function sn(t, c) {
      {
        var m = function() {
          he || (he = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function hn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, m, y, $, P, w) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function _n(t, c, m, y, $) {
      {
        var P, w = {}, S = null, ne = null;
        m !== void 0 && (L(m), S = "" + m), mn(c) && (L(c.key), S = "" + c.key), nn(c) && (ne = c.ref, Ze(c));
        for (P in c)
          ye.call(c, P) && !ie.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var H = t.defaultProps;
          for (P in H)
            w[P] === void 0 && (w[P] = H[P]);
        }
        if (S || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && sn(w, x), ne && hn(w, x);
        }
        return pn(t, S, ne, $, y, M.current, w);
      }
    }
    var Je = C.ReactCurrentOwner, Nn = C.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(m);
      } else
        Nn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (Je.current) {
          var t = R(Je.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Mn(t) {
      return "";
    }
    var jn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = kn(c);
        if (jn[m])
          return;
        jn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Je.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ae(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ae(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            cn(y) && gn(y, c);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              cn(w.value) && gn(w.value, c);
        }
      }
    }
    function zn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = R(c);
          dn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var $ = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function An(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ae(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var xn = {};
    function Sn(t, c, m, y, $, P) {
      {
        var w = re(t);
        if (!w) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = Mn();
          ne ? S += ne : S += vn();
          var H;
          t === null ? H = "null" : _(t) ? H = "array" : t !== void 0 && t.$$typeof === n ? (H = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : H = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, S);
        }
        var x = _n(t, c, m, $, P);
        if (x == null)
          return x;
        if (w) {
          var Z = c.children;
          if (Z !== void 0)
            if (y)
              if (_(Z)) {
                for (var ue = 0; ue < Z.length; ue++)
                  wn(Z[ue], t);
                Object.freeze && Object.freeze(Z);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = R(t), te = Object.keys(c).filter(function($n) {
            return $n !== "key";
          }), Ke = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? An(x) : zn(x), x;
      }
    }
    function Bn(t, c, m) {
      return Sn(t, c, m, !0);
    }
    function On(t, c, m) {
      return Sn(t, c, m, !1);
    }
    var Rn = On, Un = Bn;
    Fs.Fragment = i, Fs.jsx = Rn, Fs.jsxs = Un;
  })()), Fs;
}
var Mj;
function r7() {
  return Mj || (Mj = 1, process.env.NODE_ENV === "production" ? dh.exports = n7() : dh.exports = t7()), dh.exports;
}
var V = r7(), TF = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(TF || {}), ay = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(ay || {});
const i7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, a7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, o7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, s7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, l7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, c7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, u7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, d7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, m7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, p7 = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": i7,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": a7,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": o7,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": s7,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": l7,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": c7,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": u7,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": d7,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": m7
};
function oi(e) {
  return p7[e] ?? {};
}
const f7 = oi(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), h7 = oi(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), y7 = oi(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), g7 = oi(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), v7 = oi(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), k7 = oi(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), b7 = oi(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), _7 = oi(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), x7 = oi(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), S7 = ({
  contactId: e
}) => {
  const { useQuery: n } = yn(), { track: r } = Cn(), [i, a] = le(), [o, s] = le(), [l, u] = le(), {
    loading: p,
    error: d,
    data: f,
    refetch: h
  } = n(f7, {
    skip: !e,
    variables: { contactId: e }
  });
  return Ye(() => {
    const v = f?.Voyado?.ContactsV_GetContactById;
    !p && v && typeof v == "object" && ("id" in v && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in v && a(v.attributes), "preferences" in v && s(v.preferences), "consents" in v && u(
      v?.consents?.filter(
        (F) => F !== null
      ) || void 0
    )), !p && (!v || typeof v != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, p]), Kn(
    () => ({
      isLoading: p,
      error: d,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [d, i, o, l]
  );
};
function Gs(e = !1, n) {
  const [r, i] = le(e);
  return Ye(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const N7 = {
  count: 0,
  items: []
}, j7 = ({
  contactId: e
}) => {
  const { useQuery: n } = yn(), { track: r } = Cn(), [i, a] = le(N7), {
    loading: o,
    error: s,
    data: l
  } = n(g7, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Ye(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const u = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, p = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, d = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (p?.count ?? 0) + (d?.count ?? 0) + (u?.count ?? 0),
        items: [
          ...p.items ?? [],
          ...u.items ?? [],
          ...d.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: u.count ?? 0,
        smsReceived: p.count ?? 0,
        postalReceived: d.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, w7 = {
  count: 0,
  totalCount: 0,
  items: []
}, C7 = ({
  contactId: e
}) => {
  const { useQuery: n } = yn(), { track: r } = Cn(), [i, a] = le(
    w7
  ), {
    loading: o,
    error: s,
    data: l
  } = n(v7, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Ye(() => {
    const u = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && u) {
      a(
        u
      );
      const { count: p } = u;
      p && r("voyado:transactions:received", { count: p });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, F7 = ({
  conversationContext: e
}) => {
  const { useQuery: n } = yn(), [r, i] = le(void 0), [a, o] = le(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: u,
    error: p,
    data: d,
    refetch: f
  } = n(y7, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return Ye(() => {
    const h = d?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [d?.Voyado, u]), {
    isLoading: u,
    contactId: r,
    hasMultipleContacts: a,
    error: p,
    refetch: f
  };
}, I7 = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = yn(), [i, a] = le(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: u
  } = r(h7, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return Ye(() => {
    const p = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && p && Object.hasOwn(p, "memberlevel")) {
      const d = p?.memberlevel;
      a({
        levelName: d?.levelName,
        remainingToUpgrade: d?.remainingToUpgrade,
        basedOnRewardPoints: d?.basedOnRewardPoints,
        levelId: d?.levelId,
        latestChange: d?.latestChange,
        expires: d?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Kn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: u
    }),
    [o, s, i, u]
  );
}, $7 = "_pointer_ls8kj_48", E7 = "_list_ls8kj_53", T7 = "_listItem_ls8kj_63", ot = {
  pointer: $7,
  list: E7,
  listItem: T7
}, D7 = "_modalBody_1clhs_1", O7 = {
  modalBody: D7
}, R7 = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = yn(), { track: l } = Cn(), u = r?.id, p = r?.balance ?? 0, d = {
    balance: p?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: v } = gt({
    defaultValues: d,
    mode: "onChange"
  }), F = ko({ control: f }), N = parseInt(F?.balance ?? "0", 10), j = p === N, C = j ? "Change the value to update the points" : "", g = N < 0, z = g ? "Points can not be negative" : "", T = F.description === "", I = T ? "Description can not be empty" : "";
  Ye(() => {
    N > p ? h(
      "transactionType",
      ay.Addition
    ) : N < p && h(
      "transactionType",
      ay.Deduction
    );
  }, [p, N, h]);
  const [D, { loading: U, error: Q, reset: X }] = o(x7, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), re = () => {
    if (u) {
      const q = Z9();
      D({
        variables: {
          input: {
            accountId: u,
            transactionId: q,
            amount: Math.abs(N - p),
            transactionType: F.transactionType,
            description: F.description,
            source: TF.UpdateBalance
          }
        }
      }).then(async (R) => {
        R?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), G());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, G = () => {
    v(d), X(), n();
  };
  return /* @__PURE__ */ V.jsxs(
    jt,
    {
      isOpen: e,
      onClose: G,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ V.jsx(wt, { title: "Update points balance", onClose: G }),
        /* @__PURE__ */ V.jsxs(Ct, { className: O7.modalBody, children: [
          /* @__PURE__ */ V.jsxs(at, { children: [
            /* @__PURE__ */ V.jsx(me, { span: 6, children: /* @__PURE__ */ V.jsx(
              Ot,
              {
                name: "balance",
                control: f,
                render: ({ field: q }) => /* @__PURE__ */ V.jsx(
                  tr,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: C || z
                    },
                    input: {
                      ...q,
                      value: q.value.toString(),
                      onChange: (R) => q.onChange(R)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ V.jsx(me, { span: 6, children: /* @__PURE__ */ V.jsx(
              Ot,
              {
                name: "description",
                control: f,
                render: ({ field: q }) => /* @__PURE__ */ V.jsx(
                  tr,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: q,
                    meta: {
                      warning: I
                    }
                  }
                )
              }
            ) })
          ] }),
          Q && /* @__PURE__ */ V.jsx(In, { error: Q })
        ] }),
        /* @__PURE__ */ V.jsx(
          Pt,
          {
            confirmName: "Save",
            confirmOnClick: () => re(),
            confirmProps: {
              isLoading: U,
              disabled: j || g || T,
              loadingIndicator: /* @__PURE__ */ V.jsx(fn, { size: 16 })
            },
            cancelOnClick: G
          }
        )
      ]
    }
  );
}, P7 = "_wrapper_1ge6c_1", A7 = "_block_1ge6c_12", Bj = {
  wrapper: P7,
  block: A7
}, L7 = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = yn(), { isCopied: i, copy: a } = Gs(), { isCopied: o, copy: s } = Gs(), { isCopied: l, copy: u } = Gs(), [p, d] = le(!1), [f, h] = le(), [v, F] = le(!1), {
    loading: N,
    data: j,
    refetch: C
  } = r(b7, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  Ye(() => {
    if (j) {
      const ee = j?.Voyado?.PointAccountV_GetPointAccounts;
      ee && ee?.length > 0 && h(ee[0]);
    }
  }, [j]);
  const g = !!f?.id, z = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: T,
    lastName: I,
    street: D,
    zipCode: U,
    city: Q,
    country: X,
    isRegistrationCompleted: re,
    email: G,
    mobilePhone: q
  } = e, R = 14, B = `${T || ""} ${I || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", className: Bj.wrapper, children: [
    /* @__PURE__ */ V.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: Bj.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ V.jsx(A.Heading, { variant: "heading-2", children: B }),
          N && /* @__PURE__ */ V.jsx(fn, { size: 12 }),
          g && !N && /* @__PURE__ */ V.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ V.jsxs(Vn, { size: "small", variant: "warning", children: [
              z,
              " points"
            ] }),
            /* @__PURE__ */ V.jsx(Ge, { content: "Update points balance", children: /* @__PURE__ */ V.jsx(
              pe,
              {
                name: "pen",
                size: 12,
                onClick: () => d(!0),
                className: ot.pointer
              }
            ) }),
            v && /* @__PURE__ */ V.jsx(Ge, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ V.jsx(
              pe,
              {
                name: "info",
                size: 12,
                className: ot.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (D || Q || U || X || q || G) && /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
      q && /* @__PURE__ */ V.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ V.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ V.jsx(pe, { size: R, name: "phone" }),
          /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: q })
        ] }),
        /* @__PURE__ */ V.jsx(
          pe,
          {
            size: R,
            name: o ? "done" : "copy",
            onClick: () => s(q),
            className: ot.pointer
          }
        )
      ] }),
      G && /* @__PURE__ */ V.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ V.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ V.jsx(pe, { size: R, name: "mail" }),
          /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: G })
        ] }),
        /* @__PURE__ */ V.jsx(
          pe,
          {
            size: R,
            name: i ? "done" : "copy",
            onClick: () => a(G),
            className: ot.pointer
          }
        )
      ] }),
      (D || Q || U || X) && /* @__PURE__ */ V.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ V.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ V.jsx(pe, { size: R, name: "home" }),
          /* @__PURE__ */ V.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ V.jsx(tt, { children: D }),
            /* @__PURE__ */ V.jsxs(tt, { children: [
              U,
              " ",
              Q
            ] }),
            /* @__PURE__ */ V.jsx(tt, { children: X })
          ] })
        ] }),
        /* @__PURE__ */ V.jsx(
          pe,
          {
            size: R,
            name: l ? "done" : "copy",
            onClick: () => u(`${D}, ${U} ${Q}, ${X}`),
            className: ot.pointer
          }
        )
      ] }),
      /* @__PURE__ */ V.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ V.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ V.jsx(pe, { size: R, name: "sign-in" }),
          /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ V.jsx(
          pe,
          {
            name: re ? "check-circle-filled" : "close-circle-filled",
            color: re ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    g && /* @__PURE__ */ V.jsx(
      R7,
      {
        isOpen: p,
        pointsAccount: f,
        onClose: () => d(!1),
        setHasPointsBeenUpdated: F,
        refetchPointsQuery: C
      }
    )
  ] });
}, V7 = "_list_yud4a_7", z7 = "_listItem_yud4a_11", U7 = "_listItemTooltip_yud4a_15", M7 = "_listItemTimestamp_yud4a_18", Is = {
  list: V7,
  listItem: z7,
  listItemTooltip: U7,
  listItemTimestamp: M7
}, B7 = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ V.jsx(A.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ V.jsx(We, { className: Is.list, children: e.map((n, r) => /* @__PURE__ */ V.jsx(We.Text, { variant: "dense", className: Is.listItem, children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ V.jsx(Ge, { content: n?.comment, children: /* @__PURE__ */ V.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: it({
          [Is.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ V.jsx(A.Paragraph, { className: Is.listItemTimestamp, children: Hn(n.date).format(St) }),
          n?.comment && /* @__PURE__ */ V.jsx(pe, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ V.jsx(
      pe,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), q7 = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Hn(e.latestChange).format(St) : null, o = e?.expires ? `${Hn(e.expires).fromNow()} (${Hn(e.expires).format(St)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ V.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ V.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ V.jsx(A.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ V.jsx(Ge, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ V.jsx(
        pe,
        {
          name: "question",
          size: 14,
          className: ot.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ V.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ V.jsxs(We, { className: ot.list, children: [
      s && /* @__PURE__ */ V.jsx(We.Text, { variant: "dense", className: ot.listItem, children: /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ V.jsx(We.Text, { variant: "dense", className: ot.listItem, children: /* @__PURE__ */ V.jsx(Ge, { content: "", children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ V.jsx(Vn, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ V.jsx(We.Text, { variant: "dense", className: ot.listItem, children: /* @__PURE__ */ V.jsx(Ge, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ V.jsx(Vn, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ V.jsx(We.Text, { variant: "dense", className: ot.listItem, children: /* @__PURE__ */ V.jsx(Ge, { content: "", children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ V.jsx(Vn, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ V.jsx(We.Text, { variant: "dense", className: ot.listItem, children: /* @__PURE__ */ V.jsx(Ge, { content: "", children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ V.jsx(We.Text, { variant: "dense", className: ot.listItem, children: /* @__PURE__ */ V.jsx(Ge, { content: "", children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, H7 = "_tagHover_kzbzk_1", W7 = "_channelUnsubscribed_kzbzk_6", qj = {
  tagHover: H7,
  channelUnsubscribed: W7
}, mh = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = Cn(), { useMutation: l } = yn(), [u, p] = le(!1), [d, { loading: f }] = l(_7), h = async ({
    newPreference: F,
    isSubscribed: N,
    channelType: j
  }) => {
    p(!0), (await d({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...F
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? N ? s("voyado:channel:unsubscribe:succeeded", { channel: j }) : s("voyado:channel:subscribe:succeeded", { channel: j }) : N ? s("voyado:channel:unsubscribe:failed", { channel: j }) : s("voyado:channel:subscribe:failed", { channel: j }), setTimeout(async () => {
      await o().finally(() => p(!1));
    }, 1e3);
  }, v = u || f;
  return /* @__PURE__ */ V.jsx(Ge, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ V.jsx(
    qn,
    {
      className: qj.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ V.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: it({
            [qj.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            v ? /* @__PURE__ */ V.jsx(fn, { size: 16 }) : /* @__PURE__ */ V.jsx(pe, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, K7 = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ V.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ V.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ V.jsx(
        mh,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ V.jsx(
        mh,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ V.jsx(
        mh,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, G7 = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: u,
    refetch: p,
    attributes: d,
    preferences: f,
    consents: h
  } = S7({ contactId: e }), {
    isLoading: v,
    error: F,
    memberLevel: N
  } = I7({ contactId: e, skip: !s }), j = v || l, C = Kn(
    () => h?.filter(
      (g) => g !== null
    ),
    [h]
  );
  return u || F ? va({
    errors: u?.graphQLErrors || F?.graphQLErrors || []
  }) ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ V.jsx(A.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ V.jsx(In, { error: u || F }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ V.jsx(A.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : j ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ V.jsx(fn, {}) }) : /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
    r && /* @__PURE__ */ V.jsx(
      L7,
      {
        contactAttributes: d,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ V.jsx(q7, { memberLevel: N }),
    i && /* @__PURE__ */ V.jsx(
      K7,
      {
        refetchContact: p,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ V.jsx(B7, { contactConsents: C })
  ] });
}, oy = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, Y7 = "_list_zu4s7_1", Q7 = "_listItem_zu4s7_4", J7 = "_listSum_zu4s7_7", $s = {
  list: Y7,
  listItem: Q7,
  listSum: J7
}, X7 = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ V.jsxs(We, { className: $s.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ V.jsx(We.Text, { variant: "dense", className: $s.listItem, children: /* @__PURE__ */ V.jsx(Ge, { content: s, children: /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ V.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ V.jsx(b, { flex: "auto", children: /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ V.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: oy(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ V.jsx(
    We.Text,
    {
      variant: "dense",
      className: it($s.listItem, $s.listSum),
      children: /* @__PURE__ */ V.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "3", children: oy(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), Z7 = "_transaction_1kr8d_1", eK = "_transactionIsOpen_1kr8d_9", nK = "_transactionHeader_1kr8d_12", tK = "_transactionHeaderSubLine_1kr8d_15", rK = "_transactionHeaderAlignItemRight_1kr8d_19", ea = {
  transaction: Z7,
  transactionIsOpen: eK,
  transactionHeader: nK,
  transactionHeaderSubLine: tK,
  transactionHeaderAlignItemRight: rK
}, iK = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = le(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: u,
    lineItems: p,
    localCurrency: d,
    localNetPriceSum: f
  } = e, h = d ?? "", v = f ?? 0, F = p?.length ? p : [];
  return /* @__PURE__ */ V.jsxs(
    b,
    {
      className: it(ea.transaction, {
        [ea.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ V.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ea.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ V.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ V.jsx(Vn, { size: "small", variant: "info", children: Hn(o).format(St) }),
                  /* @__PURE__ */ V.jsxs(
                    A.Heading,
                    {
                      variant: "heading-4",
                      className: ea.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ V.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: ea.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ V.jsx(A.Heading, { variant: "heading-4", children: oy(v, h) }),
                      /* @__PURE__ */ V.jsxs(
                        A.Heading,
                        {
                          variant: "heading-4",
                          className: ea.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ V.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ V.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ V.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ V.jsx(my, {}),
              /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ V.jsx(A.Heading, { variant: "heading-2", children: s }),
                u && /* @__PURE__ */ V.jsx(qn, { children: /* @__PURE__ */ V.jsx(b, { alignItems: "center", children: u }) }),
                /* @__PURE__ */ V.jsx(
                  X7,
                  {
                    lineItems: F,
                    localCurrency: h,
                    localNetPriceSum: v
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, aK = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = C7({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ V.jsx(In, { error: r }) : /* @__PURE__ */ V.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ V.jsx(A.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ V.jsx(Vn, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ V.jsx(fn, {}) }) : /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
          s === 0 && /* @__PURE__ */ V.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, u) => /* @__PURE__ */ V.jsx(
            iK,
            {
              transaction: l,
              openByDefault: u === 0
            },
            u
          ))
        ] })
      ]
    }
  );
}, oK = "_message_unsvt_48", sK = "_messageIsOpen_unsvt_56", lK = "_messageHeader_unsvt_60", cK = "_messageText_unsvt_64", uK = "_buttonLink_unsvt_86", uo = {
  message: oK,
  messageIsOpen: sK,
  messageHeader: lK,
  messageText: cK,
  buttonLink: uK
}, ph = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, fh = (e, n) => n && e in ph && n in ph[e] ? ph[e][n] : null, dK = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = le(n), { track: a } = Cn();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: u,
    isTransactional: p,
    status: d,
    messageLink: f,
    messageText: h
  } = e, v = l ? fh("type", l) : null, F = u ? fh("source", u) : null, N = d ? fh("status", d) : null, j = l?.replace("Message", "");
  return /* @__PURE__ */ V.jsxs(
    b,
    {
      className: it(uo.message, {
        [uo.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ V.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: uo.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ V.jsxs(b, { gap: "200", alignItems: "center", children: [
                  v && /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
                    /* @__PURE__ */ V.jsx(pe, { name: v, size: 16 }),
                    " ",
                    j
                  ] }),
                  s && /* @__PURE__ */ V.jsx(Vn, { size: "small", variant: "info", children: Hn(s).format(St) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ V.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ V.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ V.jsx(my, {}),
          /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            N && /* @__PURE__ */ V.jsx(qn, { children: /* @__PURE__ */ V.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ V.jsx(pe, { name: N }),
              " ",
              d
            ] }) }),
            F && /* @__PURE__ */ V.jsx(qn, { children: /* @__PURE__ */ V.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ V.jsx(pe, { name: F }),
              " ",
              u
            ] }) }),
            p && /* @__PURE__ */ V.jsx(qn, { children: /* @__PURE__ */ V.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ V.jsx(pe, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", className: uo.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ V.jsx(
            Rt,
            {
              slotEnd: /* @__PURE__ */ V.jsx(pe, { name: "external-link" }),
              variant: "tertiary",
              className: uo.buttonLink,
              navigate: () => {
                j && a("voyado:message:external-link:opened", {
                  channel: j.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, mK = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = j7({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ V.jsx(In, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ V.jsx(A.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ V.jsx(Vn, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ V.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ V.jsx(fn, {}) }) : /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
      l && o?.map((u, p) => /* @__PURE__ */ V.jsx(
        dK,
        {
          message: u || void 0,
          openByDefault: p === 0
        },
        p
      )),
      !l && /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, Yl = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, Hj = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = Gs(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = lt(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ V.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ V.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ V.jsx(pe, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ V.jsx(Ge, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ V.jsx(
      pe,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: ot.pointer
      }
    ) })
  ] });
}, pK = "_order_19t4p_1", fK = "_orderIsOpen_19t4p_9", hK = "_orderHeader_19t4p_12", yK = "_orderIconColor_19t4p_15", Tr = {
  order: pK,
  orderIsOpen: fK,
  orderHeader: hK,
  orderIconColor: yK
}, gK = "_delivery_1m9nb_1", vK = "_deliveryCode_1m9nb_4", hh = {
  delivery: gK,
  deliveryCode: vK
}, kK = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = Gt();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ V.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ V.jsx(
      pe,
      {
        size: l,
        name: "eye",
        className: Tr.orderIconColor
      }
    ),
    /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ V.jsx(
        Ge,
        {
          content: /* @__PURE__ */ V.jsxs(A.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Hn(s).format(St)
          ] }),
          children: /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ V.jsx(
              A.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ V.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: hh.delivery,
                    children: [
                      /* @__PURE__ */ V.jsx(pe, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ V.jsx(
              A.Paragraph,
              {
                variant: "4",
                className: it(hh.delivery, hh.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ V.jsx(Ge, { content: "Copy tracking code", children: /* @__PURE__ */ V.jsx(
      pe,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: ot.pointer
      }
    ) })
  ] });
}, bK = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ V.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ V.jsx(
        pe,
        {
          size: 14,
          name: "file-text",
          className: Tr.orderIconColor
        }
      ),
      /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ V.jsx(We, { className: ot.list, children: r?.map((i, a) => /* @__PURE__ */ V.jsx(We.Item, { className: ot.listItem, children: /* @__PURE__ */ V.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ V.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ V.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: ot.listItemAlignRight,
              children: [
                /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: Yl({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, _K = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ V.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ V.jsx(
        pe,
        {
          size: 14,
          name: "tag",
          className: Tr.orderIconColor
        }
      ),
      /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ V.jsx(We, { className: ot.list, children: r?.map((i) => /* @__PURE__ */ V.jsx(
      We.Item,
      {
        className: ot.listItem,
        contentLeft: /* @__PURE__ */ V.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ V.jsx(
          Ge,
          {
            content: /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ V.jsx(b, { children: /* @__PURE__ */ V.jsx(Vn, { size: "small", variant: "info", children: Yl({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ V.jsx(
          ka,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, xK = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ V.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ V.jsx(
        pe,
        {
          size: 14,
          name: "credit-card",
          className: Tr.orderIconColor
        }
      ),
      /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ V.jsx(We, { className: ot.list, children: r?.map((i, a) => /* @__PURE__ */ V.jsx(
      We.Item,
      {
        className: ot.listItem,
        children: /* @__PURE__ */ V.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ V.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: ot.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "5", children: Hn(i?.paidAt).format(St) }),
                    /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: Yl({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, SK = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = le(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: u,
    createdAt: p,
    lastChangedAt: d,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: v,
    totalPrice: F
  } = e, N = 14;
  return /* @__PURE__ */ V.jsxs(
    b,
    {
      className: it(Tr.order, {
        [Tr.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ V.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Tr.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ V.jsxs(b, { gap: "100", flexDirection: "column", children: [
                p && /* @__PURE__ */ V.jsx(b, { alignItems: "center", children: /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: Hn(p).format(St) }) }),
                /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ V.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ V.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ V.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ V.jsx(
              pe,
              {
                size: N,
                name: "activity",
                className: Tr.orderIconColor
              }
            ),
            /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ V.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ V.jsx(Ge, { content: "Internal status", children: /* @__PURE__ */ V.jsx(Vn, { size: "small", variant: "info", children: /* @__PURE__ */ V.jsx(V.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ V.jsx(Ge, { content: "External status", children: /* @__PURE__ */ V.jsx(Vn, { size: "small", variant: "info", children: /* @__PURE__ */ V.jsx(V.Fragment, { children: s }) }) }),
                /* @__PURE__ */ V.jsx(Ge, { content: "Last updated at", children: /* @__PURE__ */ V.jsx(A.Paragraph, { as: "span", variant: "5", children: Hn(d).format(St) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ V.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ V.jsx(
              pe,
              {
                size: N,
                name: "chart-bar",
                className: Tr.orderIconColor
              }
            ),
            /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: Yl({
                value: F,
                currencyCode: l
              }) })
            ] })
          ] }),
          u && /* @__PURE__ */ V.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ V.jsx(
              pe,
              {
                size: N,
                name: "channels",
                className: Tr.orderIconColor
              }
            ),
            /* @__PURE__ */ V.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ V.jsx(Vn, { size: "small", variant: "info", children: /* @__PURE__ */ V.jsx(V.Fragment, { children: u }) }) })
            ] })
          ] }),
          /* @__PURE__ */ V.jsx(Hj, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ V.jsx(
            Hj,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: v
            }
          ),
          /* @__PURE__ */ V.jsx(kK, { delivery: e.delivery }),
          /* @__PURE__ */ V.jsx(_K, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ V.jsx(bK, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ V.jsx(
            xK,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, NK = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || va({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ V.jsx(In, { error: e }) : /* @__PURE__ */ V.jsx(V.Fragment, { children: r }), jK = ({
  contactId: e
}) => {
  const { useQuery: n } = yn(), [r, i] = le([]), { track: a } = Cn(), {
    loading: o,
    error: s,
    data: l
  } = n(k7, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return Ye(() => {
    if (l?.Voyado) {
      const u = l?.Voyado.Orders_GetAllByContact;
      if (!o && u?.items) {
        i(u.items);
        const { totalCount: p } = u;
        p && a("voyado:orders:received", { count: p });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ V.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ V.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ V.jsx(Vn, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ V.jsx(fn, {}) }) : /* @__PURE__ */ V.jsx(NK, { error: s, itemCount: r.length, children: r.map((u, p) => /* @__PURE__ */ V.jsx(
      SK,
      {
        order: u,
        openByDefault: p === 0
      },
      p
    )) })
  ] }) : null;
}, wK = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = F7({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: u,
    showPreferences: p,
    showAudiences: d,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: v,
    showOrders: F
  } = n;
  return s ? /* @__PURE__ */ V.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ V.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? va({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ V.jsx(In, { error: o }) : !u && !p && !d && !f && !h && !v ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ V.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ V.jsx(fn, {}) }) : /* @__PURE__ */ V.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ V.jsx(G7, { contactId: i, settings: n }),
        h && /* @__PURE__ */ V.jsx(mK, { contactId: i }),
        v && /* @__PURE__ */ V.jsx(aK, { contactId: i }),
        F && /* @__PURE__ */ V.jsx(jK, { contactId: i }),
        !l && /* @__PURE__ */ V.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ V.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, sy = [
  {
    key: "voyadoApiKey",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "apiHostName",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "showCustomerAttributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPreferences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAudiences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showConsents",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], CK = {
  enabled: !1,
  name: "",
  voyadoApiKey: "",
  apiHostName: "",
  showCustomerAttributes: !0,
  showPreferences: !0,
  showAudiences: !0,
  showConsents: !0,
  showLastMessages: !0,
  showCustomerTransactions: !0,
  showOrders: !0,
  showMemberLevel: !0
}, FK = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = gt({
    mode: "onChange",
    defaultValues: CK
  }), {
    create: l,
    update: u,
    remove: p,
    isLoading: d,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = Xr({
    integrationId: e,
    integrationType: "VOYADO",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: N,
    isWidgetUnknown: j,
    refetch: C,
    widgetConfiguration: g
  } = Zr({
    integrationId: e,
    fieldDefinitions: sy,
    form: s,
    onMisconfigured: v
  }), { renderConditions: z, setRenderConditions: T, renderConditionsForSubmit: I } = ei({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), D = (Q) => ti(Q, {
    fieldDefinitions: sy,
    isCreationMode: o,
    create: l,
    update: u,
    renderConditions: I
  }), U = s.watch("name");
  return /* @__PURE__ */ V.jsxs(
    ni,
    {
      form: s,
      integrationId: e,
      onValidSubmit: D,
      error: N ?? f,
      onRetry: N ? C : void 0,
      isLoading: d || F,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ V.jsx(ri, { cause: h }),
        /* @__PURE__ */ V.jsxs(at, { children: [
          /* @__PURE__ */ V.jsx(me, { children: /* @__PURE__ */ V.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ V.jsx(
            Pn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(me, { span: 3, children: /* @__PURE__ */ V.jsx(
            Qn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ V.jsx(me, { span: 3 }),
          /* @__PURE__ */ V.jsx(me, { span: 3, children: /* @__PURE__ */ V.jsx(
            Ro,
            {
              name: "voyadoApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "API key from Voyado",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ V.jsx(me, { span: 3 }),
          /* @__PURE__ */ V.jsx(me, { span: 3, children: /* @__PURE__ */ V.jsx(
            Qn,
            {
              name: "apiHostName",
              label: "API URL",
              control: s.control,
              rules: { required: "API URL is required" },
              componentProps: {
                placeholder: "The URL of the Voyado API",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ V.jsx(me, { span: 3 }),
          /* @__PURE__ */ V.jsx(me, { span: 3, children: /* @__PURE__ */ V.jsx(en, { label: "Show the customer attributes", children: /* @__PURE__ */ V.jsx(
            Pn,
            {
              name: "showCustomerAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(me, { span: 3 }),
          /* @__PURE__ */ V.jsx(me, { span: 3, children: /* @__PURE__ */ V.jsx(en, { label: "Show preferences", children: /* @__PURE__ */ V.jsx(
            Pn,
            {
              name: "showPreferences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(me, { span: 3 }),
          /* @__PURE__ */ V.jsx(me, { span: 3, children: /* @__PURE__ */ V.jsx(en, { label: "Show audiences", children: /* @__PURE__ */ V.jsx(
            Pn,
            {
              name: "showAudiences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(me, { span: 3 }),
          /* @__PURE__ */ V.jsx(me, { span: 3, children: /* @__PURE__ */ V.jsx(en, { label: "Show consents", children: /* @__PURE__ */ V.jsx(
            Pn,
            {
              name: "showConsents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(me, { span: 3 }),
          /* @__PURE__ */ V.jsx(me, { span: 3, children: /* @__PURE__ */ V.jsx(en, { label: "Show the last 5 messages", children: /* @__PURE__ */ V.jsx(
            Pn,
            {
              name: "showLastMessages",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(me, { span: 3 }),
          /* @__PURE__ */ V.jsx(me, { span: 3, children: /* @__PURE__ */ V.jsx(en, { label: "Show customer transactions", children: /* @__PURE__ */ V.jsx(
            Pn,
            {
              name: "showCustomerTransactions",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(me, { span: 3 }),
          /* @__PURE__ */ V.jsx(me, { span: 3, children: /* @__PURE__ */ V.jsx(en, { label: "Show orders by contact", children: /* @__PURE__ */ V.jsx(
            Pn,
            {
              name: "showOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(me, { span: 3 }),
          /* @__PURE__ */ V.jsx(me, { span: 3, children: /* @__PURE__ */ V.jsx(en, { label: "Show member level", children: /* @__PURE__ */ V.jsx(
            Pn,
            {
              name: "showMemberLevel",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ V.jsx(me, { span: 3 }),
          a && z !== null && /* @__PURE__ */ V.jsx(me, { children: a({
            value: z,
            onChange: T,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ V.jsx(
          ii,
          {
            integrationType: "VOYADO",
            integrationId: e,
            widgetName: U,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => p()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_11mz1_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_11mz1_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_11mz1_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_11mz1_63:last-child{box-shadow:none}._listItemHighlighted_11mz1_72{border-left:8px solid var(--dixa-color-orange-300)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var yh = { exports: {} }, mo = {}, Wj;
function IK() {
  if (Wj) return mo;
  Wj = 1;
  var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, p) {
    var d, f = {}, h = null, v = null;
    p !== void 0 && (h = "" + p), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return mo.Fragment = r, mo.jsx = s, mo.jsxs = s, mo;
}
var Es = {}, Kj;
function $K() {
  return Kj || (Kj = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), F = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[N];
      return typeof c == "function" ? c : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, m = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          m[y - 1] = arguments[y];
        z("error", t, m);
      }
    }
    function z(t, c, m) {
      {
        var y = C.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", m = m.concat([$]));
        var P = m.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var T = !1, I = !1, D = !1, U = !1, Q = !1, X;
    X = Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === p || t === d || U || t === v || T || I || D || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === X || t.getModuleId !== void 0));
    }
    function G(t, c, m) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? m + "(" + $ + ")" : m;
    }
    function q(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return q(c) + ".Consumer";
          case s:
            var m = t;
            return q(m._context) + ".Provider";
          case u:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return R(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, be, fe, de, ge, K, xe, $e;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          be = console.log, fe = console.info, de = console.warn, ge = console.error, K = console.group, xe = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Me() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: be
            }),
            info: B({}, t, {
              value: fe
            }),
            warn: B({}, t, {
              value: de
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: K
            }),
            groupCollapsed: B({}, t, {
              value: xe
            }),
            groupEnd: B({}, t, {
              value: $e
            })
          });
        }
        ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = C.ReactCurrentDispatcher, Ue;
    function De(t, c, m) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var ze = !1, Re;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new on();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var m = Re.get(t);
        if (m !== void 0)
          return m;
      }
      var y;
      ze = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Le.current, Le.current = null, qe();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (te) {
              y = te;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (te) {
              y = te;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            y = te;
          }
          t();
        }
      } catch (te) {
        if (te && y && typeof te.stack == "string") {
          for (var S = te.stack.split(`
`), ne = y.stack.split(`
`), H = S.length - 1, x = ne.length - 1; H >= 1 && x >= 0 && S[H] !== ne[x]; )
            x--;
          for (; H >= 1 && x >= 0; H--, x--)
            if (S[H] !== ne[x]) {
              if (H !== 1 || x !== 1)
                do
                  if (H--, x--, x < 0 || S[H] !== ne[x]) {
                    var Z = `
` + S[H].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (H >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Le.current = P, Me(), Error.prepareStackTrace = $;
      }
      var ue = t ? t.displayName || t.name : "", _e = ue ? De(ue) : "";
      return typeof t == "function" && Re.set(t, _e), _e;
    }
    function Qe(t, c, m) {
      return Ee(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, m) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Xe(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case p:
          return De("Suspense");
        case d:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return Qe(t.render);
          case f:
            return se(t.type, c, m);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return se(P($), c, m);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, je = {}, Ve = C.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(m);
      } else
        Ve.setExtraStackFrame(null);
    }
    function dn(t, c, m, y, $) {
      {
        var P = Function.call.bind(ye);
        for (var w in t)
          if (P(t, w)) {
            var S = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + m + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              S = t[w](c, w, y, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (H) {
              S = H;
            }
            S && !(S instanceof Error) && (Oe($), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", m, w, typeof S), Oe(null)), S instanceof Error && !(S.message in je) && (je[S.message] = !0, Oe($), g("Failed %s type: %s", m, S.message), Oe(null));
          }
      }
    }
    var E = Array.isArray;
    function _(t) {
      return E(t);
    }
    function O(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, m = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return m;
      }
    }
    function W(t) {
      try {
        return J(t), !1;
      } catch {
        return !0;
      }
    }
    function J(t) {
      return "" + t;
    }
    function L(t) {
      if (W(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", O(t)), J(t);
    }
    var M = C.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Ne;
    function nn(t) {
      if (ye.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mn(t) {
      if (ye.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Ze(t, c) {
      typeof t.ref == "string" && M.current;
    }
    function sn(t, c) {
      {
        var m = function() {
          he || (he = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function hn(t, c) {
      {
        var m = function() {
          Ne || (Ne = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        m.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var pn = function(t, c, m, y, $, P, w) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: m,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function _n(t, c, m, y, $) {
      {
        var P, w = {}, S = null, ne = null;
        m !== void 0 && (L(m), S = "" + m), mn(c) && (L(c.key), S = "" + c.key), nn(c) && (ne = c.ref, Ze(c));
        for (P in c)
          ye.call(c, P) && !ie.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var H = t.defaultProps;
          for (P in H)
            w[P] === void 0 && (w[P] = H[P]);
        }
        if (S || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && sn(w, x), ne && hn(w, x);
        }
        return pn(t, S, ne, $, y, M.current, w);
      }
    }
    var Je = C.ReactCurrentOwner, Nn = C.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, m = se(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(m);
      } else
        Nn.setExtraStackFrame(null);
    }
    var ln;
    ln = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (Je.current) {
          var t = R(Je.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Mn(t) {
      return "";
    }
    var jn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var m = typeof t == "string" ? t : t.displayName || t.name;
          m && (c = `

Check the top-level render call using <` + m + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var m = kn(c);
        if (jn[m])
          return;
        jn[m] = !0;
        var y = "";
        t && t._owner && t._owner !== Je.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ae(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, y), Ae(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var m = 0; m < t.length; m++) {
            var y = t[m];
            cn(y) && gn(y, c);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = j(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              cn(w.value) && gn(w.value, c);
        }
      }
    }
    function zn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var m;
        if (typeof c == "function")
          m = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          m = c.propTypes;
        else
          return;
        if (m) {
          var y = R(c);
          dn(m, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !ln) {
          ln = !0;
          var $ = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function An(t) {
      {
        for (var c = Object.keys(t.props), m = 0; m < c.length; m++) {
          var y = c[m];
          if (y !== "children" && y !== "key") {
            Ae(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ae(null);
            break;
          }
        }
        t.ref !== null && (Ae(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ae(null));
      }
    }
    var xn = {};
    function Sn(t, c, m, y, $, P) {
      {
        var w = re(t);
        if (!w) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = Mn();
          ne ? S += ne : S += vn();
          var H;
          t === null ? H = "null" : _(t) ? H = "array" : t !== void 0 && t.$$typeof === n ? (H = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : H = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", H, S);
        }
        var x = _n(t, c, m, $, P);
        if (x == null)
          return x;
        if (w) {
          var Z = c.children;
          if (Z !== void 0)
            if (y)
              if (_(Z)) {
                for (var ue = 0; ue < Z.length; ue++)
                  wn(Z[ue], t);
                Object.freeze && Object.freeze(Z);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Z, t);
        }
        if (ye.call(c, "key")) {
          var _e = R(t), te = Object.keys(c).filter(function($n) {
            return $n !== "key";
          }), Ke = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? An(x) : zn(x), x;
      }
    }
    function Bn(t, c, m) {
      return Sn(t, c, m, !0);
    }
    function On(t, c, m) {
      return Sn(t, c, m, !1);
    }
    var Rn = On, Un = Bn;
    Es.Fragment = i, Es.jsx = Rn, Es.jsxs = Un;
  })()), Es;
}
var Gj;
function EK() {
  return Gj || (Gj = 1, process.env.NODE_ENV === "production" ? yh.exports = IK() : yh.exports = $K()), yh.exports;
}
var Pe = EK();
const TK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_on" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, DK = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": TK
};
function OK(e) {
  return DK[e] ?? {};
}
const RK = OK(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              default_language
              dafault_currency
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
                next_points_expire_on
                next_points_expire_amount
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), PK = "_copyIcon_11mz1_48", AK = "_list_11mz1_53", LK = "_listItem_11mz1_63", VK = "_listItemHighlighted_11mz1_72", ya = {
  copyIcon: PK,
  list: AK,
  listItem: LK,
  listItemHighlighted: VK
}, zK = "_wrapper_1xucg_1", UK = "_externalLink_1xucg_7", gh = {
  wrapper: zK,
  externalLink: UK
}, MK = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Gt(), { isCopied: i, copy: a } = Gt();
  if (!e)
    return null;
  const {
    first_name: o,
    last_name: s,
    email: l,
    phone_number: u,
    account_created_at: p
  } = e, d = 14, f = `${o || ""} ${s || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Pe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Pe.jsxs(b, { className: gh.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Pe.jsx(
      b,
      {
        justifyContent: "space-between",
        className: gh.block,
        alignItems: "center",
        children: /* @__PURE__ */ Pe.jsx(A.Heading, { variant: "heading-2", children: f })
      }
    ),
    p && /* @__PURE__ */ Pe.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Pe.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Pe.jsx(A.Paragraph, { variant: "4", children: Hn(p).format(St) })
    ] }),
    l && /* @__PURE__ */ Pe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Pe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Pe.jsx(pe, { size: d, name: "mail" }),
        /* @__PURE__ */ Pe.jsx("span", { className: gh.externalLink, children: l })
      ] }),
      /* @__PURE__ */ Pe.jsx(Ge, { content: "Copy email", children: /* @__PURE__ */ Pe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Pe.jsx(
        pe,
        {
          size: d,
          name: n ? "done" : "copy",
          onClick: () => r(l),
          className: ya.copyIcon
        }
      ) }) })
    ] }),
    u && /* @__PURE__ */ Pe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Pe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Pe.jsx(pe, { size: d, name: "phone" }),
        /* @__PURE__ */ Pe.jsx(A.Paragraph, { variant: "4", children: u })
      ] }),
      /* @__PURE__ */ Pe.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ Pe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Pe.jsx(
        pe,
        {
          size: d,
          name: i ? "done" : "copy",
          onClick: () => a(u),
          className: ya.copyIcon
        }
      ) }) })
    ] })
  ] }) });
}, Gn = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = vw(n);
  return /* @__PURE__ */ Pe.jsx(
    We.Text,
    {
      variant: "dense",
      className: it(ya.listItem, {
        [ya.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ Pe.jsx(Ge, { content: r, children: /* @__PURE__ */ Pe.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ Pe.jsx(A.Paragraph, { variant: "4", children: e }),
        a ? n : Oi(n)
      ] }) })
    }
  );
}, BK = ({
  loyalty: e
}) => /* @__PURE__ */ Pe.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Pe.jsx(A.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ Pe.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Pe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ Pe.jsxs(We, { className: ya.list, children: [
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        isHighlighted: !0,
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        isHighlighted: !0,
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.next_points_expire_on || e.points_expire_date
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Points expiry amount",
        tooltip: "The number of points that are about to expire",
        content: e.next_points_expire_amount
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), qK = 0.8, HK = 0.4, Yj = (e) => {
  if (e != null)
    return e >= qK ? /* @__PURE__ */ Pe.jsx(Vn, { variant: "success", size: "small", children: "Positive" }) : e <= HK ? /* @__PURE__ */ Pe.jsx(Vn, { variant: "error", size: "small", children: "Negative" }) : /* @__PURE__ */ Pe.jsx(Vn, { variant: "warning", size: "small", children: "Neutral" });
}, WK = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ Pe.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Pe.jsx(A.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ Pe.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Pe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ Pe.jsxs(We, { className: ya.list, children: [
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        isHighlighted: !0,
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        isHighlighted: !0,
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        isHighlighted: !0,
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: Yj(e.total_avg_sentiment)
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: Yj(e.last_sentiment)
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Hn(e.last_review_date).format(
          St
        )
      }
    ),
    /* @__PURE__ */ Pe.jsx(
      Gn,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ Pe.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ Pe.jsx(Vn, { variant: "info", size: "small", children: /* @__PURE__ */ Pe.jsx(Pe.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), KK = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = yn(), { track: i } = Cn(), [a, o] = le(), [s, l] = le(!1), u = e?.customer?.email, p = e?.customer?.phone_number, d = !u && !p, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, v = n?.showUserGeneratedContent ?? !1, F = n?.displayLoyalty ?? !1, N = n?.displaySubscriptions ?? !1, j = !f, C = !h && !v && !F && !N, {
    loading: g,
    error: z,
    data: T
  } = r(RK, {
    skip: d || j,
    variables: {
      ...u && { email: u },
      ...!u && p && { phone: p },
      storeId: f,
      expand: "all"
    }
  });
  if (Ye(() => {
    const I = T?.Yotpo?.getCustomers?.customers?.[0];
    I ? (o(I), l(!1), i("yotpo:customer:received")) : l(!0);
  }, [T?.Yotpo, g]), j)
    return /* @__PURE__ */ Pe.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Pe.jsx(
      In,
      {
        error: new Nw({
          graphQLErrors: [
            {
              message: "Integration needs to be re-/authorized in the settings."
            }
          ]
        }),
        hideCopyButton: !0
      }
    ) });
  if (d)
    return /* @__PURE__ */ Pe.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ Pe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (C)
    return /* @__PURE__ */ Pe.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ Pe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (g)
    return /* @__PURE__ */ Pe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Pe.jsx(fn, {}) });
  if (s)
    return /* @__PURE__ */ Pe.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Pe.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (z) {
    const I = z.graphQLErrors;
    return kl({ errors: I }) ? /* @__PURE__ */ Pe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : bl({ errors: I }) ? /* @__PURE__ */ Pe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Pe.jsx(In, { error: z });
  }
  return /* @__PURE__ */ Pe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ Pe.jsx(MK, { customerDetails: a }),
        v && /* @__PURE__ */ Pe.jsx(
          WK,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        F && /* @__PURE__ */ Pe.jsx(BK, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
};
var Qo = (e) => e.type === "checkbox", Fi = (e) => e instanceof Date, Kt = (e) => e == null;
const DF = (e) => typeof e == "object";
var ht = (e) => !Kt(e) && !Array.isArray(e) && DF(e) && !Fi(e), OF = (e) => ht(e) && e.target ? Qo(e.target) ? e.target.checked : e.target.value : e, GK = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, RF = (e, n) => e.has(GK(n)), YK = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return ht(n) && n.hasOwnProperty("isPrototypeOf");
}, zg = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Dt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(zg && (e instanceof Blob || i)) && (r || ht(e)))
    if (n = r ? [] : {}, !r && !YK(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Dt(e[a]));
  else
    return e;
  return n;
}
var Ql = (e) => Array.isArray(e) ? e.filter(Boolean) : [], dt = (e) => e === void 0, an = (e, n, r) => {
  if (!n || !ht(e))
    return r;
  const i = Ql(n.split(/[,[\].]+?/)).reduce((a, o) => Kt(a) ? a : a[o], e);
  return dt(i) || i === e ? dt(e[n]) ? r : e[n] : i;
}, lr = (e) => typeof e == "boolean", Ug = (e) => /^\w*$/.test(e), PF = (e) => Ql(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Zn = (e, n, r) => {
  let i = -1;
  const a = Ug(n) ? [n] : PF(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let u = r;
    if (i !== s) {
      const p = e[l];
      u = ht(p) || Array.isArray(p) ? p : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = u, e = e[l];
  }
};
const hl = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, jr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Gr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, QK = Ie.createContext(null), Mg = () => Ie.useContext(QK);
var AF = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== jr.all && (n._proxyFormState[s] = !i || jr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function JK(e) {
  const n = Mg(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Ie.useState(r._formState), u = Ie.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), p = Ie.useRef(a);
  return p.current = a, Ie.useEffect(() => r._subscribe({
    name: p.current,
    formState: u.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...r._formState,
        ...d
      });
    }
  }), [r, i, o]), Ie.useEffect(() => {
    u.current.isValid && r._setValid(!0);
  }, [r]), Ie.useMemo(() => AF(s, r, u.current, !1), [s, r]);
}
var Ar = (e) => typeof e == "string", LF = (e, n, r, i, a) => Ar(e) ? (i && n.watch.add(e), an(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), an(r, o))) : (i && (n.watchAll = !0), r);
function VF(e) {
  const n = Mg(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Ie.useRef(i), u = Ie.useRef(a);
  l.current = i, Ie.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && d(LF(l.current, r._names, f.values || r._formValues, !1, u.current))
  }), [r, o, s]);
  const [p, d] = Ie.useState(r._getWatch(i, a));
  return Ie.useEffect(() => r._removeUnmounted()), p;
}
function XK(e) {
  const n = Mg(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = RF(a._names.array, r), l = VF({
    control: a,
    name: r,
    defaultValue: an(a._formValues, r, an(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), u = JK({
    control: a,
    name: r,
    exact: !0
  }), p = Ie.useRef(e), d = Ie.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...lr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Ie.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!an(u.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!an(u.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!an(u.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!an(u.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => an(u.errors, r)
    }
  }), [u, r]), h = Ie.useCallback((j) => d.current.onChange({
    target: {
      value: OF(j),
      name: r
    },
    type: hl.CHANGE
  }), [r]), v = Ie.useCallback(() => d.current.onBlur({
    target: {
      value: an(a._formValues, r),
      name: r
    },
    type: hl.BLUR
  }), [r, a._formValues]), F = Ie.useCallback((j) => {
    const C = an(a._fields, r);
    C && j && (C._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (g) => j.setCustomValidity(g),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), N = Ie.useMemo(() => ({
    name: r,
    value: l,
    ...lr(i) || u.disabled ? { disabled: u.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: F
  }), [r, i, u.disabled, h, v, F, l]);
  return Ie.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...p.current.rules,
      ...lr(p.current.disabled) ? { disabled: p.current.disabled } : {}
    });
    const C = (g, z) => {
      const T = an(a._fields, g);
      T && T._f && (T._f.mount = z);
    };
    if (C(r, !0), j) {
      const g = Dt(an(a._options.defaultValues, r));
      Zn(a._defaultValues, r, g), dt(an(a._formValues, r)) && Zn(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : C(r, !1);
    };
  }, [r, a, s, o]), Ie.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Ie.useMemo(() => ({
    field: N,
    formState: u,
    fieldState: f
  }), [N, u, f]);
}
const Qj = (e) => e.render(XK(e));
var ZK = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Fo = (e) => Array.isArray(e) ? e : [e], Jj = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, ly = (e) => Kt(e) || !DF(e);
function pi(e, n) {
  if (ly(e) || ly(n))
    return e === n;
  if (Fi(e) && Fi(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Fi(o) && Fi(s) || ht(o) && ht(s) || Array.isArray(o) && Array.isArray(s) ? !pi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var qt = (e) => ht(e) && !Object.keys(e).length, Bg = (e) => e.type === "file", wr = (e) => typeof e == "function", yl = (e) => {
  if (!zg)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, zF = (e) => e.type === "select-multiple", qg = (e) => e.type === "radio", eG = (e) => qg(e) || Qo(e), vh = (e) => yl(e) && e.isConnected;
function nG(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = dt(e) ? i++ : e[n[i++]];
  return e;
}
function tG(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !dt(e[n]))
      return !1;
  return !0;
}
function xt(e, n) {
  const r = Array.isArray(n) ? n : Ug(n) ? [n] : PF(n), i = r.length === 1 ? e : nG(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (ht(i) && qt(i) || Array.isArray(i) && tG(i)) && xt(e, r.slice(0, -1)), e;
}
var UF = (e) => {
  for (const n in e)
    if (wr(e[n]))
      return !0;
  return !1;
};
function gl(e, n = {}) {
  const r = Array.isArray(e);
  if (ht(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || ht(e[i]) && !UF(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, gl(e[i], n[i])) : Kt(e[i]) || (n[i] = !0);
  return n;
}
function MF(e, n, r) {
  const i = Array.isArray(e);
  if (ht(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || ht(e[a]) && !UF(e[a]) ? dt(n) || ly(r[a]) ? r[a] = Array.isArray(e[a]) ? gl(e[a], []) : { ...gl(e[a]) } : MF(e[a], Kt(n) ? {} : n[a], r[a]) : r[a] = !pi(e[a], n[a]);
  return r;
}
var po = (e, n) => MF(e, n, gl(n));
const Xj = {
  value: !1,
  isValid: !1
}, Zj = { value: !0, isValid: !0 };
var BF = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !dt(e[0].attributes.value) ? dt(e[0].value) || e[0].value === "" ? Zj : { value: e[0].value, isValid: !0 } : Zj
    ) : Xj;
  }
  return Xj;
}, qF = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => dt(e) ? e : n ? e === "" ? NaN : e && +e : r && Ar(e) ? new Date(e) : i ? i(e) : e;
const ew = {
  isValid: !1,
  value: null
};
var HF = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, ew) : ew;
function nw(e) {
  const n = e.ref;
  return Bg(n) ? n.files : qg(n) ? HF(e.refs).value : zF(n) ? [...n.selectedOptions].map(({ value: r }) => r) : Qo(n) ? BF(e.refs).value : qF(dt(n.value) ? e.ref.value : n.value, e);
}
var rG = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = an(n, o);
    s && Zn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, vl = (e) => e instanceof RegExp, fo = (e) => dt(e) ? e : vl(e) ? e.source : ht(e) ? vl(e.value) ? e.value.source : e.value : e, tw = (e) => ({
  isOnSubmit: !e || e === jr.onSubmit,
  isOnBlur: e === jr.onBlur,
  isOnChange: e === jr.onChange,
  isOnAll: e === jr.all,
  isOnTouch: e === jr.onTouched
});
const rw = "AsyncFunction";
var iG = (e) => !!e && !!e.validate && !!(wr(e.validate) && e.validate.constructor.name === rw || ht(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === rw)), aG = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), iw = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Io = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = an(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Io(l, n))
          break;
      } else if (ht(l) && Io(l, n))
        break;
    }
  }
};
function aw(e, n, r) {
  const i = an(e, r);
  if (i || Ug(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = an(n, o), l = an(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var oG = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return qt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || jr.all));
}, sG = (e, n, r) => !e || !n || e === n || Fo(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), lG = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, cG = (e, n) => !Ql(an(e, n)).length && xt(e, n), uG = (e, n, r) => {
  const i = Fo(an(e, r));
  return Zn(i, "root", n[r]), Zn(e, r, i), e;
}, Ys = (e) => Ar(e);
function ow(e, n, r = "validate") {
  if (Ys(e) || Array.isArray(e) && e.every(Ys) || lr(e) && !e)
    return {
      type: r,
      message: Ys(e) ? e : "",
      ref: n
    };
}
var na = (e) => ht(e) && !vl(e) ? e : {
  value: e,
  message: ""
}, sw = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: u, maxLength: p, minLength: d, min: f, max: h, pattern: v, validate: F, name: N, valueAsNumber: j, mount: C } = e._f, g = an(r, N);
  if (!C || n.has(N))
    return {};
  const z = l ? l[0] : s, T = (q) => {
    a && z.reportValidity && (z.setCustomValidity(lr(q) ? "" : q || ""), z.reportValidity());
  }, I = {}, D = qg(s), U = Qo(s), Q = D || U, X = (j || Bg(s)) && dt(s.value) && dt(g) || yl(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, re = ZK.bind(null, N, i, I), G = (q, R, B, ee = Gr.maxLength, be = Gr.minLength) => {
    const fe = q ? R : B;
    I[N] = {
      type: q ? ee : be,
      message: fe,
      ref: s,
      ...re(q ? ee : be, fe)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : u && (!Q && (X || Kt(g)) || lr(g) && !g || U && !BF(l).isValid || D && !HF(l).isValid)) {
    const { value: q, message: R } = Ys(u) ? { value: !!u, message: u } : na(u);
    if (q && (I[N] = {
      type: Gr.required,
      message: R,
      ref: z,
      ...re(Gr.required, R)
    }, !i))
      return T(R), I;
  }
  if (!X && (!Kt(f) || !Kt(h))) {
    let q, R;
    const B = na(h), ee = na(f);
    if (!Kt(g) && !isNaN(g)) {
      const be = s.valueAsNumber || g && +g;
      Kt(B.value) || (q = be > B.value), Kt(ee.value) || (R = be < ee.value);
    } else {
      const be = s.valueAsDate || new Date(g), fe = (K) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + K), de = s.type == "time", ge = s.type == "week";
      Ar(B.value) && g && (q = de ? fe(g) > fe(B.value) : ge ? g > B.value : be > new Date(B.value)), Ar(ee.value) && g && (R = de ? fe(g) < fe(ee.value) : ge ? g < ee.value : be < new Date(ee.value));
    }
    if ((q || R) && (G(!!q, B.message, ee.message, Gr.max, Gr.min), !i))
      return T(I[N].message), I;
  }
  if ((p || d) && !X && (Ar(g) || o && Array.isArray(g))) {
    const q = na(p), R = na(d), B = !Kt(q.value) && g.length > +q.value, ee = !Kt(R.value) && g.length < +R.value;
    if ((B || ee) && (G(B, q.message, R.message), !i))
      return T(I[N].message), I;
  }
  if (v && !X && Ar(g)) {
    const { value: q, message: R } = na(v);
    if (vl(q) && !g.match(q) && (I[N] = {
      type: Gr.pattern,
      message: R,
      ref: s,
      ...re(Gr.pattern, R)
    }, !i))
      return T(R), I;
  }
  if (F) {
    if (wr(F)) {
      const q = await F(g, r), R = ow(q, z);
      if (R && (I[N] = {
        ...R,
        ...re(Gr.validate, R.message)
      }, !i))
        return T(R.message), I;
    } else if (ht(F)) {
      let q = {};
      for (const R in F) {
        if (!qt(q) && !i)
          break;
        const B = ow(await F[R](g, r), z, R);
        B && (q = {
          ...B,
          ...re(R, B.message)
        }, T(B.message), i && (I[N] = q));
      }
      if (!qt(q) && (I[N] = {
        ref: z,
        ...q
      }, !i))
        return I;
    }
  }
  return T(!0), I;
};
const dG = {
  mode: jr.onSubmit,
  reValidateMode: jr.onChange,
  shouldFocusError: !0
};
function mG(e = {}) {
  let n = {
    ...dG,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: wr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = ht(n.defaultValues) || ht(n.values) ? Dt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Dt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, p = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...d
  };
  const h = {
    array: Jj(),
    state: Jj()
  }, v = tw(n.mode), F = tw(n.reValidateMode), N = n.criteriaMode === jr.all, j = (E) => (_) => {
    clearTimeout(p), p = setTimeout(E, _);
  }, C = async (E) => {
    if (!n.disabled && (d.isValid || f.isValid || E)) {
      const _ = n.resolver ? qt((await X()).errors) : await G(i, !0);
      _ !== r.isValid && h.state.next({
        isValid: _
      });
    }
  }, g = (E, _) => {
    !n.disabled && (d.isValidating || d.validatingFields || f.isValidating || f.validatingFields) && ((E || Array.from(l.mount)).forEach((O) => {
      O && (_ ? Zn(r.validatingFields, O, _) : xt(r.validatingFields, O));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !qt(r.validatingFields)
    }));
  }, z = (E, _ = [], O, W, J = !0, L = !0) => {
    if (W && O && !n.disabled) {
      if (s.action = !0, L && Array.isArray(an(i, E))) {
        const M = O(an(i, E), W.argA, W.argB);
        J && Zn(i, E, M);
      }
      if (L && Array.isArray(an(r.errors, E))) {
        const M = O(an(r.errors, E), W.argA, W.argB);
        J && Zn(r.errors, E, M), cG(r.errors, E);
      }
      if ((d.touchedFields || f.touchedFields) && L && Array.isArray(an(r.touchedFields, E))) {
        const M = O(an(r.touchedFields, E), W.argA, W.argB);
        J && Zn(r.touchedFields, E, M);
      }
      (d.dirtyFields || f.dirtyFields) && (r.dirtyFields = po(a, o)), h.state.next({
        name: E,
        isDirty: R(E, _),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Zn(o, E, _);
  }, T = (E, _) => {
    Zn(r.errors, E, _), h.state.next({
      errors: r.errors
    });
  }, I = (E) => {
    r.errors = E, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, D = (E, _, O, W) => {
    const J = an(i, E);
    if (J) {
      const L = an(o, E, dt(O) ? an(a, E) : O);
      dt(L) || W && W.defaultChecked || _ ? Zn(o, E, _ ? L : nw(J._f)) : be(E, L), s.mount && C();
    }
  }, U = (E, _, O, W, J) => {
    let L = !1, M = !1;
    const ie = {
      name: E
    };
    if (!n.disabled) {
      if (!O || W) {
        (d.isDirty || f.isDirty) && (M = r.isDirty, r.isDirty = ie.isDirty = R(), L = M !== ie.isDirty);
        const he = pi(an(a, E), _);
        M = !!an(r.dirtyFields, E), he ? xt(r.dirtyFields, E) : Zn(r.dirtyFields, E, !0), ie.dirtyFields = r.dirtyFields, L = L || (d.dirtyFields || f.dirtyFields) && M !== !he;
      }
      if (O) {
        const he = an(r.touchedFields, E);
        he || (Zn(r.touchedFields, E, O), ie.touchedFields = r.touchedFields, L = L || (d.touchedFields || f.touchedFields) && he !== O);
      }
      L && J && h.state.next(ie);
    }
    return L ? ie : {};
  }, Q = (E, _, O, W) => {
    const J = an(r.errors, E), L = (d.isValid || f.isValid) && lr(_) && r.isValid !== _;
    if (n.delayError && O ? (u = j(() => T(E, O)), u(n.delayError)) : (clearTimeout(p), u = null, O ? Zn(r.errors, E, O) : xt(r.errors, E)), (O ? !pi(J, O) : J) || !qt(W) || L) {
      const M = {
        ...W,
        ...L && lr(_) ? { isValid: _ } : {},
        errors: r.errors,
        name: E
      };
      r = {
        ...r,
        ...M
      }, h.state.next(M);
    }
  }, X = async (E) => {
    g(E, !0);
    const _ = await n.resolver(o, n.context, rG(E || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(E), _;
  }, re = async (E) => {
    const { errors: _ } = await X(E);
    if (E)
      for (const O of E) {
        const W = an(_, O);
        W ? Zn(r.errors, O, W) : xt(r.errors, O);
      }
    else
      r.errors = _;
    return _;
  }, G = async (E, _, O = {
    valid: !0
  }) => {
    for (const W in E) {
      const J = E[W];
      if (J) {
        const { _f: L, ...M } = J;
        if (L) {
          const ie = l.array.has(L.name), he = J._f && iG(J._f);
          he && d.validatingFields && g([W], !0);
          const Ne = await sw(J, l.disabled, o, N, n.shouldUseNativeValidation && !_, ie);
          if (he && d.validatingFields && g([W]), Ne[L.name] && (O.valid = !1, _))
            break;
          !_ && (an(Ne, L.name) ? ie ? uG(r.errors, Ne, L.name) : Zn(r.errors, L.name, Ne[L.name]) : xt(r.errors, L.name));
        }
        !qt(M) && await G(M, _, O);
      }
    }
    return O.valid;
  }, q = () => {
    for (const E of l.unMount) {
      const _ = an(i, E);
      _ && (_._f.refs ? _._f.refs.every((O) => !vh(O)) : !vh(_._f.ref)) && ze(E);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (E, _) => !n.disabled && (E && _ && Zn(o, E, _), !pi($e(), a)), B = (E, _, O) => LF(E, l, {
    ...s.mount ? o : dt(_) ? a : Ar(E) ? { [E]: _ } : _
  }, O, _), ee = (E) => Ql(an(s.mount ? o : a, E, n.shouldUnregister ? an(a, E, []) : [])), be = (E, _, O = {}) => {
    const W = an(i, E);
    let J = _;
    if (W) {
      const L = W._f;
      L && (!L.disabled && Zn(o, E, qF(_, L)), J = yl(L.ref) && Kt(_) ? "" : _, zF(L.ref) ? [...L.ref.options].forEach((M) => M.selected = J.includes(M.value)) : L.refs ? Qo(L.ref) ? L.refs.length > 1 ? L.refs.forEach((M) => (!M.defaultChecked || !M.disabled) && (M.checked = Array.isArray(J) ? !!J.find((ie) => ie === M.value) : J === M.value)) : L.refs[0] && (L.refs[0].checked = !!J) : L.refs.forEach((M) => M.checked = M.value === J) : Bg(L.ref) ? L.ref.value = "" : (L.ref.value = J, L.ref.type || h.state.next({
        name: E,
        values: Dt(o)
      })));
    }
    (O.shouldDirty || O.shouldTouch) && U(E, J, O.shouldTouch, O.shouldDirty, !0), O.shouldValidate && xe(E);
  }, fe = (E, _, O) => {
    for (const W in _) {
      const J = _[W], L = `${E}.${W}`, M = an(i, L);
      (l.array.has(E) || ht(J) || M && !M._f) && !Fi(J) ? fe(L, J, O) : be(L, J, O);
    }
  }, de = (E, _, O = {}) => {
    const W = an(i, E), J = l.array.has(E), L = Dt(_);
    Zn(o, E, L), J ? (h.array.next({
      name: E,
      values: Dt(o)
    }), (d.isDirty || d.dirtyFields || f.isDirty || f.dirtyFields) && O.shouldDirty && h.state.next({
      name: E,
      dirtyFields: po(a, o),
      isDirty: R(E, L)
    })) : W && !W._f && !Kt(L) ? fe(E, L, O) : be(E, L, O), iw(E, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? E : void 0,
      values: Dt(o)
    });
  }, ge = async (E) => {
    s.mount = !0;
    const _ = E.target;
    let O = _.name, W = !0;
    const J = an(i, O), L = (M) => {
      W = Number.isNaN(M) || Fi(M) && isNaN(M.getTime()) || pi(M, an(o, O, M));
    };
    if (J) {
      let M, ie;
      const he = _.type ? nw(J._f) : OF(E), Ne = E.type === hl.BLUR || E.type === hl.FOCUS_OUT, nn = !aG(J._f) && !n.resolver && !an(r.errors, O) && !J._f.deps || lG(Ne, an(r.touchedFields, O), r.isSubmitted, F, v), mn = iw(O, l, Ne);
      Zn(o, O, he), Ne ? (J._f.onBlur && J._f.onBlur(E), u && u(0)) : J._f.onChange && J._f.onChange(E);
      const Ze = U(O, he, Ne), sn = !qt(Ze) || mn;
      if (!Ne && h.state.next({
        name: O,
        type: E.type,
        values: Dt(o)
      }), nn)
        return (d.isValid || f.isValid) && (n.mode === "onBlur" ? Ne && C() : Ne || C()), sn && h.state.next({ name: O, ...mn ? {} : Ze });
      if (!Ne && mn && h.state.next({ ...r }), n.resolver) {
        const { errors: hn } = await X([O]);
        if (L(he), W) {
          const pn = aw(r.errors, i, O), _n = aw(hn, i, pn.name || O);
          M = _n.error, O = _n.name, ie = qt(hn);
        }
      } else
        g([O], !0), M = (await sw(J, l.disabled, o, N, n.shouldUseNativeValidation))[O], g([O]), L(he), W && (M ? ie = !1 : (d.isValid || f.isValid) && (ie = await G(i, !0)));
      W && (J._f.deps && xe(J._f.deps), Q(O, ie, M, Ze));
    }
  }, K = (E, _) => {
    if (an(r.errors, _) && E.focus)
      return E.focus(), 1;
  }, xe = async (E, _ = {}) => {
    let O, W;
    const J = Fo(E);
    if (n.resolver) {
      const L = await re(dt(E) ? E : J);
      O = qt(L), W = E ? !J.some((M) => an(L, M)) : O;
    } else E ? (W = (await Promise.all(J.map(async (L) => {
      const M = an(i, L);
      return await G(M && M._f ? { [L]: M } : M);
    }))).every(Boolean), !(!W && !r.isValid) && C()) : W = O = await G(i);
    return h.state.next({
      ...!Ar(E) || (d.isValid || f.isValid) && O !== r.isValid ? {} : { name: E },
      ...n.resolver || !E ? { isValid: O } : {},
      errors: r.errors
    }), _.shouldFocus && !W && Io(i, K, E ? J : l.mount), W;
  }, $e = (E) => {
    const _ = {
      ...s.mount ? o : a
    };
    return dt(E) ? _ : Ar(E) ? an(_, E) : E.map((O) => an(_, O));
  }, Y = (E, _) => ({
    invalid: !!an((_ || r).errors, E),
    isDirty: !!an((_ || r).dirtyFields, E),
    error: an((_ || r).errors, E),
    isValidating: !!an(r.validatingFields, E),
    isTouched: !!an((_ || r).touchedFields, E)
  }), qe = (E) => {
    E && Fo(E).forEach((_) => xt(r.errors, _)), h.state.next({
      errors: E ? r.errors : {}
    });
  }, Me = (E, _, O) => {
    const W = (an(i, E, { _f: {} })._f || {}).ref, J = an(r.errors, E) || {}, { ref: L, message: M, type: ie, ...he } = J;
    Zn(r.errors, E, {
      ...he,
      ..._,
      ref: W
    }), h.state.next({
      name: E,
      errors: r.errors,
      isValid: !1
    }), O && O.shouldFocus && W && W.focus && W.focus();
  }, Le = (E, _) => wr(E) ? h.state.subscribe({
    next: (O) => E(B(void 0, _), O)
  }) : B(E, _, !0), Ue = (E) => h.state.subscribe({
    next: (_) => {
      sG(E.name, _.name, E.exact) && oG(_, E.formState || d, Oe, E.reRenderRoot) && E.callback({
        values: { ...o },
        ...r,
        ..._
      });
    }
  }).unsubscribe, De = (E) => (s.mount = !0, f = {
    ...f,
    ...E.formState
  }, Ue({
    ...E,
    formState: f
  })), ze = (E, _ = {}) => {
    for (const O of E ? Fo(E) : l.mount)
      l.mount.delete(O), l.array.delete(O), _.keepValue || (xt(i, O), xt(o, O)), !_.keepError && xt(r.errors, O), !_.keepDirty && xt(r.dirtyFields, O), !_.keepTouched && xt(r.touchedFields, O), !_.keepIsValidating && xt(r.validatingFields, O), !n.shouldUnregister && !_.keepDefaultValue && xt(a, O);
    h.state.next({
      values: Dt(o)
    }), h.state.next({
      ...r,
      ..._.keepDirty ? { isDirty: R() } : {}
    }), !_.keepIsValid && C();
  }, Re = ({ disabled: E, name: _ }) => {
    (lr(E) && s.mount || E || l.disabled.has(_)) && (E ? l.disabled.add(_) : l.disabled.delete(_));
  }, on = (E, _ = {}) => {
    let O = an(i, E);
    const W = lr(_.disabled) || lr(n.disabled);
    return Zn(i, E, {
      ...O || {},
      _f: {
        ...O && O._f ? O._f : { ref: { name: E } },
        name: E,
        mount: !0,
        ..._
      }
    }), l.mount.add(E), O ? Re({
      disabled: lr(_.disabled) ? _.disabled : n.disabled,
      name: E
    }) : D(E, !0, _.value), {
      ...W ? { disabled: _.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!_.required,
        min: fo(_.min),
        max: fo(_.max),
        minLength: fo(_.minLength),
        maxLength: fo(_.maxLength),
        pattern: fo(_.pattern)
      } : {},
      name: E,
      onChange: ge,
      onBlur: ge,
      ref: (J) => {
        if (J) {
          on(E, _), O = an(i, E);
          const L = dt(J.value) && J.querySelectorAll && J.querySelectorAll("input,select,textarea")[0] || J, M = eG(L), ie = O._f.refs || [];
          if (M ? ie.find((he) => he === L) : L === O._f.ref)
            return;
          Zn(i, E, {
            _f: {
              ...O._f,
              ...M ? {
                refs: [
                  ...ie.filter(vh),
                  L,
                  ...Array.isArray(an(a, E)) ? [{}] : []
                ],
                ref: { type: L.type, name: E }
              } : { ref: L }
            }
          }), D(E, !1, void 0, L);
        } else
          O = an(i, E, {}), O._f && (O._f.mount = !1), (n.shouldUnregister || _.shouldUnregister) && !(RF(l.array, E) && s.action) && l.unMount.add(E);
      }
    };
  }, Ee = () => n.shouldFocusError && Io(i, K, l.mount), Qe = (E) => {
    lr(E) && (h.state.next({ disabled: E }), Io(i, (_, O) => {
      const W = an(i, O);
      W && (_.disabled = W._f.disabled || E, Array.isArray(W._f.refs) && W._f.refs.forEach((J) => {
        J.disabled = W._f.disabled || E;
      }));
    }, 0, !1));
  }, Xe = (E, _) => async (O) => {
    let W;
    O && (O.preventDefault && O.preventDefault(), O.persist && O.persist());
    let J = Dt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: L, values: M } = await X();
      r.errors = L, J = M;
    } else
      await G(i);
    if (l.disabled.size)
      for (const L of l.disabled)
        Zn(J, L, void 0);
    if (xt(r.errors, "root"), qt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await E(J, O);
      } catch (L) {
        W = L;
      }
    } else
      _ && await _({ ...r.errors }, O), Ee(), setTimeout(Ee);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: qt(r.errors) && !W,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), W)
      throw W;
  }, se = (E, _ = {}) => {
    an(i, E) && (dt(_.defaultValue) ? de(E, Dt(an(a, E))) : (de(E, _.defaultValue), Zn(a, E, Dt(_.defaultValue))), _.keepTouched || xt(r.touchedFields, E), _.keepDirty || (xt(r.dirtyFields, E), r.isDirty = _.defaultValue ? R(E, Dt(an(a, E))) : R()), _.keepError || (xt(r.errors, E), d.isValid && C()), h.state.next({ ...r }));
  }, ye = (E, _ = {}) => {
    const O = E ? Dt(E) : a, W = Dt(O), J = qt(E), L = J ? a : W;
    if (_.keepDefaultValues || (a = O), !_.keepValues) {
      if (_.keepDirtyValues) {
        const M = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(po(a, o))
        ]);
        for (const ie of Array.from(M))
          an(r.dirtyFields, ie) ? Zn(L, ie, an(o, ie)) : de(ie, an(L, ie));
      } else {
        if (zg && dt(E))
          for (const M of l.mount) {
            const ie = an(i, M);
            if (ie && ie._f) {
              const he = Array.isArray(ie._f.refs) ? ie._f.refs[0] : ie._f.ref;
              if (yl(he)) {
                const Ne = he.closest("form");
                if (Ne) {
                  Ne.reset();
                  break;
                }
              }
            }
          }
        for (const M of l.mount)
          de(M, an(L, M));
      }
      o = Dt(L), h.array.next({
        values: { ...L }
      }), h.state.next({
        values: { ...L }
      });
    }
    l = {
      mount: _.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!_.keepIsValid || !!_.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? r.submitCount : 0,
      isDirty: J ? !1 : _.keepDirty ? r.isDirty : !!(_.keepDefaultValues && !pi(E, a)),
      isSubmitted: _.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: J ? {} : _.keepDirtyValues ? _.keepDefaultValues && o ? po(a, o) : r.dirtyFields : _.keepDefaultValues && E ? po(a, E) : _.keepDirty ? r.dirtyFields : {},
      touchedFields: _.keepTouched ? r.touchedFields : {},
      errors: _.keepErrors ? r.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, je = (E, _) => ye(wr(E) ? E(o) : E, _), Ve = (E, _ = {}) => {
    const O = an(i, E), W = O && O._f;
    if (W) {
      const J = W.refs ? W.refs[0] : W.ref;
      J.focus && (J.focus(), _.shouldSelect && wr(J.select) && J.select());
    }
  }, Oe = (E) => {
    r = {
      ...r,
      ...E
    };
  }, dn = {
    control: {
      register: on,
      unregister: ze,
      getFieldState: Y,
      handleSubmit: Xe,
      setError: Me,
      _subscribe: Ue,
      _runSchema: X,
      _getWatch: B,
      _getDirty: R,
      _setValid: C,
      _setFieldArray: z,
      _setDisabledField: Re,
      _setErrors: I,
      _getFieldArray: ee,
      _reset: ye,
      _resetDefaultValues: () => wr(n.defaultValues) && n.defaultValues().then((E) => {
        je(E, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: q,
      _disableForm: Qe,
      _subjects: h,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(E) {
        s = E;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(E) {
        l = E;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(E) {
        n = {
          ...n,
          ...E
        };
      }
    },
    subscribe: De,
    trigger: xe,
    register: on,
    handleSubmit: Xe,
    watch: Le,
    setValue: de,
    getValues: $e,
    reset: je,
    resetField: se,
    clearErrors: qe,
    unregister: ze,
    setError: Me,
    setFocus: Ve,
    getFieldState: Y
  };
  return {
    ...dn,
    formControl: dn
  };
}
function pG(e = {}) {
  const n = Ie.useRef(void 0), r = Ie.useRef(void 0), [i, a] = Ie.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: wr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: wr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : mG(e),
    formState: i
  }, e.formControl && e.defaultValues && !wr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Ie.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Ie.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Ie.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Ie.useEffect(() => {
    e.values && !pi(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Ie.useEffect(() => {
    e.errors && !qt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Ie.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Ie.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = AF(i, o), n.current;
}
const fG = "_settingsWrapper_1ycvy_1", hG = "_settingsWrapperHeader_1ycvy_6", yG = "_settingsWrapperContent_1ycvy_10", gG = "_settingsWrapperContentCode_1ycvy_18", vG = "_settingsWrapperContentCURL_1ycvy_26", ho = {
  settingsWrapper: fG,
  settingsWrapperHeader: hG,
  settingsWrapperContent: yG,
  settingsWrapperContentCode: gG,
  settingsWrapperContentCURL: vG
}, kG = ({
  handleChangeText: e
}) => {
  const [n, r] = le(!1), { isCopied: i, copy: a } = Gt(), { control: o } = pG({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = VF({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", u = lt(() => {
    const p = s.storeId, d = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${p || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${d ? ` \\
  --data '{"secret":"${d}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ Pe.jsx(Pe.Fragment, { children: /* @__PURE__ */ Pe.jsx(me, { span: 6, children: /* @__PURE__ */ Pe.jsxs(b, { flexDirection: "column", className: ho.settingsWrapper, children: [
    /* @__PURE__ */ Pe.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: ho.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ Pe.jsx(A.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ Pe.jsx(pe, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ Pe.jsxs(
      b,
      {
        flexDirection: "column",
        className: ho.settingsWrapperContent,
        children: [
          /* @__PURE__ */ Pe.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Pe.jsx(
            xl,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ Pe.jsxs("ol", { children: [
                /* @__PURE__ */ Pe.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ Pe.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ Pe.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ Pe.jsx("span", { className: ho.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ Pe.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ Pe.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ Pe.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ Pe.jsx(
            Qj,
            {
              name: "storeId",
              control: o,
              render: ({ field: p }) => /* @__PURE__ */ Pe.jsx(
                tr,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...p,
                    onChange: (d) => {
                      p.onChange(d), e({
                        target: {
                          name: "yotpoStoreId",
                          value: d?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ Pe.jsx(
            Qj,
            {
              name: "secret",
              control: o,
              render: ({ field: p }) => /* @__PURE__ */ Pe.jsx(
                tr,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: p
                }
              )
            }
          ),
          l && /* @__PURE__ */ Pe.jsxs(Pe.Fragment, { children: [
            /* @__PURE__ */ Pe.jsx(en, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ Pe.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: ho.settingsWrapperContentCURL,
                children: u()
              }
            ) }),
            /* @__PURE__ */ Pe.jsx(b, { alignContent: "start", children: /* @__PURE__ */ Pe.jsx(
              Ge,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ Pe.jsx(
                  Yn,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(u()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, bG = [
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], _G = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: ga
  }
], xG = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: kG
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], SG = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, NG = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, jG = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: MH,
  featureSettings: []
} : n ? {
  authSettings: BH,
  featureSettings: [...SF]
} : e ? {
  authSettings: [
    ...xj,
    ...zH
  ],
  featureSettings: [...Sj]
} : {
  authSettings: [
    ...xj,
    ...UH
  ],
  featureSettings: [...Sj]
}, WF = (e, n) => ({
  hasOAuth: r = !1,
  isCreationMode: i = !1
}) => r || i ? e : n, wG = WF(
  _G,
  xG
), CG = WF(
  X2,
  Z2
), KF = ({
  key: e,
  configuration: n,
  settingType: r,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = NG(a?.value, r), s = i !== void 0 ? i : SG(
    r
  );
  return o !== void 0 ? o : s;
}, Hg = (e = {
  SHOPIFY: {},
  YOTPO: {},
  KLAVIYO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r, KLAVIYO: i } = e, {
    authSettings: a,
    featureSettings: o
  } = jG(n), s = wG(r), l = CG(i);
  return {
    SHOPIFY: {
      widget: Y9,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      settingsConfiguration: [
        ...a,
        ...o
      ]
    },
    JIRA: {
      widget: jL,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      fieldDefinitions: Th,
      WidgetSettings: FL
    },
    GITHUB: {
      widget: CP,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      fieldDefinitions: Ih,
      WidgetSettings: IP
    },
    MIUROS: {
      widget: QB,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      fieldDefinitions: Jh,
      WidgetSettings: XB
    },
    KLAVIYO: {
      widget: Q2,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...l, ...J2]
    },
    LINEAR: {
      widget: NM,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      fieldDefinitions: Kh,
      WidgetSettings: wM
    },
    VOYADO: {
      widget: wK,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: sy,
      WidgetSettings: FK
    },
    LOYALTYLION: {
      widget: rB,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      fieldDefinitions: Gh,
      WidgetSettings: aB
    },
    RECHARGE: {
      widget: S5,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      fieldDefinitions: ey,
      WidgetSettings: j5
    },
    BRAZE: {
      widget: BT,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      settingsConfiguration: [...qT]
    },
    YOTPO: {
      widget: KK,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      settingsConfiguration: [...s, ...bG]
    },
    INGRID: {
      widget: tA,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: $h,
      WidgetSettings: iA
    },
    RIVOLOYALTY: {
      widget: cq,
      icon: "rivoloyalty",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: ty,
      WidgetSettings: FH
    }
  };
}, FG = (e, n) => {
  const r = n.find(
    (i) => i.key === e.key
  )?.value;
  return e.type === "boolean" ? dI(r, e.defaultValue) : mI(r, e.defaultValue);
}, IG = (e, n) => e.map((r) => ({
  key: r.key,
  value: FG(r, n)
})), $G = (e, n) => e.map(({ key: r, type: i, defaultValue: a }) => ({
  key: r,
  value: KF({
    key: r,
    configuration: n,
    settingType: i,
    settingDefault: a
  })
})), EG = ({ fieldDefinitions: e, settingsConfiguration: n }, r) => e ? IG(
  e.filter(({ secret: i }) => !i),
  r
) : $G(
  (n ?? []).filter(({ secret: i }) => !i),
  r
), TG = (e) => {
  const n = Hg();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      renderConditions: l,
      integrationKey: u
    }) => {
      const d = n[i];
      return {
        id: r,
        type: i,
        name: a,
        settings: EG(d, o),
        misconfigured: s,
        renderConditions: l,
        icon: d.icon,
        iconColors: d.iconColors,
        widget: d.widget,
        integrationKey: u
      };
    }
  );
}, C8 = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: u,
  renderConditionMatchedIndicator: p,
  widgetAnnotations: d
}) => {
  const f = Ii(
    {}
  ), h = (D) => (f.current[D] || (f.current[D] = { current: null }), f.current[D]), { track: v } = Cn(), F = Kn(
    () => TG(e),
    [e]
  ), N = {
    headline: "",
    text: "",
    onConfirm: () => I(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [j, C] = le(N), [g, z] = le(!1), T = (D) => {
    z(!0), C(D);
  }, I = () => {
    z(!1), C(N);
  };
  return /* @__PURE__ */ Be.jsxs(Be.Fragment, { children: [
    F.map(
      ({
        id: D,
        name: U,
        type: Q,
        widget: X,
        settings: re,
        misconfigured: G,
        renderConditions: q,
        icon: R,
        iconColors: B,
        integrationKey: ee
      }, be) => {
        const fe = `partner-integration-${Q}`, de = d?.get(D) === !1, ge = /* @__PURE__ */ Be.jsx(py, { icon: R, color: B }), K = re?.reduce(
          (xe, $e) => (xe[$e.key] = $e.value, xe),
          {}
        );
        return s ? /* @__PURE__ */ Be.jsx("div", { className: "icon-holder", children: ge }, `partner-icon-${D}`) : /* @__PURE__ */ Be.jsxs(
          hr,
          {
            onToggle: () => {
              v(
                o(ee) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: D,
                  widgetType: Q.toLowerCase()
                }
              ), a(ee);
            },
            isOpen: o(ee),
            className: fe,
            containerRef: (xe) => {
              h(ee).current = xe;
            },
            children: [
              /* @__PURE__ */ Be.jsx(
                hr.Header,
                {
                  className: it({
                    [hT.unmatchedHeader]: de
                  }),
                  wrap: "normal",
                  avatar: ge,
                  slotBeforeTitle: u?.(
                    ee,
                    be,
                    h(ee)
                  ),
                  slotAfterTitle: /* @__PURE__ */ Be.jsx(Be.Fragment, { children: l?.(ee) }),
                  children: /* @__PURE__ */ Be.jsxs(b, { alignItems: "center", flexDirection: "row", gap: "200", children: [
                    U,
                    p?.(
                      q ?? [],
                      D
                    )
                  ] })
                }
              ),
              /* @__PURE__ */ Be.jsx(hr.Content, { children: G ? /* @__PURE__ */ Be.jsx(In, { isMisconfigured: !0 }) : /* @__PURE__ */ Be.jsx(
                _w.Provider,
                {
                  value: {
                    onError: (xe, $e) => console.warn(
                      `Something went wrong with a partner widget of type '${Q}' and id '${D}'`,
                      xe,
                      $e
                    )
                  },
                  children: /* @__PURE__ */ Be.jsx(
                    e1,
                    {
                      integrationId: D,
                      type: Q,
                      configuration: n,
                      showNotification: i,
                      showModal: T,
                      children: _I(X, {
                        conversationContext: r,
                        settings: K
                      })
                    }
                  )
                }
              ) })
            ]
          },
          ee
        );
      }
    ),
    /* @__PURE__ */ Be.jsx(
      gw,
      {
        isOpen: g,
        setIsOpen: z,
        headline: j.headline,
        text: j.text,
        confirmLabel: j.confirmLabel,
        confirmVariant: j.confirmVariant,
        cancelLabel: j.cancelLabel,
        cancelVariant: j.cancelVariant,
        onConfirm: j.onConfirm ? () => {
          try {
            j.onConfirm && j.onConfirm();
          } finally {
            z(!1), C(N);
          }
        } : void 0,
        onCancel: j.onCancel ? () => {
          try {
            j.onCancel && j.onCancel();
          } finally {
            z(!1), C(N);
          }
        } : void 0,
        children: j.children
      }
    )
  ] });
}, DG = Sl`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`;
function F8(e, { skip: n = !1 } = {}) {
  const [r, i] = le([]), [a, o] = le(!1);
  return Ye(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), Zw(e).query({
      query: DG
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (u) => u != null
        ).map((u) => ({
          ...u,
          integrationKey: `partner-integration-${u.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
const OG = ({
  widgetConfiguration: e
}) => {
  const n = Kn(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), r = Kn(() => (e?.additionalProperties ?? {}).tokenSource === "marketplace_app", [e]);
  return {
    hasShopifyWidgetOAuth: n,
    isShopifyMarketplaceApp: r,
    initialValuesForShopify: []
  };
}, RG = "FULL_ACCESS", PG = "2", AG = ({
  type: e,
  baseUrl: n
}) => {
  const r = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((u) => u.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: r,
        scopes: [RG],
        version: PG
      })
    }).then((l) => l.json())
  };
}, LG = "dixaApiToken", Wg = "dixaApiTokenId", GF = "dixaApiTokenName", lw = (e) => [Wg, GF].every(
  (r) => e.find((i) => i?.key === r)
);
function VG({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const r = zG(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(r, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const zG = (e) => [
  {
    key: LG,
    value: e.value,
    secret: !0
  },
  {
    key: Wg,
    value: e.id,
    secret: !1
  },
  {
    key: GF,
    value: e.name,
    secret: !1
  }
], UG = "_wrapper_1lmim_1", MG = "_wrapperBox_1lmim_4", BG = "_wrapperBoxErrorBorder_1lmim_9", kh = {
  wrapper: UG,
  wrapperBox: MG,
  wrapperBoxErrorBorder: BG
}, qG = ({
  required: e,
  readOnly: n,
  isSecret: r,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: u,
  handleChangeText: p
}) => {
  const f = o?.find(
    (z) => z.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: v } = f, F = `Insert your ${h.label.toLowerCase()}`, N = `Insert your ${v.label.toLowerCase()}`, [j, C] = le({
    username: "",
    password: ""
  }), g = lt(
    (z) => {
      p({
        target: {
          name: s,
          value: z
        }
      });
    },
    [s, p]
  );
  return Ye(() => {
    g(
      j.username !== "" && j.password !== "" ? window.btoa(`${j.username}:${j.password}`) : ""
    );
  }, [j]), /* @__PURE__ */ Be.jsx(
    en,
    {
      required: e,
      label: a,
      meta: l,
      className: kh.wrapper,
      children: /* @__PURE__ */ Be.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: it(kh.wrapperBox, {
            [kh.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ Be.jsx(
              tr,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: F,
                input: {
                  name: s,
                  value: j.username,
                  onChange: (z) => C({
                    username: z?.target.value ?? "",
                    password: j.password
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => u(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ Be.jsx(
              tr,
              {
                noAlert: !0,
                required: e,
                label: v.label,
                readOnly: n,
                placeholder: N,
                input: {
                  name: s,
                  value: j.password,
                  onChange: (z) => C({
                    username: j.username,
                    password: z?.target.value ?? ""
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => u(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function cw({
  isSecret: e,
  widgetSettingsKey: n,
  label: r,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: u,
  handleEditSecret: p,
  getValueByKey: d,
  isEditingField: f,
  errors: h,
  type: v,
  isCreationMode: F,
  prefix: N,
  integrationId: j,
  integrationType: C,
  configuration: g,
  settings: z,
  otherProps: T
}) {
  const I = v === "custom" && T?.component, D = d(n)?.value;
  return I ? /* @__PURE__ */ Be.jsx(
    I,
    {
      configuration: g,
      integrationId: j,
      integrationType: C,
      label: r,
      settings: z,
      getValueByKey: d,
      widgetSettingsKey: n,
      handleChangeSelect: u,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ Be.jsxs(Be.Fragment, { children: [
    /* @__PURE__ */ Be.jsx(me, { span: 3, children: /* @__PURE__ */ Be.jsx(
      HG,
      {
        widgetSettingsKey: n,
        label: r,
        isEditingField: f,
        handleEditSecret: p,
        isCreationMode: F,
        children: v === "input" ? /* @__PURE__ */ Be.jsx(
          tr,
          {
            required: i,
            readOnly: a,
            label: r,
            placeholder: o,
            input: {
              name: n,
              value: D,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: N,
            ...e && !F && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => p(!1, n)
                }
              }
            }
          }
        ) : v === "basicAuthInput" ? /* @__PURE__ */ Be.jsx(
          qG,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: F,
            label: r,
            widgetSettingsKey: n,
            settings: z,
            meta: { error: h[n] },
            handleEditSecret: p,
            handleChangeText: s
          }
        ) : v === "switch" ? /* @__PURE__ */ Be.jsx(en, { label: r, children: /* @__PURE__ */ Be.jsx(
          fy,
          {
            input: {
              name: n,
              value: "",
              checked: D,
              onChange: l
            }
          }
        ) }) : v === "select" ? /* @__PURE__ */ Be.jsx(en, { label: r, children: /* @__PURE__ */ Be.jsx(
          ui,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (U) => u(n, U),
            getItemTitleByValue: (U) => U ? /* @__PURE__ */ Be.jsx(A.Paragraph, { children: U.label }) : /* @__PURE__ */ Be.jsx(Be.Fragment, {}),
            value: D ? [
              {
                label: (T?.selectItems || []).find(
                  (U) => U.value === D
                )?.label,
                value: D
              }
            ] : [],
            equalityFn: (U, Q) => U.value === Q.value,
            children: (T?.selectItems || []).map((U) => /* @__PURE__ */ Be.jsx(mt.Item, { value: U, children: U.label }, U.value))
          }
        ) }) : /* @__PURE__ */ Be.jsx(Be.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ Be.jsx(me, { span: 3 })
  ] });
}
function HG({
  widgetSettingsKey: e,
  label: n,
  isEditingField: r,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return r || o ? a : /* @__PURE__ */ Be.jsx(en, { label: n, children: /* @__PURE__ */ Be.jsxs(
    Yn,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const $o = "partner-integrations-widget-name-form-field", uw = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: r = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: u
  }) => ({
    key: i,
    value: KF({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: r ? !0 : !o,
    type: s,
    ...u && { customValidation: u }
  })
), WG = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = le(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = le({}), s = (T) => i(T), l = (T) => !T || T === "", u = (T) => {
    const { [T]: I, ...D } = a;
    o(D);
  }, p = (T) => ({
    ...T,
    settings: T.settings.filter(({ isEditing: I }) => I).map(({ key: I, value: D, secret: U }) => ({
      key: I,
      value: D,
      secret: U
    }))
  }), d = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = (T) => {
    if (!T)
      return;
    const {
      target: { name: I, value: D }
    } = T;
    a[I] && !l(D) && u(I), i({
      ...r,
      settings: r.settings.map(
        (U) => U.key === I ? { ...U, value: D } : U
      )
    });
  }, h = (T) => {
    if (!T)
      return;
    const {
      target: { name: I, checked: D }
    } = T;
    i({
      ...r,
      settings: r.settings.map(
        (U) => U.key === I ? { ...U, value: D } : U
      )
    });
  }, v = (T, I) => {
    if (!I)
      return;
    const { selectedValues: D } = I, U = D?.[0];
    if (U) {
      const Q = r.settings.map(
        (X) => X.key === T ? { ...X, value: U?.value } : X
      );
      i({
        ...r,
        settings: Q
      });
    } else {
      const Q = r.settings.filter(
        (X) => X.key !== T
      );
      i({
        ...r,
        settings: Q
      });
    }
  }, F = (T) => {
    i({
      ...r,
      enabled: T
    });
  }, N = (T) => {
    if (!T)
      return;
    const {
      target: { value: I }
    } = T;
    a[$o] && !l(I) && u($o), i({
      ...r,
      name: I
    });
  }, j = (T, I) => {
    const { settings: D } = r, U = D.map((Q) => Q.key === I ? {
      ...Q,
      isEditing: T,
      ...!T && { value: "" }
    } : Q);
    a[I] && !T && u(I), i({
      ...r,
      settings: U
    });
  }, C = (T) => r.settings.find(
    (I) => I.key === T
  ), g = async (T) => {
    T.preventDefault(), z() && n(p(r));
  }, z = () => {
    const T = {}, { name: I, settings: D } = r;
    return l(I) && (T[$o] = d.input), D.forEach(
      ({ key: U, value: Q, required: X, isEditing: re, type: G, customValidation: q }) => {
        if (X && re)
          if (q) {
            const R = q(Q);
            typeof R == "string" && (T[U] = R);
          } else
            typeof Q == "string" && l(Q) && (T[U] = d[G]);
      }
    ), o(T), !Object.keys(T)?.length;
  };
  return {
    formData: r,
    errors: a,
    handleIsEnabled: F,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: v,
    handleEditSecret: j,
    handleChangeName: N,
    handleSubmit: g,
    getSettingValueByKey: C,
    initializeFormData: s,
    validate: z
  };
}, KG = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], dw = "The configuration of the integration is not correct. Please check the settings.", GG = (e) => {
  const n = Hg()[e.type]?.WidgetSettings;
  return n ? /* @__PURE__ */ Be.jsx(n, { ...e }) : /* @__PURE__ */ Be.jsx(YG, { ...e });
}, YG = ({
  integrationId: e,
  type: n,
  handleRedirect: r,
  showNotification: i,
  configuration: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => {
  const { track: l } = Cn(), { deleteDixaApiToken: u, createDixaApiToken: p } = AG({
    type: n,
    baseUrl: a.baseUrl
  }), f = LI().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), h = !e && !!n && !!f, v = KG.includes(n), [F, N] = le(), [j, C] = le(!1), [g, z] = le(!1), [T, I] = le(!1), [D, U] = le(null), [Q, X] = le(), [re, G] = le(h ? [] : null);
  Ye(() => {
    G(h ? [] : null);
  }, [e, h]), Ye(() => {
    Q && re === null && G(Q.renderConditions ?? []);
  }, [Q, re]);
  const { isInboundOAuth: q } = pI(), R = q && h ? "Submit & Authorize" : "Submit", {
    hasShopifyWidgetOAuth: B,
    isShopifyMarketplaceApp: ee,
    initialValuesForShopify: be
  } = OG({
    featureFlags: a.featureFlags,
    widgetConfiguration: Q
  }), fe = n === "YOTPO" && !!Q?.additionalProperties?.isUsingOAuth, de = n === "KLAVIYO" && !!Q?.additionalProperties?.isUsingOAuth, ge = h && n === "SHOPIFY", $e = Hg({
    SHOPIFY: {
      hasShopifyOAuth: B,
      isShopifyMarketplaceApp: ee,
      isCreationMode: h
    },
    YOTPO: {
      hasOAuth: fe,
      isCreationMode: h
    },
    KLAVIYO: {
      hasOAuth: de,
      isCreationMode: h
    }
  })[n].settingsConfiguration ?? [], Y = $e.filter(({ type: W }) => W !== "hidden").filter(({ hideOnCreate: W }) => h ? !W : !0), qe = Y.filter(
    ({ additionalProperties: W }) => W?.renderAboveForm === !0
  ), Me = Y.filter(
    ({ additionalProperties: W }) => W?.renderAboveForm !== !0
  ), {
    error: Le,
    loading: Ue,
    refetch: De
  } = RI(fI, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (W) => {
      if (Object.keys(W).length === 0)
        I(!0);
      else {
        I(!1);
        const J = W?.Management?.widgetConfigurations?.[0];
        J && X({
          ...J,
          // Not needed here, just to satisfy the type
          integrationKey: `partner-integration-${J.id}`,
          additionalProperties: J.additionalProperties ?? void 0
        });
      }
    }
  }), [ze, { error: Re }] = Yg(
    h ? hI : yI,
    {
      onError: (W) => {
        N(W), C(!1), i({
          title: "Something went wrong",
          text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (W) => {
        if (C(!1), Object.keys(W).length !== 0) {
          if (h && r(
            W.Management?.createWidgetConfiguration?.id
          ), !h) {
            const L = W.Management?.updateWidgetConfiguration;
            L?.misconfigured ? U(
              L.misconfigurationCause ?? dw
            ) : U(null);
          }
          if ((h || s) && re) {
            const J = (Q?.renderConditions?.length ?? 0) > 0;
            gI(
              l,
              h,
              re,
              J
            );
          }
          i({
            title: `${h ? "Creating" : "Updating"} was successful`,
            text: `${h ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [on] = Yg(vI, {
    onError: (W) => {
      N(W), C(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      C(!1), r(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: Ee,
    handleIsEnabled: Qe,
    errors: Xe,
    handleChangeText: se,
    handleChangeBoolean: ye,
    handleChangeSelect: je,
    handleEditSecret: Ve,
    handleChangeName: Oe,
    handleSubmit: dn,
    getSettingValueByKey: E,
    initializeFormData: _
  } = WG({
    onSubmit: async (W) => {
      h ? l("settings:create:submitted", { widgetType: n }) : e && l("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), C(!0);
      const J = W.settings.map(
        (he) => typeof he.value == "boolean" ? { ...he, value: he.value.toString() } : he
      ), L = lw(J) && h;
      let M = [];
      if (L) {
        const he = await p().catch(
          (Ne) => {
            C(!1), console.warn("API-Token (creation) error resonse", Ne), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        he?.data && (M = VG({
          token: he.data,
          settings: J
        }));
      }
      const ie = {
        ...W,
        settings: [
          ...M.length > 0 ? M : J
        ]
      };
      (L && M.length > 1 || !L && M.length === 0) && (ze({
        variables: {
          ...!h && { id: e },
          ...h && { type: n },
          ...ie,
          ...(h || !!s) && re !== null && { renderConditions: re }
        }
      }), J.forEach(
        (Ne) => Ne.secret && Ve(!1, Ne.key)
      ));
    },
    ...h && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: uw({
          settingsFromBackend: be,
          settingsConfiguration: $e,
          creating: !0
        })
      }
    }
  });
  Ye(() => {
    if (Q) {
      const W = uw({
        settingsFromBackend: Q.settings,
        settingsConfiguration: $e
      });
      _({
        enabled: !!Q.enabled,
        name: Q.name,
        settings: W
      }), Q.misconfigured ? U(
        Q?.misconfigurationCause ?? dw
      ) : U(null);
    }
  }, [Q]);
  const O = Kn(() => o ? !o.isCoupled : !0, [o]);
  return Le || Re || F ? /* @__PURE__ */ Be.jsx(
    In,
    {
      error: Le || F,
      retry: Le ? De : void 0
    }
  ) : j || Ue ? /* @__PURE__ */ Be.jsx(fn, { "data-testid": "widget-settings-loading" }) : T ? /* @__PURE__ */ Be.jsxs(A.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ Be.jsx(qn, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ Be.jsxs("form", { children: [
    D && /* @__PURE__ */ Be.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Be.jsx(
      xl,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ Be.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ Be.jsx(A.Paragraph, { children: D }),
          /* @__PURE__ */ Be.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ Be.jsx(A.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ Be.jsx(A.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ Be.jsxs(
      at,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          qe.map(
            ({ key: W, label: J, ...L }) => /* @__PURE__ */ Be.jsx(
              cw,
              {
                widgetSettingsKey: W,
                isEditingField: !1,
                handleEditSecret: () => {
                },
                handleChangeText: () => {
                },
                handleChangeBoolean: () => {
                },
                handleChangeSelect: () => {
                },
                getValueByKey: E,
                isSecret: !1,
                label: J,
                placeholder: "",
                required: !1,
                errors: Xe,
                type: "custom",
                isCreationMode: h,
                integrationId: e,
                integrationType: n,
                configuration: a,
                settings: $e,
                otherProps: L
              },
              W
            )
          ),
          !ge && /* @__PURE__ */ Be.jsxs(Be.Fragment, { children: [
            /* @__PURE__ */ Be.jsx(me, { children: /* @__PURE__ */ Be.jsx(en, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Be.jsx(
              fy,
              {
                input: {
                  name: "enabled",
                  checked: Ee.enabled,
                  value: "dummy",
                  onChange: (W) => Qe(W.target.checked)
                }
              }
            ) }) }),
            /* @__PURE__ */ Be.jsx(me, { span: 3, children: /* @__PURE__ */ Be.jsx(
              tr,
              {
                required: !0,
                label: "Widget name",
                placeholder: "Insert the name of the widget",
                input: {
                  name: $o,
                  value: Ee.name,
                  onChange: Oe
                },
                meta: {
                  error: Xe[$o]
                }
              }
            ) }),
            /* @__PURE__ */ Be.jsx(me, { span: 3 })
          ] }),
          !ge && s && re !== null && /* @__PURE__ */ Be.jsx(me, { children: s({
            value: re,
            onChange: G,
            configurationKey: Q?.id
          }) }),
          Me?.map(
            ({
              key: W,
              secret: J,
              label: L,
              placeholder: M = "",
              required: ie = !1,
              type: he,
              prefix: Ne,
              readOnly: nn,
              ...mn
            }) => {
              const { settings: Ze } = Ee, sn = Ze.find(
                (hn) => hn.key === W
              );
              return /* @__PURE__ */ Be.jsx(xI, { children: /* @__PURE__ */ Be.jsx(
                cw,
                {
                  widgetSettingsKey: W,
                  isEditingField: !!sn?.isEditing,
                  handleEditSecret: Ve,
                  handleChangeText: se,
                  handleChangeBoolean: ye,
                  handleChangeSelect: je,
                  getValueByKey: E,
                  isSecret: J,
                  label: L,
                  placeholder: M,
                  required: ie,
                  errors: Xe,
                  type: he,
                  isCreationMode: h,
                  prefix: Ne,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: nn,
                  settings: $e,
                  otherProps: mn
                }
              ) }, W);
            }
          )
        ]
      }
    ),
    !ge && /* @__PURE__ */ Be.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ Be.jsx(Yn, { onClick: dn, children: R }),
      !h && /* @__PURE__ */ Be.jsx(
        Ge,
        {
          content: "The widget is used in automations",
          disabled: O,
          children: /* @__PURE__ */ Be.jsx(
            Yn,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && l("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), z(!0);
              },
              disabled: !O,
              isLoading: o?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ Be.jsx(
      gw,
      {
        isOpen: g,
        setIsOpen: z,
        confirmVariant: v ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && l("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && l("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), lw(Ee.settings)) {
            const W = Ee.settings.find(
              ({ key: J }) => J === Wg
            )?.value;
            W && u(W).catch((J) => {
              console.warn("API-Token (deletion) error response", J), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          on({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ Be.jsx(b, { children: v ? /* @__PURE__ */ Be.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ Be.jsx(
            pe,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ Be.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ Be.jsxs(A.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ Be.jsxs(A.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ Be.jsxs(A.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              Ee.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ Be.jsxs(Be.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          Ee.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, I8 = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => /* @__PURE__ */ Be.jsx(
  _w.Provider,
  {
    value: {
      onError: (l, u) => console.warn(
        `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
        l,
        u
      )
    },
    children: /* @__PURE__ */ Be.jsx(
      e1,
      {
        integrationId: n,
        type: r,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ Be.jsx(
          GG,
          {
            configuration: e,
            integrationId: n,
            type: r,
            handleRedirect: i,
            showNotification: a,
            automationCouplingState: o,
            renderConditionsEditor: s
          }
        )
      }
    )
  }
), mw = "__PairingContext__", YF = globalThis[mw] ?? (() => {
  const e = kw({});
  return globalThis[mw] = e, e;
})(), $8 = () => dy(YF), E8 = ({
  value: e,
  children: n
}) => /* @__PURE__ */ Be.jsx(YF.Provider, { value: e, children: n });
var Ts = { exports: {} }, pw;
function QG() {
  if (pw) return Ts.exports;
  pw = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(I, D, U) {
    return Function.prototype.apply.call(I, D, U);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(I) {
    return Object.getOwnPropertyNames(I).concat(Object.getOwnPropertySymbols(I));
  } : r = function(I) {
    return Object.getOwnPropertyNames(I);
  };
  function i(T) {
    console && console.warn && console.warn(T);
  }
  var a = Number.isNaN || function(I) {
    return I !== I;
  };
  function o() {
    o.init.call(this);
  }
  Ts.exports = o, Ts.exports.once = C, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(T) {
    if (typeof T != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof T);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(T) {
      if (typeof T != "number" || T < 0 || a(T))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + T + ".");
      s = T;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(I) {
    if (typeof I != "number" || I < 0 || a(I))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + I + ".");
    return this._maxListeners = I, this;
  };
  function u(T) {
    return T._maxListeners === void 0 ? o.defaultMaxListeners : T._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return u(this);
  }, o.prototype.emit = function(I) {
    for (var D = [], U = 1; U < arguments.length; U++) D.push(arguments[U]);
    var Q = I === "error", X = this._events;
    if (X !== void 0)
      Q = Q && X.error === void 0;
    else if (!Q)
      return !1;
    if (Q) {
      var re;
      if (D.length > 0 && (re = D[0]), re instanceof Error)
        throw re;
      var G = new Error("Unhandled error." + (re ? " (" + re.message + ")" : ""));
      throw G.context = re, G;
    }
    var q = X[I];
    if (q === void 0)
      return !1;
    if (typeof q == "function")
      n(q, this, D);
    else
      for (var R = q.length, B = F(q, R), U = 0; U < R; ++U)
        n(B[U], this, D);
    return !0;
  };
  function p(T, I, D, U) {
    var Q, X, re;
    if (l(D), X = T._events, X === void 0 ? (X = T._events = /* @__PURE__ */ Object.create(null), T._eventsCount = 0) : (X.newListener !== void 0 && (T.emit(
      "newListener",
      I,
      D.listener ? D.listener : D
    ), X = T._events), re = X[I]), re === void 0)
      re = X[I] = D, ++T._eventsCount;
    else if (typeof re == "function" ? re = X[I] = U ? [D, re] : [re, D] : U ? re.unshift(D) : re.push(D), Q = u(T), Q > 0 && re.length > Q && !re.warned) {
      re.warned = !0;
      var G = new Error("Possible EventEmitter memory leak detected. " + re.length + " " + String(I) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      G.name = "MaxListenersExceededWarning", G.emitter = T, G.type = I, G.count = re.length, i(G);
    }
    return T;
  }
  o.prototype.addListener = function(I, D) {
    return p(this, I, D, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(I, D) {
    return p(this, I, D, !0);
  };
  function d() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(T, I, D) {
    var U = { fired: !1, wrapFn: void 0, target: T, type: I, listener: D }, Q = d.bind(U);
    return Q.listener = D, U.wrapFn = Q, Q;
  }
  o.prototype.once = function(I, D) {
    return l(D), this.on(I, f(this, I, D)), this;
  }, o.prototype.prependOnceListener = function(I, D) {
    return l(D), this.prependListener(I, f(this, I, D)), this;
  }, o.prototype.removeListener = function(I, D) {
    var U, Q, X, re, G;
    if (l(D), Q = this._events, Q === void 0)
      return this;
    if (U = Q[I], U === void 0)
      return this;
    if (U === D || U.listener === D)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Q[I], Q.removeListener && this.emit("removeListener", I, U.listener || D));
    else if (typeof U != "function") {
      for (X = -1, re = U.length - 1; re >= 0; re--)
        if (U[re] === D || U[re].listener === D) {
          G = U[re].listener, X = re;
          break;
        }
      if (X < 0)
        return this;
      X === 0 ? U.shift() : N(U, X), U.length === 1 && (Q[I] = U[0]), Q.removeListener !== void 0 && this.emit("removeListener", I, G || D);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(I) {
    var D, U, Q;
    if (U = this._events, U === void 0)
      return this;
    if (U.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : U[I] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete U[I]), this;
    if (arguments.length === 0) {
      var X = Object.keys(U), re;
      for (Q = 0; Q < X.length; ++Q)
        re = X[Q], re !== "removeListener" && this.removeAllListeners(re);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (D = U[I], typeof D == "function")
      this.removeListener(I, D);
    else if (D !== void 0)
      for (Q = D.length - 1; Q >= 0; Q--)
        this.removeListener(I, D[Q]);
    return this;
  };
  function h(T, I, D) {
    var U = T._events;
    if (U === void 0)
      return [];
    var Q = U[I];
    return Q === void 0 ? [] : typeof Q == "function" ? D ? [Q.listener || Q] : [Q] : D ? j(Q) : F(Q, Q.length);
  }
  o.prototype.listeners = function(I) {
    return h(this, I, !0);
  }, o.prototype.rawListeners = function(I) {
    return h(this, I, !1);
  }, o.listenerCount = function(T, I) {
    return typeof T.listenerCount == "function" ? T.listenerCount(I) : v.call(T, I);
  }, o.prototype.listenerCount = v;
  function v(T) {
    var I = this._events;
    if (I !== void 0) {
      var D = I[T];
      if (typeof D == "function")
        return 1;
      if (D !== void 0)
        return D.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function F(T, I) {
    for (var D = new Array(I), U = 0; U < I; ++U)
      D[U] = T[U];
    return D;
  }
  function N(T, I) {
    for (; I + 1 < T.length; I++)
      T[I] = T[I + 1];
    T.pop();
  }
  function j(T) {
    for (var I = new Array(T.length), D = 0; D < I.length; ++D)
      I[D] = T[D].listener || T[D];
    return I;
  }
  function C(T, I) {
    return new Promise(function(D, U) {
      function Q(re) {
        T.removeListener(I, X), U(re);
      }
      function X() {
        typeof T.removeListener == "function" && T.removeListener("error", Q), D([].slice.call(arguments));
      }
      z(T, I, X, { once: !0 }), I !== "error" && g(T, Q, { once: !0 });
    });
  }
  function g(T, I, D) {
    typeof T.on == "function" && z(T, "error", I, D);
  }
  function z(T, I, D, U) {
    if (typeof T.on == "function")
      U.once ? T.once(I, D) : T.on(I, D);
    else if (typeof T.addEventListener == "function")
      T.addEventListener(I, function Q(X) {
        U.once && T.removeEventListener(I, Q), D(X);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof T);
  }
  return Ts.exports;
}
var JG = QG();
function T8() {
  const e = new JG.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  uT as GraphQLClientProvider,
  YF as PairingContext,
  E8 as PairingProvider,
  C8 as PartnerIntegrations,
  I8 as PartnerIntegrationsSettings,
  Hg as getWidgetDefinitions,
  T8 as initializePartnerEventEmitter,
  $8 as usePairing,
  F8 as usePartnerIntegrationWidgetConfigurations,
  OG as useShopifyConfiguration
};
